import React, { useEffect, useState } from "react";
import { Link, redirect, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Accordion, Button, Col, Form, Modal, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment, { min } from "moment";
import { List, Spin } from "antd";
import {
  convertTimeToDateTime,
  customConfirmDialog,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import { SVGICON } from "../../../constant/theme";
import Cropper from "react-cropper";
import {
  dataUrlToFile,
  dataUrlToFileUsingFetch,
} from "../../../CustomControls/Utils";
import "cropperjs/dist/cropper.css";
import { useRef } from "react";
import Webcam from "react-webcam";
import {
  POST_DDLGetInwardListForInwardClubing,
  POST_DDLParametersRange_SubGroupByReferenceStandardID_TestMasterID,
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetCustomerContactPersonDDL,
  POST_GetCustomerContactPersonDDLByCustomerProject,
  POST_GetCustomerDDLList,
  POST_GetCustomerDDLListAJAX,
  POST_GetCustomerProjectAddressDDLList,
  // POST_GetCustomerProjectContactPersonDDLList,
  POST_GetCustomerProjectList,
  POST_GetDDLTestMasterByDepartmentProductGroupMaterialType,
  POST_GetDepartmentDropDownList,
  // POST_GetDepartmentDropDownList,
  POST_GetEmployeeDDLList,
  POST_GetMachiningProcessDDLList,
  // POST_GetMaterialInwardDetailByID,
  POST_GetMaterialInwardProjectWorkDetailDDLList,
  POST_GetMixDesignMasterDropDownListAll,
  POST_GetParametersPreferenceListBasedOnRefStandardTestSubGroup,
  POST_GetReferenceStandardTestSubGroupDDL,
  POST_GetSamplePreparationAndTestingDetail,
  POST_GetTestingDateWiseParameterTestMethodDDLList,
  POST_GetTestingDateWiseTestMethodDDLList,
  POST_GetTestingParameterFormulaExpressionResult,
  POST_GetTestMethodDDL_ReferenceStandardDDL_TestMasterDetails_ByTestMasterID,
  POST_GetTestParametersList,
  POST_GetTestWiseDefineMoreRatesList,
  // POST_GetMaterialTypeDDLListByDepartment_ProductGroup,
  POST_GetVoucherSeriesDDLList,
  POST_MaterialInwardHeaderDetailChange,
  POST_MaterialInwardInsert,
  POST_MaterialInwardUpdate,
  POST_SamplePreparationAndTestingFilesSave,
  POST_SamplePreparationAndTestingInsert,
  POST_SamplePreparationAndTestingUpdate,
  POST_TestingFetchMachineParameterResults,
  POST_TestingMachineList,
  POST_ValidateCustomerCredit,
  // POST_ProductGroupDropDownListByDepartmentID,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import MixDesignIncludedTestResultDetail from "../Testing/MixDesignIncludedTestResultDetail";

const AddSamplePreparationAndTesting = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const {
    PrimaryIdParam,
    ViewPrimaryIdParam,
    CopyInwardIdParam,
    editHeaderInwardIdParam,
  } = useParams();

  const [inwardNoOptions, setInwardNoOptions] = useState([]);
  // const [customerOptions, setCustomerOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [stampWriteUpOptions, setStampWriteUpOptions] = useState([]);
  // const [departmentOptions, setDepartmentOptions] = useState([]);
  const [modeByOptions, setModeByOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [sampleReceivedViaOptions, setSampleReceivedViaOptions] = useState([]);
  const [referredByOptions, setReferredByOptions] = useState([]);
  const [tpiCustomerOptions, setTPICustomerOptions] = useState([]);
  const [tpiContactPersonOptions, setTPIContactPersonOptions] = useState([]);
  const [dispatchMaterialModeOptions, setDispatchMaterialModeOptions] =
    useState([]);
  const [tcNoOptions, setTCNoOptions] = useState([]);

  const [unitOptions, setUnitOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const yesNoOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const [stampImage, setStampImage] = useState(null);
  const [stampImageFile, setStampImageFile] = useState(null);

  const [showLetterRefDocModal, setShowLetterRefDocModal] = useState(false);
  const [showAddTPIDetailModal, setShowAddTPIDetailModal] = useState(false);
  const [showTPIDetailModal, setShowTPIDetailModal] = useState(false);
  const [showMaterialInfoImagesModal, setShowMaterialInfoImagesModal] =
    useState(false);
  const [
    showMaterialInfoRepeatRowQtyModal,
    setShowMaterialInfoRepeatRowQtyModal,
  ] = useState(false);
  const [showWorkDetailModal, setShowWorkDetailModal] = useState(false);

  const webcamRef = useRef(null);

  const videoConstraints = {
    width: 600,
    height: 600,
    facingMode: "environment",
  };

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const getInwardNoDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 1, // 1 = Inward
      TranDate: InwardDate
        ? moment(InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setInwardNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item.VoucherSeries,
              value: item.VoucherSeriesIDEncrypt,
              IsTCNoBasedOnInwardNo: item.IsTCNoBasedOnInwardNo,
            }))
          );
          if (InwardNo) {
            if (
              response?.VoucherSeriesList?.filter(
                (x) => x.VoucherSeriesIDEncrypt == InwardNo
              )?.length == 0
            ) {
              formik.setFieldValue("InwardNo", "");
            }
          } else {
            /*select the value when there is only one option while insert only*/
            if (response?.VoucherSeriesList?.length == 1 && !PrimaryIdParam) {
              formik.setFieldValue(
                "InwardNo",
                response?.VoucherSeriesList[0].VoucherSeriesIDEncrypt
              );
              formik.setFieldValue(
                "IsTCNoBasedOnInwardNo",
                response?.VoucherSeriesList[0].IsTCNoBasedOnInwardNo
              );
            }
          }
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTCNoDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 5, // 5 = TCNo
      TranDate: InwardDate
        ? moment(InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTCNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item?.VoucherSeries,
              value: item?.VoucherSeriesIDEncrypt,
            }))
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTPICustomerDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TPIFlag: 1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPICustomerOptions(
            response?.CustomerDDLList?.filter((x) => x.IsTPI == true)?.map(
              (item) => ({
                label: item.CustomerName,
                value: item.CustomerIDEncrypted,
              })
            )
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProjectDDL = async (customerID) => {
    //setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: customerID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            }))
          );
          if (
            response?.CustomerProjectDDLList?.length >= 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted
            ).length == 0
          ) {
            formik.setFieldValue("CustomerProjectIDEncrypted", "");
            formik.setFieldValue("CustomerProjectName", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.CustomerProjectDDLList?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "CustomerProjectIDEncrypted",
                response?.CustomerProjectDDLList[0].CustomerProjectIDEncrypt
              );
              formik.setFieldValue(
                "CustomerProjectName",
                response?.CustomerProjectDDLList[0].ProjectName
              );
            }
          }
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getStampWriteUpDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: CustomerIDEncrypted,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setStampWriteUpOptions(
            response?.ListOfContactPersons?.filter(
              (x) => x.StempWriteup != ""
            )?.map((item) => ({
              label: item.StempWriteup,
              value: item.CustomerContactPersonIDEncrypted,
            }))
          );
          if (
            response?.ListOfContactPersons?.filter((x) => x.StempWriteup != "")
              ?.length > 0 &&
            StampWriteUpIDEncrypted &&
            response?.ListOfContactPersons?.filter(
              (x) => x.StempWriteup != ""
            )?.filter(
              (x) =>
                x.CustomerContactPersonIDEncrypted == StampWriteUpIDEncrypted
            ).length == 0
          ) {
            formik.setFieldValue("StampWriteUpIDEncrypted", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.ListOfContactPersons?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "StampWriteUpIDEncrypted",
                response?.ListOfContactPersons[0]
                  .CustomerContactPersonIDEncrypted
              );
            }
          }

          response?.ListOfContactPersons?.map((item) => ({
            label: item.ContactPerson,
            value: item.CustomerContactPersonIDEncrypted,
          }));
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getReferredByDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypted: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setReferredByOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
            }))
          );
          if (
            response?.ListOfContactPersons?.length > 0 &&
            ReferenceByIDEncrypted &&
            response?.ListOfContactPersons?.filter(
              (x) =>
                x.CustomerContactPersonIDEncrypted == ReferenceByIDEncrypted
            ).length == 0
          ) {
            formik.setFieldValue("ReferenceByIDEncrypted", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.ListOfContactPersons?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "ReferenceByIDEncrypted",
                response?.ListOfContactPersons[0]
                  .CustomerContactPersonIDEncrypted
              );
            }
          }
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTPIContactPersonDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: TPIIDEncrypted,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPIContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              IsBilling: item.IsBilling,
              IsReporting: item.IsReporting,
              IsDispatch: item.IsDispatch,
              IsDispatchMaterial: item.IsDispatchMaterial,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getEmployeeDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetEmployeeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      UserType: AuthUser?.UserType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmployeeOptions(
            response?.EmployeeList?.map((item) => ({
              label: item.EmployeeName,
              value: item.EmployeeIDEncrypted,
            }))
          );
          /*select the value when there is only one option while insert only*/
          if (response?.EmployeeList?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue(
              "MaterialTakenByUserEncrypted",
              response?.EmployeeList[0].EmployeeIDEncrypted
            );
          }
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getSampleReceivedViaDDL = () => {
    setSampleReceivedViaOptions([
      {
        value: 1,
        label: "Hand to Hand",
      },
      {
        value: 2,
        label: "Courier",
        //label: "Post",
      },
    ]);
  };

  const getModeByDDL = () => {
    setModeByOptions([
      {
        value: 1,
        label: "Email",
      },
      {
        value: 2,
        label: "Post",
      },
      {
        value: 3,
        label: "Hand to Hand",
      },
      {
        value: 4,
        label: "Courier",
      },
    ]);
  };

  const getDispatchMaterialModeDDL = () => {
    setDispatchMaterialModeOptions([
      {
        value: 2,
        label: "Post",
      },
      {
        value: 3,
        label: "Hand to Hand",
      },
      {
        value: 4,
        label: "Courier",
      },
    ]);
  };

  const getProjectDDLModeDetails = async (customerID, index) => {
    if (customerID) {
      setIsLoading(true);

      await post(POST_GetCustomerProjectList, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        CustomerIDEncrypt: customerID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfModeDetails[${index}].projectOptions`,
              response?.CustomerProjectDDLList?.map((item) => ({
                label: item.ProjectName,
                value: item.CustomerProjectIDEncrypt,
              }))
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      formik.setFieldValue(`ListOfModeDetails[${index}].projectOptions`, []);
      formik.setFieldValue(
        `ListOfModeDetails[${index}].CustomerProjectIDEncrypted`,
        ""
      );
    }
  };

  const getProjectAddressDDL = async (customerID, projectID, index) => {
    if (customerID && projectID) {
      setIsLoading(true);
      await post(POST_GetCustomerProjectAddressDDLList, {
        CustomerIDEncrypted: customerID,
        CustomerProjectIDEncrypted: projectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfModeDetails[${index}].projectAddressOptions`,
              response?.ProjectAddressDDLList?.map((item) => ({
                label: item.Address,
                value: item.CustomerProjectAddressIDEncrypted,
              }))
            );
            /*select the value when there is only one option while insert only*/
            if (
              response?.ProjectAddressDDLList?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                `ListOfModeDetails[${index}].CustomerProjectAddressIDEncrypted`,
                response?.ProjectAddressDDLList[0]
                  .CustomerProjectAddressIDEncrypted
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      formik.setFieldValue(
        `ListOfModeDetails[${index}].projectAddressOptions`,
        []
      );
      formik.setFieldValue(
        `ListOfModeDetails[${index}].CustomerProjectAddressIDEncrypted`,
        ""
      );
    }
  };

  const getContactPersonDDL = async (customerID, projectID, index) => {
    // if (customerID) {
    if (customerID && projectID) {
      setIsLoading(true);
      await post(POST_GetCustomerContactPersonDDLByCustomerProject, {
        CustomerIDEncrypted: customerID,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        CustomerProjectIDEncrypted: projectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfModeDetails[${index}].contactPersonOptions`,
              response?.ListOfContactPersons?.map((item) => ({
                label: item?.ContactPerson,
                value: item?.CustomerContactPersonIDEncrypted,
                IsBilling: item?.IsBilling,
                IsReporting: item?.IsReporting,
                IsDispatch: item?.IsDispatch,
                IsDispatchMaterial: item?.IsDispatchMaterial,
              }))
            );
            /*select the value when there is only one option while insert only*/
            if (
              response?.ListOfContactPersons?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                `ListOfModeDetails[${index}].CustomerContactPersonIDEncrypted`,
                response?.ListOfContactPersons[0]
                  .CustomerContactPersonIDEncrypted
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      formik.setFieldValue(
        `ListOfModeDetails[${index}].contactPersonOptions`,
        []
      );
      formik.setFieldValue(
        `ListOfModeDetails[${index}].CustomerContactPersonIDEncrypted`,
        ""
      );
    }
  };

  const getCustomerReviewList = async () => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 7, //Customer Review
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfReviews",
            response?.List?.map((item) => ({
              InwardReviewIDEncrypted: "",
              Review: item.CategoryName,
              CategoryID: item.CategoryID,
              StatusOfReview: false,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProjectWorkDetailList = async () => {
    setIsLoading(true);
    post(POST_GetMaterialInwardProjectWorkDetailDDLList, {
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikWorkDetail.setFieldValue(
            "projectWorkDetailList",
            response?.ProjectWorkDetailDDLList?.map((item) => ({
              WorkDetail: item.ProjectDetails,
              IsSelected: false,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getDepartmentDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TransactionDate: InwardDate
        ? moment(InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item?.DepartmentName,
              value: item?.DepartmentIDEncrypted,
              IsNABLScopeExpired: item?.IsNABLScopeExpired,
            }))
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const initMaterialTestDetail = {
    InwardMaterialTestDetailIDEncrypted: "",
    DepartmentIDEncrypted: "",
    ProductGroupIDEncrypted: "",
    MaterialTypeIDEncrypted: "",
    TestMasterIDEncrypted: "",
    TestMethodIDEncrypted: "",
    ReferenceStandardIDEncrypted: "",
    RefStandardSubGroup: "",
    TestCount: "",
    BillingQty: "",
    UnitID: "",
    Rate: "0.00",
    //IsMachining: false,
    TestNote: "",
    productGroupOptions: [],
    materialTypeOptions: [],
    testOptions: [],
    testMethodOptions: [],
    referenceStandardOptions: [],
    refStandardSubGroupOptions: [],
    parametersRangeList: [],
    IsDeleted: false,
    IsCancel: false,
    ListOfTestParameters: [],
    ListOfDefineMoreRates: [],
    IsMixDesign: false,
    TestMixDesignDetail: {
      StipulationsProportioningIDEncrypted: "",
      // InwardIDEncrypted: "",
      // InwardMaterialIDEncrypted: "",
      // InwardMaterialTestDetailIDEncrypted: "",
      // TestMasterIDEncrypted: "",
      TypeofCementIDEncrypted: "",
      TypeofMineralAdmixtureIDEncrypted: "",
      MaximumNominalSizeofAggregateIDEncrypted: "",
      EnvironmentalExposureConditionsIDEncrypted: "",
      TypeofAggregateFineIDEncrypted: "",
      ChemicalAdmixtureTypeIDEncrypted: "",
      ChemicalAdmixtureBrandBatchandMarkIDEncrypted: "",
      GradeDesignation: "",
      MinimumCementContent: "",
      MaximumCementContent: "",
      MaximumWaterCementRatio: "",
      Workability: "",
      RetentionTime: "",
      TransportationTime: "",
      DegreeofSiteControl: "",
      TypeofAggregateFineCoarse: "",
      MethodofConcretePlacingIsChute_NonPumpable: false,
      MethodofConcretePlacingIsPumping: false,
      ListOfMixDesignIncludedTest: [],
      /* Mix Design Testing Purpose */
      TypeofCementName: "",
      TypeofMineralAdmixtureName: "",
      MaximumNominalSizeofAggregateName: "",
      EnvironmentalExposureConditionsName: "",
      TypeofAggregateFineName: "",
      ChemicalAdmixtureTypeName: "",
      ChemicalAdmixtureBrandBatchandMarkName: "",
      FineAggregateConformingToGradingZone: "",
      FineAggregateReferenceStandardAndTableName: "",
      ApproximateAirContentResultTitle: "",
      ApproximateAirContentResultValue: "",
      ApproximateAirContentReferenceStandardAndTableName: "",
      SelectionOfWaterCementRatioReferenceStandardName: "",
      SelectionOfWaterCementRatioReferenceStandardTableName: "",
      FreeWaterCementRatio: "",
      TargetStrengthForMixProportioningResultValue: "",
      ConcreteType: "",
      ConcreteGrade: "",
      MaxFreeWaterCementRatio: "",
      SelectionOfWaterContentReferenceStandardAndTableName: "",
      SelectionOfWaterContentRemarks: "",
      EstimatedWaterContentFor: "",
      AsSuperPlasticizerIsUsed: "",
      WaterCementRatio: "",
      CementContentKgPerM3FormulaValue: "",
      CementContentKgPerM3ResultValue: "",
      CementContentKgPerM3FinalResult: "",
      CementitiousMaterialContentIsTakenAsMoreOrLessPercentage: "",
      CementitiousMaterialContentOfCementContentPercentage: "",
      CementContentKgPerM3: "",
      WaterContentKgPerM3: "",
      WaterCementRatioCementitiousMaterial: "",
      CementitiousMaterialContentKgPerM3: "",
    },
    IsMixDesignIncludedTest: false,
    MixDesignTestMasterIDEncrypted: "",
    TestingDetails: {
      TestingIDEncrypted: "",
      TestingDate: new Date(),
      TestingToDate: new Date(),
      UnitID: "",
      BasedOnMeasurementValue: "",
      BasedOnHrsValue: "",
      TestMethodIDEncrypt: "",
      MachineIDEncrypt: "",
      ParameterWith: 0,
      IsMergeSameValue: false,
      Result: "",
      Remarks: "",
      TestingStatus: 1,
      ListOfTPIDetails: [],
      ListTestingResultImages: [],
      ListTestMasterImages: [],
      ListTestingBy: [],
      ListOfParameter: [],
      AllowTestingEdit: 1,
      LocationType: 0,
      ListOfMachines: [],
      TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData: {},
      ListOfMixDesignTargetStrengthForMixProportioning: [],
      ListOfMixDesignGroupParameters: [],
      ListOfMixDesignMixCalculation: [],
      ListOfMixDesignMixProportionsForTrial: [],
      IsReTestTesting: false,
      ChangeNote: "",
    },
    AllowTestEdit: 1,
  };

  const initMaterialInformation = {
    id: "",
    TCNoAllocated: false,
    InwardMaterialIDEncrypted: "",
    TCNo: "",
    ULRNo: "",
    // DepartmentIDEncrypted: "",
    // ProductGroupIDEncrypted: "",
    // MaterialTypeIDEncrypted: "",
    Size: "",
    Condition: "",
    SampleDetail: "",
    IsMachining: false,
    ListOfMaterialPhotos: [],
    ListOfMaterialTestDetails: [initMaterialTestDetail],
    // productGroupOptions: [],
    // materialTypeOptions: [],
    IsDeleted: false,
    IsErrorDisplay: false,
    IsHeaderDetailMaterialInformationChange: false,
    ListOfProcessThicknessDetailsFinal: [],
    IsHold: false,
    AllowTCEdit: 1,
  };

  const initModeDetails = [
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 1,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 2,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 3,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 4,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
  ];

  const validationSchema = Yup.object().shape({
    btnSubmitType: Yup.number(),
    InwardNo: Yup.string().when("btnSubmitType", ([btnSubmitType], schema) => {
      if (btnSubmitType != 1)
        return Yup.string().required("Inward No is required field");
      return schema;
    }),
    InwardDate: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Inward Date is required field");
        return schema;
      }
    ),
    CustomerIDEncrypted: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Customer is required field");
        return schema;
      }
    ),
    CustomerProjectIDEncrypted: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Project is required field");
        return schema;
      }
    ),
    ChangeReason: Yup.string().when(
      "IsEditMaterialInwardHeaderDetail",
      ([IsEditMaterialInwardHeaderDetail], schema) => {
        if (IsEditMaterialInwardHeaderDetail == true)
          return Yup.string().required("Change Reason is required field");
        return schema;
      }
    ),
    CustomerProjectName: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1 && !CustomerProjectIDEncrypted)
          return Yup.string().required("Project is required field");
        return schema;
      }
    ),

    InwardIDsClubing: Yup.array().when(
      "InwardClubing",
      ([InwardClubing], schema) => {
        if (InwardClubing == true)
          return Yup.array()
            .required("Inward No is required field")
            .min(1, "Inward No is required field")
            .nullable();
        return schema;
      }
    ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, { setSubmitting }) =>
      handleValidSubmit(values, { setSubmitting }),
    initialValues: {
      InwardIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      InwardNo: "",
      InwardDate: new Date(),
      InwardCurrentStatus: 1,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectName: "",
      ProjectDetails: "",
      LetterRefNo: "",
      StampWriteUpIDEncrypted: "",
      StampImageFilePath: "",
      MaterialReceiveViaID: "",
      ReceiveRemarks: "",
      MaterialTakenByUserEncrypted: "",
      ExpectedDateOfDelivery: "",
      EDDRemarks: "",
      ReferenceByIDEncrypted: "",
      IsMaterialReturnable: false,
      IsTPIRequired: false,
      ListOfLetterRefDoc: [],
      ListOfTPIDetails: [],
      ListOfMaterials: [initMaterialInformation],
      ListOfModeDetails: initModeDetails,
      ListOfReviews: [],
      selectedMaterialInfoRow: -1,
      btnSubmitType: 1, // 1 = Draft, 2 = Submit
      IsStampImageFileDeleted: false,
      IsTCNoBasedOnInwardNo: true,
      IsEditMaterialInwardHeaderDetail: editHeaderInwardIdParam ? true : false,
      AllowToChangeCustomerAndProject: true,
      IsHeaderDetailCustomerChange: false,
      originalCustomerID: "",
      originalCustomerName: "",
      IsHeaderDetailProjectChange: false,
      originalProjectID: "",
      originalProjectName: "",
      IsMaterialDispatched: false,
      IsHeaderDetailWorkDetailChange: false,
      originalWorkDetail: "",
      IsHeaderDetailLetterRefNoChange: false,
      originalLetterRefNo: "",
      // IsHeaderDetailTPIRequiredChange: false,
      // originalIsTPIRequired: false,
      // IsHeaderDetailTPIDetailChange: false,
      // originalListOfTPIDetails: [],
      originalListOfMaterials: [],
      ChangeReason: "",
      InwardClubing: false,
      InwardIDsClubing: [],
      IsAllowToEdit: 1,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardNo,
      InwardDate,
      InwardCurrentStatus,
      CustomerIDEncrypted,
      CustomerName,
      CustomerProjectIDEncrypted,
      CustomerProjectName,
      IsMaterialReturnable,
      IsTPIRequired,
      ListOfReviews,
      ListOfLetterRefDoc,
      ListOfTPIDetails,
      ListOfMaterials,
      selectedMaterialInfoRow,
      ListOfModeDetails,
      StampWriteUpIDEncrypted,
      ReferenceByIDEncrypted,
      IsTCNoBasedOnInwardNo,
      AllowToChangeCustomerAndProject,
      InwardClubing,
      InwardIDsClubing,
      IsAllowToEdit,
    },
  } = formik;

  const handleValidSubmit = (values, { setSubmitting }) => {
    if (ViewPrimaryIdParam) {
      return;
    }
    setIsLoading(true);
    if (values?.btnSubmitType == 2) {
      if (ListOfMaterials?.filter((x) => x.IsDeleted == false)?.length == 0) {
        formik.setFieldError(
          "ListOfMaterials",
          "Material Information is required"
        );
        formik.setFieldTouched("ListOfMaterials", true);
        setSubmitting(false);
        setIsLoading(false);
        return;
      } else {
        let IsmaterialInfoValid = true;
        let IsTestInfoValid = true;
        let IsTestRequiredValid = true;
        Promise.all(
          ListOfMaterials?.filter((x) => x.IsDeleted == false)?.map(
            (item, indx) => {
              if (
                (!item?.TCNo && IsTCNoBasedOnInwardNo == false) ||
                // !item?.DepartmentIDEncrypted ||
                // !item?.ProductGroupIDEncrypted ||
                // !item?.MaterialTypeIDEncrypted ||
                !item?.Size?.trim() ||
                !item?.Condition?.trim() ||
                !item?.SampleDetail?.trim()
              ) {
                IsmaterialInfoValid = false;
              } else {
                if (
                  item?.ListOfMaterialTestDetails?.filter(
                    (x) => x?.IsDeleted == false
                  )?.length == 0
                ) {
                  IsTestRequiredValid = false;
                } else {
                  Promise.all(
                    item?.ListOfMaterialTestDetails?.filter(
                      (x) => x?.IsDeleted == false
                    )?.map((test) => {
                      if (
                        !test?.DepartmentIDEncrypted ||
                        // !test?.ProductGroupIDEncrypted ||
                        // !test?.MaterialTypeIDEncrypted ||
                        !test?.TestMasterIDEncrypted ||
                        // !test?.TestMethodIDEncrypted ||
                        //!test?.ReferenceStandardIDEncrypted ||
                        !test?.TestCount ||
                        !test?.BillingQty
                        // ||
                        // !test?.UnitID ||
                        // !test?.Rate ||
                        // !test?.TestNote?.trim()
                      ) {
                        IsTestInfoValid = false;
                      }
                    })
                  );
                }
              }
            }
          )
        );

        /* //Below code to highlight the error in Material Information
        let newList = [];
        newList = ListOfMaterials?.filter((x) => x.IsDeleted == false)?.map(
          (item, indx) => {
            if (
              (!item?.TCNo && IsTCNoBasedOnInwardNo == false) ||
              // !item?.DepartmentIDEncrypted ||
              // !item?.ProductGroupIDEncrypted ||
              // !item?.MaterialTypeIDEncrypted ||
              !item?.Size?.trim() ||
              !item?.Condition?.trim() ||
              !item?.SampleDetail?.trim()
            ) {
              return {
                ...item,
                IsErrorDisplay: true,
              };
            } else {
              return {
                ...item,
                IsErrorDisplay: false,
              };
            }
          }
        );

        formik.setFieldValue("ListOfMaterials", newList);
        */

        if (IsmaterialInfoValid == false) {
          // errorMessage(
          //   "Please fill all the above details of Material Information..."
          // );
          setTimeout(() => {
            formik.setFieldError(
              "ListOfMaterials",
              "Please fill all the above details of Material Information..."
            );
            formik.setFieldTouched("ListOfMaterials", true);
          }, 800);
          setSubmitting(false);
          setIsLoading(false);
          return;
        }
        if (IsTestRequiredValid == false) {
          // warningMessage("Test Detail is required");
          formik.setFieldError("TestError", "Test Detail is required");
          formik.setFieldTouched("TestError", true);
          setSubmitting(false);
          setIsLoading(false);
          return;
        } else {
          if (IsTestInfoValid == false) {
            // warningMessage(
            //   "Please fill all the details of Test..."
            // );
            formik.setFieldError(
              "TestError",
              "Please fill all the above details of Test..."
            );
            formik.setFieldTouched("TestError", true);
            setSubmitting(false);
            setIsLoading(false);
            return;
          } else {
            let IsBillingQtyValid = true;
            Promise.all(
              ListOfMaterials?.filter((x) => x?.IsDeleted == false)?.map(
                (item, idxM) => {
                  Promise.all(
                    item?.ListOfMaterialTestDetails?.filter(
                      (x) => x?.IsDeleted == false && x?.IsCancel == false
                    )?.map((test) => {
                      if (
                        parseInt(test?.TestCount) < parseInt(test?.BillingQty)
                      ) {
                        IsBillingQtyValid = false;
                      }
                    })
                  );
                }
              )
            );
            if (IsBillingQtyValid == false) {
              formik.setFieldError(
                "ListOfMaterials",
                "Billing Qty must be less then or equal to Test Count..."
              );
              formik.setFieldTouched("ListOfMaterials", true);
              setSubmitting(false);
              setIsLoading(false);
              return;
            }
          }
        }
      }
    }

    //console.log("payload", values);

    setIsLoading(true);
    let payload = {
      InwardIDEncrypted: values?.InwardIDEncrypt,
      InwardNo: values?.InwardNo,
      InwardDate: values?.InwardDate
        ? moment(values?.InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: values?.CustomerIDEncrypted,
      CustomerProjectIDEncrypted: values?.CustomerProjectIDEncrypted,
      IsMaterialReturnable: values?.IsMaterialReturnable,
      StampWriteUpIDEncrypted: values?.StampWriteUpIDEncrypted,
      ProjectDetails: values?.ProjectDetails.trim(),
      LetterRefNo: values?.LetterRefNo,
      IsTPIRequired: values?.IsTPIRequired,
      MaterialReceiveViaID: values?.MaterialReceiveViaID
        ? values?.MaterialReceiveViaID
        : null,
      ReceiveRemarks: values?.ReceiveRemarks,
      MaterialTakenByUserEncrypted: values?.MaterialTakenByUserEncrypted,
      ExpectedDateOfDelivery: values?.ExpectedDateOfDelivery
        ? moment(values?.ExpectedDateOfDelivery)
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")
        : "",
      EDDRemarks: values?.EDDRemarks,
      ReferenceByIDEncrypted: values?.ReferenceByIDEncrypted,
      InwardCurrentStatus: values?.btnSubmitType == 2 ? 5 : 1, // 1 = Draft, 5 = Inward Approved
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      IsInwardNoClubing: values?.InwardClubing,
      InwardIDsClubing: Array.from(
        values?.InwardIDsClubing,
        (x) => x.value
      ).join(","),
      ChangeReason: values?.ChangeReason?.trim(),
      ListOfTPIDetails: values?.ListOfTPIDetails?.map((x) => ({
        ...x,
        TPIExpectedDate: x.TPIExpectedDate
          ? moment(x.TPIExpectedDate).format("YYYY-MM-DD").replace(/^\-/, "")
          : "",
      })),
      ListOfMaterials: values?.ListOfMaterials?.map((x, i) => ({
        id: i + 1,
        InwardMaterialIDEncrypted: x.InwardMaterialIDEncrypted,
        TCNo: x.TCNo,
        Size: x.Size,
        Condition: x.Condition,
        SampleDetail: x.SampleDetail,
        IsMachining: x.IsMachining,
        IsDeleted: x.IsDeleted,
        ListOfTests: x?.ListOfMaterialTestDetails?.map((y, j) => ({
          id_test: j + 1,
          InwardMaterialTestDetailIDEncrypted:
            y.InwardMaterialTestDetailIDEncrypted,
          InwardMaterialIDEncrypted: x.InwardMaterialIDEncrypted,
          InwardIDEncrypted: values?.InwardIDEncrypt,
          DepartmentIDEncrypted: y.DepartmentIDEncrypted,
          ProductGroupIDEncrypted: y.ProductGroupIDEncrypted,
          MaterialTypeIDEncrypted: y.MaterialTypeIDEncrypted,
          TestMasterIDEncrypted: y.TestMasterIDEncrypted,
          TestMethodIDEncrypted: y.TestMethodIDEncrypted,
          ReferenceStandardIDEncrypted: y.ReferenceStandardIDEncrypted,
          RefStandardSubGroup: y.RefStandardSubGroup,
          TestCount: y.TestCount ? y.TestCount : null,
          BillingQty: y.BillingQty ? y.BillingQty : null,
          UnitID: y.UnitID ? y.UnitID : null,
          Rate: y.Rate,
          TestNote: y.TestNote,
          IsDeleted: y.IsDeleted,
          IsMixDesign: y.IsMixDesign,
          StipulationsProportioningIDEncrypted:
            y?.TestMixDesignDetail?.StipulationsProportioningIDEncrypted,
          TypeofCementIDEncrypted:
            y?.TestMixDesignDetail?.TypeofCementIDEncrypted,
          TypeofMineralAdmixtureIDEncrypted:
            y?.TestMixDesignDetail?.TypeofMineralAdmixtureIDEncrypted,
          MaximumNominalSizeofAggregateIDEncrypted:
            y?.TestMixDesignDetail?.MaximumNominalSizeofAggregateIDEncrypted,
          EnvironmentalExposureConditionsIDEncrypted:
            y?.TestMixDesignDetail?.EnvironmentalExposureConditionsIDEncrypted,
          TypeofAggregateFineIDEncrypted:
            y?.TestMixDesignDetail?.TypeofAggregateFineIDEncrypted,
          ChemicalAdmixtureTypeIDEncrypted:
            y?.TestMixDesignDetail?.ChemicalAdmixtureTypeIDEncrypted,
          ChemicalAdmixtureBrandBatchandMarkIDEncrypted:
            y?.TestMixDesignDetail
              ?.ChemicalAdmixtureBrandBatchandMarkIDEncrypted,
          GradeDesignation: y?.TestMixDesignDetail?.GradeDesignation,
          MinimumCementContent: y?.TestMixDesignDetail?.MinimumCementContent
            ? y?.TestMixDesignDetail?.MinimumCementContent.toString()
            : "",
          MaximumCementContent: y?.TestMixDesignDetail?.MaximumCementContent
            ? y?.TestMixDesignDetail?.MaximumCementContent.toString()
            : "",
          MaximumWaterCementRatio: y?.TestMixDesignDetail
            ?.MaximumWaterCementRatio
            ? y?.TestMixDesignDetail?.MaximumWaterCementRatio.toString()
            : "",
          Workability: y?.TestMixDesignDetail?.Workability,
          RetentionTime:
            y?.TestMixDesignDetail?.RetentionTime != ""
              ? moment(y?.TestMixDesignDetail?.RetentionTime, "HH:mm:ss")
                  .format("HH:mm")
                  .replace(/^\-/, "")
              : "",
          TransportationTime:
            y?.TestMixDesignDetail?.TransportationTime != ""
              ? moment(y?.TestMixDesignDetail?.TransportationTime, "HH:mm:ss")
                  .format("HH:mm")
                  .replace(/^\-/, "")
              : "",
          DegreeofSiteControl: y?.TestMixDesignDetail?.DegreeofSiteControl,
          TypeofAggregateFineCoarse:
            y?.TestMixDesignDetail?.TypeofAggregateFineCoarse,
          MethodofConcretePlacingIsChute_NonPumpable:
            y?.TestMixDesignDetail?.MethodofConcretePlacingIsChute_NonPumpable,
          MethodofConcretePlacingIsPumping:
            y?.TestMixDesignDetail?.MethodofConcretePlacingIsPumping,
          IsMixDesignIncludedTest: y.IsMixDesignIncludedTest,
          MixDesignTestMasterIDEncrypted: y.MixDesignTestMasterIDEncrypted,
          ListOfParameters: y?.ListOfTestParameters?.filter(
            (x) => x.IsSelected == true
          )?.map((z, k) => ({
            InwardMaterialTestDetailIDEncrypted:
              y.InwardMaterialTestDetailIDEncrypted,
            TestMasterIDEncrypted: y.TestMasterIDEncrypted,
            RefParameterIDEncrypted: z.RefParameterIDEncrypted,
            ParameterType: z.ParameterType,
          })),
          ListOfDefineMoreRates: y?.ListOfDefineMoreRates?.map((z, k) => ({
            InwardMaterialTestDetailIDEncrypted:
              y.InwardMaterialTestDetailIDEncrypted,
            TestMasterIDEncrypted: y.TestMasterIDEncrypted,
            RateType: z.RateType,
          })),
          TestingDetails: {
            TestingIDEncrypted: y?.TestingDetails?.TestingIDEncrypted,
            TestingDate: y?.TestingDetails?.TestingDate,
            TestingToDate: y?.TestingDetails?.TestingToDate,
            UnitID: y?.TestingDetails?.UnitID
              ? y?.TestingDetails?.UnitID
              : null,
            BasedOnMeasurementValue: y?.TestingDetails?.BasedOnMeasurementValue,
            BasedOnHrsValue: y?.TestingDetails?.BasedOnHrsValue,
            TestMethodIDEncrypt: y?.TestingDetails?.TestMethodIDEncrypt,
            MachineIDEncrypt: y?.TestingDetails?.MachineIDEncrypt,
            ParameterWith: y?.TestingDetails?.ParameterWith,
            IsMergeSameValue: y?.TestingDetails?.IsMergeSameValue,
            Result: y?.TestingDetails?.Result,
            Remarks: y?.TestingDetails?.Remarks,
            ChangeNote: y?.TestingDetails?.ChangeNote,
            TestingStatus: y?.TestingDetails?.TestingStatus,
            TestingByIDs: Array.from(
              y?.TestingDetails?.ListTestingBy?.filter(
                (e) => e.IsSelected == true
              ),
              (emp) => emp.EmployeeIDEncrypt
            ).join(","),
            LocationType: y?.TestingDetails?.LocationType,
            ListOfTPIDetails: y?.TestingDetails?.ListOfTPIDetails?.map((t) => ({
              ...t,
              TPIExpectedDate: t.TPIExpectedDate
                ? moment(t.TPIExpectedDate)
                    .format("YYYY-MM-DD")
                    .replace(/^\-/, "")
                : "",
            })),
            ListOfTestingResultList:
              y?.TestingDetails?.ListOfParameter?.flatMap((p) => {
                return p?.ListOfResultValue?.map((r, rIndex) => ({
                  ...r,
                  TestingIDEncrypted: y?.TestingDetails?.TestingIDEncrypted,
                  TestingCount: rIndex + 1,
                  TestingCountHeader: r?.TestingCountHeader,
                  TestingIDEncrypted: values?.TestingIDEncrypt,
                  ParameterType: p?.ParameterType,
                  RefParameterIDEncrypted: p?.TestMasterParameterIDEncrypted,
                  ParameterName: p?.ParameterName,
                  DisplayCode: p?.DisplayCode,
                  IsNABLParameter: p?.IsNABLParameter,
                  MinValue: p?.MinValue,
                  MaxValue: p?.MaxValue,
                  RangeValue: p?.RangeValue,
                  NABLRangeFrom: p?.NABLRangeFrom,
                  NABLRangeTo: p?.NABLRangeTo,
                  Requirement: p?.Requirement,
                  IsDeleted: false,
                  TestMethodIDEncrypted: p?.TestMethodIDEncrypt,
                  IsSelected: p?.IsSelected,
                  IsAverageRequired: p?.IsAverageRequired,
                  AverageResultValue: p?.AverageResultValue,
                  ParameterSequence: p?.Sequence,
                }));
              }),
            ListOfParameterSequence: y?.TestingDetails?.ListOfParameter?.map(
              (p) => ({
                Sequence: p?.Sequence,
                ParameterType: p?.ParameterType,
                ParameterIDEncrypted: p?.TestMasterParameterIDEncrypted,
              })
            ),
          },
        })),
        ListOfProcessThicknessDetailsFinal:
          x?.ListOfProcessThicknessDetailsFinal?.map((pt) => ({
            ...pt,
            Length: pt?.Length ? pt?.Length.toString() : "",
            Thickness: pt?.Thickness ? pt?.Thickness.toString() : "",
          })),
      })),
      ListOfModeDetails: values?.ListOfModeDetails,
      ListOfReviews: values?.ListOfReviews,
    };

    //console.log("payload", payload);

    let formData = new FormData();
    formData.append(
      "InwardDate",
      values?.InwardDate
        ? moment(values?.InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : ""
    );
    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("StampImageFile", stampImageFile ?? "");
    formData.append("StampImageFilePath", values?.StampImageFilePath);
    formData.append("IsStampImageFileDeleted", values?.IsStampImageFileDeleted);

    Promise.all(
      //ListOfLetterRefDoc
      values?.ListOfLetterRefDoc?.map((x, i) => {
        formData.append(
          `ListOfLetterRefDoc[${i}].InwardLetterRefImageIDEncrypted`,
          x.InwardLetterRefImageIDEncrypted
        );
        formData.append(
          `ListOfLetterRefDoc[${i}].LetterRefImageFile`,
          x.LetterRefImageFile
        );
        formData.append(
          `ListOfLetterRefDoc[${i}].LetterRefImageFilePath`,
          x.LetterRefImageFilePath
        );
        formData.append(`ListOfLetterRefDoc[${i}].IsDeleted`, x.IsDeleted);
      })
    );

    post(
      PrimaryIdParam
        ? POST_SamplePreparationAndTestingUpdate
        : POST_SamplePreparationAndTestingInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          let inwardId = PrimaryIdParam
            ? values?.InwardIDEncrypt
            : response?.InwardIDEncrypted;
          if (inwardId) {
            formData.append("InwardIDEncrypted", inwardId);

            let mImgIdx = 0;
            let tImgIdx = 0;
            Promise.all(
              //ListOfMaterialPhotos
              values?.ListOfMaterials?.map((x, i) => {
                let id = i + 1;
                let inwardMaterialId = response?.ListOfMaterial_Id?.filter(
                  (f) => f.id == id
                )[0]?.InwardMaterialIDEncrypted;
                x?.ListOfMaterialPhotos?.map((y, j) => {
                  formData.append(`ListOfMaterialPhotos[${mImgIdx}].id`, id);
                  formData.append(
                    `ListOfMaterialPhotos[${j}].InwardMaterialIDEncrypted`,
                    inwardMaterialId
                  );
                  formData.append(
                    `ListOfMaterialPhotos[${mImgIdx}].InwardMaterialPhotoIDEncrypted`,
                    y.InwardMaterialPhotoIDEncrypted
                  );
                  formData.append(
                    `ListOfMaterialPhotos[${mImgIdx}].MaterialPhotoFile`,
                    y.MaterialPhotoFile
                  );
                  formData.append(
                    `ListOfMaterialPhotos[${mImgIdx}].MaterialPhotoFilePath`,
                    y.MaterialPhotoFilePath
                  );
                  formData.append(
                    `ListOfMaterialPhotos[${mImgIdx}].IsDeleted`,
                    y.IsDeleted
                  );
                  mImgIdx = mImgIdx + 1;
                });
                //ListOfTestResultImages
                x?.ListOfMaterialTestDetails?.map((t, k) => {
                  let id_test = k + 1;
                  let testingId = response?.ListOfTest_Id?.filter(
                    (f) => f.id == id && f.id_test == id_test
                  )[0]?.TestingIDEncrypt;
                  t?.TestingDetails?.ListTestingResultImages?.map((z) => {
                    formData.append(
                      `ListOfTestResultImages[${tImgIdx}].TestingIDEncrypted`,
                      testingId
                    );
                    formData.append(
                      `ListOfTestResultImages[${tImgIdx}].TestingResultImageIDEncrypted`,
                      z.TestingResultImageIDEncrypted
                    );
                    formData.append(
                      `ListOfTestResultImages[${tImgIdx}].ResultImageFile`,
                      z.TestingResultImageFile
                    );
                    formData.append(
                      `ListOfTestResultImages[${tImgIdx}].ResultImagePath`,
                      z.ResultImagePath
                    );
                    formData.append(
                      `ListOfTestResultImages[${tImgIdx}].IsDeleted`,
                      z.IsDeleted
                    );
                    formData.append(
                      `ListOfTestResultImages[${tImgIdx}].Remarks`,
                      z.Remarks
                    );
                    tImgIdx = tImgIdx + 1;
                  });
                });
              })
            );
            setIsLoading(true);
            postFormData(POST_SamplePreparationAndTestingFilesSave, formData)
              .then((res) => {
                if (res?.IsSuccess) {
                  successMessage(response?.Message); //show success message from main api response
                  setTimeout(() => {
                    navigate(-1);
                  }, 1000);
                  setIsLoading(false);
                  setSubmitting(false);
                } else {
                  errorMessage(
                    "Record Save but files/images not save: ",
                    res?.Message
                  );
                  setIsLoading(false);
                  setSubmitting(false);
                }
              })
              .catch((error) => {
                console.log(error);
                setIsLoading(false);
                setSubmitting(false);
              });
          } else {
            successMessage(response?.Message);
            setTimeout(() => {
              navigate(-1);
            }, 1000);
            setIsLoading(false);
            setSubmitting(false);
          }
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
          setSubmitting(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        setSubmitting(false);
      });
  };

  useEffect(() => {
    if (!InwardDate) {
      formik.setFieldValue("InwardDate", "");
    }
    if (InwardCurrentStatus == 1) {
      getInwardNoDDL();
    }
    getTCNoDDL();
    getDepartmentDDL();
  }, [InwardDate]);

  useEffect(() => {
    if (CustomerIDEncrypted) {
      //formik.setFieldValue("CustomerProjectIDEncrypted", "");
      getProjectDDL(CustomerIDEncrypted);
      getInwardNoClubingDDLList(CustomerIDEncrypted);
    } else {
      setProjectOptions([]);
      formik.setFieldValue("CustomerProjectIDEncrypted", "");
      formik.setFieldValue("CustomerProjectName", "");
    }
    if (CustomerIDEncrypted && CustomerProjectIDEncrypted) {
      //formik.setFieldValue("StampWriteUpIDEncrypted", "");
      //formik.setFieldValue("ReferenceByIDEncrypted", "");
      getStampWriteUpDDL();
      getProjectWorkDetailList();
    } else {
      setStampWriteUpOptions([]);
      formik.setFieldValue("StampWriteUpIDEncrypted", "");
      formik.setFieldValue("ReferenceByIDEncrypted", "");
      formikWorkDetail.setFieldValue("projectWorkDetailList", []);
    }
  }, [CustomerIDEncrypted]);

  useEffect(() => {
    if (CustomerIDEncrypted && CustomerProjectIDEncrypted) {
      //formik.setFieldValue("StampWriteUpIDEncrypted", "");
      //formik.setFieldValue("ReferenceByIDEncrypted", "");
      getStampWriteUpDDL();
      getProjectWorkDetailList();

      if (!PrimaryIdParam && !CopyInwardIdParam && !editHeaderInwardIdParam) {
        /*Only in add b'coz edit mode it's effect the other fields */
        /*Set Inward selected Customer & Project to Mode Details List*/
        ListOfModeDetails?.map((item, index) => {
          //if (!item.CustomerIDEncrypted) {
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerIDEncrypted`,
            CustomerIDEncrypted
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerName`,
            CustomerName
          );
          //}
          //if (!item.CustomerProjectIDEncrypted) {
          formik.setFieldValue(
            `ListOfModeDetails[${index}].projectOptions`,
            projectOptions
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerProjectIDEncrypted`,
            CustomerProjectIDEncrypted
          );
          getProjectAddressDDL(
            CustomerIDEncrypted,
            CustomerProjectIDEncrypted,
            index
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerProjectAddressIDEncrypted`,
            ""
          );
          getContactPersonDDL(
            CustomerIDEncrypted,
            CustomerProjectIDEncrypted,
            index
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerContactPersonIDEncrypted`,
            ""
          );
          //}
        });
      }
    } else {
      setStampWriteUpOptions([]);
      formik.setFieldValue("StampWriteUpIDEncrypted", "");
      formik.setFieldValue("ReferenceByIDEncrypted", "");
      formikWorkDetail.setFieldValue("projectWorkDetailList", []);

      if (!PrimaryIdParam) {
        /*Only in add b'coz edit mode it's effect the other fields */
        /*Set Inward selected Customer & Project to Mode Details List*/
        ListOfModeDetails?.map((item, index) => {
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerIDEncrypted`,
            ""
          );
          formik.setFieldValue(`ListOfModeDetails[${index}].CustomerName`, "");
          formik.setFieldValue(
            `ListOfModeDetails[${index}].projectOptions`,
            []
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerProjectIDEncrypted`,
            ""
          );
          getProjectAddressDDL("", "", index);
          getContactPersonDDL("", "", index);
        });
      }
    }
  }, [CustomerProjectIDEncrypted]);

  const getSamplePreparationAndTestingDetailByID = async (inwardID) => {
    setIsLoading(true);
    await post(POST_GetSamplePreparationAndTestingDetail, {
      InwardIDEncrypted: inwardID,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setIsLoading(true);
          formik.setValues({
            ...response,
            InwardIDEncrypt: response?.InwardIDEncrypted,
            InwardDate: response?.InwardDate
              ? new Date(response?.InwardDate)
              : "",
            ExpectedDateOfDelivery: response?.ExpectedDateOfDelivery
              ? new Date(response?.ExpectedDateOfDelivery)
              : "",
            ListOfLetterRefDoc: response?.ListOfLetterRefDoc?.map((x) => {
              return {
                ...x,
                LetterRefImageFile: "",
                viewFile: "",
                LetterRefImageFileName: x?.LetterRefImageFileName,
                IsDeleted: false,
              };
            }),
            ListOfTPIDetails: response?.ListOfTPIDetails?.map((x) => {
              return {
                ...x,
                TPIExpectedDate: x?.TPIExpectedDate
                  ? new Date(x?.TPIExpectedDate)
                  : "",
                displayTPIExpectedDate: x?.TPIExpectedDate,
                IsDeleted: false,
              };
            }),
            ListOfMaterials: response?.ListOfMaterials?.map((x, i) => {
              return {
                ...x,
                TCNoAllocated: x?.TCNo ? true : false,
                id: i + 1,
                ListOfMaterialPhotos: x.ListOfMaterialPhotos?.map((y, j) => {
                  return {
                    ...y,
                    id: i + 1,
                    viewFile: "",
                    MaterialPhotoFile: "",
                    IsDeleted: false,
                  };
                }),
                ListOfMaterialTestDetails:
                  x?.ListOfTests?.length > 0
                    ? x?.ListOfTests?.map((t) => {
                        /*----------------------List of Para Set----------------------*/
                        /* Below code comment b'coz at the time of testing button press set the details */
                        // let ResultValueList = [];
                        // if (t?.TestingDetails?.TestingStatus == 1) {
                        //   if (t?.TestCount > 0) {
                        //     for (
                        //       let indexQ = 0;
                        //       indexQ < t?.TestingQty;
                        //       indexQ++
                        //     ) {
                        //       ResultValueList.push({
                        //         TestingResultIDEncrypted: "",
                        //         TestingCount: indexQ + 1,
                        //         TestingCountHeader:
                        //           "Sample:" +
                        //           (indexQ + 1 > 9
                        //             ? indexQ + 1
                        //             : "0" + (indexQ + 1)),
                        //         ResultValue: "",
                        //         ConsiderNABLResult: -1,
                        //         ConsiderResult: -1,
                        //       });
                        //     }
                        //   } else {
                        //     ResultValueList = [
                        //       {
                        //         TestingResultIDEncrypted: "",
                        //         TestingCount: 1,
                        //         TestingCountHeader: "",
                        //         ResultValue: "",
                        //         ConsiderNABLResult: -1,
                        //         ConsiderResult: -1,
                        //       },
                        //     ];
                        //   }
                        // }

                        // let selectedParaCount =
                        //   t?.TestingDetails?.ListOfParameter?.filter(
                        //     (xP) => xP.IsSelected == true
                        //   )?.length;

                        // let newListOfParameter =
                        //   t?.TestingDetails?.ListOfParameter?.map(
                        //     (tPara, indexTP) => ({
                        //       ...tPara,
                        //       IsSelected:
                        //         selectedParaCount > 0
                        //           ? tPara?.IsSelected
                        //           : true, //by default selected if there is no parameters selected (this is for Old records before parameter selection development)
                        //       Sequence: indexTP + 1,
                        //       TestMasterParameterIDEncrypted:
                        //         tPara?.TestMasterParameterIDEncrypted,
                        //       ParameterIDEncrypted: tPara?.ParameterIDEncrypted,
                        //       DisplayCode: tPara?.DisplayCode,
                        //       ParameterName: tPara?.ParameterName,
                        //       ParameterType: tPara?.ParameterType,
                        //       IsNABLParameter: tPara?.IsNABLParameter,
                        //       RangeValue: tPara?.RangeValue,
                        //       MinValue: tPara?.MinValue
                        //         ? tPara?.MinValue
                        //         : tPara?.ListOfRange?.length == 1
                        //         ? tPara?.ListOfRange[0]?.MinValue
                        //         : "",
                        //       MaxValue: tPara?.MaxValue
                        //         ? tPara?.MaxValue
                        //         : tPara?.ListOfRange?.length == 1
                        //         ? tPara?.ListOfRange[0]?.MaxValue
                        //         : "",
                        //       //Requirement: x?.Requirement,
                        //       Requirement:
                        //         response?.TestingStatus != 1
                        //           ? tPara?.Requirement
                        //           : tPara?.ListOfRange?.length == 1
                        //           ? tPara?.ListOfRange[0]?.Requirement
                        //           : tPara?.Requirement,

                        //       TestMethodIDEncrypt: tPara?.TestMethodIDEncrypted
                        //         ? tPara?.ListOfParameterTestMethod?.filter(
                        //             (method) =>
                        //               method.TestMethodIDEncrypted ==
                        //               tPara?.TestMethodIDEncrypted
                        //           )?.length == 0
                        //           ? ""
                        //           : tPara?.TestMethodIDEncrypted
                        //         : "",
                        //       testMethodOptions:
                        //         tPara?.ListOfParameterTestMethod?.map(
                        //           (method) => ({
                        //             ...method,
                        //             label: method.NickName
                        //               ? `${method.TestMethod} (${method.NickName})`
                        //               : method.TestMethod,
                        //             value: method?.TestMethodIDEncrypted,
                        //           })
                        //         ),

                        //       NABLRangeFrom: tPara?.NABLRangeFrom
                        //         ? tPara?.ListOfParameterTestMethod?.filter(
                        //             (method) =>
                        //               method.TestMethodIDEncrypted ==
                        //               tPara?.TestMethodIDEncrypted
                        //           )?.length == 0
                        //           ? ""
                        //           : tPara?.NABLRangeFrom
                        //         : "",
                        //       NABLRangeTo: tPara?.NABLRangeTo
                        //         ? tPara?.ListOfParameterTestMethod?.filter(
                        //             (method) =>
                        //               method.TestMethodIDEncrypted ==
                        //               tPara?.TestMethodIDEncrypted
                        //           )?.length == 0
                        //           ? ""
                        //           : tPara?.NABLRangeTo
                        //         : "",

                        //       rangeOptions: tPara?.ListOfRange?.filter(
                        //         (xR) => xR.RangeValue != ""
                        //       )?.map((range) => ({
                        //         label: range?.RangeValue,
                        //         value: range?.RangeValue,
                        //         MinValue: range?.MinValue,
                        //         MaxValue: range?.MaxValue,
                        //         Requirement: range?.Requirement,
                        //         DefaultValue: range?.DefaultValue,
                        //       })),

                        //       ListOfResultValue:
                        //         //  response?.IsReTestTesting
                        //         //   ? x?.ListOfResultValue?.map((result, indexR) => ({
                        //         //       TestingResultIDEncrypted:
                        //         //         result?.TestingResultIDEncrypted,
                        //         //       TestingCount: result?.TestingCount,
                        //         //       TestingCountHeader:
                        //         //         result?.TestingCountHeader,
                        //         //       ResultValue: result?.ResultValue,
                        //         //       ConsiderNABLResult:
                        //         //         result?.ConsiderNABLResult,
                        //         //       ConsiderResult: result?.ConsiderResult,
                        //         //     }))
                        //         //   :
                        //         response?.TestingStatus != 1
                        //           ? tPara?.ListOfResultValue?.map(
                        //               (result, indexR) => ({
                        //                 TestingResultIDEncrypted:
                        //                   result?.TestingResultIDEncrypted,
                        //                 TestingCount: result?.TestingCount,
                        //                 TestingCountHeader:
                        //                   result?.TestingCountHeader
                        //                     ? result?.TestingCountHeader
                        //                     : "Sample:" +
                        //                       (indexR + 1 > 9
                        //                         ? indexR + 1
                        //                         : "0" + (indexR + 1)),
                        //                 ResultValue: result?.ResultValue,
                        //                 ConsiderNABLResult:
                        //                   result?.ConsiderNABLResult,
                        //                 ConsiderResult: result?.ConsiderResult,
                        //               })
                        //             )
                        //           : ResultValueList?.map((r) => ({
                        //               ...r,
                        //               //ResultValue: tPara?.ResultValue,
                        //               ResultValue:
                        //                 tPara?.ListOfRange?.length == 1
                        //                   ? tPara?.ListOfRange[0]?.DefaultValue
                        //                   : tPara?.ResultValue,
                        //             })),

                        //       ShortCode: tPara?.ShortCode,
                        //       FormulaExpression: tPara?.FormulaExpression,
                        //       FormulaVariables: tPara?.FormulaVariables,
                        //       FormulaEvaluationStatus:
                        //         tPara?.FormulaEvaluationStatus,
                        //       IsAverageRequired: tPara?.IsAverageRequired,
                        //       AverageResultValue: tPara?.AverageResultValue,
                        //       ParameterResultType: tPara?.ParameterResultType,
                        //     })
                        //   );

                        // //Reorder - Sequence, if All parameters are not selected
                        // if (
                        //   selectedParaCount > 0 &&
                        //   t?.TestingDetails?.ListOfParameter?.filter(
                        //     (xTLP) => xTLP.IsSelected == false
                        //   )?.length > 0
                        // ) {
                        //   let newList = [];
                        //   Promise.all(
                        //     newListOfParameter
                        //       ?.filter((para) => para?.IsSelected == true)
                        //       ?.map((xNP, idxNP) => {
                        //         newList.push({
                        //           ...xNP,
                        //           Sequence: idxNP + 1,
                        //         });
                        //       })
                        //   );
                        //   newList = [
                        //     ...newList,
                        //     ...newListOfParameter?.filter(
                        //       (para) => para?.IsSelected == false
                        //     ),
                        //   ];

                        //   newListOfParameter = newList;
                        // }
                        /*----------------------List of Para Set----------------------*/

                        return {
                          ...t,
                          // productGroupOptions: [], //get the options through api
                          // materialTypeOptions: [], //get the options through api
                          // testOptions: [], //get the options through api
                          // testMethodOptions: [], //get the options through api
                          // referenceStandardOptions: [], //get the options through api
                          productGroupOptions: t?.ProductGroupDDLOptions?.map(
                            (opt) => ({
                              label: opt?.ProductGroupName,
                              value: opt?.ProductGroupIDEncrypted,
                            })
                          ),
                          materialTypeOptions: t?.MaterialTypeDDLOptions?.map(
                            (opt) => ({
                              label: opt.MaterialTypeName,
                              value: opt.MaterialTypeIDEncrypted,
                            })
                          ),
                          testOptions: t?.TestMasterDDLOptions?.map((opt) => ({
                            label: opt?.TestName,
                            value: opt?.TestMasterIDEncrypted,
                            IsMixDesign: opt?.IsMixDesign,
                          })),
                          testMethodOptions: [],
                          referenceStandardOptions:
                            t?.ReferenceStandardDDLOptions?.map((opt) => ({
                              label: opt?.ReferenceStandard,
                              value: opt?.ReferenceStandardIDEncrypted,
                              IsExpiredReferenceStandard:
                                opt?.IsExpiredReferenceStandard,
                            })),
                          refStandardSubGroupOptions:
                            t?.RefStandardSubGroupOptions?.map((opt) => ({
                              label: opt?.SubGroup,
                              value: opt?.SubGroup,
                            })),
                          IsDeleted: false,
                          ListOfTestParameters:
                            t?.ListOfTestParameters?.filter(
                              (x) => x.IsSelected == true
                            )?.length > 0
                              ? t?.ListOfTestParameters
                              : t?.ListOfTestParameters?.map((para) => ({
                                  ...para,
                                  IsSelected: true,
                                })),
                          ListOfDefineMoreRates:
                            t?.ListOfDefineMoreRates?.filter(
                              (x) => x.IsSelected == true
                            )?.length > 0
                              ? t?.ListOfDefineMoreRates
                              : t?.ListOfDefineMoreRates?.map((para) => ({
                                  ...para,
                                  IsSelected: para.IsSelected,
                                })),
                          TestingDetails: {
                            ...t?.TestingDetails,
                            TestingDate: t?.TestingDetails?.TestingDate
                              ? new Date(t?.TestingDetails?.TestingDate)
                              : new Date(),
                            TestingToDate: t?.TestingDetails?.TestingToDate
                              ? new Date(t?.TestingDetails?.TestingToDate)
                              : new Date(),
                            IsMergeSameValue: t?.TestingDetails?.MergeSameValue,
                            ListOfTPIDetails: t?.TestingDetails?.TPIList?.map(
                              (x) => {
                                return {
                                  ...x,
                                  TPIIDEncrypted: x?.TPIIDEncrypt,
                                  TPIContactPersonIDEncrypted:
                                    x?.TPIContactPersonIDEncrypt,
                                  TPIExpectedDate: x?.TPIExpectedDate
                                    ? new Date(x?.TPIExpectedDate)
                                    : "",
                                  displayTPIExpectedDate: x?.TPIExpectedDate,
                                  IsDeleted: false,
                                };
                              }
                            ),
                            ListTestingResultImages:
                              t?.TestingDetails?.ListOfTestResultImages?.map(
                                (item) => ({
                                  ...item,
                                  TestingResultImageFile: "",
                                  viewFile: "",
                                  IsDeleted: false,
                                })
                              ),
                            ListTestMasterImages:
                              t?.TestingDetails?.ListOfTestImage?.map(
                                (item) => ({
                                  ...item,
                                })
                              ),
                            ListTestingBy:
                              t?.TestingDetails?.TestingByList?.map((item) => ({
                                EmployeeIDEncrypt: item.EmployeeIDEncrypted,
                                EmployeeName: item.EmployeeName,
                                IsSelected: item.IsSelected,
                                display: true,
                              })),
                            // ListOfParameter: newListOfParameter,
                            TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData:
                              t?.IsMixDesign == true
                                ? {
                                    ...t?.TestingDetails
                                      ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData,
                                  }
                                : {},
                            ListOfMixDesignTargetStrengthForMixProportioning:
                              t?.IsMixDesign == true
                                ? t?.TestingDetails
                                    ?.ListOfMixDesignTargetStrengthForMixProportioning
                                : [],
                            ListOfMixDesignGroupParameters:
                              t?.IsMixDesign == true
                                ? t?.TestingDetails
                                    ?.ListOfMixDesignGroupParameters
                                : [],
                            ListOfMixDesignMixCalculation:
                              t?.IsMixDesign == true
                                ? t?.TestingDetails
                                    ?.ListOfMixDesignMixCalculation
                                : [],
                            ListOfMixDesignMixProportionsForTrial:
                              t?.IsMixDesign == true
                                ? t?.TestingDetails
                                    ?.ListOfMixDesignMixProportionsForTrial
                                : [],
                            IsReTestTesting: false,
                          },
                        };
                      })
                    : response?.InwardCurrentStatus == 2
                    ? [initMaterialTestDetail]
                    : [],
                IsDeleted: false,
                IsErrorDisplay: false,
                IsHeaderDetailMaterialInformationChange: false,
                ListOfProcessThicknessDetailsFinal:
                  x.ListOfMachiningDetails?.map((t) => {
                    return {
                      ...t,
                      IsDeleted: false,
                    };
                  }),
                IsHold: false,
              };
            }),
            ListOfModeDetails: response?.ListOfModeDetails?.map((x) => {
              return {
                ...x,
                projectOptions: [], //get the options through api
                projectAddressOptions: [], //get the options through api
                contactPersonOptions: [], //get the options through api
              };
            }),
            selectedMaterialInfoRow: -1,
            btnSubmitType: 1, // 1 = Draft, 2 = Submit
            IsStampImageFileDeleted: false,
            IsEditMaterialInwardHeaderDetail: editHeaderInwardIdParam
              ? true
              : false,
            IsHeaderDetailCustomerChange: false,
            originalCustomerID: response?.CustomerIDEncrypted,
            originalCustomerName: response?.CustomerName,
            IsHeaderDetailProjectChange: false,
            originalProjectID: response?.CustomerProjectIDEncrypted,
            originalProjectName: response?.CustomerProjectName,
            IsHeaderDetailWorkDetailChange: false,
            originalWorkDetail: response?.ProjectDetails,
            IsHeaderDetailLetterRefNoChange: false,
            originalLetterRefNo: response?.LetterRefNo,
            /*Header Detail Change option is not enable right now so no need to do below efforts*/
            // originalListOfMaterials: response?.ListOfMaterials?.map((x, i) => {
            //   return {
            //     ...x,
            //     TCNoAllocated: x?.TCNo ? true : false,
            //     id: i + 1,
            //     ListOfMaterialPhotos: x.ListOfMaterialPhotos?.map((y, j) => {
            //       return {
            //         ...y,
            //         id: i + 1,
            //         viewFile: "",
            //         MaterialPhotoFile: "",
            //         IsDeleted: false,
            //       };
            //     }),
            //     IsDeleted: false,
            //     IsErrorDisplay: false,
            //     IsHeaderDetailMaterialInformationChange: false,
            //   };
            // }),
            ChangeReason: "",
            InwardClubing: response?.IsInwardNoClubing,
            InwardIDsClubing: response?.ListOfInwardNoClubing?.map((item) => ({
              label: item.InwardNo,
              value: item.MainInwardIDEncrypted,
            })),
          });

          if (response?.StampImageFilePath) {
            setStampImage(response?.StampImageFilePath);
          }
          /* getInwardNoDDL does not need to call as it's call on InwardDate change */
          // if (response?.InwardCurrentStatus == 1) {
          //   getInwardNoDDL();
          // }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCopyInwardDetails = async () => {
    setIsLoading(true);
    await post(POST_GetSamplePreparationAndTestingDetail, {
      InwardIDEncrypted: window.atob(CopyInwardIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "CustomerIDEncrypted",
            response?.CustomerIDEncrypted
          );
          formik.setFieldValue("CustomerName", response?.CustomerName);
          formik.setFieldValue(
            "CustomerProjectIDEncrypted",
            response?.CustomerProjectIDEncrypted
          );
          formik.setFieldValue(
            "CustomerProjectName",
            response?.CustomerProjectName
          );
          formik.setFieldValue(
            "ListOfMaterials",
            response?.ListOfMaterials?.map((x, i) => {
              return {
                ...x,
                TCNo: "",
                ULRNo: "",
                TCNoAllocated: false,
                id: i + 1,
                // ListOfMaterialPhotos: x.ListOfMaterialPhotos?.map((y, j) => {
                //   return {
                //     ...y,
                //     id: i + 1,
                //     viewFile: "",
                //     MaterialPhotoFile: "",
                //     IsDeleted: false,
                //   };
                // }),
                ListOfMaterialPhotos: [],
                // // productGroupOptions: [], //get the options through api
                // materialTypeOptions: [], //get the options through api
                IsDeleted: false,
                IsErrorDisplay: false,
                IsHeaderDetailMaterialInformationChange: false,
              };
            })
          );
          formik.setFieldValue(
            "ListOfModeDetails",
            response?.ListOfModeDetails?.map((x) => {
              return {
                ...x,
                projectOptions: [], //get the options through api
                projectAddressOptions: [], //get the options through api
                contactPersonOptions: [], //get the options through api
              };
            })
          );
          response?.ListOfModeDetails?.map((item, index) => {
            getProjectDDLModeDetails(item.CustomerIDEncrypted ?? "", index);
            getProjectAddressDDL(
              item.CustomerIDEncrypted,
              item.CustomerProjectIDEncrypted,
              index
            );
            getContactPersonDDL(
              item.CustomerIDEncrypted,
              item.CustomerProjectIDEncrypted,
              index
            );
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    getTPICustomerDDL();

    // getModeByDDL();
    getEmployeeDDL();
    getSampleReceivedViaDDL();
    // getCustomerReviewList();
    // getDispatchMaterialModeDDL();
    getReferredByDDL();
    getProcessNameDDL();

    getUnitDDL();
    getTestingRemarksList();

    if (PrimaryIdParam) {
      getSamplePreparationAndTestingDetailByID(window.atob(PrimaryIdParam));
    } else if (ViewPrimaryIdParam) {
      getSamplePreparationAndTestingDetailByID(window.atob(ViewPrimaryIdParam));
    } else if (editHeaderInwardIdParam) {
      getSamplePreparationAndTestingDetailByID(
        window.atob(editHeaderInwardIdParam)
      );
    } else {
      //getInwardNoDDL();
      setIsLoading(false);
    }

    if (CopyInwardIdParam) {
      getCopyInwardDetails();
    }
  }, []);

  const uploadStampImage = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        setStampImageFile(null);
        setStampImage(null);
        warningMessage("Select valid image file!");
      } else {
        setStampImageFile(file);
        setStampImage(URL.createObjectURL(file));
      }
      //formik.setFieldValue("StampImageFilePath", "");
    }
  };

  const uploadLetterRefDoc = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      //console.log(file);
      if (file) {
        formik.setFieldValue("ListOfLetterRefDoc", [
          ...ListOfLetterRefDoc,
          {
            InwardLetterRefImageIDEncrypted: "",
            LetterRefImageFile: file,
            viewFile: URL.createObjectURL(file),
            LetterRefImageFileName: file?.name,
            LetterRefImageFilePath: "",
            IsDeleted: false,
          },
        ]);

        //successMessage("Letter Ref Doc Uploaded...");
      }
    }
  };

  const validationSchemaTPIDetail = Yup.object().shape({
    TPIIDEncrypted: Yup.string().required("TPI is required field"),
    TPIContactPersonIDEncrypted: Yup.string().required(
      "TPI Contact Person is required field"
    ),
  });

  const formikTPIDetail = useFormik({
    validationSchema: validationSchemaTPIDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTPIDetail(values, formikHelpers),
    initialValues: {
      TPIIDEncrypted: "",
      TPIContactPersonIDEncrypted: "",
      TPIExpectedDate: "",
      TPIName: "",
      TPIContactPersonName: "",
      displayTPIExpectedDate: "",
      editIndexTPI: "",
      actionFlagTPI: 0, // 0 = Add,  1 = edit
      IsDeleted: false,
      isTPIForTesting: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { TPIIDEncrypted, actionFlagTPI },
  } = formikTPIDetail;

  useEffect(() => {
    if (TPIIDEncrypted) {
      //formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
      getTPIContactPersonDDL();
    } else {
      setTPIContactPersonOptions([]);
      formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
    }
  }, [TPIIDEncrypted]);

  const handleValidSubmitTPIDetail = (values) => {
    if (values?.isTPIForTesting == true) {
      //Testing TPI
      if (values?.editIndexTPI !== "") {
        //edit mode
        if (
          formikTesting?.values?.ListOfTPIDetails?.filter(
            (x, i) =>
              x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
              x?.TPIContactPersonIDEncrypted ==
                values?.TPIContactPersonIDEncrypted &&
              x?.IsDeleted == false &&
              i != values?.editIndexTPI
          )?.length > 0
        ) {
          warningMessage("TPI detail already exists!");
          return;
        } else {
          formikTesting.setFieldValue(
            "ListOfTPIDetails",
            formikTesting?.values?.ListOfTPIDetails?.map((x, idx) => {
              if (idx == values?.editIndexTPI) {
                return {
                  ...x,
                  TPIIDEncrypted: values?.TPIIDEncrypted,
                  TPIContactPersonIDEncrypted:
                    values?.TPIContactPersonIDEncrypted,
                  TPIExpectedDate: values?.TPIExpectedDate,
                  TPIName: values?.TPIName,
                  TPIContactPersonName: values?.TPIContactPersonName,
                  displayTPIExpectedDate: values?.TPIExpectedDate
                    ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
                    : "",
                };
              } else {
                return { ...x };
              }
            })
          );
        }
      } else {
        //add mode
        if (
          formikTesting?.values?.ListOfTPIDetails?.filter(
            (x) =>
              x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
              x?.TPIContactPersonIDEncrypted ==
                values?.TPIContactPersonIDEncrypted &&
              x?.IsDeleted == false
          )?.length > 0
        ) {
          warningMessage("TPI detail already exists!");
          return;
        } else {
          formikTesting.setFieldValue("ListOfTPIDetails", [
            ...formikTesting?.values?.ListOfTPIDetails,
            {
              ...values,
              displayTPIExpectedDate: values?.TPIExpectedDate
                ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
                : "",
            },
          ]);
        }
      }
    } else {
      //Inward TPI
      if (values?.editIndexTPI !== "") {
        if (
          ListOfTPIDetails?.filter(
            (x, i) =>
              x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
              x?.TPIContactPersonIDEncrypted ==
                values?.TPIContactPersonIDEncrypted &&
              x?.IsDeleted == false &&
              i != values?.editIndexTPI
          )?.length > 0
        ) {
          warningMessage("TPI detail already exists!");
          return;
        } else {
          formik.setFieldValue(
            "ListOfTPIDetails",
            ListOfTPIDetails?.map((x, idx) => {
              if (idx == values?.editIndexTPI) {
                return {
                  ...x,
                  TPIIDEncrypted: values?.TPIIDEncrypted,
                  TPIContactPersonIDEncrypted:
                    values?.TPIContactPersonIDEncrypted,
                  TPIExpectedDate: values?.TPIExpectedDate,
                  TPIName: values?.TPIName,
                  TPIContactPersonName: values?.TPIContactPersonName,
                  displayTPIExpectedDate: values?.TPIExpectedDate
                    ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
                    : "",
                };
              } else {
                return { ...x };
              }
            })
          );
        }
      } else {
        if (
          ListOfTPIDetails?.filter(
            (x) =>
              x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
              x?.TPIContactPersonIDEncrypted ==
                values?.TPIContactPersonIDEncrypted &&
              x?.IsDeleted == false
          )?.length > 0
        ) {
          warningMessage("TPI detail already exists!");
          return;
        } else {
          formik.setFieldValue("ListOfTPIDetails", [
            ...ListOfTPIDetails,
            {
              ...values,
              displayTPIExpectedDate: values?.TPIExpectedDate
                ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
                : "",
            },
          ]);
        }
      }
    }
    setShowAddTPIDetailModal(false);
  };

  const addNewTPI = (isForTesting) => {
    if (CustomerProjectIDEncrypted) {
      formikTPIDetail.resetForm();
      formikTPIDetail.setFieldValue("isTPIForTesting", isForTesting);
      /*select the value when there is only one option while insert only*/
      if (tpiCustomerOptions?.length == 1) {
        formikTPIDetail.setFieldValue(
          "TPIIDEncrypted",
          tpiCustomerOptions[0].value
        );
        formikTPIDetail.setFieldValue("TPIName", tpiCustomerOptions[0].label);
      }
      /*select the value when there is only one option while insert only*/
      if (tpiContactPersonOptions?.length == 1) {
        formikTPIDetail.setFieldValue(
          "TPIContactPersonIDEncrypted",
          tpiContactPersonOptions[0].value
        );
        formikTPIDetail.setFieldValue(
          "TPIContactPersonName",
          tpiContactPersonOptions[0].label
        );
      }
      setShowAddTPIDetailModal(true);
    } else {
      warningMessage("Please select Project first...");
    }
  };

  const editTPI = (i, isForTesting) => {
    let editData;
    if (isForTesting == true) {
      editData = formikTesting?.values?.ListOfTPIDetails[i];
    } else {
      editData = ListOfTPIDetails[i];
    }
    formikTPIDetail.setFieldValue("isTPIForTesting", isForTesting);
    formikTPIDetail.setValues({ ...editData, editIndexTPI: i });
    formikTPIDetail.setFieldValue("actionFlagTPI", 1); // 1 = edit
    setShowAddTPIDetailModal(true);
  };

  const deleteTPI = (i, isForTesting) => {
    if (isForTesting == true) {
      if (
        formikTesting?.values?.ListOfTPIDetails[i]?.InwardTPIDetailIDEncrypted
      ) {
        formikTesting.setFieldValue(`ListOfTPIDetails[${i}].IsDeleted`, true);
      } else {
        formikTesting.setFieldValue(
          "ListOfTPIDetails",
          ListOfTPIDetails?.filter((x, ix) => ix != i)
        );
      }
    } else {
      if (ListOfTPIDetails[i]?.InwardTPIDetailIDEncrypted) {
        formik.setFieldValue(`ListOfTPIDetails[${i}].IsDeleted`, true);
      } else {
        formik.setFieldValue(
          "ListOfTPIDetails",
          ListOfTPIDetails?.filter((x, ix) => ix != i)
        );
      }
    }
  };

  const AddNewMaterialInformation = () => {
    formik.setFieldValue("ListOfMaterials", [
      ...ListOfMaterials,
      initMaterialInformation,
    ]);
  };

  const deleteMaterialInformation = (i) => {
    if (ListOfMaterials[i]?.InwardMaterialIDEncrypted) {
      formik.setFieldValue(`ListOfMaterials[${i}].IsDeleted`, true);
      formik.setFieldValue(
        `ListOfMaterials[${i}].ListOfMaterialPhotos`,
        ListOfMaterials[i]?.ListOfMaterialPhotos?.map((x) => {
          return { ...x, IsDeleted: true };
        })
      );
    } else {
      formik.setFieldValue(
        "ListOfMaterials",
        ListOfMaterials?.filter((x, idx) => idx != i)
      );
    }
  };

  const validationMaterialInfoRepeatRow = Yup.object().shape({
    NoOfRepeatMaterialInfoRow: Yup.number()
      .min(1, "No of Repeat Row is required field")
      .required("No of Repeat Row is required field"),
  });

  const formikMaterialInfoRepeatRow = useFormik({
    validationSchema: validationMaterialInfoRepeatRow,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitMaterialInfoRepeatRow(values, formikHelpers),
    initialValues: {
      NoOfRepeatMaterialInfoRow: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikMaterialInfoRepeatRow;

  const handleValidSubmitMaterialInfoRepeatRow = (values) => {
    setIsLoading(true);
    setTimeout(() => {
      let selectedRow = ListOfMaterials[selectedMaterialInfoRow];
      let newListOfMaterials = ListOfMaterials;
      for (let i = 0; i < values?.NoOfRepeatMaterialInfoRow; i++) {
        newListOfMaterials = [
          ...newListOfMaterials,
          {
            ...selectedRow,
            id: "",
            TCNo: "",
            TCNoAllocated: false,
            InwardMaterialIDEncrypted: "",
            ULRNo: "",
            ListOfMaterialPhotos: [],
            ListOfMaterialTestDetails:
              selectedRow?.ListOfMaterialTestDetails?.map((x) => {
                return {
                  ...x,
                  InwardMaterialTestDetailIDEncrypted: "",
                  ListOfTestParameters: x?.ListOfTestParameters?.map((y) => {
                    return { ...y, InwardMaterialTestDetailIDEncrypted: "" };
                  }),
                  TestMixDesignDetail: {
                    ...x?.TestMixDesignDetail,
                    StipulationsProportioningIDEncrypted: "",
                  },
                  TestingDetails: {
                    ...x?.TestingDetails,
                    TestingIDEncrypted: "",
                    TestingStatus: 1,
                    ListTestingResultImages: [],
                  },
                };
              }) ?? [],
            ListOfProcessThicknessDetailsFinal:
              selectedRow?.ListOfProcessThicknessDetailsFinal?.map((x) => {
                return {
                  ...x,
                  InwardMachiningDetailIDEncrypted: "",
                  InwardMaterialIDEncrypted: "",
                };
              }) ?? [],
          },
        ];
      }
      formik.setFieldValue("ListOfMaterials", newListOfMaterials);
      setShowMaterialInfoRepeatRowQtyModal(false);
      setIsLoading(false);
    }, 300);
  };

  const [materialPhoto, setMaterialPhoto] = useState(null);
  const [materialPhotoFile, setMaterialPhotoFile] = useState(null);

  const [fileKeyMaterialPhoto, setFileKeyMaterialPhoto] = useState();

  const [zoomMaterialPhoto, setZoomMaterialPhoto] = useState(0.5);

  const [openCropperModalMaterialPhoto, setOpenCropperModalMaterialPhoto] =
    useState(false);
  const [openWebCamModalMaterialImage, setOpenWebCamModalMaterialImage] =
    useState(false);
  const [imageMaterialPhoto, setImageMaterialPhoto] = useState();
  const [cropperMaterialPhoto, setCropperMaterialPhoto] = useState();

  const getCropDataMaterialPhoto = () => {
    if (typeof cropperMaterialPhoto !== "undefined") {
      handleUploadMaterialPhoto(
        cropperMaterialPhoto.getCroppedCanvas().toDataURL()
      );
      setMaterialPhoto(cropperMaterialPhoto.getCroppedCanvas().toDataURL());
    }
  };

  const handleUploadMaterialPhoto = async (url) => {
    const outputFileMaterialPhoto = await dataUrlToFileUsingFetch(
      url,
      "output.png",
      "image/png"
    );
    //const file = dataUrlToFile(url, "output.png");
    setMaterialPhotoFile(outputFileMaterialPhoto);
  };

  const uploadMaterialPhoto = (event) => {
    if (event.target.files.length === 1) {
      var pattern = /image-*/;
      if (event.target.files[0].type.match(pattern)) {
        event.preventDefault();
        let files;
        if (event.dataTransfer) {
          files = event.dataTransfer.files;
        } else if (event.target) {
          files = event.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
          setImageMaterialPhoto(reader.result);
        };
        reader.readAsDataURL(files[0]);
        setOpenCropperModalMaterialPhoto(true);
      } else {
        setMaterialPhotoFile(null);
        setMaterialPhoto(null);
        warningMessage("Select valid image file!");
      }
    }
  };

  const capturePhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc !== null) {
      setMaterialPhoto(imageSrc);
      const outputFileMaterialPhotoCapture = await dataUrlToFileUsingFetch(
        imageSrc,
        "output.png",
        "image/png"
      );
      setMaterialPhotoFile(outputFileMaterialPhotoCapture);
    } else {
      warningMessage("Webcam device not found.");
    }
    setOpenWebCamModalMaterialImage(false);
  }, [webcamRef]);

  const onUserMedia = (e) => {
    console.log(e);
  };

  const addMaterialImage = () => {
    //console.log(ListOfMaterials[selectedMaterialInfoRow]);
    formik.setFieldValue(
      `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos`,
      [
        ...ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos,
        {
          id: "",
          InwardMaterialPhotoIDEncrypted: "",
          viewFile: URL.createObjectURL(materialPhotoFile),
          MaterialPhotoFile: materialPhotoFile,
          MaterialPhotoFilePath: "",
          IsDeleted: false,
        },
      ]
    );
    setMaterialPhoto(null);
    setMaterialPhotoFile(null);
  };

  const deleteMaterialImage = (i) => {
    if (
      ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos[i]
        ?.InwardMaterialPhotoIDEncrypted
    ) {
      formik.setFieldValue(
        `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos[${i}].IsDeleted`,
        true
      );
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos`,
        ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos?.filter(
          (x, idx) => idx != i
        )
      );
    }
  };

  const formikWorkDetail = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitWorkDetail(values, formikHelpers),
    initialValues: {
      projectWorkDetailList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { projectWorkDetailList },
  } = formikWorkDetail;

  const handleValidSubmitWorkDetail = (values) => {
    formik.setFieldValue(
      "ProjectDetails",
      values?.projectWorkDetailList
        ?.filter((x) => x.IsSelected == true)
        ?.map((wd) => {
          return wd.WorkDetail;
        })
        .join(" ")
    );
    setShowWorkDetailModal(false);
  };

  const [refreshCustomerKey, setRefreshCustomerKey] = useState("0");

  const loadOptionsCutomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const deleteLetterRefDoc = (i) => {
    if (ListOfLetterRefDoc[i]?.InwardLetterRefImageIDEncrypted) {
      formik.setFieldValue(`ListOfLetterRefDoc[${i}].IsDeleted`, true);
    } else {
      formik.setFieldValue(
        "ListOfLetterRefDoc",
        ListOfLetterRefDoc?.filter((x, ix) => ix != i)
      );
    }
  };

  const ValidateCustomerCredit = async (customerId) => {
    setIsLoading(true);
    await post(POST_ValidateCustomerCredit, {
      CustomerIDEncrypt: customerId,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess == false) {
          customConfirmDialog(
            response?.Message,
            "Do you want to create more Inwards?",
            fnCallbackValidateCustomerCredit,
            false
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallbackValidateCustomerCredit = () => {
    navigate(-1);
  };

  const [letterRefDocPhoto, setLetterRefDocPhoto] = useState(null);
  const [letterRefDocPhotoFile, setLetterRefDocPhotoFile] = useState(null);
  const [
    openWebCamModalLetterRefDocImage,
    setOpenWebCamModalLetterRefDocImage,
  ] = useState(false);

  const [letterRefDocPhotoFileName, setLetterRefDocPhotoFileName] = useState();

  const addLetterRefDocFile = () => {
    formik.setFieldValue("ListOfLetterRefDoc", [
      ...ListOfLetterRefDoc,
      {
        InwardLetterRefImageIDEncrypted: "",
        LetterRefImageFile: letterRefDocPhotoFile,
        viewFile: URL.createObjectURL(letterRefDocPhotoFile),
        LetterRefImageFileName: letterRefDocPhotoFileName,
        LetterRefImageFilePath: "",
        IsDeleted: false,
      },
    ]);

    setLetterRefDocPhoto(null);
    setLetterRefDocPhotoFile(null);
  };

  const captureLetterRefDocPhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc !== null) {
      setLetterRefDocPhoto(imageSrc);
      const outputFileLetterRefDocPhotoCapture = await dataUrlToFileUsingFetch(
        imageSrc,
        "output.png",
        "image/png"
      );
      setLetterRefDocPhotoFile(outputFileLetterRefDocPhotoCapture);
      const fileName = outputFileLetterRefDocPhotoCapture.name;
      setLetterRefDocPhotoFileName(fileName);
    } else {
      warningMessage("Webcam device not found.");
    }
    setOpenWebCamModalLetterRefDocImage(false);
  }, [webcamRef]);

  const handleChangeHeaderDetailCustomerChange = (e) => {
    if (AllowToChangeCustomerAndProject == true) {
      customConfirmDialog(
        `Report Printing ${
          AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
        } transactions will be deleted if they exist.`,
        "Do you want to change Customer?",
        fnCallbackHandleChangeHeaderDetailCustomerChange,
        true
      );
    } else {
      warningMessage(
        "Once an accounting transaction, such as a proforma invoice or an invoice, has been created, it cannot be changed."
      );
    }
  };

  const fnCallbackHandleChangeHeaderDetailCustomerChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailCustomerChange",
      !formik?.values?.IsHeaderDetailCustomerChange
    );
  };

  const cancelHeaderDetailCustomerChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailCustomerChange",
      !formik?.values?.IsHeaderDetailCustomerChange
    );
    if (CustomerIDEncrypted !== formik?.values?.originalCustomerID) {
      formik.setFieldValue(
        "CustomerIDEncrypted",
        formik?.values?.originalCustomerID
      );
      formik.setFieldValue(
        "CustomerName",
        formik?.values?.originalCustomerName
      );
      getProjectDDL(formik?.values?.originalCustomerID);
      formik.setFieldValue(
        "CustomerProjectIDEncrypted",
        formik?.values?.originalProjectID
      );
      formik.setFieldValue(
        "CustomerProjectName",
        formik?.values?.originalProjectName
      );
    }
  };

  const handleChangeHeaderDetailProjectChange = (e) => {
    if (AllowToChangeCustomerAndProject == true) {
      customConfirmDialog(
        `Report Printing ${
          AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
        } transactions will be deleted if they exist.`,
        "Do you want to change Project?",
        fnCallbackHandleChangeHeaderDetailProjectChange,
        true
      );
    } else {
      warningMessage(
        "Once an accounting transaction, such as a proforma invoice or an invoice, has been created, it cannot be changed."
      );
    }
  };

  const fnCallbackHandleChangeHeaderDetailProjectChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailProjectChange",
      !formik?.values?.IsHeaderDetailProjectChange
    );
  };

  const cancelHeaderDetailProjectChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailProjectChange",
      !formik?.values?.IsHeaderDetailProjectChange
    );
    if (CustomerProjectIDEncrypted !== formik?.values?.originalProjectID) {
      formik.setFieldValue(
        "CustomerProjectIDEncrypted",
        formik?.values?.originalProjectID
      );
      formik.setFieldValue(
        "CustomerProjectName",
        formik?.values?.originalProjectName
      );
    }
  };

  const handleChangeHeaderDetailWorkDetailChange = (e) => {
    customConfirmDialog(
      `Report Printing ${
        AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
      } transactions will be deleted if they exist.`,
      "Do you want to change Work Detail?",
      fnCallbackHandleChangeHeaderDetailWorkDetailChange,
      true
    );
  };

  const fnCallbackHandleChangeHeaderDetailWorkDetailChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailWorkDetailChange",
      !formik?.values?.IsHeaderDetailWorkDetailChange
    );
  };

  const cancelHeaderDetailWorkDetailChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailWorkDetailChange",
      !formik?.values?.IsHeaderDetailWorkDetailChange
    );
    if (formik?.values?.ProjectDetails !== formik?.values?.originalWorkDetail) {
      formik.setFieldValue(
        "ProjectDetails",
        formik?.values?.originalWorkDetail
      );
    }
  };

  const handleChangeHeaderDetailLetterRefNoChange = (e) => {
    customConfirmDialog(
      `Report Printing ${
        AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
      } transactions will be deleted if they exist.`,
      "Do you want to change Letter Ref No?",
      fnCallbackHandleChangeHeaderDetailLetterRefNoChange,
      true
    );
  };

  const fnCallbackHandleChangeHeaderDetailLetterRefNoChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailLetterRefNoChange",
      !formik?.values?.IsHeaderDetailLetterRefNoChange
    );
  };

  const cancelHeaderDetailLetterRefNoChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailLetterRefNoChange",
      !formik?.values?.IsHeaderDetailLetterRefNoChange
    );
    if (formik?.values?.LetterRefNo !== formik?.values?.originalLetterRefNo) {
      formik.setFieldValue("LetterRefNo", formik?.values?.originalLetterRefNo);
    }
  };

  const handleChangeIsTPIRequired = (e) => {
    // if (
    //   editHeaderInwardIdParam &&
    //   !IsTPIRequired !== formik?.values?.originalIsTPIRequired
    // ) {
    //   customConfirmDialog(
    //     `Report Printing & Upload Scan Copy transactions will be deleted if they exist.`,
    //     "Do you want to change TPI Required?",
    //     fnCallbackHandleChangeHeaderDetailIsTPIRequiredChange,
    //     true
    //   );
    // } else {
    formik.setFieldValue("IsTPIRequired", !IsTPIRequired);
    //   formik.setFieldValue("IsHeaderDetailTPIRequiredChange", false);
    //   if (!IsTPIRequired == false) {
    //     formik.setFieldValue("IsHeaderDetailTPIDetailChange", false);
    //   }
    // }
  };

  // const fnCallbackHandleChangeHeaderDetailIsTPIRequiredChange = () => {
  //   formik.setFieldValue("IsTPIRequired", !IsTPIRequired);
  //   formik.setFieldValue("IsHeaderDetailTPIRequiredChange", true);
  //   if (!IsTPIRequired == true) {
  //     formik.setFieldValue("IsHeaderDetailTPIDetailChange", true);
  //   }
  // };

  // const handleChangeHeaderDetailTPIDetailChange = (e) => {
  //   customConfirmDialog(
  //     `Report Printing & Upload Scan Copy transactions will be deleted if they exist.`,
  //     "Do you want to change TPI Details?",
  //     fnCallbackHandleChangeHeaderDetailTPIDetailChange,
  //     true
  //   );
  // };

  // const fnCallbackHandleChangeHeaderDetailTPIDetailChange = () => {
  //   formik.setFieldValue(
  //     "IsHeaderDetailTPIDetailChange",
  //     !formik?.values?.IsHeaderDetailTPIDetailChange
  //   );
  // };

  // const cancelHeaderDetailTPIDetailChange = () => {
  //   formik.setFieldValue(
  //     "IsHeaderDetailTPIDetailChange",
  //     !formik?.values?.IsHeaderDetailTPIDetailChange
  //   );
  //   if (
  //     formik?.values?.ListOfTPIDetails !==
  //     formik?.values?.originalListOfTPIDetails
  //   ) {
  //     formik.setFieldValue(
  //       "ListOfTPIDetails",
  //       formik?.values?.originalListOfTPIDetails
  //     );
  //   }
  // };

  const handleChangeHeaderDetailMaterialInformationChange = (mIndex) => {
    formik.setFieldValue(
      `ListOfMaterials[${mIndex}].IsHeaderDetailMaterialInformationChange`,
      !ListOfMaterials[mIndex].IsHeaderDetailMaterialInformationChange
    );
  };

  const cancelHeaderDetailMaterialInformationChange = (mIndex) => {
    formik.setFieldValue(
      `ListOfMaterials[${mIndex}].IsHeaderDetailMaterialInformationChange`,
      !ListOfMaterials[mIndex].IsHeaderDetailMaterialInformationChange
    );
    if (
      formik?.values?.ListOfMaterials[mIndex] !==
      formik?.values?.originalListOfMaterials[mIndex]
    ) {
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}]`,
        formik?.values?.originalListOfMaterials[mIndex]
      );
    }
  };

  const handleChangeInwardClubing = (e) => {
    formik.setFieldValue("InwardClubing", !InwardClubing);
  };

  const [inwardNoClubingOptions, setInwardNoClubingOptions] = useState([]);

  const getInwardNoClubingDDLList = async (customerID) => {
    if (customerID) {
      setIsLoading(true);
      await post(POST_DDLGetInwardListForInwardClubing, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
        CustomerIDEncrypted: customerID,
        InwardIDEncrypted: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      })
        .then((response) => {
          if (response?.IsSuccess) {
            setInwardNoClubingOptions(
              response?.ListOfInwardNo?.map((item) => ({
                label: item.InwardNo,
                value: item.InwardIDEncrypted,
              }))
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setInwardNoClubingOptions([]);
      formik.setFieldValue("InwardIDsClubing", []);
    }
  };

  const handleChangeInwardNos = (e) => {
    let inwards = e ?? [];
    formik.setFieldValue("InwardIDsClubing", inwards);
  };

  const handleChangeIsMachining = (indx, e, item) => {
    if (item?.IsHold == false) {
      formik.setFieldValue(
        `ListOfMaterials[${indx}].IsMachining`,
        !item?.IsMachining
      );

      formikMaterialProcessDetail.setFieldValue("MaterialListIndex", indx);

      getMaterialProcessDetails(
        indx,
        e.target.checked,
        item?.InwardMaterialIDEncrypted
      );
    }
  };

  const [showMaterialProcessModal, setShowMaterialProcessModal] =
    useState(false);
  const [processNameOptions, setProcessNameOptions] = useState([]);

  const getProcessNameDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetMachiningProcessDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProcessNameOptions(
            response?.List?.map((item) => ({
              label: item?.ProcessName,
              value: item?.MachiningConfigurationIDEncrypted,
              RateMatrix: item?.RateMatrix,
              VendorRate: item?.VendorRate,
              InvoiceRate: item?.InvoiceRate,
              //RateMatrixList: item.ListOfRateMatrix,
            }))
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const initProcessThicknessDetails = {
    InwardMachiningDetailIDEncrypted: "",
    InwardMaterialIDEncrypted: "",
    InwardIDEncrypted: "",
    MachiningConfigurationIDEncrypted: "",
    MachiningNote: "",
    Qty: "",
    Length: "",
    Thickness: "",
    VendorRate: "",
    InvoiceRate: "",
    IsDeleted: false,
  };

  const validationMaterialProcessDetailSchema = Yup.object().shape({});

  const formikMaterialProcessDetail = useFormik({
    validationMaterialProcessDetailSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidMaterialProcessSubmit(values, formikHelpers),
    initialValues: {
      MaterialListIndex: -1,
      ListOfProcessThicknessDetails: [initProcessThicknessDetails],
    },
    validateOnBlur: false,
  });

  const {
    values: { ListOfProcessThicknessDetails },
  } = formikMaterialProcessDetail;

  const handleValidMaterialProcessSubmit = (values) => {
    formik.setFieldValue(
      `ListOfMaterials[${values.MaterialListIndex}].ListOfProcessThicknessDetailsFinal`,
      values?.ListOfProcessThicknessDetails?.filter(
        (x, ix) => ix?.MachiningConfigurationIDEncrypted != ""
      )
    );

    setShowMaterialProcessModal(false);
  };

  const getMaterialProcessDetails = (index, valueChecked, id) => {
    if (valueChecked == true) {
      formikMaterialProcessDetail.setFieldValue("MaterialListIndex", index);

      let newListOneRecord = ListOfMaterials[
        index
      ].ListOfProcessThicknessDetailsFinal?.filter(
        (x) => x.IsDeleted == false
      )?.map((item, idx) => {
        if (item?.MachiningConfigurationIDEncrypted == "") {
          return {
            ...item,
            IsDeleted: true,
          };
        } else {
          return {
            ...item,
            IsDeleted: false,
          };
        }
      });

      formikMaterialProcessDetail.setFieldValue(
        "ListOfProcessThicknessDetails",
        [
          // ...ListOfMaterials[index].ListOfProcessThicknessDetailsFinal,
          ...newListOneRecord,
          initProcessThicknessDetails,
        ]
      );

      setShowMaterialProcessModal(true);
    } else {
      setShowMaterialProcessModal(false);

      let newList = ListOfProcessThicknessDetails?.filter(
        (x) => x.IsDeleted == false
      )?.map((item, idx) => {
        if (item?.InwardMachiningDetailIDEncrypted == "") {
          return {
            ...item,
            IsDeleted: true,
          };
        } else {
          return {
            ...item,
            IsDeleted: false,
          };
        }
      });

      formikMaterialProcessDetail.setFieldValue(
        "ListOfProcessThicknessDetails",
        []
      );

      formik.setFieldValue(
        `ListOfMaterials[${index}].ListOfProcessThicknessDetailsFinal`,
        newList
      );
    }
  };

  const addNewProcess = (indxTest) => {
    formikMaterialProcessDetail.setFieldValue(`ListOfProcessThicknessDetails`, [
      ...ListOfProcessThicknessDetails,
      initProcessThicknessDetails,
    ]);
  };

  const removeProcess = (indxTest) => {
    let newList = ListOfProcessThicknessDetails?.filter(
      (x) => x?.IsDeleted == false
    )?.map((item, idx) => {
      if (indxTest == idx) {
        return {
          ...item,
          IsDeleted: true,
        };
      } else {
        return { ...item };
      }
    });

    formikMaterialProcessDetail.setFieldValue(
      `ListOfProcessThicknessDetails`,
      newList
    );
  };

  const checkValidationProcess = (id, index) => {
    ListOfProcessThicknessDetails?.filter((x) => x.IsDeleted == false)?.map(
      (x) => {
        if (x?.MachiningConfigurationIDEncrypted == id) {
          warningMessage("Process Already Exist!");

          formikMaterialProcessDetail.setFieldValue(
            `ListOfProcessThicknessDetails[${index}].MachiningConfigurationIDEncrypted`,
            ""
          );
          return;
        }
      }
    );
  };

  const handleOnClickRepeatTestDetails = (indx) => {
    formik.setFieldValue("selectedMaterialInfoRow", indx);
    formikTestDetailsRepeat.resetForm();
    openRepeatTestDetailsModel(indx);
  };

  const [showTestDetailsRepeatModal, setShowTestDetailsRepeatModal] =
    useState(false);

  const validationTestDetailsRepeat = Yup.object().shape({});

  const formikTestDetailsRepeat = useFormik({
    validationSchema: validationTestDetailsRepeat,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestDetailsRepeat(values, formikHelpers),
    initialValues: {
      repeatTestDetailsProductGroupID: "",
      repeatTestDetailsProductGroupName: "",
      repeatTestDetailsMaterialTypeID: "",
      repeatTestDetailsMaterialTypeName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      repeatTestDetailsProductGroupID,
      repeatTestDetailsProductGroupName,
      repeatTestDetailsMaterialTypeID,
      repeatTestDetailsMaterialTypeName,
    },
  } = formikTestDetailsRepeat;

  const openRepeatTestDetailsModel = (selectedIndex) => {
    setShowTestDetailsRepeatModal(true);
  };

  const handleValidSubmitTestDetailsRepeat = (values) => {
    setIsLoading(true);
    let selectedTestDetails = ListOfMaterials[
      selectedMaterialInfoRow
    ]?.ListOfMaterialTestDetails?.filter(
      (x) => x.IsDeleted == false && x.IsCancel == false
    );

    formik.setFieldValue(
      "ListOfMaterials",
      ListOfMaterials?.map((x, i) => {
        if (
          selectedMaterialInfoRow != i &&
          // &&
          // repeatTestDetailsProductGroupID == x?.ProductGroupIDEncrypted &&
          // repeatTestDetailsMaterialTypeID == x?.MaterialTypeIDEncrypted
          x?.IsHold == false
        ) {
          return {
            ...x,
            ListOfMaterialTestDetails: [
              ...x?.ListOfMaterialTestDetails?.map((e) => {
                return { ...e, IsDeleted: true };
              }),
              ...selectedTestDetails?.map((t) => {
                return {
                  ...t,
                  InwardMaterialTestDetailIDEncrypted: "",
                  ListOfTestParameters: t?.ListOfTestParameters?.map((y) => {
                    return { ...y, InwardMaterialTestDetailIDEncrypted: "" };
                  }),
                  TestMixDesignDetail: {
                    ...t?.TestMixDesignDetail,
                    StipulationsProportioningIDEncrypted: "",
                  },
                  TestingDetails: {
                    ...t?.TestingDetails,
                    TestingIDEncrypted: "",
                    TestingStatus: 1,
                    ListTestingResultImages: [],
                  },
                };
              }),
            ],
          };
        } else {
          return { ...x };
        }
      })
    );

    setShowTestDetailsRepeatModal(false);
    setIsLoading(false);
  };

  const getTestDDL = async (
    departmentID,
    productGroupID,
    materialTypeID,
    mIndex,
    tIndex,
    loaderOff = true
  ) => {
    if (departmentID) {
      setIsLoading(true);
      await post(POST_GetDDLTestMasterByDepartmentProductGroupMaterialType, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        DepartmentIDEncrypted: departmentID,
        ProductGroupIDEncrypted: productGroupID,
        MaterialTypeIDEncrypted: materialTypeID,
        TestType: 1, // 0 - All, 1 - DT, 2 - NDT
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].testOptions`,
              response?.List?.map((item) => ({
                label: item?.TestName,
                value: item?.TestMasterIDEncrypted,
                IsMixDesign: item?.IsMixDesign,
              }))
            );
          }
          if (loaderOff == true) {
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const getTestMethodDDL_RefStandardDDL_TestDetailsByTest = async (
    testID,
    mIndex,
    tIndex,
    inwardDate,
    setDefault = true,
    loaderOff = true
  ) => {
    if (testID) {
      // let IsTestAlreadyExist = false;
      //if (setDefault == true) {
      /*check if condition to handle undefine ListOfMaterials While get the data*/
      //   Promise.all(
      //     ListOfMaterials[mIndex]?.ListOfMaterialTestDetails?.filter(
      //       (x) => x?.IsDeleted == false && x?.IsCancel == false
      //     )?.map((item, idxM) => {
      //       if (item?.TestMasterIDEncrypted === testID && idxM != tIndex) {
      //         IsTestAlreadyExist = true;
      //       }
      //     })
      //   );
      // }

      // if (IsTestAlreadyExist) {
      //   formik.setFieldValue(
      //     `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].TestMasterIDEncrypted`,
      //     ""
      //   );
      //   warningMessage("Selected Test Name already Exist...!");
      //   return;
      // } else {
      setIsLoading(true);
      await post(
        POST_GetTestMethodDDL_ReferenceStandardDDL_TestMasterDetails_ByTestMasterID,
        {
          TestMasterIDEncrypted: testID,
          TranDate: inwardDate
            ? moment(inwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
            : "",
        }
      )
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].testMethodOptions`,
              response?.TestMethodList?.map((item) => ({
                label: item?.TestMethod,
                value: item?.TestMethodIDEncrypted,
                IsExpiredTestMethod: item?.IsExpiredTestMethod,
              }))
            );
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].referenceStandardOptions`,
              response?.ReferenceStandardList?.map((item) => ({
                label: item?.ReferenceStandard,
                value: item?.ReferenceStandardIDEncrypted,
                IsExpiredReferenceStandard: item?.IsExpiredReferenceStandard,
              }))
            );
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].productGroupOptions`,
              [
                {
                  label: response?.ProductGroupName,
                  value: response?.ProductGroupIDEncrypted,
                },
              ]
            );
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].materialTypeOptions`,
              response?.MaterialTypeList?.map((item) => ({
                label: item.MaterialTypeName,
                value: item.MaterialTypeIDEncrypted,
              }))
            );

            if (setDefault) {
              if (
                response?.TestMethodList?.length == 1 &&
                response?.TestMethodList[0]?.IsExpiredTestMethod == false
              ) {
                formik.setFieldValue(
                  `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].TestMethodIDEncrypted`,
                  response?.TestMethodList[0]?.TestMethodIDEncrypted
                );
              }
              if (
                response?.ReferenceStandardList?.length == 1 &&
                response?.ReferenceStandardList[0]
                  ?.IsExpiredReferenceStandard == false
              ) {
                formik.setFieldValue(
                  `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ReferenceStandardIDEncrypted`,
                  response?.ReferenceStandardList[0]
                    ?.ReferenceStandardIDEncrypted
                );
                getReferenceStandardTestSubGroupDDL(
                  response?.ReferenceStandardList[0]
                    ?.ReferenceStandardIDEncrypted,
                  testID,
                  mIndex,
                  tIndex
                );
              }
              formik.setFieldValue(
                `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].TestCount`,
                response?.DefaultTestCount
              );
              // formik.setFieldValue(
              //   `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].IsMachining`,
              //   response?.MachiningRequired
              // );
              formik.setFieldValue(
                `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ProductGroupIDEncrypted`,
                response?.ProductGroupIDEncrypted
              );
              if (response?.MaterialTypeList?.length == 1) {
                formik.setFieldValue(
                  `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].MaterialTypeIDEncrypted`,
                  response?.MaterialTypeList[0]?.MaterialTypeIDEncrypted
                );
              }
            }

            // formik.setFieldValue(
            //   `ListOfMaterials[${mIndex}].IsMachining`,
            //   response?.MachiningRequired
            // );
          }
          if (loaderOff == true) {
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
      // }
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].testMethodOptions`,
        []
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].referenceStandardOptions`,
        []
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].refStandardSubGroupOptions`,
        []
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].parametersRangeList`,
        []
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].productGroupOptions`,
        []
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].materialTypeOptions`,
        []
      );
    }
  };

  const getReferenceStandardTestSubGroupDDL = async (
    referenceStandardID,
    testMasterID,
    indx,
    indxTest
  ) => {
    setIsLoading(true);
    await post(POST_GetReferenceStandardTestSubGroupDDL, {
      ReferenceStandardIDEncrypted: referenceStandardID,
      TestMasterIDEncrypted: testMasterID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].refStandardSubGroupOptions`,
            response?.SubGroupList?.map((item) => ({
              label: item?.SubGroup,
              value: item?.SubGroup,
            }))
          );
          formik.setFieldValue(
            `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].parametersRangeList`,
            response?.RangeList?.map((item) => ({
              ...item,
            }))
          );
          /*select the value when there is only one option*/
          if (response?.SubGroupList?.length == 1) {
            formik.setFieldValue(
              `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
              response?.SubGroupList[0].SubGroup
            );
            getParameterPreferenceBasedOnRefStandardTestMap(
              response?.SubGroupList[0].SubGroup,
              referenceStandardID,
              testMasterID,
              indx,
              indxTest
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getParameterPreferenceBasedOnRefStandardTestMap = async (
    refStandardSubGroup,
    referenceStandardID,
    testMasterID,
    indx,
    indxTest
  ) => {
    if (
      AuthUser?.Permissions?.ParameterPreferenceLoadBasedOnRefStandardTestMap ==
      true
    ) {
      setIsLoading(true);
      await post(
        POST_GetParametersPreferenceListBasedOnRefStandardTestSubGroup,
        {
          TestMasterIDEncrypted: testMasterID,
          ReferenceStandardIDEncrypted: referenceStandardID,
          RefStandardSubGroup: refStandardSubGroup,
          BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
          CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
          CustomerIDEncrypted: CustomerIDEncrypted,
          InwardMaterialTestDetailIDEncrypted:
            ListOfMaterials[indx]?.ListOfMaterialTestDetails[indxTest]
              .InwardMaterialTestDetailIDEncrypted,
        }
      )
        .then((response) => {
          if (response?.IsSuccess) {
            /* set the list if any of the parameters is selected from the list based on preference */
            if (
              response?.ParametersList?.filter((x) => x.IsSelected == true)
                ?.length > 0
            ) {
              formik.setFieldValue(
                `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ListOfTestParameters`,
                response?.ParametersList
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const getInwardMaterialTestParametersList = async (
    inwardMaterialTestDetailID,
    testMasterID,
    mIndex,
    tIndex
  ) => {
    setIsLoading(true);
    await post(POST_GetTestParametersList, {
      TestMasterIDEncrypted: testMasterID,
      CustomerIDEncrypted: CustomerIDEncrypted,
      InwardMaterialTestDetailIDEncrypted: inwardMaterialTestDetailID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ListOfTestParameters`,
            response?.ParametersList?.filter((x) => x.IsSelected == true)
              ?.length > 0
              ? response?.ParametersList
              : response?.ParametersList?.map((para) => ({
                  ...para,
                  IsSelected: true,
                }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showTestParametersModal, setShowTestParametersModal] = useState(false);

  const validationTestParameters = Yup.object().shape({});

  const formikTestPrameters = useFormik({
    validationSchema: validationTestParameters,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestParameters(values, formikHelpers),
    initialValues: {
      ParametersTestName: "",
      ParametersList: [],
      materialIndexPara: 0,
      testIndexPara: 0,
      selectAllPara: false,
      isTestParametersForTesting: false,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ParametersTestName,
      ParametersList,
      selectAllPara,
      isTestParametersForTesting,
    },
  } = formikTestPrameters;

  const handleValidSubmitTestParameters = (values) => {
    if (isTestParametersForTesting == true) {
      let testingParametersShortCodes = values?.ParametersList?.filter(
        (para) => para?.IsSelected == true && para?.ShortCode != ""
      )
        ?.map((x) => x.ShortCode)
        ?.join(",");

      if (formikTesting?.values?.IsMixDesign == true) {
        let shortCodes = [];

        formikTesting?.values?.ListOfMixDesignIncludedTest.forEach((test) => {
          if (test.TestDetails && test.TestDetails.ListOfParameter) {
            test.TestDetails.ListOfParameter.forEach((param) => {
              if (param.ShortCode) {
                shortCodes.push(param.ShortCode);
              }
            });
          }
        });

        let mixDesignIncludedTestParametersShortCodes = shortCodes.join(", ");

        if (mixDesignIncludedTestParametersShortCodes) {
          testingParametersShortCodes = testingParametersShortCodes
            ? testingParametersShortCodes +
              ", " +
              mixDesignIncludedTestParametersShortCodes
            : mixDesignIncludedTestParametersShortCodes;
        }
      }

      let newList = [];
      Promise.all(
        values?.ParametersList?.filter((para) => para?.IsSelected == true)?.map(
          (x, idx) => {
            newList.push({
              ...x,
              Sequence: idx + 1,
              FormulaEvaluationStatus:
                x.FormulaEvaluationStatus > 0
                  ? checkFormulaEvaluationStatus(
                      testingParametersShortCodes,
                      x.FormulaVariables
                    ) == true
                    ? 1
                    : 2
                  : 0,
            });
          }
        )
      );
      newList = [
        ...newList,
        ...values?.ParametersList?.filter((para) => para?.IsSelected == false),
      ];

      formikTesting.setFieldValue("ListOfParameter", newList);
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${values?.materialIndexPara}].ListOfMaterialTestDetails[${values?.testIndexPara}].ListOfTestParameters`,
        values?.ParametersList
      );
    }
    setShowTestParametersModal(false);
  };

  const handleChangeSelectAllPara = (isChecked) => {
    formikTestPrameters.setFieldValue("selectAllPara", isChecked);
    formikTestPrameters.setFieldValue(
      "ParametersList",
      ParametersList?.map((x) => {
        return { ...x, IsSelected: isChecked };
      })
    );
  };

  const AddNewMaterialTestInformation = (index) => {
    formik.setFieldValue(
      `ListOfMaterials[${index}].ListOfMaterialTestDetails`,
      [
        ...ListOfMaterials[index].ListOfMaterialTestDetails,
        initMaterialTestDetail,
      ]
    );

    // /*select the value when there is only one option while insert only*/
    // if (ListOfMaterials[index]?.testOptions?.length == 1) {
    //   let newIndex = ListOfMaterials[index].ListOfMaterialTestDetails?.length;
    //   formik.setFieldValue(
    //     `ListOfMaterials[${index}].ListOfMaterialTestDetails[${newIndex}].TestMasterIDEncrypted`,
    //     ListOfMaterials[index]?.testOptions[0].value
    //   );
    //   getTestMethodDDL_RefStandardDDL_TestDetailsByTest(
    //     ListOfMaterials[index]?.testOptions[0].value,
    //     index,
    //     newIndex
    //   );
    // }

    /*select the value when there is only one option while insert only*/
    if (ListOfMaterials[index]?.departmentOptions?.length == 1) {
      let newIndex = ListOfMaterials[index].ListOfMaterialTestDetails?.length;
      formik.setFieldValue(
        `ListOfMaterials[${index}].ListOfMaterialTestDetails[${newIndex}].DepartmentIDEncrypted`,
        ListOfMaterials[index]?.departmentOptions[0].value
      );
      // getTestDDL(
      //   ListOfMaterials[index]?.departmentOptions[0].value,
      //   ListOfMaterials[index]?.ProductGroupIDEncrypted,
      //   ListOfMaterials[index]?.MaterialTypeIDEncrypted,
      //   index,
      //   newIndex
      // );
      getTestDDL(
        ListOfMaterials[index]?.departmentOptions[0].value,
        "",
        "",
        index,
        newIndex
      );
    }
    /*select the value when there is only one option while insert only*/
    if (unitOptions?.length == 1) {
      let newIndex = ListOfMaterials[index].ListOfMaterialTestDetails?.length;
      formik.setFieldValue(
        `ListOfMaterials[${index}].ListOfMaterialTestDetails[${newIndex}].UnitID`,
        unitOptions[0].value
      );
    }
  };

  const deleteMaterialTestInformation = (mIndex, tIndex) => {
    if (
      ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex].IsMixDesign ==
        true &&
      ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex]
        .TestMasterIDEncrypted
    ) {
      deleteMixDesignIncludedTest(
        mIndex,
        ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex]
          .TestMasterIDEncrypted,
        true
      );
    } else {
      if (
        ListOfMaterials[mIndex]?.InwardMaterialIDEncrypted &&
        ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex]
          ?.InwardMaterialTestDetailIDEncrypted
      ) {
        formik.setFieldValue(
          `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].IsDeleted`,
          true
        );
      } else {
        formik.setFieldValue(
          `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails`,
          ListOfMaterials[mIndex]?.ListOfMaterialTestDetails?.filter(
            (x, idx) => idx != tIndex
          )
        );
      }
    }
  };

  const handleChangeDepartment = (indx, indxTest, e) => {
    const path = `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}]`;
    let itemTest = ListOfMaterials[indx].ListOfMaterialTestDetails[indxTest];
    let mixDesignTest = false;
    if (itemTest.IsMixDesign == true) {
      mixDesignTest = true;
      setSelectedTCIndex(indx);
      setSelectedMixDesignTestID(itemTest.TestMasterIDEncrypted);
    }

    formik.setFieldValue(`${path}.DepartmentIDEncrypted`, e?.value ?? "");
    formik.setFieldValue(`${path}.ProductGroupIDEncrypted`, "");
    formik.setFieldValue(`${path}.MaterialTypeIDEncrypted`, "");
    formik.setFieldValue(`${path}.TestMasterIDEncrypted`, "");
    formik.setFieldValue(`${path}.TestMethodIDEncrypted`, "");
    formik.setFieldValue(`${path}.ReferenceStandardIDEncrypted`, "");
    formik.setFieldValue(`${path}.RefStandardSubGroup`, "");
    formik.setFieldValue(`${path}.testOptions`, []);
    formik.setFieldValue(`${path}.testMethodOptions`, []);
    formik.setFieldValue(`${path}.referenceStandardOptions`, []);
    formik.setFieldValue(`${path}.refStandardSubGroupOptions`, []);
    formik.setFieldValue(`${path}.parametersRangeList`, []);
    formik.setFieldValue(`${path}.productGroupOptions`, []);
    formik.setFieldValue(`${path}.materialTypeOptions`, []);
    formik.setFieldValue(`${path}.ListOfTestParameters`, []);
    formik.setFieldValue(`${path}.IsMixDesign`, false);
    formik.setFieldValue(
      `${path}.TestMixDesignDetail`,
      initMaterialTestDetail.TestMixDesignDetail
    );
    formik.setFieldValue(
      `${path}.TestingDetails`,
      initMaterialTestDetail.TestingDetails
    );
    // getProductGroupDDL(
    //  e?.value ?? "",
    //   indx,
    //   indxTest
    // );
    getTestDDL(e?.value ?? "", "", "", indx, indxTest);

    if (mixDesignTest == true) {
      setDeleteMixDesignIncludedTestActionStatus(true);
    }
  };

  const handleChangeTestMaster = (indx, indxTest, e, itemTest) => {
    let IsTestAlreadyExist = false;
    const path = `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}]`;
    let mixDesignTest = false;
    if (itemTest.IsMixDesign == true) {
      mixDesignTest = true;
      setSelectedTCIndex(indx);
      setSelectedMixDesignTestID(itemTest.TestMasterIDEncrypted);
    }

    if (e && e?.value) {
      if (e?.value !== itemTest?.TestMasterIDEncrypted) {
        Promise.all(
          ListOfMaterials[indx]?.ListOfMaterialTestDetails?.filter(
            (x) => x?.IsDeleted == false && x?.IsCancel == false
          )?.map((item, idxM) => {
            if (item?.TestMasterIDEncrypted === e?.value && idxM != indxTest) {
              IsTestAlreadyExist = true;
            }
          })
        );

        formik.setFieldValue(`${path}.ListOfTestParameters`, []);
        formik.setFieldValue(`${path}.IsMixDesign`, false);
        formik.setFieldValue(
          `${path}.TestMixDesignDetail`,
          initMaterialTestDetail.TestMixDesignDetail
        );
        formik.setFieldValue(`${path}.TestMethodIDEncrypted`, "");
        formik.setFieldValue(`${path}.ReferenceStandardIDEncrypted`, "");
        formik.setFieldValue(`${path}.referenceStandardOptions`, []);
        formik.setFieldValue(`${path}.RefStandardSubGroup`, "");
        formik.setFieldValue(`${path}.refStandardSubGroupOptions`, []);
        formik.setFieldValue(`${path}.parametersRangeList`, []);
        formik.setFieldValue(`${path}.ProductGroupIDEncrypted`, "");
        formik.setFieldValue(`${path}.MaterialTypeIDEncrypted`, "");
        if (IsTestAlreadyExist) {
          formik.setFieldValue(`${path}.TestMasterIDEncrypted`, "");
          warningMessage("Selected Test Name already Exist...!");
          //return;
        } else {
          formik.setFieldValue(`${path}.TestMasterIDEncrypted`, e?.value ?? "");
          if (e?.IsMixDesign == true) {
            formikMixDesignTestDetails.resetForm();
            formikMixDesignTestDetails.setFieldValue(
              "MixDesignTestName",
              e?.label
            );
            formikMixDesignTestDetails.setFieldValue("tcIndex", indx);
            formikMixDesignTestDetails.setFieldValue("testIndex", indxTest);
            getMixDesignMasterDDLAll(e?.value ?? "", itemTest);
            setShowMixDesignTestDetailModal(true);
          }
          formik.setFieldValue(`${path}.IsMixDesign`, e?.IsMixDesign);
          getInwardMaterialTestParametersList(
            itemTest?.InwardMaterialTestDetailIDEncrypted,
            e?.value,
            indx,
            indxTest
          );
          getInwardMaterialDefineMoreRatesList(
            itemTest?.InwardMaterialTestDetailIDEncrypted,
            e?.value,
            indx,
            indxTest
          );
          getTestMethodDDL_RefStandardDDL_TestDetailsByTest(
            e?.value ?? "",
            indx,
            indxTest,
            InwardDate
          );
        }
      }
    } else {
      formik.setFieldValue(`${path}.ListOfTestParameters`, []);
      formik.setFieldValue(`${path}.IsMixDesign`, false);
      formik.setFieldValue(
        `${path}.TestMixDesignDetail`,
        initMaterialTestDetail.TestMixDesignDetail
      );
      formik.setFieldValue(`${path}.TestMasterIDEncrypted`, e?.value ?? "");
      formik.setFieldValue(`${path}.TestMethodIDEncrypted`, "");
      formik.setFieldValue(`${path}.ReferenceStandardIDEncrypted`, "");
      formik.setFieldValue(`${path}.referenceStandardOptions`, []);
      formik.setFieldValue(`${path}.RefStandardSubGroup`, "");
      formik.setFieldValue(`${path}.refStandardSubGroupOptions`, []);
      formik.setFieldValue(`${path}.parametersRangeList`, []);
      formik.setFieldValue(`${path}.ProductGroupIDEncrypted`, "");
      formik.setFieldValue(`${path}.MaterialTypeIDEncrypted`, "");
    }

    if (mixDesignTest == true) {
      setDeleteMixDesignIncludedTestActionStatus(true);
    }
  };

  const handleOnClickParameterSelection = (indx, indxTest, item, itemTest) => {
    if (
      itemTest?.IsCancel == false &&
      item?.IsHold == false &&
      itemTest?.TestingDetails?.TestingStatus == 1
    ) {
      formikTestPrameters.setFieldValue(
        "ParametersTestName",
        itemTest?.testOptions?.filter(
          (x) => x?.value == itemTest?.TestMasterIDEncrypted
        )[0]?.label
      );
      formikTestPrameters.setFieldValue(
        "ParametersList",
        itemTest?.ListOfTestParameters
      );
      formikTestPrameters.setFieldValue("materialIndexPara", indx);
      formikTestPrameters.setFieldValue("testIndexPara", indxTest);
      formikTestPrameters.setFieldValue(
        "selectAllPara",
        itemTest?.ListOfTestParameters?.filter((x) => x.IsSelected == false)
          ?.length > 0
          ? false
          : true
      );
      formikTestPrameters.setFieldValue("isTestParametersForTesting", false);
      setShowTestParametersModal(true);
    }
  };

  const handleChangeReferenceStandard = (testMasterID, indx, indxTest, e) => {
    if (e?.IsExpiredReferenceStandard == true) {
      warningMessage("Reference Standard is Expired..!");
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ReferenceStandardIDEncrypted`,
        e?.value ?? ""
      );
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].refStandardSubGroupOptions`,
        []
      );
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].parametersRangeList`,
        []
      );
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
        ""
      );
      getReferenceStandardTestSubGroupDDL(
        e?.value ?? "",
        testMasterID,
        indx,
        indxTest
      );
    }
  };

  const handleChangeRefStandardSubGroup = (
    referenceStandardID,
    testMasterID,
    indx,
    indxTest,
    e
  ) => {
    formik.setFieldValue(
      `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
      e?.value ?? ""
    );
    getParameterPreferenceBasedOnRefStandardTestMap(
      e?.value ?? "",
      referenceStandardID,
      testMasterID,
      indx,
      indxTest
    );
  };

  const handleChangeTestCount = (indx, indxTest, e) => {
    if (e?.target?.value < 1000) {
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestCount`,
        e?.target?.value ?? ""
      );
    }
  };

  const [showMixDesignTestDetailModal, setShowMixDesignTestDetailModal] =
    useState(false);

  const validationMixDesignTestDetail = Yup.object().shape({
    GradeDesignation: Yup.string().required(
      "Grade Designation is required field"
    ),
  });

  const formikMixDesignTestDetails = useFormik({
    validationSchema: validationMixDesignTestDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitMixDesignTestDetail(values, formikHelpers),
    initialValues: {
      MixDesignTestName: "",
      StipulationsProportioningIDEncrypted: "",
      TypeofCementIDEncrypted: "",
      TypeofMineralAdmixtureIDEncrypted: "",
      MaximumNominalSizeofAggregateIDEncrypted: "",
      EnvironmentalExposureConditionsIDEncrypted: "",
      TypeofAggregateFineIDEncrypted: "",
      ChemicalAdmixtureTypeIDEncrypted: "",
      ChemicalAdmixtureBrandBatchandMarkIDEncrypted: "",
      GradeDesignation: "",
      MinimumCementContent: "",
      MaximumCementContent: "450",
      MaximumWaterCementRatio: "",
      Workability: "",
      RetentionTime: "",
      TransportationTime: "",
      DegreeofSiteControl: "Good",
      TypeofAggregateFineCoarse: "Crushed angular aggregate",
      MethodofConcretePlacingIsChute_NonPumpable: false,
      MethodofConcretePlacingIsPumping: false,
      optionsTypeOfCement: [],
      optionsTypeOfMineralAdmixture: [],
      optionsMaximumNominalSizeofAggregate: [],
      optionsEnvironmentralExposureConditions: [],
      optionsTypeOfAggregateFine: [],
      optionsChemicalAdmixtureType: [],
      optionsChemicalAdmixtureBrandBatchMarkId: [],
      ListOfMixDesignIncludedTest: [],
      tcIndex: 0,
      testIndex: 0,
      optionsFineAggregateReferenceStandardWithTable: [],
      ListOfConcreteExposureReferenceStandardTable: [],
      optionsReferenceStandardConcreteExposure: [],
      optionsReferenceStandardTableConcreteExposure: [],
      optionsTypeOfConcrete: [],
      optionsTypeOfConcreteGrade: [],
      TypeofCementName: "",
      TypeofMineralAdmixtureName: "",
      MaximumNominalSizeofAggregateName: "",
      EnvironmentalExposureConditionsName: "",
      TypeofAggregateFineName: "",
      ChemicalAdmixtureTypeName: "",
      ChemicalAdmixtureBrandBatchandMarkName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      MixDesignTestName,
      optionsTypeOfCement,
      optionsTypeOfMineralAdmixture,
      optionsMaximumNominalSizeofAggregate,
      optionsEnvironmentralExposureConditions,
      optionsTypeOfAggregateFine,
      optionsChemicalAdmixtureType,
      optionsChemicalAdmixtureBrandBatchMarkId,
      MethodofConcretePlacingIsChute_NonPumpable,
      MethodofConcretePlacingIsPumping,
      optionsFineAggregateReferenceStandardWithTable,
      ListOfConcreteExposureReferenceStandardTable,
      optionsReferenceStandardConcreteExposure,
      optionsReferenceStandardTableConcreteExposure,
      optionsTypeOfConcrete,
      optionsTypeOfConcreteGrade,
    },
  } = formikMixDesignTestDetails;

  const [mixDesignTestAddingAction, setMixDesignTestAddingAction] =
    useState(false);
  const [countOfNewAddedIncludedTest, setCountOfNewAddedIncludedTest] =
    useState(0);

  useEffect(() => {
    if (mixDesignTestAddingAction == true) {
      let totalTests =
        ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
          .ListOfMaterialTestDetails.length;
      if (countOfNewAddedIncludedTest > 0) {
        let startIndex = totalTests - countOfNewAddedIncludedTest;
        let endIndex = startIndex + countOfNewAddedIncludedTest - 1;

        if (startIndex > 0) {
          for (let i = startIndex; i <= endIndex; i++) {
            getInwardMaterialTestParametersList(
              ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
                .ListOfMaterialTestDetails[i]
                ?.InwardMaterialTestDetailIDEncrypted,
              ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
                .ListOfMaterialTestDetails[i]?.TestMasterIDEncrypted,
              formikMixDesignTestDetails.values.tcIndex,
              i
            );

            getInwardMaterialDefineMoreRatesList(
              ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
                .ListOfMaterialTestDetails[i]
                ?.InwardMaterialTestDetailIDEncrypted,
              ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
                .ListOfMaterialTestDetails[i]?.TestMasterIDEncrypted,
              formikMixDesignTestDetails.values.tcIndex,
              i
            );
            getTestMethodDDL_RefStandardDDL_TestDetailsByTest(
              ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
                .ListOfMaterialTestDetails[i]?.TestMasterIDEncrypted,
              formikMixDesignTestDetails.values.tcIndex,
              i,
              InwardDate
            );
          }
        }
      }
      setMixDesignTestAddingAction(false);
    }
  }, [mixDesignTestAddingAction]);

  const handleValidSubmitMixDesignTestDetail = (values) => {
    let existingListOfMaterialTestDetails =
      ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails;

    existingListOfMaterialTestDetails[values.testIndex].TestMixDesignDetail = {
      ...existingListOfMaterialTestDetails[values.testIndex]
        .TestMixDesignDetail,
      StipulationsProportioningIDEncrypted:
        values?.StipulationsProportioningIDEncrypted,
      TypeofCementIDEncrypted: values?.TypeofCementIDEncrypted,
      TypeofMineralAdmixtureIDEncrypted:
        values?.TypeofMineralAdmixtureIDEncrypted,
      MaximumNominalSizeofAggregateIDEncrypted:
        values?.MaximumNominalSizeofAggregateIDEncrypted,
      EnvironmentalExposureConditionsIDEncrypted:
        values?.EnvironmentalExposureConditionsIDEncrypted,
      TypeofAggregateFineIDEncrypted: values?.TypeofAggregateFineIDEncrypted,
      ChemicalAdmixtureTypeIDEncrypted:
        values?.ChemicalAdmixtureTypeIDEncrypted,
      ChemicalAdmixtureBrandBatchandMarkIDEncrypted:
        values?.ChemicalAdmixtureBrandBatchandMarkIDEncrypted,
      GradeDesignation: values?.GradeDesignation,
      MinimumCementContent: values?.MinimumCementContent
        ? values?.MinimumCementContent.toString()
        : "",
      MaximumCementContent: values?.MaximumCementContent
        ? values?.MaximumCementContent.toString()
        : "",
      MaximumWaterCementRatio: values?.MaximumWaterCementRatio
        ? values?.MaximumWaterCementRatio.toString()
        : "",
      Workability: values?.Workability,
      RetentionTime:
        values?.RetentionTime != ""
          ? moment(values?.RetentionTime, "HH:mm:ss")
              .format("HH:mm")
              .replace(/^\-/, "")
          : "",
      TransportationTime:
        values?.TransportationTime != ""
          ? moment(values?.TransportationTime, "HH:mm:ss")
              .format("HH:mm")
              .replace(/^\-/, "")
          : "",
      DegreeofSiteControl: values?.DegreeofSiteControl,
      TypeofAggregateFineCoarse: values?.TypeofAggregateFineCoarse,
      MethodofConcretePlacingIsChute_NonPumpable:
        values?.MethodofConcretePlacingIsChute_NonPumpable,
      MethodofConcretePlacingIsPumping:
        values?.MethodofConcretePlacingIsPumping,
      TypeofCementName: values?.TypeofCementName,
      TypeofMineralAdmixtureName: values?.TypeofMineralAdmixtureName,
      MaximumNominalSizeofAggregateName:
        values?.MaximumNominalSizeofAggregateName,
      EnvironmentalExposureConditionsName:
        values?.EnvironmentalExposureConditionsName,
      TypeofAggregateFineName: values?.TypeofAggregateFineName,
      ChemicalAdmixtureTypeName: values?.ChemicalAdmixtureTypeName,
      ChemicalAdmixtureBrandBatchandMarkName:
        values?.ChemicalAdmixtureBrandBatchandMarkName,
    };

    let includedTestTobeAddList = [];
    values?.ListOfMixDesignIncludedTest?.map((x) => {
      if (
        ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails.filter(
          (test) =>
            test.TestMasterIDEncrypted == x.TestMasterIDEncrypted &&
            test.IsDeleted == false &&
            test.IsCancel == false
        ).length == 0
      ) {
        includedTestTobeAddList.push({
          ...initMaterialTestDetail,
          DepartmentIDEncrypted:
            ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails[
              values.testIndex
            ].DepartmentIDEncrypted,
          testOptions:
            ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails[
              values.testIndex
            ].testOptions,
          TestMasterIDEncrypted: x.TestMasterIDEncrypted,
          IsMixDesignIncludedTest: true,
          MixDesignTestMasterIDEncrypted:
            ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails[
              values.testIndex
            ].TestMasterIDEncrypted,
        });
      } else {
        let testIndexExisting = ListOfMaterials[
          values.tcIndex
        ].ListOfMaterialTestDetails.findIndex(
          (test) =>
            test.TestMasterIDEncrypted == x.TestMasterIDEncrypted &&
            test.IsDeleted == false &&
            test.IsCancel == false
        );
        existingListOfMaterialTestDetails[
          testIndexExisting
        ].IsMixDesignIncludedTest = true;
        existingListOfMaterialTestDetails[
          testIndexExisting
        ].MixDesignTestMasterIDEncrypted =
          ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails[
            values.testIndex
          ].TestMasterIDEncrypted;
      }
    });

    setCountOfNewAddedIncludedTest(includedTestTobeAddList.length);
    if (includedTestTobeAddList.length > 0) {
      formik.setFieldValue(
        `ListOfMaterials[${values.tcIndex}].ListOfMaterialTestDetails`,
        [...existingListOfMaterialTestDetails, ...includedTestTobeAddList]
      );
      setMixDesignTestAddingAction(true);
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${values.tcIndex}].ListOfMaterialTestDetails`,
        existingListOfMaterialTestDetails
      );
    }
    setShowMixDesignTestDetailModal(false);
  };

  const getMixDesignMasterDDLAll = async (testMasterID, resMain) => {
    setIsLoading(true);
    await post(POST_GetMixDesignMasterDropDownListAll, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TestMasterIDEncrypted: testMasterID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfCement",
            response.TypeofCementList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfMineralAdmixture",
            response.TypeofMineralAdmixtureList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsMaximumNominalSizeofAggregate",
            response.MaximumNominalSizeofAggregateList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsEnvironmentralExposureConditions",
            response.EnvironmentalExposureConditionsList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfAggregateFine",
            response.TypeofAggregateFineList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsChemicalAdmixtureType",
            response.ChemicalAdmixtureTypeList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsChemicalAdmixtureBrandBatchMarkId",
            response.ChemicalAdmixtureBrandBatchandIDMarkList
          );
          formikMixDesignTestDetails.setFieldValue(
            "ListOfMixDesignIncludedTest",
            response.ListOfMixDesignIncludedTest
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsFineAggregateReferenceStandardWithTable",
            response.ListOfFineAggregateReferenceStandardWithTableName?.map(
              (item) => ({
                value: item.ReferenceStandardWithTableName,
                label: item.ReferenceStandardWithTableName,
              })
            )
          );
          formikMixDesignTestDetails.setFieldValue(
            "ListOfConcreteExposureReferenceStandardTable",
            response.ListOfConcreteExposureReferenceStandardTable
          );

          const distinctReferenceStandardNames = [
            ...new Set(
              response.ListOfConcreteExposureReferenceStandardTable.map(
                (item) => item.ReferenceStandardName
              )
            ),
          ];
          formikMixDesignTestDetails.setFieldValue(
            "optionsReferenceStandardConcreteExposure",
            distinctReferenceStandardNames?.map((item) => ({
              value: item,
              label: item,
            }))
          );

          if (
            resMain?.TestMixDesignDetail
              ?.SelectionOfWaterCementRatioReferenceStandardName
          ) {
            const distinctReferenceStandardTableNames = [
              ...new Set(
                response.ListOfConcreteExposureReferenceStandardTable?.filter(
                  (x) =>
                    x.ReferenceStandardName ==
                    resMain?.TestMixDesignDetail
                      ?.SelectionOfWaterCementRatioReferenceStandardName
                )?.map((item) => item.ReferenceStandardTableName)
              ),
            ];

            formikMixDesignTestDetails.setFieldValue(
              "optionsReferenceStandardTableConcreteExposure",
              distinctReferenceStandardTableNames?.map((item) => ({
                value: item,
                label: item,
              }))
            );

            if (
              resMain?.TestMixDesignDetail
                ?.SelectionOfWaterCementRatioReferenceStandardTableName
            ) {
              formikMixDesignTestDetails.setFieldValue(
                "optionsTypeOfConcrete",
                [
                  {
                    value: "Plain Concrete",
                    label: "Plain Concrete",
                  },
                  {
                    value: "Reinforced Concrete",
                    label: "Reinforced Concrete",
                  },
                ]
              );
              if (resMain?.TestMixDesignDetail?.ConcreteType) {
                if (
                  resMain?.TestMixDesignDetail?.ConcreteType == "Plain Concrete"
                ) {
                  formikMixDesignTestDetails.setFieldValue(
                    "optionsTypeOfConcreteGrade",
                    response.ListOfConcreteExposureReferenceStandardTable?.filter(
                      (x) =>
                        x.ReferenceStandardName ==
                          resMain?.TestMixDesignDetail
                            ?.SelectionOfWaterCementRatioReferenceStandardName &&
                        x.ReferenceStandardTableName ==
                          resMain?.TestMixDesignDetail
                            ?.SelectionOfWaterCementRatioReferenceStandardTableName
                    )?.map((item) => ({
                      label: item.PlainConcreteMinGradeOfConcrete,
                      value: item.PlainConcreteMinGradeOfConcrete,
                      MaxFreeWaterCementRatio:
                        item.PlainConcreteMaxFreeWaterCementRatio,
                    }))
                  );
                } else if (
                  resMain?.TestMixDesignDetail?.ConcreteType ==
                  "Reinforced Concrete"
                ) {
                  formikMixDesignTestDetails.setFieldValue(
                    "optionsTypeOfConcreteGrade",
                    response.ListOfConcreteExposureReferenceStandardTable?.filter(
                      (x) =>
                        x.ReferenceStandardName ==
                          resMain?.TestMixDesignDetail
                            ?.SelectionOfWaterCementRatioReferenceStandardName &&
                        x.ReferenceStandardTableName ==
                          resMain?.TestMixDesignDetail
                            ?.SelectionOfWaterCementRatioReferenceStandardTableName
                    )?.map((item) => ({
                      label: item.ReinforcedConcreteMinGradeOfConcrete,
                      value: item.ReinforcedConcreteMinGradeOfConcrete,
                      MaxFreeWaterCementRatio:
                        item.ReinforcedConcreteMaxFreeWaterCementRatio,
                    }))
                  );
                }
              }
            }
          }
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOnClickMixDesignDetail = (indx, indxTest, item, itemTest) => {
    if (itemTest?.IsCancel == false && item?.IsHold == false) {
      formikMixDesignTestDetails.resetForm();
      let testName = itemTest?.testOptions.filter(
        (x) => x.value == itemTest.TestMasterIDEncrypted
      )[0]?.label;
      let mdDetail = itemTest?.TestMixDesignDetail;
      formikMixDesignTestDetails.setFieldValue("MixDesignTestName", testName);
      formikMixDesignTestDetails.setFieldValue("tcIndex", indx);
      formikMixDesignTestDetails.setFieldValue("testIndex", indxTest);
      formikMixDesignTestDetails.setFieldValue(
        "StipulationsProportioningIDEncrypted",
        mdDetail?.StipulationsProportioningIDEncrypted
      );
      formikMixDesignTestDetails.setFieldValue(
        "TypeofCementIDEncrypted",
        mdDetail?.TypeofCementIDEncrypted
      );
      formikMixDesignTestDetails.setFieldValue(
        "TypeofMineralAdmixtureIDEncrypted",
        mdDetail?.TypeofMineralAdmixtureIDEncrypted
      );
      formikMixDesignTestDetails.setFieldValue(
        "MaximumNominalSizeofAggregateIDEncrypted",
        mdDetail?.MaximumNominalSizeofAggregateIDEncrypted
      );
      formikMixDesignTestDetails.setFieldValue(
        "EnvironmentalExposureConditionsIDEncrypted",
        mdDetail?.EnvironmentalExposureConditionsIDEncrypted
      );
      formikMixDesignTestDetails.setFieldValue(
        "TypeofAggregateFineIDEncrypted",
        mdDetail?.TypeofAggregateFineIDEncrypted
      );
      formikMixDesignTestDetails.setFieldValue(
        "ChemicalAdmixtureTypeIDEncrypted",
        mdDetail?.ChemicalAdmixtureTypeIDEncrypted
      );
      formikMixDesignTestDetails.setFieldValue(
        "ChemicalAdmixtureBrandBatchandMarkIDEncrypted",
        mdDetail?.ChemicalAdmixtureBrandBatchandMarkIDEncrypted
      );
      formikMixDesignTestDetails.setFieldValue(
        "GradeDesignation",
        mdDetail?.GradeDesignation
      );
      formikMixDesignTestDetails.setFieldValue(
        "MinimumCementContent",
        mdDetail?.MinimumCementContent
      );
      formikMixDesignTestDetails.setFieldValue(
        "MaximumCementContent",
        mdDetail?.MaximumCementContent == ""
          ? "450"
          : mdDetail?.MaximumCementContent
      );
      formikMixDesignTestDetails.setFieldValue(
        "MaximumWaterCementRatio",
        mdDetail?.MaximumWaterCementRatio
      );
      formikMixDesignTestDetails.setFieldValue(
        "Workability",
        mdDetail?.Workability
      );
      formikMixDesignTestDetails.setFieldValue(
        "RetentionTime",
        mdDetail?.RetentionTime != ""
          ? convertTimeToDateTime(mdDetail?.RetentionTime)
          : ""
      );
      formikMixDesignTestDetails.setFieldValue(
        "TransportationTime",
        mdDetail?.TransportationTime != ""
          ? convertTimeToDateTime(mdDetail?.TransportationTime)
          : ""
      );
      formikMixDesignTestDetails.setFieldValue(
        "DegreeofSiteControl",
        mdDetail?.DegreeofSiteControl == ""
          ? "Good"
          : mdDetail?.DegreeofSiteControl
      );
      formikMixDesignTestDetails.setFieldValue(
        "TypeofAggregateFineCoarse",
        mdDetail?.TypeofAggregateFineCoarse == ""
          ? "Crushed angular aggregate"
          : mdDetail?.TypeofAggregateFineCoarse
      );
      formikMixDesignTestDetails.setFieldValue(
        "MethodofConcretePlacingIsChute_NonPumpable",
        mdDetail?.MethodofConcretePlacingIsChute_NonPumpable
      );
      formikMixDesignTestDetails.setFieldValue(
        "MethodofConcretePlacingIsPumping",
        mdDetail?.MethodofConcretePlacingIsPumping
      );
      getMixDesignMasterDDLAll(itemTest.TestMasterIDEncrypted, itemTest);
      setShowMixDesignTestDetailModal(true);
    }
  };

  const [selectedTCIndex, setSelectedTCIndex] = useState(-1);
  const [selectedMixDesignTestID, setSelectedMixDesignTestID] = useState("");
  const [
    deleteMixDesignIncludedTestActionStatus,
    setDeleteMixDesignIncludedTestActionStatus,
  ] = useState(false);

  useEffect(() => {
    if (deleteMixDesignIncludedTestActionStatus == true) {
      deleteMixDesignIncludedTest(selectedTCIndex, selectedMixDesignTestID);
      setDeleteMixDesignIncludedTestActionStatus(false);
    }
  }, [deleteMixDesignIncludedTestActionStatus]);

  const deleteMixDesignIncludedTest = (
    mIndex,
    mixDesignTestID,
    deleteMixDesignTestAlso = false
  ) => {
    let newListOfMaterialTestDetails = [];
    Promise.all(
      ListOfMaterials[mIndex].ListOfMaterialTestDetails?.map((test, tIx) => {
        if (
          ListOfMaterials[mIndex]?.InwardMaterialIDEncrypted &&
          test?.InwardMaterialTestDetailIDEncrypted
        ) {
          if (test.MixDesignTestMasterIDEncrypted == mixDesignTestID) {
            newListOfMaterialTestDetails.push({ ...test, IsDeleted: true });
          } else {
            if (test.TestMasterIDEncrypted == mixDesignTestID) {
              if (deleteMixDesignTestAlso == true) {
                newListOfMaterialTestDetails.push({ ...test, IsDeleted: true });
              } else {
                newListOfMaterialTestDetails.push({ ...test });
              }
            } else {
              newListOfMaterialTestDetails.push({ ...test });
            }
          }
        } else {
          if (test.MixDesignTestMasterIDEncrypted != mixDesignTestID) {
            if (test.TestMasterIDEncrypted == mixDesignTestID) {
              if (deleteMixDesignTestAlso == false) {
                newListOfMaterialTestDetails.push({ ...test });
              }
            } else {
              newListOfMaterialTestDetails.push({ ...test });
            }
          }
        }
      })
    );

    formik.setFieldValue(
      `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails`,
      newListOfMaterialTestDetails
    );
  };

  const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
    useState(false);

  const getInwardMaterialDefineMoreRatesList = async (
    inwardMaterialTestDetailID,
    testMasterID,
    mIndex,
    tIndex
  ) => {
    setIsLoading(true);
    await post(POST_GetTestWiseDefineMoreRatesList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TestMasterIDEncrypted: testMasterID,
      InwardMaterialTestDetailIDEncrypted: inwardMaterialTestDetailID,
      CustomerIDEncrypted: CustomerIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ListOfDefineMoreRates`,
            response?.ListOfDefineMoreRates?.filter((x) => x.IsSelected == true)
              ?.length > 0
              ? response?.ListOfDefineMoreRates
              : response?.ListOfDefineMoreRates?.map((para) => ({
                  ...para,
                  IsSelected: para?.IsSelected,
                }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOnClickDefineMoreRatesSelection = async (
    indx,
    indxTest,
    item,
    itemTest,
    testmasterid,
    TestDetailID
  ) => {
    if (
      itemTest?.IsCancel == false &&
      item?.IsHold == false &&
      itemTest?.TestingDetails?.TestingStatus == 1
    ) {
      formikDefineMoreRates.setFieldValue(
        "MoreTestRatesList",
        itemTest?.ListOfDefineMoreRates
      );

      formikDefineMoreRates.setFieldValue("materialIndexPara", indx);
      formikDefineMoreRates.setFieldValue("testIndexPara", indxTest);
      formikDefineMoreRates.setFieldValue("testmasterid", testmasterid);
      formikDefineMoreRates.setFieldValue("TestDetailID", TestDetailID);
      formikDefineMoreRates.setFieldValue("isDefineMoreRateForTesting", false);
      setShowDefineMoreRatesModal(true);
    }
  };

  const validationSchemaDefineMoreRates = Yup.object().shape({});

  const formikDefineMoreRates = useFormik({
    validationSchema: validationSchemaDefineMoreRates,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitDefineMoreRates(values, formikHelpers),
    initialValues: {
      MoreTestRatesList: [],
      materialIndexPara: 0,
      testIndexPara: 0,
      FristtimeClickbtn: false,
      testmasterid: "",
      TestDetailID: "",
      isDefineMoreRateForTesting: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { MoreTestRatesList, isDefineMoreRateForTesting },
  } = formikDefineMoreRates;

  const handleValidSubmitDefineMoreRates = (values) => {
    if (isDefineMoreRateForTesting == true) {
      formikTesting.setFieldValue(
        "ListOfTestDefineMoreRates",
        values?.MoreTestRatesList?.map((itemsubRate) => ({
          InwardMaterialTestDetailIDEncrypted: values?.TestDetailID,
          TestMasterIDEncrypted: values?.testmasterid,
          RateType: itemsubRate?.RateType,
          RateTypeName: itemsubRate?.RateTypeName,
          IsSelected: itemsubRate?.IsSelected,
        }))
      );
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${values?.materialIndexPara}].ListOfMaterialTestDetails[${values?.testIndexPara}].ListOfDefineMoreRates`,
        values?.MoreTestRatesList?.map((itemsubRate) => ({
          InwardMaterialTestDetailIDEncrypted: values?.TestDetailID,
          TestMasterIDEncrypted: values?.testmasterid,
          RateType: itemsubRate?.RateType,
          RateTypeName: itemsubRate?.RateTypeName,
          IsSelected: itemsubRate?.IsSelected,
        }))
      );
    }
    setShowDefineMoreRatesModal(false);
  };

  const [showTestingModal, setshowTestingModal] = useState(false);

  const validationformikTesting = Yup.object().shape({
    btnSubmitTypeTesting: Yup.number(),
    TestingStatus: Yup.number(),
    TestingQty: Yup.number().when(
      "btnSubmitTypeTesting",
      ([btnSubmitTypeTesting], schema) => {
        if (btnSubmitTypeTesting != 1)
          return Yup.number()
            .required("Test Count is required field")
            .min(1, "Test Count is required field");
        return schema;
      }
    ),
    InvoiceQty: Yup.number().when(
      "btnSubmitTypeTesting",
      ([btnSubmitTypeTesting], schema) => {
        if (btnSubmitTypeTesting != 1)
          return Yup.number()
            .required("Billing Qty is required field")
            .min(1, "Billing Qty is required field");
        return schema;
      }
    ),
    ProductGroupIDEncrypted: Yup.string().when(
      "btnSubmitTypeTesting",
      ([btnSubmitTypeTesting], schema) => {
        if (btnSubmitTypeTesting != 1)
          return Yup.string().required("Material Group is required field");
        return schema;
      }
    ),
    ReferenceStandardIDEncrypted: Yup.string(),
    MaterialTypeIDEncrypted: Yup.string().when(
      "btnSubmitTypeTesting",
      ([btnSubmitTypeTesting], schema) => {
        if (btnSubmitTypeTesting != 1)
          return Yup.string().required("Material Type is required field");
        return schema;
      }
    ),
    ChangeNote: Yup.string().when(
      [
        "btnSubmitTypeTesting",
        "TestingStatus",
        "InwardMaterialTestDetailIDEncrypt",
      ],
      (
        [
          btnSubmitTypeTesting,
          TestingStatus,
          InwardMaterialTestDetailIDEncrypt,
        ],
        schema
      ) => {
        if (
          btnSubmitTypeTesting != 1 &&
          TestingStatus > 1 &&
          InwardMaterialTestDetailIDEncrypt
        )
          return Yup.string().required("Change Note is required field");
        return schema;
      }
    ),
    RefStandardSubGroup: Yup.string().when(
      ["btnSubmitTypeTesting", "ReferenceStandardIDEncrypted"],
      ([btnSubmitTypeTesting, ReferenceStandardIDEncrypted], schema) => {
        if (
          btnSubmitTypeTesting != 1 &&
          ReferenceStandardIDEncrypted &&
          refStandardSubGroupOptionsTesting?.filter((x) => x.value != "")
            ?.length > 0
        )
          return Yup.string().required("Group is required field");
        return schema;
      }
    ),
  });

  const formikTesting = useFormik({
    validationSchema: validationformikTesting,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTesting(values, formikHelpers),
    initialValues: {
      tcIndexTesting: -1,
      testIndexTesting: -1,
      TestMasterIDEncrypted: "",
      TestName: "",
      DepartmentIDEncrypt: "",
      DepartmentName: "",
      ProductGroupIDEncrypted: "",
      MaterialTypeIDEncrypted: "",
      ReferenceStandardIDEncrypted: "",
      RefStandardSubGroup: "",
      TestingQty: "",
      InvoiceQty: "",
      TestingIDEncrypt: "",
      InwardMaterialTestDetailIDEncrypt: "",
      TestingDate: new Date(),
      TestingToDate: new Date(),
      UnitID: "",
      TestMethodIDEncrypt: "",
      TestingByID: "",
      MachineIDEncrypt: "",
      ParameterWith: 1,
      IsMergeSameValue: false,
      Result: "",
      Remarks: "",
      ChangeNote: "",
      TestingStatus: 1,
      ListOfTPIDetails: [],
      ListTestingResultImages: [],
      ListTestMasterImages: [],
      ListTestingBy: [],
      btnSubmitTypeTesting: 1,
      ListOfParameter: [],
      IsNABLRangeChange: false,
      IsReTestTesting: false,
      TestingDateDisplay: "",
      TestingToDateDisplay: "",
      MachineName: "",
      UnitName: "",
      TestMethodName: "",
      ReferenceStandardName: "",
      AllowTestingEdit: 0,
      IsDefaultLoad: false,
      LocationType: 0,
      IsDefaultLoadCalculateAverage: false,
      ListOfTestDefineMoreRates: [],
      BasedOnMeasurementValue: "",
      BasedOnHrsValue: "",
      IsMixDesign: false,
      TestMixDesignDetail: {},
      ListOfMixDesignIncludedTest: [],
      IsMixDesignValidateFormulaExpression: false,
      ListOfMachines: [],
      TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData: {},
      ListOfMixDesignTargetStrengthForMixProportioning: [],
      ListOfMixDesignGroupParameters: [],
      ListOfMixDesignMixCalculation: [],
      ListOfMixDesignMixProportionsForTrial: [],
      testMethodOptionsTesting: [],
      refStandardSubGroupOptionsTesting: [],
      testingParametersRangeList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      tcIndexTesting,
      testIndexTesting,
      TestingDate,
      TestingToDate,
      testMethodOptionsTesting,
      testingParametersRangeList,
      refStandardSubGroupOptionsTesting,
    },
  } = formikTesting;

  const [onLoadSetParametersTestMethod, setOnLoadSetParametersTestMethod] =
    useState(false);

  useEffect(() => {
    if (onLoadSetParametersTestMethod == true) {
      getParameterTestMethodDDLList(formikTesting?.values?.TestingDate);
      setOnLoadSetParametersTestMethod(false);
    }
  }, [onLoadSetParametersTestMethod]);

  const handleOnClickTesting = (indx, indxTest, item, itemTest) => {
    if (itemTest?.IsCancel == false && item?.IsHold == false) {
      formikTesting.resetForm();
      formikTesting.setFieldValue("tcIndexTesting", indx);
      formikTesting.setFieldValue("testIndexTesting", indxTest);
      let testName = itemTest?.testOptions.filter(
        (x) => x.value == itemTest.TestMasterIDEncrypted
      )[0]?.label;
      formikTesting.setFieldValue("TestName", testName);
      formikTesting.setFieldValue(
        "TestMasterIDEncrypted",
        itemTest.TestMasterIDEncrypted
      );
      formikTesting.setFieldValue(
        "InwardMaterialTestDetailIDEncrypt",
        itemTest.InwardMaterialTestDetailIDEncrypted
      );
      let departmentName = departmentOptions.filter(
        (x) => x.value == itemTest.DepartmentIDEncrypted
      )[0]?.label;
      formikTesting.setFieldValue(
        "DepartmentIDEncrypt",
        itemTest.DepartmentIDEncrypted
      );
      formikTesting.setFieldValue("DepartmentName", departmentName);
      formikTesting.setFieldValue(
        "ProductGroupIDEncrypted",
        itemTest.ProductGroupIDEncrypted
      );
      formikTesting.setFieldValue(
        "MaterialTypeIDEncrypted",
        itemTest.MaterialTypeIDEncrypted
      );
      formikTesting.setFieldValue(
        "ReferenceStandardIDEncrypted",
        itemTest.ReferenceStandardIDEncrypted
      );
      formikTesting.setFieldValue(
        "RefStandardSubGroup",
        itemTest.RefStandardSubGroup
      );
      formikTesting.setFieldValue("TestingQty", itemTest.TestCount);
      formikTesting.setFieldValue("InvoiceQty", itemTest.BillingQty);
      formikTesting.setFieldValue(
        "TestingIDEncrypt",
        itemTest?.TestingDetails?.TestingIDEncrypted
      );
      formikTesting.setFieldValue("IsMixDesign", itemTest.IsMixDesign);
      formikTesting.setFieldValue(
        "TestMixDesignDetail",
        itemTest.TestMixDesignDetail
      );
      formikTesting.setFieldValue(
        "ListOfTestDefineMoreRates",
        itemTest.ListOfDefineMoreRates
      );
      formikTesting.setFieldValue(
        "TestingDate",
        itemTest?.TestingDetails?.TestingStatus == 1
          ? InwardDate
          : itemTest?.TestingDetails?.TestingDate
          ? new Date(itemTest?.TestingDetails?.TestingDate)
          : new Date()
      );
      formikTesting.setFieldValue(
        "TestingToDate",
        itemTest?.TestingDetails?.TestingStatus == 1
          ? InwardDate
          : itemTest?.TestingDetails?.TestingToDate
          ? new Date(itemTest?.TestingDetails?.TestingToDate)
          : new Date()
      );
      formikTesting.setFieldValue("UnitID", itemTest?.TestingDetails?.UnitID);
      formikTesting.setFieldValue(
        "BasedOnMeasurementValue",
        itemTest?.TestingDetails?.BasedOnMeasurementValue
      );
      formikTesting.setFieldValue(
        "BasedOnHrsValue",
        itemTest?.TestingDetails?.BasedOnHrsValue
      );
      formikTesting.setFieldValue(
        "TestMethodIDEncrypt",
        itemTest?.TestingDetails?.TestMethodIDEncrypt
      );
      formikTesting.setFieldValue(
        "MachineIDEncrypt",
        itemTest?.TestingDetails?.MachineIDEncrypt
      );
      formikTesting.setFieldValue(
        "ParameterWith",
        itemTest?.TestingDetails?.ParameterWith == 0
          ? itemTest.ReferenceStandardIDEncrypted
            ? 2
            : 1
          : itemTest?.TestingDetails?.ParameterWith
      );
      formikTesting.setFieldValue(
        "IsMergeSameValue",
        itemTest?.TestingDetails?.IsMergeSameValue
      );
      formikTesting.setFieldValue("Result", itemTest?.TestingDetails?.Result);
      formikTesting.setFieldValue("Remarks", itemTest?.TestingDetails?.Remarks);
      formikTesting.setFieldValue(
        "TestingStatus",
        itemTest?.TestingDetails?.TestingStatus
      );
      formikTesting.setFieldValue(
        "ListOfTPIDetails",
        itemTest?.TestingDetails?.TestingStatus == 1
          ? ListOfTPIDetails
          : itemTest?.TestingDetails?.ListOfTPIDetails
      );
      formikTesting.setFieldValue(
        "ListTestingResultImages",
        itemTest?.TestingDetails?.ListTestingResultImages
      );
      formikTesting.setFieldValue(
        "ListTestMasterImages",
        itemTest?.TestingDetails?.ListTestMasterImages
      );
      formikTesting.setFieldValue(
        "ListTestingBy",
        itemTest?.TestingDetails?.ListTestingBy
      );
      formikTesting.setFieldValue(
        "AllowTestingEdit",
        itemTest?.TestingDetails?.AllowTestingEdit
      );
      formikTesting.setFieldValue(
        "LocationType",
        itemTest?.TestingDetails?.LocationType
      );
      formikTesting.setFieldValue(
        "ListOfMachines",
        itemTest?.TestingDetails?.ListOfMachines
      );
      formikTesting.setFieldValue(
        "TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData",
        itemTest?.TestingDetails
          ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
      );
      formikTesting.setFieldValue(
        "ListOfMixDesignTargetStrengthForMixProportioning",
        itemTest?.TestingDetails
          ?.ListOfMixDesignTargetStrengthForMixProportioning
      );
      formikTesting.setFieldValue(
        "ListOfMixDesignGroupParameters",
        itemTest?.TestingDetails?.ListOfMixDesignGroupParameters
      );
      formikTesting.setFieldValue(
        "ListOfMixDesignMixCalculation",
        itemTest?.TestingDetails?.ListOfMixDesignMixCalculation
      );
      formikTesting.setFieldValue(
        "ListOfMixDesignMixProportionsForTrial",
        itemTest?.TestingDetails?.ListOfMixDesignMixProportionsForTrial
      );
      formikTesting.setFieldValue(
        "testingParametersRangeList",
        itemTest.parametersRangeList
      );
      formikTesting.setFieldValue(
        "refStandardSubGroupOptionsTesting",
        itemTest.refStandardSubGroupOptions
      );

      let ResultValueList = [];
      if (itemTest?.TestingDetails?.TestingStatus == 1) {
        if (itemTest.TestCount > 0) {
          for (let index = 0; index < itemTest.TestCount; index++) {
            ResultValueList.push({
              TestingResultIDEncrypted: "",
              TestingCount: index + 1,
              TestingCountHeader:
                "Sample:" + (index + 1 > 9 ? index + 1 : "0" + (index + 1)),
              ResultValue: "",
              ConsiderNABLResult: -1,
              ConsiderResult: -1,
            });
          }
        } else {
          ResultValueList = [
            {
              TestingResultIDEncrypted: "",
              TestingCount: 1,
              TestingCountHeader: "",
              ResultValue: "",
              ConsiderNABLResult: -1,
              ConsiderResult: -1,
            },
          ];
        }
      }

      if (
        itemTest?.TestingDetails.ListOfParameter?.length == 0 &&
        itemTest?.TestingDetails?.TestingStatus == 1
      ) {
        //Add Mode
        let selectedParaCount = itemTest?.ListOfTestParameters?.filter(
          (x) => x.IsSelected == true
        )?.length;

        let newListOfParameter = itemTest?.ListOfTestParameters?.map(
          (x, index) => ({
            IsSelected: selectedParaCount > 0 ? x?.IsSelected : true, //by default selected if there is no parameters selected (this is for Old records before parameter selection development)
            Sequence: index + 1,
            TestMasterParameterIDEncrypted: x?.RefParameterIDEncrypted,
            ParameterIDEncrypted: x?.ParameterIDEncrypted,
            DisplayCode: x?.DisplayCode,
            ParameterName: x?.ParameterName,
            ParameterType: x?.ParameterType,
            IsNABLParameter: x?.IsNABLParameter,
            RangeValue: x?.RangeValue,
            MinValue:
              x?.ParameterType == 1
                ? itemTest.parametersRangeList?.filter(
                    (r) =>
                      r.ParameterIDEncrypted == x.ParameterIDEncrypted &&
                      r.SubGroup == itemTest.RefStandardSubGroup
                  )?.length == 1
                  ? itemTest.parametersRangeList?.filter(
                      (r) =>
                        r.ParameterIDEncrypted == x.ParameterIDEncrypted &&
                        r.SubGroup == itemTest.RefStandardSubGroup
                    )[0]?.MinValue
                  : ""
                : x.MinValue,
            MaxValue:
              x?.ParameterType == 1
                ? itemTest.parametersRangeList?.filter(
                    (r) =>
                      r.ParameterIDEncrypted == x.ParameterIDEncrypted &&
                      r.SubGroup == itemTest.RefStandardSubGroup
                  )?.length == 1
                  ? itemTest.parametersRangeList?.filter(
                      (r) =>
                        r.ParameterIDEncrypted == x.ParameterIDEncrypted &&
                        r.SubGroup == itemTest.RefStandardSubGroup
                    )[0]?.MaxValue
                  : ""
                : x.MaxValue,
            Requirement:
              x?.ParameterType == 1
                ? itemTest.parametersRangeList?.filter(
                    (r) =>
                      r.ParameterIDEncrypted == x.ParameterIDEncrypted &&
                      r.SubGroup == itemTest.RefStandardSubGroup
                  )?.length == 1
                  ? itemTest.parametersRangeList?.filter(
                      (r) =>
                        r.ParameterIDEncrypted == x.ParameterIDEncrypted &&
                        r.SubGroup == itemTest.RefStandardSubGroup
                    )[0]?.Requirement
                  : ""
                : x.Requirement,

            TestMethodIDEncrypt: x?.TestMethodIDEncrypted
              ? x?.ListOfParameterTestMethod?.filter(
                  (method) =>
                    method.TestMethodIDEncrypted == x?.TestMethodIDEncrypted
                )?.length == 0
                ? ""
                : x?.TestMethodIDEncrypted
              : "",
            // testMethodOptions: x?.ListOfParameterTestMethod?.map((method) => ({
            //   ...method,
            //   label: method.NickName
            //     ? `${method.TestMethod} (${method.NickName})`
            //     : method.TestMethod,
            //   value: method?.TestMethodIDEncrypted,
            // })),
            TestMethod: x?.TestMethod ? x?.TestMethod : "",
            testMethodOptions: [], //will be set later for add mode
            ListOfParameterTestMethod: [], //will be set later for add mode

            NABLRangeFrom: x?.NABLRangeFrom
              ? x?.ListOfParameterTestMethod?.filter(
                  (method) =>
                    method.TestMethodIDEncrypted == x?.TestMethodIDEncrypted
                )?.length == 0
                ? ""
                : x?.NABLRangeFrom
              : "",
            NABLRangeTo: x?.NABLRangeTo
              ? x?.ListOfParameterTestMethod?.filter(
                  (method) =>
                    method.TestMethodIDEncrypted == x?.TestMethodIDEncrypted
                )?.length == 0
                ? ""
                : x?.NABLRangeTo
              : "",

            rangeOptions:
              x?.ParameterType == 1
                ? itemTest.parametersRangeList
                    ?.filter(
                      (r) =>
                        r.ParameterIDEncrypted == x.ParameterIDEncrypted &&
                        r.SubGroup == itemTest.RefStandardSubGroup &&
                        r.RangeValue != ""
                    )
                    ?.map((range) => ({
                      ...range,
                      label: range?.RangeValue,
                      value: range?.RangeValue,
                    }))
                : [],

            ListOfRange:
              x?.ParameterType == 1
                ? itemTest.parametersRangeList
                    ?.filter(
                      (r) =>
                        r.ParameterIDEncrypted == x.ParameterIDEncrypted &&
                        r.SubGroup == itemTest.RefStandardSubGroup
                      // &&
                      // r.RangeValue != ""
                    )
                    ?.map((range) => ({
                      ...range,
                      label: range?.RangeValue,
                      value: range?.RangeValue,
                    }))
                : [],

            ListOfResultValue: itemTest?.TestingDetails?.IsReTestTesting
              ? x?.ListOfResultValue?.map((result, index) => ({
                  TestingResultIDEncrypted: result?.TestingResultIDEncrypted,
                  TestingCount: result?.TestingCount,
                  TestingCountHeader: result?.TestingCountHeader,
                  ResultValue: result?.ResultValue,
                  ConsiderNABLResult: result?.ConsiderNABLResult,
                  ConsiderResult: result?.ConsiderResult,
                }))
              : itemTest?.TestingDetails?.TestingStatus != 1
              ? x?.ListOfResultValue?.map((result, index) => ({
                  TestingResultIDEncrypted: result?.TestingResultIDEncrypted,
                  TestingCount: result?.TestingCount,
                  TestingCountHeader: result?.TestingCountHeader
                    ? result?.TestingCountHeader
                    : "Sample:" +
                      (index + 1 > 9 ? index + 1 : "0" + (index + 1)),
                  ResultValue: result?.ResultValue,
                  ConsiderNABLResult: result?.ConsiderNABLResult,
                  ConsiderResult: result?.ConsiderResult,
                }))
              : ResultValueList?.map((r) => ({
                  ...r,
                  //ResultValue: x?.ResultValue,
                  ResultValue:
                    x?.ListOfRange?.length == 1
                      ? x?.ListOfRange[0]?.DefaultValue
                      : "",
                })),

            ShortCode: x?.ShortCode,
            FormulaExpression: x?.FormulaExpression,
            FormulaVariables: x?.FormulaVariables,
            FormulaEvaluationStatus: x?.FormulaEvaluationStatus,
            IsAverageRequired: x?.IsAverageRequired,
            AverageResultValue: x?.AverageResultValue,
            ParameterResultType: x?.ParameterResultType,
          })
        );

        /*Reorder - Sequence, if All parameters are not selected*/
        if (
          selectedParaCount > 0 &&
          itemTest?.ListOfTestParameters?.filter((x) => x.IsSelected == false)
            ?.length > 0
        ) {
          let newList = [];
          Promise.all(
            newListOfParameter
              ?.filter((para) => para?.IsSelected == true)
              ?.map((x, idx) => {
                newList.push({
                  ...x,
                  Sequence: idx + 1,
                });
              })
          );
          newList = [
            ...newList,
            ...newListOfParameter?.filter((para) => para?.IsSelected == false),
          ];

          newListOfParameter = newList;
        }

        formikTesting.setFieldValue("ListOfParameter", newListOfParameter);
        setOnLoadSetParametersTestMethod(true); //to set test method options
      } else {
        //Edit mode
        let selectedParaCount =
          itemTest?.TestingDetails?.ListOfParameter?.filter(
            (x) => x.IsSelected == true
          )?.length;

        let newListOfParameter = itemTest?.TestingDetails?.ListOfParameter?.map(
          (x, index) => ({
            IsSelected: selectedParaCount > 0 ? x?.IsSelected : true, //by default selected if there is no parameters selected (this is for Old records before parameter selection development)
            Sequence: index + 1,
            TestMasterParameterIDEncrypted: x?.TestMasterParameterIDEncrypted,
            ParameterIDEncrypted: x?.ParameterIDEncrypted,
            DisplayCode: x?.DisplayCode,
            ParameterName: x?.ParameterName,
            ParameterType: x?.ParameterType,
            IsNABLParameter: x?.IsNABLParameter,
            RangeValue: x?.RangeValue,
            MinValue: x?.MinValue
              ? x?.MinValue
              : x?.ListOfRange?.length == 1
              ? x?.ListOfRange[0]?.MinValue
              : "",
            MaxValue: x?.MaxValue
              ? x?.MaxValue
              : x?.ListOfRange?.length == 1
              ? x?.ListOfRange[0]?.MaxValue
              : "",
            //Requirement: x?.Requirement,
            Requirement:
              itemTest?.TestingDetails?.TestingStatus != 1
                ? x?.Requirement
                : x?.ListOfRange?.length == 1
                ? x?.ListOfRange[0]?.Requirement
                : x?.Requirement,

            TestMethodIDEncrypt: x?.TestMethodIDEncrypted
              ? x?.ListOfParameterTestMethod?.filter(
                  (method) =>
                    method.TestMethodIDEncrypted == x?.TestMethodIDEncrypted
                )?.length == 0
                ? ""
                : x?.TestMethodIDEncrypted
              : "",
            testMethodOptions: x?.ListOfParameterTestMethod?.map((method) => ({
              ...method,
              label: method.NickName
                ? `${method.TestMethod} (${method.NickName})`
                : method.TestMethod,
              value: method?.TestMethodIDEncrypted,
            })),
            ListOfParameterTestMethod: x?.ListOfParameterTestMethod,

            NABLRangeFrom: x?.NABLRangeFrom
              ? x?.ListOfParameterTestMethod?.filter(
                  (method) =>
                    method.TestMethodIDEncrypted == x?.TestMethodIDEncrypted
                )?.length == 0
                ? ""
                : x?.NABLRangeFrom
              : "",
            NABLRangeTo: x?.NABLRangeTo
              ? x?.ListOfParameterTestMethod?.filter(
                  (method) =>
                    method.TestMethodIDEncrypted == x?.TestMethodIDEncrypted
                )?.length == 0
                ? ""
                : x?.NABLRangeTo
              : "",

            rangeOptions: x?.ListOfRange?.filter(
              (x) => x.RangeValue != ""
            )?.map((range) => ({
              ...range,
              label: range?.RangeValue,
              value: range?.RangeValue,
            })),

            ListOfRange: x?.ListOfRange,

            ListOfResultValue: itemTest?.TestingDetails?.IsReTestTesting
              ? x?.ListOfResultValue?.map((result, index) => ({
                  TestingResultIDEncrypted: result?.TestingResultIDEncrypted,
                  TestingCount: result?.TestingCount,
                  TestingCountHeader: result?.TestingCountHeader,
                  ResultValue: result?.ResultValue,
                  ConsiderNABLResult: result?.ConsiderNABLResult,
                  ConsiderResult: result?.ConsiderResult,
                }))
              : itemTest?.TestingDetails?.TestingStatus != 1
              ? x?.ListOfResultValue?.map((result, index) => ({
                  TestingResultIDEncrypted: result?.TestingResultIDEncrypted,
                  TestingCount: result?.TestingCount,
                  TestingCountHeader: result?.TestingCountHeader
                    ? result?.TestingCountHeader
                    : "Sample:" +
                      (index + 1 > 9 ? index + 1 : "0" + (index + 1)),
                  ResultValue: result?.ResultValue,
                  ConsiderNABLResult: result?.ConsiderNABLResult,
                  ConsiderResult: result?.ConsiderResult,
                }))
              : ResultValueList?.map((r) => ({
                  ...r,
                  //ResultValue: x?.ResultValue,
                  ResultValue:
                    x?.ListOfRange?.length == 1
                      ? x?.ListOfRange[0]?.DefaultValue
                      : x?.ResultValue,
                })),

            ShortCode: x?.ShortCode,
            FormulaExpression: x?.FormulaExpression,
            FormulaVariables: x?.FormulaVariables,
            FormulaEvaluationStatus: x?.FormulaEvaluationStatus,
            IsAverageRequired: x?.IsAverageRequired,
            AverageResultValue: x?.AverageResultValue,
            ParameterResultType: x?.ParameterResultType,
          })
        );

        /*Reorder - Sequence, if All parameters are not selected*/
        if (
          selectedParaCount > 0 &&
          itemTest?.TestingDetails?.ListOfParameter?.filter(
            (x) => x.IsSelected == false
          )?.length > 0
        ) {
          let newList = [];
          Promise.all(
            newListOfParameter
              ?.filter((para) => para?.IsSelected == true)
              ?.map((x, idx) => {
                newList.push({
                  ...x,
                  Sequence: idx + 1,
                });
              })
          );
          newList = [
            ...newList,
            ...newListOfParameter?.filter((para) => para?.IsSelected == false),
          ];

          newListOfParameter = newList;
        }

        formikTesting.setFieldValue("ListOfParameter", newListOfParameter);

        setMachineOptions(
          itemTest?.TestingDetails?.ListOfMachines?.map((item) => ({
            label: item?.MachineName,
            value: item?.MachineIDEncrypted,
            IsCalibrationValidity: item?.IsCalibrationValidity,
            IsCalibrationValidityExpire: item?.IsCalibrationValidityExpire,
          }))
        );
        formikTesting.setFieldValue(
          "ListTestingBy",
          itemTest?.TestingDetails?.ListTestingBy?.map((item) => ({
            ...item,
            display: true,
          }))
        );
      }

      //ListOfMixDesignIncludedTest
      if (itemTest?.IsMixDesign == true) {
        let newListOfIncludedTests = [];
        item?.ListOfMaterialTestDetails?.filter(
          (x) =>
            x?.IsMixDesignIncludedTest == true &&
            x?.MixDesignTestMasterIDEncrypted == itemTest?.TestMasterIDEncrypted
        )?.map((x) => {
          let includedTestName = x?.testOptions.filter(
            (t) => t.value == x.TestMasterIDEncrypted
          )[0]?.label;
          newListOfIncludedTests.push({
            TestName: includedTestName,
            TestDetails: {
              ...x?.TestingDetails,
              TestingStatusName:
                x?.TestingDetails?.TestingStatus == 2
                  ? "Draft Save"
                  : x?.TestingDetails?.TestingStatus == 3
                  ? "Unapproved"
                  : x?.TestingDetails?.TestingStatus == 4
                  ? "Approved"
                  : x?.TestingDetails?.TestingStatus == 5
                  ? "Revise & Rectify"
                  : "Pending",
              ListOfParameter: x?.TestingDetails?.ListOfParameter?.map((p) => ({
                ...p,
                ListOfTestingResult: p?.ListOfResultValue,
              })),
            },
          });
        });
        formikTesting.setFieldValue(
          "ListOfMixDesignIncludedTest",
          newListOfIncludedTests
        );
      }

      setshowTestingModal(true);
    }
  };

  const handleValidSubmitTesting = (values) => {
    if (
      values?.testMethodOptionsTesting?.filter(
        (x) => x?.value == values?.TestMethodIDEncrypt
      )[0]?.IsExpiredTestMethod == true &&
      values.btnSubmitTypeTesting != 1
    ) {
      warningMessage("Test Method is Expired..!");
      return;
    }

    if (
      values.btnSubmitTypeTesting != 1 &&
      values?.ReferenceStandardIDEncrypted &&
      values?.refStandardSubGroupOptionsTesting?.filter(
        (x) => x?.value == values?.ReferenceStandardIDEncrypted
      )[0]?.IsExpiredReferenceStandard == true
    ) {
      warningMessage("Reference Standard is Expired..!");
      return;
    }

    if (values.btnSubmitTypeTesting != 1) {
      if (parseInt(values?.TestingQty) < parseInt(values?.InvoiceQty)) {
        formikTesting.setFieldError(
          "InvoiceQty",
          "Invoice Qty must be less then or equal to Testing Qty..."
        );
        formikTesting.setFieldTouched("InvoiceQty", true);
        return;
      }
      Promise.all(
        values?.ListOfParameter?.map((p) => {
          if (
            p?.testMethodOptions?.filter(
              (x) => x?.value == p?.TestMethodIDEncrypt
            )[0]?.IsExpiredTestMethod == true
          ) {
            warningMessage(
              p?.testMethodOptions?.filter(
                (x) => x?.value == p?.TestMethodIDEncrypt
              )[0]?.TestMethod + " - Test Method is Expired..!"
            );
            return;
          }
        })
      );
    }

    if (
      values?.ListTestingBy?.filter((e) => e.IsSelected == true)?.length == 0 &&
      values.btnSubmitTypeTesting != 1
    ) {
      //warningMessage("Please select atleast one Testing By...");
      formikTesting.setFieldError(
        "ListTestingBy",
        "Testing By is required field"
      );
      formikTesting.setFieldTouched("ListTestingBy", true);
      return;
    }

    if (
      values?.btnSubmitTypeTesting != 1 &&
      values?.ReferenceStandardIDEncrypted &&
      values?.ListOfParameter?.filter(
        (x) => x.rangeOptions?.length > 0 && x.IsSelected == true
      )?.length > 0 &&
      values?.ListOfParameter?.filter(
        (x) =>
          x.rangeOptions?.length > 0 && !x.RangeValue && x.IsSelected == true
      )?.length > 0
    ) {
      formikTesting.setFieldError("ListOfParameter", "Please select Range...");
      formikTesting.setFieldTouched("ListOfParameter", true);
      return;
    }

    if (
      AuthUser?.Permissions?.Account == 1 &&
      values?.btnSubmitTypeTesting != 1
    ) {
      if (
        values?.ListOfTestDefineMoreRates?.filter(
          (e) => e?.IsSelected == true && e?.RateType == 4 //Based On Measurement
        )?.length > 0
      ) {
        if (values?.UnitID == "") {
          formikTesting.setFieldError("UnitID", "Please select Unit...");
          formikTesting.setFieldTouched("UnitID", true);
          return;
        }

        if (values?.BasedOnMeasurementValue == "") {
          formikTesting.setFieldError(
            "BasedOnMeasurementValue",
            "Based On Measurement Value is required field..."
          );
          formikTesting.setFieldTouched("BasedOnMeasurementValue", true);
          return;
        }
      }

      if (
        values?.ListOfTestDefineMoreRates?.filter(
          (e) => e?.IsSelected == true && e?.RateType == 7 //Based On Hrs
        )?.length > 0 &&
        values?.BasedOnHrsValue == ""
      ) {
        formikTesting.setFieldError(
          "BasedOnHrsValue",
          "Based On HrsValue is required field..."
        );
        formikTesting.setFieldTouched("BasedOnHrsValue", true);
        return;
      }
    }

    formik.setFieldValue(
      `ListOfMaterials[${values.tcIndexTesting}].ListOfMaterialTestDetails[${values.testIndexTesting}].ProductGroupIDEncrypted`,
      values?.ProductGroupIDEncrypted
    );
    formik.setFieldValue(
      `ListOfMaterials[${values.tcIndexTesting}].ListOfMaterialTestDetails[${values.testIndexTesting}].MaterialTypeIDEncrypted`,
      values?.MaterialTypeIDEncrypted
    );
    formik.setFieldValue(
      `ListOfMaterials[${values.tcIndexTesting}].ListOfMaterialTestDetails[${values.testIndexTesting}].ReferenceStandardIDEncrypted`,
      values?.ReferenceStandardIDEncrypted
    );
    formik.setFieldValue(
      `ListOfMaterials[${values.tcIndexTesting}].ListOfMaterialTestDetails[${values.testIndexTesting}].refStandardSubGroupOptions`,
      values?.refStandardSubGroupOptionsTesting
    );
    formik.setFieldValue(
      `ListOfMaterials[${values.tcIndexTesting}].ListOfMaterialTestDetails[${values.testIndexTesting}].RefStandardSubGroup`,
      values?.RefStandardSubGroup
    );
    formik.setFieldValue(
      `ListOfMaterials[${values.tcIndexTesting}].ListOfMaterialTestDetails[${values.testIndexTesting}].TestCount`,
      values?.TestingQty
    );
    formik.setFieldValue(
      `ListOfMaterials[${values.tcIndexTesting}].ListOfMaterialTestDetails[${values.testIndexTesting}].BillingQty`,
      values?.InvoiceQty
    );
    formik.setFieldValue(
      `ListOfMaterials[${values.tcIndexTesting}].ListOfMaterialTestDetails[${values.testIndexTesting}].parametersRangeList`,
      values?.testingParametersRangeList
    );
    formik.setFieldValue(
      `ListOfMaterials[${values.tcIndexTesting}].ListOfMaterialTestDetails[${values.testIndexTesting}].TestingDetails`,
      {
        TestingIDEncrypted: values?.TestingIDEncrypt,
        TestingDate: values?.TestingDate
          ? moment(values?.TestingDate).format("YYYY-MM-DD").replace(/^\-/, "")
          : "",
        TestingToDate: values?.TestingToDate
          ? moment(values?.TestingToDate)
              .format("YYYY-MM-DD")
              .replace(/^\-/, "")
          : "",
        UnitID: values?.UnitID,
        BasedOnMeasurementValue: values?.BasedOnMeasurementValue,
        BasedOnHrsValue: values?.BasedOnHrsValue,
        TestMethodIDEncrypt: values?.TestMethodIDEncrypt,
        MachineIDEncrypt: values?.MachineIDEncrypt,
        ParameterWith: values?.ParameterWith,
        IsMergeSameValue: values?.IsMergeSameValue,
        Result: values?.Result,
        Remarks: values?.Remarks,
        TestingStatus:
          values?.btnSubmitTypeTesting == 1
            ? 2
            : values?.btnSubmitTypeTesting == 2
            ? 4
            : 3,
        ListOfTPIDetails: values?.ListOfTPIDetails,
        ListTestingResultImages: values?.ListTestingResultImages,
        ListTestMasterImages: values?.ListTestMasterImages,
        ListTestingBy: values?.ListTestingBy,
        ListOfParameter: values?.ListOfParameter,
        AllowTestingEdit: values?.AllowTestingEdit,
        LocationType: values?.LocationType,
        ListOfMachines: values?.ListOfMachines,
        TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData:
          values?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData,
        ListOfMixDesignTargetStrengthForMixProportioning:
          values?.ListOfMixDesignTargetStrengthForMixProportioning,
        ListOfMixDesignGroupParameters: values?.ListOfMixDesignGroupParameters,
        ListOfMixDesignMixCalculation: values?.ListOfMixDesignMixCalculation,
        ListOfMixDesignMixProportionsForTrial:
          values?.ListOfMixDesignMixProportionsForTrial,
        IsReTestTesting: values?.IsReTestTesting,
        ChangeNote: values?.ChangeNote,
      }
    );

    setshowTestingModal(false);
  };

  useEffect(() => {
    if (TestingToDate && TestingToDate < TestingDate) {
      formikTesting.setFieldValue("TestingToDate", TestingDate);
    }
    getTestMethodDDLList();
  }, [TestingDate]);

  const getTestMethodDDLList = async () => {
    //setIsLoading(true);
    post(POST_GetTestingDateWiseTestMethodDDLList, {
      InwardMaterialTestDetailIDEncrypted:
        formikTesting?.values?.InwardMaterialTestDetailIDEncrypt,
      TranDate: TestingDate
        ? moment(TestingDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          if (response?.ListOfTestMethod?.length > 0) {
            formikTesting.setFieldValue(
              "testMethodOptionsTesting",
              response?.ListOfTestMethod?.map((item) => ({
                label: item?.TestMethod,
                value: item?.TestMethodIDEncrypted,
                IsExpiredTestMethod: item?.IsExpiredTestMethod,
              }))
            );
            if (formikTesting?.values?.TestMethodIDEncrypt) {
              if (
                response?.ListOfTestMethod?.filter(
                  (x) =>
                    x.TestMethodIDEncrypted ==
                    formikTesting?.values?.TestMethodIDEncrypt
                )?.length == 0
              ) {
                formikTesting.setFieldValue("TestMethodIDEncrypt", "");
              }
            }
          } else {
            formikTesting.setFieldValue("testMethodOptionsTesting", []);
            formikTesting.setFieldValue("TestMethodIDEncrypt", "");
          }
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getParameterTestMethodDDLList = async (testingDate) => {
    setIsLoading(true);
    post(POST_GetTestingDateWiseParameterTestMethodDDLList, {
      InwardMaterialTestDetailIDEncrypted:
        formikTesting?.values?.InwardMaterialTestDetailIDEncrypt,
      TranDate: testingDate
        ? moment(testingDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : moment(new Date()).format("YYYY-MM-DD").replace(/^\-/, ""),
      TestMasterIDEncrypted: formikTesting?.values?.TestMasterIDEncrypted,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          if (response?.ListOfParameterTestMethod?.length > 0) {
            formikTesting?.values?.ListOfParameter?.map((para, index) => {
              let paraTestMethodList =
                response?.ListOfParameterTestMethod?.filter(
                  (x) => x.ParameterIDEncrypted == para?.ParameterIDEncrypted
                );
              formikTesting.setFieldValue(
                `ListOfParameter[${index}].testMethodOptions`,
                paraTestMethodList?.map((method) => ({
                  ...method,
                  label: method.NickName
                    ? `${method.TestMethod} (${method.NickName})`
                    : method.TestMethod,
                  value: method?.TestMethodIDEncrypted,
                }))
              );
              formikTesting.setFieldValue(
                `ListOfParameter[${index}].ListOfParameterTestMethod`,
                paraTestMethodList?.map((method) => ({
                  ...method,
                  label: method.NickName
                    ? `${method.TestMethod} (${method.NickName})`
                    : method.TestMethod,
                  value: method?.TestMethodIDEncrypted,
                }))
              );
              if (
                paraTestMethodList?.filter(
                  (x) => x.TestMethodIDEncrypted == para.TestMethodIDEncrypt
                )?.length == 0
              ) {
                formikTesting.setFieldValue(
                  `ListOfParameter[${index}].TestMethodIDEncrypt`,
                  ""
                );
                formikTesting.setFieldValue(
                  `ListOfParameter[${index}].NABLRangeFrom`,
                  ""
                );
                formikTesting.setFieldValue(
                  `ListOfParameter[${index}].NABLRangeTo`,
                  ""
                );
              }
            });

            formikTesting.setFieldValue("IsNABLRangeChange", true);
          } else {
            formikTesting?.values?.ListOfParameter?.map((para, index) => {
              formikTesting.setFieldValue(
                `ListOfParameter[${index}].testMethodOptions`,
                []
              );
              formikTesting.setFieldValue(
                `ListOfParameter[${index}].TestMethodIDEncrypt`,
                ""
              );
              formikTesting.setFieldValue(
                `ListOfParameter[${index}].NABLRangeFrom`,
                ""
              );
              formikTesting.setFieldValue(
                `ListOfParameter[${index}].NABLRangeTo`,
                ""
              );

              //NABL Range From or To is blank or Non Numeric or Non Std. Para then result is not identified
              for (let i = 0; i < para?.ListOfResultValue?.length; i++) {
                formikTesting.setFieldValue(
                  `ListOfParameter[${index}].ListOfResultValue[${i}].ConsiderNABLResult`,
                  -1
                );
              }
            });
          }
          if (!formikTesting?.values?.InwardMaterialTestDetailIDEncrypt) {
            setMachineOptions(
              response?.ListOfMachines?.map((item) => ({
                label: item?.MachineName,
                value: item?.MachineIDEncrypted,
                IsCalibrationValidity: item?.IsCalibrationValidity,
                IsCalibrationValidityExpire: item?.IsCalibrationValidityExpire,
              }))
            );
            formikTesting.setFieldValue(
              "ListTestingBy",
              response?.TestingByList?.map((item) => ({
                EmployeeIDEncrypt: item.EmployeeIDEncrypted,
                EmployeeName: item.EmployeeName,
                IsSelected: item.IsSelected,
                display: true,
              }))
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getDepartmentDDLForScopeValidityCheck = async (testingDate) => {
    setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TransactionDate: testingDate
        ? moment(testingDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : moment(new Date()).format("YYYY-MM-DD").replace(/^\-/, ""),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          if (formikTesting?.values?.DepartmentIDEncrypt) {
            response?.List?.map((item) => {
              if (
                item?.DepartmentIDEncrypted ==
                formikTesting?.values?.DepartmentIDEncrypt
              ) {
                if (item?.IsNABLScopeExpired == true) {
                  customConfirmDialog(
                    `${item?.DepartmentName} Scope is Expired`,
                    `Do you want to continue?`,
                    () => {
                      setshowTestingModal(false);
                    },
                    false
                  );
                }
              }
            });
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeTestMethodTesting = async (
    testMethodID,
    IsExpiredTestMethod
  ) => {
    if (IsExpiredTestMethod) {
      warningMessage("Test Method is Expired..!");
      formikTesting.setFieldValue("TestMethodIDEncrypt", "");
      return;
    }
    formikTesting.setFieldValue("TestMethodIDEncrypt", testMethodID);

    /*To set selected test method to all parameters test method which is having same method and not selected*/
    formikTesting?.values?.ListOfParameter?.map((x, i) => {
      if (x?.ParameterType == 1) {
        if (
          !x?.TestMethodIDEncrypt &&
          x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)
            ?.length > 0
        ) {
          formikTesting.setFieldValue(
            `ListOfParameter[${i}].TestMethodIDEncrypt`,
            testMethodID
          );
          formikTesting.setFieldValue(
            `ListOfParameter[${i}].NABLRangeFrom`,
            x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)[0]
              ?.NABLRangeFrom
          );
          formikTesting.setFieldValue(
            `ListOfParameter[${i}].NABLRangeTo`,
            x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)[0]
              ?.NABLRangeTo
          );
        }
      }
    });

    formikTesting.setFieldValue("IsNABLRangeChange", true);
  };

  const getUnitDDL = () => {
    //setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 8, // Unit
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setUnitOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            }))
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fetchMachineResults = async () => {
    if (formikTesting?.values?.TestingQty == 0) {
      warningMessage("Testing Qty is required...!");
      return;
    }
    if (formikTesting?.values?.MachineIDEncrypt == "") {
      warningMessage("Machine is required...!");
      return;
    }
    if (ListOfMaterials[tcIndexTesting]?.TCNo == "") {
      warningMessage("TC No is required...!");
      return;
    }

    setIsLoading(true);

    await post(POST_TestingFetchMachineParameterResults, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      MachineIDEncrypted: formikTesting?.values?.MachineIDEncrypt,
      TestMasterIDEncrypted:
        ListOfMaterials[tcIndexTesting]?.ListOfMaterialTestDetails[
          testIndexTesting
        ]?.TestMasterIDEncrypted,
      TCNo: ListOfMaterials[tcIndexTesting]?.TCNo,
      TestCount: formikTesting?.values?.TestingQty,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          if (response?.ListOfResults?.length > 0) {
            Promise.all(
              formikTesting?.values?.ListOfParameter?.map((para, pIndex) => {
                // if (para.ParameterType == 1) {
                // if (
                //   response?.ListOfResults?.filter(
                //     (x) => x.ParameterIDEncrypted == para.ParameterIDEncrypted
                //   )?.length > 0
                // ) {
                const matchingResults = response?.ListOfResults?.filter(
                  (x) =>
                    x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                    x.ParameterType == para.ParameterType
                );
                if (matchingResults?.length > 0) {
                  // Loop through each TestCount
                  matchingResults.forEach((result, index) => {
                    // Assuming you have TestCount-related data in the 'result' object
                    const resultValue = result?.csvParameterResultValue;
                    const resultIndex = result.TestCount - 1;

                    // Set the ResultValue for each TestCount dynamically
                    formikTesting.setFieldValue(
                      `ListOfParameter[${pIndex}].ListOfResultValue[${resultIndex}].ResultValue`,
                      resultValue
                    );

                    // Call the function to handle changes based on ResultValue
                    OnResultValueChangeConsiderResult(
                      pIndex,
                      resultIndex,
                      para?.MinValue,
                      para?.MaxValue,
                      resultValue,
                      para?.ParameterType,
                      para?.NABLRangeFrom,
                      para?.NABLRangeTo,
                      para?.ParameterResultType,
                      para?.IsNABLParameter
                    );
                  });
                  //successMessage("Parameter Results Fetch Successfully!");
                } else {
                }
                // }
                // } else {
                // }
              })
            );
            formikTesting.setFieldValue("IsDefaultLoadCalculateAverage", true); //calculate average
          } else {
            warningMessage("Parameter Results not found...!");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const OnResultValueChangeConsiderResult = (
    pIndex,
    rIndex,
    minValue,
    maxValue,
    resultValue,
    pType,
    minValueNABL,
    maxValueNABL,
    ParameterResultType,
    IsNABLParameter
  ) => {
    if (resultValue && isNaN(resultValue) == false) {
      /*Consider minValue blank = 0, maxValue blank = infinite*/
      if (
        // minValue &&
        // maxValue &&
        // isNaN(minValue) == false &&
        // isNaN(maxValue) == false
        (minValue || maxValue) &&
        isNaN(minValue ? minValue : 0) == false &&
        isNaN(maxValue ? maxValue : 0) == false
      ) {
        if (
          // parseFloat(resultValue) >= parseFloat(minValue) &&
          // parseFloat(resultValue) <= parseFloat(maxValue)
          parseFloat(resultValue) >= parseFloat(minValue ? minValue : 0) &&
          ((maxValue && parseFloat(resultValue) <= parseFloat(maxValue)) ||
            (!maxValue && 1 == 1))
        ) {
          formikTesting.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderResult`,
            1
          );
        } else {
          formikTesting.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderResult`,
            0
          );
        }
      } else {
        //minValue or maxValue is not available then result is not identified
        formikTesting.setFieldValue(
          `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderResult`,
          -1
        );
        // formik.setFieldValue(
        //   `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
        //   -1
        // );
        formikTesting.setFieldValue(
          `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
          IsNABLParameter ? (ParameterResultType == 2 ? 1 : -1) : -1
        );
      }
      //set NABL Result
      /*Consider minValue blank = 0, maxValue blank = infinite*/
      if (
        pType == 1 &&
        // minValueNABL &&
        // maxValueNABL &&
        // isNaN(minValueNABL) == false &&
        // isNaN(maxValueNABL) == false
        (minValueNABL || maxValueNABL) &&
        isNaN(minValueNABL ? minValueNABL : 0) == false &&
        isNaN(maxValueNABL ? maxValueNABL : 0) == false
      ) {
        if (
          // parseFloat(resultValue) >= parseFloat(minValueNABL) &&
          // parseFloat(resultValue) <= parseFloat(maxValueNABL)
          parseFloat(resultValue) >=
            parseFloat(minValueNABL ? minValueNABL : 0) &&
          ((maxValueNABL &&
            parseFloat(resultValue) <= parseFloat(maxValueNABL)) ||
            (!maxValueNABL && 1 == 1))
        ) {
          formikTesting.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
            1
          );
        } else {
          // formik.setFieldValue(
          //   `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
          //   0
          // );
          formikTesting.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
            IsNABLParameter ? (ParameterResultType == 2 ? 1 : 0) : 0
          );
        }
      } else {
        //parameter is non standard then NABL result consider as not identified
        if (
          pType == 1 &&
          formikTesting?.values?.ListOfParameter[pIndex].TestMethodIDEncrypt
        ) {
          formikTesting.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
            IsNABLParameter ? (ParameterResultType == 2 ? 1 : -1) : -1
          );
        } else {
          formikTesting.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
            -1
          );
        }
      }
    } else {
      //result Value is blank then result is not identified
      formikTesting.setFieldValue(
        `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderResult`,
        -1
      );
      if (
        resultValue &&
        formikTesting?.values?.ListOfParameter[pIndex].TestMethodIDEncrypt
      ) {
        formikTesting.setFieldValue(
          `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
          IsNABLParameter ? (ParameterResultType == 2 ? 1 : -1) : -1
        );
      } else {
        formikTesting.setFieldValue(
          `ListOfParameter[${pIndex}].ListOfResultValue[${rIndex}].ConsiderNABLResult`,
          -1
        );
      }
    }
  };

  const [showMachineListModal, setShowMachineListModal] = useState(false);
  const [showCertificateModal, setShowCertificateModal] = useState(false);

  const [machineCalibrationDocumentsList, setMachineCalibrationDocumentsList] =
    useState([]);

  const [machineOptions, setMachineOptions] = useState([]);

  const fetchMachineList = async () => {
    formikTesting.setFieldValue("ListOfMachines", "");
    if (formikTesting?.values?.MachineIDEncrypt) {
      await post(POST_TestingMachineList, {
        MachineIDEncrypted: formikTesting?.values?.MachineIDEncrypt,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formikTesting.setFieldValue(
              "ListOfMachines",
              response?.ListOfMachines
            );
          } else {
            formikTesting.setFieldValue("ListOfMachines", "");
          }
        })
        .catch((error) => {
          console.log(error);
        });

      setShowMachineListModal(true);
    }
  };

  const handleChangeMachine = (e) => {
    formikTesting.setFieldValue("MachineIDEncrypt", e?.value ?? "");
    if (e?.IsCalibrationValidityExpire) {
      // warningMessage(e?.label + " Calibration Validity Expired!");
      // formikTesting.setFieldValue("MachineIDEncrypt", "");

      customConfirmDialog(
        e?.label + " Calibration Validity Expired!",
        "Do you want to continue?",
        fnCallbackChangeMachine,
        false
      );
    }
  };

  const fnCallbackChangeMachine = () => {
    formikTesting.setFieldValue("MachineIDEncrypt", "");
  };

  const locationTypeOptions = [
    { label: "Permanent Facility", value: 1 },
    { label: "On Site", value: 2 },
  ];

  const handleChangeSearchTestingBy = (e) => {
    formikTesting.setFieldValue("searchTestingBy", e?.target?.value);
    formikTesting.setFieldValue(
      "ListTestingBy",
      formikTesting?.values?.ListTestingBy?.map((x) => {
        return {
          ...x,
          display: x.EmployeeName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase()
          )
            ? true
            : false,
        };
      })
    );
  };

  const getDefineMoreRatesModal = async () => {
    formikDefineMoreRates.setFieldValue(
      "MoreTestRatesList",
      formikTesting?.values?.ListOfTestDefineMoreRates?.map((itemsubRate) => ({
        TestMasterDefineMoreRatesIDEncrypted:
          itemsubRate?.TestMasterDefineMoreRatesIDEncrypted,
        InwardMaterialTestDetailIDEncrypted:
          itemsubRate?.InwardMaterialTestDetailIDEncrypted,
        TestMasterIDEncrypted: itemsubRate?.TestMasterIDEncrypted,
        RateType: itemsubRate?.RateType,
        RateTypeName: itemsubRate?.RateTypeName,
        IsSelected: itemsubRate?.IsSelected,
      }))
    );

    formikDefineMoreRates.setFieldValue(
      "materialIndexPara",
      formikTesting?.values?.tcIndexTesting
    );
    formikDefineMoreRates.setFieldValue(
      "testIndexPara",
      formikTesting?.values?.testIndexTesting
    );
    formikDefineMoreRates.setFieldValue(
      "testmasterid",
      formikTesting?.values?.TestMasterIDEncrypted
    );
    formikDefineMoreRates.setFieldValue(
      "TestDetailID",
      formikTesting?.values?.InwardMaterialTestDetailIDEncrypt
    );
    formikDefineMoreRates.setFieldValue("isDefineMoreRateForTesting", true);
    setShowDefineMoreRatesModal(true);
  };

  const [showTestMasterImagesModal, setShowTestMasterImagesModal] =
    useState(false);
  const [showTestingImagesModal, setShowTestingImagesModal] = useState(false);

  const uploadTestingResultImage = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        warningMessage("Select valid image file!");
      } else {
        formikTesting.setFieldValue("ListTestingResultImages", [
          ...formikTesting?.values?.ListTestingResultImages,
          {
            TestingResultImageIDEncrypted: "",
            TestingID: "",
            TestingResultImageFile: file,
            viewFile: URL.createObjectURL(file),
            TestingResultImageFileName: file?.name,
            ResultImagePath: "",
            IsDeleted: false,
            Remarks: "",
          },
        ]);
      }
    }
  };

  const deleteTestingResultImage = (i) => {
    formikTesting.setFieldValue(
      "ListTestingResultImages",
      formikTesting?.values?.ListTestingResultImages?.map((x, idx) => {
        if (idx == i) {
          return {
            ...x,
            IsDeleted: true,
          };
        } else {
          return { ...x };
        }
      })
    );
  };

  const reorder = (list, startIndex, endIndex) => {
    //console.log("List", list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      formikTesting?.values?.ListOfParameter,
      result.source.index,
      result.destination.index
    );

    let newList = [];
    Promise.all(
      items?.map((x, idx) => {
        newList.push({
          ...x,
          Sequence: idx + 1,
        });
      })
    );

    formikTesting.setFieldValue("ListOfParameter", newList);
  };

  const checkFormulaEvaluationStatus = (
    testingParametersShortCodes,
    formulaVariables
  ) => {
    // Split the testingAllParametersShortCodes and trim whitespace
    const testingParametersShortCodesArray = testingParametersShortCodes
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries

    const variablesArray = formulaVariables
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries;

    // Find formulaVariables that do not exist in testingParametersShortCodes
    const notExists = variablesArray.filter(
      (variable) => !testingParametersShortCodesArray.includes(variable)
    );

    // Return true if all variables exist, otherwise false
    return notExists.length === 0;
  };

  const handleChangeTestingCountHeaderText = (headerText, resultIndex) => {
    formikTesting?.values?.ListOfParameter?.map((para, pIndex) => {
      formikTesting.setFieldValue(
        `ListOfParameter[${pIndex}].ListOfResultValue[${resultIndex}].TestingCountHeader`,
        headerText
      );
    });
  };

  const [
    showParameterFormulaExpressionModal,
    setShowParameterFormulaExpressionModal,
  ] = useState(false);

  const validationSchemaParameterFormula = Yup.object().shape({});

  const formikParameterFormula = useFormik({
    validationSchema: validationSchemaParameterFormula,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitParameterFormula(values, formikHelpers),
    initialValues: {
      ParameterName: "",
      FormulaExpression: "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitParameterFormula,
    values: {},
  } = formikParameterFormula;

  const showFormula = (parameterName, formula) => {
    formikParameterFormula.setFieldValue("ParameterName", parameterName);
    formikParameterFormula.setFieldValue("FormulaExpression", formula);
    setShowParameterFormulaExpressionModal(true);
  };

  const calculateFormula = (paraIndex, formulaExpression, formulaVariables) => {
    setIsLoading(true);

    let parameterResultVariablesValueList = [];

    const variablesArray = formulaVariables
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries;

    Promise.all(
      formikTesting?.values?.ListOfParameter[paraIndex]?.ListOfResultValue?.map(
        (item, itemIndex) => {
          let variablesValueList = [];

          Promise.all(
            variablesArray?.map((x) => {
              let xValue = "";
              xValue =
                formikTesting?.values?.ListOfParameter?.filter(
                  (p) => p.ShortCode == x
                )[0]?.ListOfResultValue?.filter((r, i) => i == itemIndex)[0]
                  ?.ResultValue ?? "";

              if (!xValue && formikTesting?.values?.IsMixDesign == true) {
                formikTesting?.values?.ListOfMixDesignIncludedTest?.forEach(
                  (test) => {
                    if (test.TestDetails && test.TestDetails.ListOfParameter) {
                      test.TestDetails.ListOfParameter.forEach((param) => {
                        if (param.ShortCode == x) {
                          if (param.ListOfTestingResult.length > itemIndex) {
                            xValue =
                              param.ListOfTestingResult[itemIndex].ResultValue;
                          } else {
                            if (param.ListOfTestingResult.length > 0) {
                              xValue = param.ListOfTestingResult[0].ResultValue;
                            }
                          }
                        }
                      });
                    }
                  }
                );
              }

              variablesValueList.push({
                VariableName: x,
                VariableValue: xValue,
              });
            })
          );

          parameterResultVariablesValueList.push({
            ResultIndex: itemIndex,
            ListOfVariableValues: variablesValueList,
          });
        }
      )
    );

    post(POST_GetTestingParameterFormulaExpressionResult, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      FormulaExpression: formulaExpression,
      FormulaVariables: formulaVariables,
      ListOfParametersVariableResultValue: parameterResultVariablesValueList,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          response?.ListOfParametersResultValue?.map((result) => {
            formikTesting.setFieldValue(
              `ListOfParameter[${paraIndex}].ListOfResultValue[${result.ResultIndex}].ResultValue`,
              result.ResultValue.includes(".")
                ? parseFloat(result.ResultValue).toFixed(2)
                : result.ResultValue
            );
            if (
              formikTesting?.values?.ListOfParameter[paraIndex]
                .IsAverageRequired == true
            ) {
              calculateResultAverage(
                paraIndex,
                result.ResultIndex,
                result.ResultValue.includes(".")
                  ? parseFloat(result.ResultValue).toFixed(2)
                  : result.ResultValue
              );
            }
          });
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const calculateResultAverage = (paraIndex, resultIndex, resultValue) => {
    let averageResultValue = 0,
      resultCount = 0;
    resultCount = formikTesting?.values?.ListOfParameter[
      paraIndex
    ].ListOfResultValue?.filter(
      (x, i) => i != resultIndex && x.ResultValue
    ).length;
    if (resultValue) {
      resultCount = resultCount + 1;
    }
    if (resultCount > 0) {
      let resultValueTotal = resultValue
        ? isNaN(resultValue) == false
          ? parseFloat(resultValue)
          : 0
        : 0;
      formikTesting?.values?.ListOfParameter[
        paraIndex
      ].ListOfResultValue?.filter(
        (x, i) => i != resultIndex && x.ResultValue
      )?.map((item) => {
        resultValueTotal =
          resultValueTotal +
          (isNaN(item.ResultValue) == false ? parseFloat(item.ResultValue) : 0);
      });
      averageResultValue = parseFloat(resultValueTotal / resultCount).toFixed(
        2
      );
    } else {
      averageResultValue = resultValue;
    }
    if (isNaN(averageResultValue) == true) {
      averageResultValue = "";
    }
    formikTesting.setFieldValue(
      `ListOfParameter[${paraIndex}].AverageResultValue`,
      averageResultValue
    );
  };

  useEffect(() => {
    if (formikTesting?.values?.IsDefaultLoadCalculateAverage) {
      formikTesting?.values?.ListOfParameter?.map((para, index) => {
        if (para.IsAverageRequired == true) {
          calculateResultAverage(index, -1, "");
        }
      });
      formikTesting.setFieldValue("IsDefaultLoadCalculateAverage", false);
    }
  }, [formikTesting?.values?.IsDefaultLoadCalculateAverage]);

  const handleChangeTestMethodParameter = async (
    index,
    testMethodID,
    IsExpiredTestMethod,
    testMethod
  ) => {
    if (IsExpiredTestMethod) {
      warningMessage("Test Method is Expired..!");
      formikTesting.setFieldValue(
        `ListOfParameter[${index}].TestMethodIDEncrypt`,
        ""
      );
      formikTesting.setFieldValue(`ListOfParameter[${index}].TestMethod`, "");
      return;
    }
    formikTesting.setFieldValue(
      `ListOfParameter[${index}].TestMethodIDEncrypt`,
      testMethodID
    );
    formikTesting.setFieldValue(
      `ListOfParameter[${index}].TestMethod`,
      testMethod
    );
    formikTesting.setFieldValue(
      `ListOfParameter[${index}].NABLRangeFrom`,
      formikTesting?.values?.ListOfParameter[index]?.testMethodOptions?.filter(
        (opt) => opt.value == testMethodID
      )[0]?.NABLRangeFrom
    );
    formikTesting.setFieldValue(
      `ListOfParameter[${index}].NABLRangeTo`,
      formikTesting?.values?.ListOfParameter[index]?.testMethodOptions?.filter(
        (opt) => opt.value == testMethodID
      )[0]?.NABLRangeTo
    );

    /*To set selected test method to all parameters test method which is having same method and not selected*/
    formikTesting?.values?.ListOfParameter?.map((x, i) => {
      if (index != i && x?.ParameterType == 1) {
        if (
          !x?.TestMethodIDEncrypt &&
          x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)
            ?.length > 0
        ) {
          formikTesting.setFieldValue(
            `ListOfParameter[${i}].TestMethodIDEncrypt`,
            testMethodID
          );
          formikTesting.setFieldValue(
            `ListOfParameter[${i}].TestMethod`,
            testMethod
          );
          formikTesting.setFieldValue(
            `ListOfParameter[${i}].NABLRangeFrom`,
            x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)[0]
              ?.NABLRangeFrom
          );
          formikTesting.setFieldValue(
            `ListOfParameter[${i}].NABLRangeTo`,
            x?.testMethodOptions?.filter((opt) => opt.value == testMethodID)[0]
              ?.NABLRangeTo
          );
        }
      }
    });

    formikTesting.setFieldValue("IsNABLRangeChange", true);
  };

  const OnLoadConsiderResultBasedOnDefaultValue = () => {
    formikTesting?.values?.ListOfParameter?.map((para, index) =>
      OnMinMaxValueChangeConsiderResult(index, para?.MinValue, para?.MaxValue)
    );
  };

  useEffect(() => {
    if (formikTesting?.values?.IsDefaultLoad) {
      OnLoadConsiderResultBasedOnDefaultValue();
      formik.setFieldValue("IsDefaultLoad", false);
    }
  }, [formikTesting?.values?.IsDefaultLoad]);

  useEffect(() => {
    if (formikTesting?.values?.IsNABLRangeChange) {
      OnNABLRangeChangeConsiderNABLResult();
    }
  }, [formikTesting?.values?.IsNABLRangeChange]);

  const OnNABLRangeChangeConsiderNABLResult = () => {
    /*Consider minValue blank = 0, maxValue blank = infinite*/
    for (let p = 0; p < formikTesting?.values?.ListOfParameter?.length; p++) {
      if (
        formikTesting?.values?.ListOfParameter[p]?.ParameterType == 1 &&
        // ListOfParameter[p]?.NABLRangeFrom &&
        // ListOfParameter[p]?.NABLRangeTo &&
        // isNaN(ListOfParameter[p]?.NABLRangeFrom) == false &&
        // isNaN(ListOfParameter[p]?.NABLRangeTo) == false
        (formikTesting?.values?.ListOfParameter[p]?.NABLRangeFrom ||
          formikTesting?.values?.ListOfParameter[p]?.NABLRangeTo) &&
        isNaN(
          formikTesting?.values?.ListOfParameter[p]?.NABLRangeFrom
            ? formikTesting?.values?.ListOfParameter[p]?.NABLRangeFrom
            : 0
        ) == false &&
        isNaN(
          formikTesting?.values?.ListOfParameter[p]?.NABLRangeTo
            ? formikTesting?.values?.ListOfParameter[p]?.NABLRangeTo
            : 0
        ) == false
      ) {
        for (
          let i = 0;
          i <
          formikTesting?.values?.ListOfParameter[p]?.ListOfResultValue?.length;
          i++
        ) {
          if (
            formikTesting?.values?.ListOfParameter[p].ListOfResultValue[i]
              .ResultValue &&
            isNaN(
              formikTesting?.values?.ListOfParameter[p].ListOfResultValue[i]
                .ResultValue
            ) == false
          ) {
            if (
              // parseFloat(ListOfParameter[p].ListOfResultValue[i].ResultValue) >=
              //   parseFloat(ListOfParameter[p]?.NABLRangeFrom) &&
              // parseFloat(ListOfParameter[p].ListOfResultValue[i].ResultValue) <=
              //   parseFloat(ListOfParameter[p]?.NABLRangeTo)
              parseFloat(
                formikTesting?.values?.ListOfParameter[p].ListOfResultValue[i]
                  .ResultValue
              ) >=
                parseFloat(
                  formikTesting?.values?.ListOfParameter[p]?.NABLRangeFrom
                    ? formikTesting?.values?.ListOfParameter[p]?.NABLRangeFrom
                    : 0
                ) &&
              ((formikTesting?.values?.ListOfParameter[p]?.NABLRangeTo &&
                parseFloat(
                  formikTesting?.values?.ListOfParameter[p].ListOfResultValue[i]
                    .ResultValue
                ) <=
                  parseFloat(
                    formikTesting?.values?.ListOfParameter[p]?.NABLRangeTo
                  )) ||
                (!formikTesting?.values?.ListOfParameter[p]?.NABLRangeTo &&
                  1 == 1))
            ) {
              formikTesting.setFieldValue(
                `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
                1
              );
            } else {
              // formik.setFieldValue(
              //   `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
              //   0
              // );
              formikTesting.setFieldValue(
                `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
                formikTesting?.values?.ListOfParameter[p]?.IsNABLParameter
                  ? formikTesting?.values?.ListOfParameter[p]
                      ?.ParameterResultType == 2
                    ? 1
                    : 0
                  : 0
              );
            }
          } else {
            //Result Value is blank or Non Numeric then result is not identified
            if (
              formikTesting?.values?.ListOfParameter[p].ListOfResultValue[i]
                .ResultValue
            ) {
              formikTesting.setFieldValue(
                `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
                formikTesting?.values?.ListOfParameter[p]?.IsNABLParameter
                  ? formikTesting?.values?.ListOfParameter[p]
                      ?.ParameterResultType == 2
                    ? 1
                    : -1
                  : -1
              );
            } else {
              formikTesting.setFieldValue(
                `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
                -1
              );
            }
          }
        }
      } else {
        //NABL Range From or To is blank or Non Numeric or Non Std. Para then result is not identified
        for (
          let i = 0;
          i <
          formikTesting?.values?.ListOfParameter[p]?.ListOfResultValue?.length;
          i++
        ) {
          formikTesting.setFieldValue(
            `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderNABLResult`,
            -1
          );
        }
      }
    }
    formikTesting.setFieldValue("IsNABLRangeChange", false);
  };

  const OnMinMaxValueChangeConsiderResult = (pIndex, minValue, maxValue) => {
    /*Consider minValue blank = 0, maxValue blank = infinite*/
    if (
      // minValue &&
      // maxValue &&
      // isNaN(minValue) == false &&
      // isNaN(maxValue) == false
      (minValue || maxValue) &&
      isNaN(minValue ? minValue : 0) == false &&
      isNaN(maxValue ? maxValue : 0) == false
    ) {
      for (
        let i = 0;
        i <
        formikTesting?.values?.ListOfParameter[pIndex]?.ListOfResultValue
          ?.length;
        i++
      ) {
        if (
          formikTesting?.values?.ListOfParameter[pIndex].ListOfResultValue[i]
            .ResultValue &&
          isNaN(
            formikTesting?.values?.ListOfParameter[pIndex].ListOfResultValue[i]
              .ResultValue
          ) == false
        ) {
          if (
            // parseFloat(
            //   ListOfParameter[pIndex].ListOfResultValue[i].ResultValue
            // ) >= parseFloat(minValue) &&
            //   parseFloat(
            //     ListOfParameter[pIndex].ListOfResultValue[i].ResultValue
            //   ) <= parseFloat(maxValue)
            parseFloat(
              formikTesting?.values?.ListOfParameter[pIndex].ListOfResultValue[
                i
              ].ResultValue
            ) >= parseFloat(minValue ? minValue : 0) &&
            ((maxValue &&
              parseFloat(
                formikTesting?.values?.ListOfParameter[pIndex]
                  .ListOfResultValue[i].ResultValue
              ) <= parseFloat(maxValue)) ||
              (!maxValue && 1 == 1))
          ) {
            formikTesting.setFieldValue(
              `ListOfParameter[${pIndex}].ListOfResultValue[${i}].ConsiderResult`,
              1
            );
          } else {
            formikTesting.setFieldValue(
              `ListOfParameter[${pIndex}].ListOfResultValue[${i}].ConsiderResult`,
              0
            );
          }
        } else {
          //result Value is blank then result is not identified
          formikTesting.setFieldValue(
            `ListOfParameter[${pIndex}].ListOfResultValue[${i}].ConsiderResult`,
            -1
          );
        }
      }
    } else {
      //minValue or maxValue is not available then result is not identified
      for (
        let i = 0;
        i <
        formikTesting?.values?.ListOfParameter[pIndex]?.ListOfResultValue
          ?.length;
        i++
      ) {
        formikTesting.setFieldValue(
          `ListOfParameter[${pIndex}].ListOfResultValue[${i}].ConsiderResult`,
          -1
        );
      }
    }
  };

  const [showTestingRemarksModal, setShowTestingRemarksModal] = useState(false);

  const formikTestingRemarks = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestingRemarks(values, formikHelpers),
    initialValues: {
      TestingRemarksList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { TestingRemarksList },
  } = formikTestingRemarks;

  const handleValidSubmitTestingRemarks = (values) => {
    formikTesting.setFieldValue(
      "Remarks",
      values?.TestingRemarksList?.filter((x) => x.IsSelected == true)
        ?.map((wd) => {
          return wd.TestingRemarks;
        })
        .join(" ")
    );
    setShowTestingRemarksModal(false);
  };

  const getTestingRemarksList = async () => {
    //setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 9, //Testing Remarks
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikTestingRemarks.setFieldValue(
            "TestingRemarksList",
            response?.List?.map((item) => ({
              TestingRemarks: item.CategoryName,
              CategoryID: item.CategoryID,
              IsSelected: false,
            }))
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeReferenceSubGroupTesting = (subGroup) => {
    //set standard parameters rangeOptions from parametersRangeList on SubGroup change
    formikTesting.setFieldValue(
      "ListOfParameter",
      formikTesting?.values?.ListOfParameter?.map((para) => ({
        ...para,
        RangeValue: para?.ParameterType == 1 ? "" : para.RangeValue,
        MinValue:
          para?.ParameterType == 1
            ? testingParametersRangeList?.filter(
                (x) =>
                  x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                  x.SubGroup == subGroup
              )?.length == 1
              ? testingParametersRangeList?.filter(
                  (x) =>
                    x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                    x.SubGroup == subGroup
                )[0]?.MinValue
              : ""
            : para.MinValue,
        MaxValue:
          para?.ParameterType == 1
            ? testingParametersRangeList?.filter(
                (x) =>
                  x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                  x.SubGroup == subGroup
              )?.length == 1
              ? testingParametersRangeList?.filter(
                  (x) =>
                    x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                    x.SubGroup == subGroup
                )[0]?.MaxValue
              : ""
            : para.MaxValue,
        rangeOptions:
          para?.ParameterType == 1
            ? testingParametersRangeList
                ?.filter(
                  (x) =>
                    x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                    x.SubGroup == subGroup &&
                    x.RangeValue != ""
                )
                ?.map((range) => ({
                  ...range,
                  label: range?.RangeValue,
                  value: range?.RangeValue,
                }))
            : para?.rangeOptions,
        ListOfRange:
          para?.ParameterType == 1
            ? testingParametersRangeList
                ?.filter(
                  (x) =>
                    x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                    x.SubGroup == subGroup
                  //&& x.RangeValue != ""
                )
                ?.map((range) => ({
                  ...range,
                  label: range?.RangeValue,
                  value: range?.RangeValue,
                }))
            : para?.ListOfRange,
        Requirement:
          para?.ParameterType == 1
            ? testingParametersRangeList?.filter(
                (x) =>
                  x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                  x.SubGroup == subGroup
              )?.length == 1
              ? testingParametersRangeList?.filter(
                  (x) =>
                    x.ParameterIDEncrypted == para.ParameterIDEncrypted &&
                    x.SubGroup == subGroup
                )[0]?.Requirement
              : ""
            : para?.Requirement,
        ListOfResultValue:
          formikTesting?.values?.TestingStatus == 1
            ? // && IsReTestTesting == false
              para?.ListOfResultValue?.map((result) => {
                return {
                  ...result,
                  ResultValue:
                    para?.ParameterType == 1
                      ? testingParametersRangeList?.filter(
                          (x) =>
                            x.ParameterIDEncrypted ==
                              para.ParameterIDEncrypted &&
                            x.SubGroup == subGroup
                        )?.length == 1
                        ? testingParametersRangeList?.filter(
                            (x) =>
                              x.ParameterIDEncrypted ==
                                para.ParameterIDEncrypted &&
                              x.SubGroup == subGroup
                          )[0]?.DefaultValue
                        : ""
                      : result?.ResultValue,
                };
              })
            : para.ListOfResultValue,
      }))
    );

    // //set parameters result to non identified
    // for (let p = 0; p < ListOfParameter?.length; p++) {
    //   for (let i = 0; i < ListOfParameter[p]?.ListOfResultValue?.length; i++) {
    //     formikTesting.setFieldValue(
    //       `ListOfParameter[${p}].ListOfResultValue[${i}].ConsiderResult`,
    //       -1
    //     );
    //   }
    // }

    formikTesting.setFieldValue("IsDefaultLoad", true); //Consider Result
  };

  const [singleSubGroupSelect, setSingleSubGroupSelect] = useState(false);

  const getRefSubGroupAndRangeDDLTesting = async (
    testMasterID,
    referenceStandardID,
    testingStatus
  ) => {
    if (testMasterID && referenceStandardID) {
      setIsLoading(true);
      await post(
        POST_DDLParametersRange_SubGroupByReferenceStandardID_TestMasterID,
        {
          TestMasterIDEncrypted: testMasterID,
          ReferenceStandardIDEncrypted: referenceStandardID,
        }
      )
        .then((response) => {
          if (response?.IsSuccess) {
            formikTesting.setFieldValue(
              "refStandardSubGroupOptionsTesting",
              response?.SubGroupList?.map((item) => ({
                label: item.SubGroup,
                value: item.SubGroup,
              }))
            );
            formikTesting.setFieldValue(
              "testingParametersRangeList",
              response?.RangeList?.map((item) => ({
                ...item,
              }))
            );

            /*select the value when there is only one option while insert only*/
            if (response?.SubGroupList?.length == 1 && testingStatus == 1) {
              setSingleSubGroupSelect(true);
            }
          } else {
            formikTesting.setFieldValue(
              "refStandardSubGroupOptionsTesting",
              []
            );
            formikTesting.setFieldValue("testingParametersRangeList", []);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      formikTesting.setFieldValue("refStandardSubGroupOptionsTesting", []);
      formikTesting.setFieldValue("testingParametersRangeList", []);
    }
  };

  useEffect(() => {
    if (singleSubGroupSelect == true) {
      formikTesting.setFieldValue(
        "RefStandardSubGroup",
        formikTesting?.values?.refStandardSubGroupOptionsTesting[0]?.value ?? ""
      );
      handleChangeReferenceSubGroupTesting(
        formikTesting?.values?.refStandardSubGroupOptionsTesting[0]?.value ?? ""
      );
      setSingleSubGroupSelect(false);
    }
  }, [singleSubGroupSelect]);

  useEffect(() => {
    if (formikTesting?.values?.ReferenceStandardIDEncrypted) {
      //TestingStatus == 1 (Pending)
      if (formikTesting?.values?.TestingStatus == 1) {
        formikTesting.setFieldValue("ParameterWith", 2); //set Print Min/Max
      }
    } else {
      formikTesting.setFieldValue("ParameterWith", 1); //set None
    }
  }, [formikTesting?.values?.ReferenceStandardIDEncrypted]);

  const handleChangeTestingQty = (e) => {
    if (e?.target?.value < 1000) {
      formikTesting.setFieldValue("TestingQty", e?.target?.value ?? "");
      let qty = e?.target?.value ?? 0;

      let resultCount =
        formikTesting?.values?.ListOfParameter[0]?.ListOfResultValue?.length;

      if (parseInt(qty) > parseInt(resultCount)) {
        let newAddCount = parseInt(qty) - parseInt(resultCount);
        let newValueList = [];
        for (let index = 0; index < newAddCount; index++) {
          newValueList.push({
            TestingResultIDEncrypted: "",
            TestingCount: resultCount + index + 1,
            TestingCountHeader:
              "Sample:" +
              (resultCount + index + 1 > 9
                ? resultCount + index + 1
                : "0" + (resultCount + index + 1)),
            ResultValue: "",
            ConsiderNABLResult: -1,
            ConsiderResult: -1,
          });
        }

        formikTesting?.values?.ListOfParameter?.map((para, iPara) => {
          formikTesting.setFieldValue(
            `ListOfParameter[${iPara}].ListOfResultValue`,
            [...para.ListOfResultValue, ...newValueList]
          );
        });
      } else {
        // let newValueList = [];
        // for (let index = 0; index < parseInt(qty); index++) {
        //   newValueList.push({
        //     TestingResultIDEncrypted: "",
        //     TestingCount: index + 1,
        //     TestingCountHeader:
        //       "Sample:" + (index + 1 > 9 ? index + 1 : "0" + (index + 1)),
        //     ResultValue: "",
        //     ConsiderNABLResult: -1,
        //     ConsiderResult: -1,
        //   });
        // }

        // formikTesting?.values?.ListOfParameter?.map((para, iPara) => {
        //   formikTesting.setFieldValue(`ListOfParameter[${iPara}].ListOfResultValue`, [
        //     ...newValueList,
        //   ]);
        //   formikTesting.setFieldValue(
        //     `ListOfParameter[${iPara}].AverageResultValue`,
        //     ""
        //   );
        // });

        Promise.all(
          formikTesting?.values?.ListOfParameter?.map((para, iPara) => {
            formikTesting.setFieldValue(
              `ListOfParameter[${iPara}].ListOfResultValue`,
              [...para.ListOfResultValue.slice(0, parseInt(qty))]
            );
          })
        );
        formikTesting.setFieldValue("IsDefaultLoadCalculateAverage", true); //calculate average
      }
    }
  };

  const [showTestingTPIDetailModal, setShowTestingTPIDetailModal] =
    useState(false);

  const calculateFormulaMixDesignSieveAnalysisCoarseAggregate = (
    cIndex,
    paraIndex,
    formulaExpression,
    formulaVariables
  ) => {
    setIsLoading(true);

    let parameterResultVariablesValueList = [];

    const variablesArray = formulaVariables
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries;

    Promise.all(
      formikTesting?.values?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList?.map(
        (item, itemIndex) => {
          let variablesValueList = [];

          Promise.all(
            variablesArray?.map((x) => {
              let xValue = "";
              if (
                `${formikTesting?.values?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[0]?.ParameterList[paraIndex]?.CriateriaList[cIndex].ColumnShortCode}X` ==
                x
              ) {
                xValue =
                  formikTesting?.values
                    ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                    .SieveSizeList[0]?.ParameterList[paraIndex]?.CriateriaList[
                    cIndex
                  ].InputColumnValueofX;
              } else {
                item?.ParameterList?.forEach((para) => {
                  para.CriateriaList.forEach((c) => {
                    if (c.ColumnShortCode == x) {
                      xValue = c.ColumnValue ?? "";
                    }
                  });
                });
              }
              variablesValueList.push({
                VariableName: x,
                VariableValue: xValue.toString(),
              });
            })
          );

          parameterResultVariablesValueList.push({
            ResultIndex: itemIndex,
            ListOfVariableValues: variablesValueList,
          });
        }
      )
    );

    post(POST_GetTestingParameterFormulaExpressionResult, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      FormulaExpression: formulaExpression,
      FormulaVariables: formulaVariables,
      ListOfParametersVariableResultValue: parameterResultVariablesValueList,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          response?.ListOfParametersResultValue?.map((result) => {
            formikTesting.setFieldValue(
              `TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[${result.ResultIndex}]ParameterList[${paraIndex}].CriateriaList[${cIndex}].ColumnValue`,
              result.ResultValue.includes(".")
                ? parseFloat(result.ResultValue).toFixed(2)
                : result.ResultValue
            );
          });
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // Group the data by Formula
  const objMixDesignTargetStrength =
    formikTesting?.values?.ListOfMixDesignTargetStrengthForMixProportioning?.reduce(
      (acc, item, index) => {
        if (!acc[item.Formula]) {
          acc[item.Formula] = [];
        }
        acc[item.Formula].push({ ...item, originalIndex: index }); // Add the original index
        return acc;
      },
      {}
    );

  const calculateFormulaMixDesignTargetStrength = (
    tIndex,
    formulaGroup,
    formulaExpression,
    formulaVariables
  ) => {
    setIsLoading(true);

    let parameterResultVariablesValueList = [];

    const variablesArray = formulaVariables
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries;

    let variablesValueList = [];

    Promise.all(
      variablesArray?.map((x) => {
        let xValue = "";
        xValue =
          formikTesting?.values?.ListOfMixDesignTargetStrengthForMixProportioning?.filter(
            (t) =>
              t.Formula == formulaGroup &&
              t.VariableName == x &&
              t.IsResultRow == false
          )[0]?.VariableValue ?? "";
        variablesValueList.push({
          VariableName: x,
          VariableValue: xValue.toString(),
        });
      })
    );

    parameterResultVariablesValueList.push({
      ResultIndex: 0,
      ListOfVariableValues: variablesValueList,
    });

    post(POST_GetTestingParameterFormulaExpressionResult, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      FormulaExpression: formulaExpression,
      FormulaVariables: formulaVariables,
      ListOfParametersVariableResultValue: parameterResultVariablesValueList,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          response?.ListOfParametersResultValue?.map((result) => {
            formikTesting.setFieldValue(
              `ListOfMixDesignTargetStrengthForMixProportioning[${tIndex}].VariableValue`,
              result.ResultValue.includes(".")
                ? parseFloat(result.ResultValue).toFixed(2)
                : result.ResultValue
            );
          });
          SetCalcFinalResultTargetStrength(true);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [calcFinalResultTargetStrength, SetCalcFinalResultTargetStrength] =
    useState(false);

  useEffect(() => {
    if (calcFinalResultTargetStrength) {
      let resultList = [];
      formikTesting?.values?.ListOfMixDesignTargetStrengthForMixProportioning?.map(
        (item) => {
          if (
            item.IsResultRow == false &&
            item.FormulaExpression &&
            item.VariableValue
          ) {
            resultList.push(item.VariableValue);
          }
        }
      );

      // Sort in descending order (greatest first)
      const sortedNumbers = resultList.sort(
        (a, b) => parseFloat(b) - parseFloat(a)
      );
      const index =
        formikTesting?.values?.ListOfMixDesignTargetStrengthForMixProportioning.findIndex(
          (item) => item.IsResultRow === true
        );
      formikTesting.setFieldValue(
        `ListOfMixDesignTargetStrengthForMixProportioning[${index}].FormulaVariables`,
        sortedNumbers.join(" > ")
      );
      formikTesting.setFieldValue(
        `ListOfMixDesignTargetStrengthForMixProportioning[${index}].VariableValue`,
        sortedNumbers[0] ?? ""
      );
      SetCalcFinalResultTargetStrength(false);
    }
  }, [calcFinalResultTargetStrength]);

  useEffect(() => {
    if (
      formikTesting?.values?.TestMixDesignDetail
        .MaximumNominalSizeofAggregateIDEncrypted &&
      !formikTesting?.values?.TestMixDesignDetail
        .ApproximateAirContentResultValue
    ) {
      formikTesting.setFieldValue(
        "TestMixDesignDetail.ApproximateAirContentResultValue",
        optionsMaximumNominalSizeofAggregate?.filter(
          (x) =>
            x.value ==
            formikTesting?.values?.TestMixDesignDetail
              .MaximumNominalSizeofAggregateIDEncrypted
        )[0]?.ApproximateAirContent ?? ""
      );
    }
  }, [optionsMaximumNominalSizeofAggregate]);

  const handleChangeSelectionOfWaterCementRatioReferenceStandardName = (e) => {
    if (
      e?.value !==
      formikTesting?.values?.TestMixDesignDetail
        .SelectionOfWaterCementRatioReferenceStandardName
    ) {
      formikTesting.setFieldValue(
        "TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardName",
        e?.value ?? ""
      );
      if (e?.value) {
        const distinctReferenceStandardTableNames = [
          ...new Set(
            ListOfConcreteExposureReferenceStandardTable?.filter(
              (x) => x.ReferenceStandardName == e?.value
            )?.map((item) => item.ReferenceStandardTableName)
          ),
        ];

        formikMixDesignTestDetails.setFieldValue(
          "optionsReferenceStandardTableConcreteExposure",
          distinctReferenceStandardTableNames?.map((item) => ({
            value: item,
            label: item,
          }))
        );
      } else {
        formikMixDesignTestDetails.setFieldValue(
          "optionsReferenceStandardTableConcreteExposure",
          []
        );
      }
      formikMixDesignTestDetails.setFieldValue("optionsTypeOfConcrete", []);
      formikMixDesignTestDetails.setFieldValue(
        "optionsTypeOfConcreteGrade",
        []
      );
      formikTesting.setFieldValue(
        "TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardTableName",
        ""
      );
      formikTesting.setFieldValue("TestMixDesignDetail.ConcreteType", "");
      formikTesting.setFieldValue("TestMixDesignDetail.ConcreteGrade", "");
      formikTesting.setFieldValue(
        "TestMixDesignDetail.MaxFreeWaterCementRatio",
        ""
      );
    }
  };

  const handleChangeSelectionOfWaterCementRatioReferenceStandardTableName = (
    e
  ) => {
    if (
      e?.value !==
      formikTesting?.values?.TestMixDesignDetail
        .SelectionOfWaterCementRatioReferenceStandardTableName
    ) {
      formikTesting.setFieldValue(
        "TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardTableName",
        e?.value ?? ""
      );
      if (e?.value) {
        formikMixDesignTestDetails.setFieldValue("optionsTypeOfConcrete", [
          {
            value: "Plain Concrete",
            label: "Plain Concrete",
          },
          {
            value: "Reinforced Concrete",
            label: "Reinforced Concrete",
          },
        ]);
      } else {
        formikMixDesignTestDetails.setFieldValue("optionsTypeOfConcrete", []);
      }
      formikMixDesignTestDetails.setFieldValue(
        "optionsTypeOfConcreteGrade",
        []
      );
      formikTesting.setFieldValue("TestMixDesignDetail.ConcreteType", "");
      formikTesting.setFieldValue("TestMixDesignDetail.ConcreteGrade", "");
      formikTesting.setFieldValue(
        "TestMixDesignDetail.MaxFreeWaterCementRatio",
        ""
      );
    }
  };

  const handleChangeSelectionOfWaterCementRatioTypeOfConcrete = (e) => {
    if (e?.value !== formikTesting?.values?.TestMixDesignDetail.ConcreteType) {
      formikTesting.setFieldValue(
        "TestMixDesignDetail.ConcreteType",
        e?.value ?? ""
      );

      if (e?.value == "Plain Concrete") {
        formikMixDesignTestDetails.setFieldValue(
          "optionsTypeOfConcreteGrade",
          ListOfConcreteExposureReferenceStandardTable?.filter(
            (x) =>
              x.ReferenceStandardName ==
                formikTesting?.values?.TestMixDesignDetail
                  .SelectionOfWaterCementRatioReferenceStandardName &&
              x.ReferenceStandardTableName ==
                formikTesting?.values?.TestMixDesignDetail
                  .SelectionOfWaterCementRatioReferenceStandardTableName
          )?.map((item) => ({
            label: item.PlainConcreteMinGradeOfConcrete,
            value: item.PlainConcreteMinGradeOfConcrete,
            MaxFreeWaterCementRatio: item.PlainConcreteMaxFreeWaterCementRatio,
          }))
        );
      } else if (e?.value == "Reinforced Concrete") {
        formikMixDesignTestDetails.setFieldValue(
          "optionsTypeOfConcreteGrade",
          ListOfConcreteExposureReferenceStandardTable?.filter(
            (x) =>
              x.ReferenceStandardName ==
                formikTesting?.values?.TestMixDesignDetail
                  .SelectionOfWaterCementRatioReferenceStandardName &&
              x.ReferenceStandardTableName ==
                formikTesting?.values?.TestMixDesignDetail
                  .SelectionOfWaterCementRatioReferenceStandardTableName
          )?.map((item) => ({
            label: item.ReinforcedConcreteMinGradeOfConcrete,
            value: item.ReinforcedConcreteMinGradeOfConcrete,
            MaxFreeWaterCementRatio:
              item.ReinforcedConcreteMaxFreeWaterCementRatio,
          }))
        );
      } else {
        formikMixDesignTestDetails.setFieldValue(
          "optionsTypeOfConcreteGrade",
          []
        );
      }
      formikTesting.setFieldValue("TestMixDesignDetail.ConcreteGrade", "");
      formikTesting.setFieldValue(
        "TestMixDesignDetail.MaxFreeWaterCementRatio",
        ""
      );
    }
  };

  const handleChangeSelectionOfWaterCementRatioTypeOfConcreteGrade = (e) => {
    formikTesting.setFieldValue(
      "TestMixDesignDetail.ConcreteGrade",
      e?.value ?? ""
    );
    if (e?.value) {
      formikTesting.setFieldValue(
        "TestMixDesignDetail.MaxFreeWaterCementRatio",
        e?.MaxFreeWaterCementRatio ?? ""
      );
    } else {
      formikTesting.setFieldValue(
        "TestMixDesignDetail.MaxFreeWaterCementRatio",
        ""
      );
    }
  };

  const calculateFormulaMixDesignGroupParameters = (
    pIndex,
    formulaExpression,
    formulaVariables,
    groupName
  ) => {
    setIsLoading(true);

    let parameterResultVariablesValueList = [];

    const variablesArray = formulaVariables
      ?.split(",")
      ?.map((s) => s.trim())
      ?.filter((s) => s); // Remove empty entries;

    let variablesValueList = [];

    Promise.all(
      variablesArray?.map((x) => {
        let xValue = "";
        xValue =
          formikTesting?.values?.ListOfMixDesignGroupParameters?.filter(
            (t) => t.ShortCode == x
          )[0]?.ParameterValue ?? "";
        variablesValueList.push({
          VariableName: x,
          VariableValue: xValue.toString(),
        });
      })
    );

    parameterResultVariablesValueList.push({
      ResultIndex: 0,
      ListOfVariableValues: variablesValueList,
    });

    post(POST_GetTestingParameterFormulaExpressionResult, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      FormulaExpression: formulaExpression,
      FormulaVariables: formulaVariables,
      ListOfParametersVariableResultValue: parameterResultVariablesValueList,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          response?.ListOfParametersResultValue?.map((result) => {
            if (
              formikTesting?.values?.ListOfMixDesignGroupParameters[pIndex]
                .IsResultValueBasedOnFormula
            ) {
              formikTesting.setFieldValue(
                `ListOfMixDesignGroupParameters[${pIndex}].ResultValue`,
                result.ResultValue.includes(".")
                  ? parseFloat(result.ResultValue).toFixed(3)
                  : result.ResultValue
              );
            } else {
              formikTesting.setFieldValue(
                `ListOfMixDesignGroupParameters[${pIndex}].ParameterValue`,
                result.ResultValue.includes(".")
                  ? parseFloat(result.ResultValue).toFixed(3)
                  : result.ResultValue
              );

              if (groupName == "A-6") {
                const maxDisplaySequenceElement =
                  formikTesting?.values?.ListOfMixDesignGroupParameters?.filter(
                    (x) => x.GroupName === "A-6"
                  )?.reduce(
                    (max, current) =>
                      current.DisplaySequence >
                      (max?.DisplaySequence || -Infinity)
                        ? current
                        : max,
                    null
                  );

                const index =
                  formikTesting?.values?.ListOfMixDesignGroupParameters.indexOf(
                    maxDisplaySequenceElement
                  );
                if (pIndex == index) {
                  formikTesting.setFieldValue(
                    "TestMixDesignDetail.WaterContentKgPerM3",
                    result.ResultValue.includes(".")
                      ? parseFloat(result.ResultValue).toFixed(2)
                      : result.ResultValue
                  );

                  SetCalculateCementContent(true);
                }
              }
            }
          });
          SetCalcFinalResultTargetStrength(true);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [calculateCementContent, SetCalculateCementContent] = useState(false);

  useEffect(() => {
    if (calculateCementContent == true) {
      const maxDisplaySequenceElement =
        formikTesting?.values?.ListOfMixDesignGroupParameters?.filter(
          (x) => x.GroupName === "A-6"
        )?.reduce(
          (max, current) =>
            current.DisplaySequence > (max?.DisplaySequence || -Infinity)
              ? current
              : max,
          null
        );
      const index =
        formikTesting?.values?.ListOfMixDesignGroupParameters.indexOf(
          maxDisplaySequenceElement
        );

      const waterContent =
        formikTesting?.values?.ListOfMixDesignGroupParameters[index]
          ?.ParameterValue;
      const waterCementRatio =
        formikTesting?.values?.TestMixDesignDetail?.WaterCementRatio;
      if (waterContent && waterCementRatio) {
        formikTesting.setFieldValue(
          "TestMixDesignDetail.CementContentKgPerM3FormulaValue",
          `${waterContent}/${waterCementRatio}`
        );
        const resultValue =
          parseFloat(waterContent) / parseFloat(waterCementRatio);
        const finalResultValue = Math.round(resultValue, 0.1);
        formikTesting.setFieldValue(
          "TestMixDesignDetail.CementContentKgPerM3ResultValue",
          resultValue.toFixed(2)
        );
        formikTesting.setFieldValue(
          "TestMixDesignDetail.CementContentKgPerM3FinalResult",
          finalResultValue
        );
        let WaterCementRatioCementitiousMaterial =
          parseFloat(waterContent) / parseFloat(finalResultValue);
        formikTesting.setFieldValue(
          "TestMixDesignDetail.WaterCementRatioCementitiousMaterial",
          WaterCementRatioCementitiousMaterial.toFixed(2)
        );
      }
      SetCalculateCementContent(false);
    }
  }, [calculateCementContent]);

  const calculateFormulaMixCalculation = (indx, parameterShortCode) => {
    let resultValue = "";
    let formulaValue = "";
    if (parameterShortCode == "b") {
      let a =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "a"
        )[0]?.ParameterResultValue ?? 0;
      formulaValue = "1%";
      resultValue = ((parseFloat(a ? a : 0) * 1) / 100).toFixed(2);
    } else if (parameterShortCode == "c") {
      let massCement = 0;
      let specificGravityOfCement = 0;
      if (
        formikTesting?.values?.TestMixDesignDetail
          ?.TypeofMineralAdmixtureIDEncrypted
      ) {
        massCement =
          formikTesting?.values?.TestMixDesignDetail.CementContentKgPerM3;
      } else {
        massCement =
          formikTesting?.values?.TestMixDesignDetail
            .CementContentKgPerM3FinalResult;
      }
      specificGravityOfCement =
        formikTesting?.values?.ListOfParameter?.find((x) =>
          x.ParameterName?.toLowerCase().includes(
            "Specific gravity of cement".toLowerCase()
          )
        )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `(${massCement} / ${specificGravityOfCement}) * (1 / 1000)`;
      resultValue = (
        (parseFloat(massCement) / parseFloat(specificGravityOfCement)) *
        (1 / 1000)
      ).toFixed(4);
    } else if (parameterShortCode == "d") {
      let massCement =
        formikTesting?.values?.TestMixDesignDetail
          .CementitiousMaterialContentKgPerM3 ?? 0;
      let specificGravityOfCement = 1;
      // specificGravityOfCement =
      //   ListOfParameter?.find((x) =>
      //     x.ParameterName?.toLowerCase().includes(
      //       "Specific gravity of cement".toLowerCase()
      //     )
      //   )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `(${massCement} / ${specificGravityOfCement}) * (1 / 1000)`;
      if (specificGravityOfCement > 0) {
        resultValue = (
          (parseFloat(massCement) / parseFloat(specificGravityOfCement)) *
          (1 / 1000)
        ).toFixed(3);
      }
    } else if (parameterShortCode == "e") {
      let massWater =
        formikTesting?.values?.TestMixDesignDetail.WaterContentKgPerM3;
      let specificGravityOfWater = 0;
      specificGravityOfWater =
        formikTesting?.values?.ListOfParameter?.find((x) =>
          x.ParameterName?.toLowerCase().includes(
            "Specific gravity of water".toLowerCase()
          )
        )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `(${massWater} / ${specificGravityOfWater}) * (1 / 1000)`;
      if (specificGravityOfWater > 0) {
        resultValue = (
          (parseFloat(massWater) / parseFloat(specificGravityOfWater)) *
          (1 / 1000)
        ).toFixed(3);
      }
    } else if (parameterShortCode == "f.") {
      let massAdmixture =
        formikTesting?.values?.TestMixDesignDetail
          .CementitiousMaterialContentKgPerM3 ?? 0;
      let sgMineralAdmixture =
        formikTesting?.values?.ListOfParameter?.find((x) =>
          x.ParameterName?.toLowerCase().includes(
            "specific gravity of mineral admixture".toLowerCase()
          )
        )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `(${massAdmixture} / ${sgMineralAdmixture}) * (1 / 1000)`;
      if (sgMineralAdmixture > 0) {
        resultValue = (massAdmixture / sgMineralAdmixture) * (1 / 1000);
      }
    } else if (parameterShortCode == "f") {
      let cementContent =
        formikTesting?.values?.TestMixDesignDetail
          .CementContentKgPerM3FinalResult;
      let massChemicalAdmixure = (
        (parseFloat(cementContent) * 1) /
        100
      ).toFixed(3);
      let specificGravityOfChemicalAdmixture =
        formikTesting?.values?.ListOfParameter?.find((x) =>
          x.ParameterName?.toLowerCase().includes(
            "specific gravity of chemical admixture".toLowerCase()
          )
        )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `(${massChemicalAdmixure} / ${specificGravityOfChemicalAdmixture}) * (1 / 1000)`;
      if (specificGravityOfChemicalAdmixture > 0) {
        resultValue = (
          (parseFloat(massChemicalAdmixure) /
            parseFloat(specificGravityOfChemicalAdmixture)) *
          (1 / 1000)
        ).toFixed(6);
      }
    } else if (parameterShortCode == "g") {
      let a =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "a"
        )[0]?.ParameterResultValue ?? 0;
      let b =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "b"
        )[0]?.ParameterResultValue ?? 0;
      let c =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "c"
        )[0]?.ParameterResultValue ?? 0;
      let d =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "d"
        )[0]?.ParameterResultValue ?? 0;
      let e =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "e"
        )[0]?.ParameterResultValue ?? 0;
      let f =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "f"
        )[0]?.ParameterResultValue ?? 0;
      formulaValue = ` [(${a ? a : 0}-${b ? b : 0})-(${c ? c : 0}+${
        d ? d : 0
      }+${e ? e : 0}+${f ? f : 0})]`;
      resultValue = (
        [parseFloat(a ? a : 0) - parseFloat(b ? b : 0)] -
        (parseFloat(c ? c : 0) +
          parseFloat(d ? d : 0) +
          parseFloat(e ? e : 0) +
          parseFloat(f ? f : 0))
      ).toFixed(4);
    } else if (parameterShortCode == "h") {
      let a =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "a"
        )[0]?.ParameterResultValue ?? 0;
      let b =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "b"
        )[0]?.ParameterResultValue ?? 0;
      let c =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "c"
        )[0]?.ParameterResultValue ?? 0;
      let d =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "d"
        )[0]?.ParameterResultValue ?? 0;
      let e =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "e"
        )[0]?.ParameterResultValue ?? 0;
      let f =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "f"
        )[0]?.ParameterResultValue ?? 0;
      let g = (
        [parseFloat(a ? a : 0) - parseFloat(b ? b : 0)] -
        (parseFloat(c ? c : 0) +
          parseFloat(d ? d : 0) +
          parseFloat(e ? e : 0) +
          parseFloat(f ? f : 0))
      ).toFixed(4);
      let volumeOfCourseAggregate =
        formikTesting?.values?.ListOfMixDesignGroupParameters.filter(
          (x) => x.ShortCode == "PCWCR" && x.GroupName == "A-8."
        )[0]?.ParameterValue;
      let specificGravityOfCoarseAggregate = 0;
      let coarseAggregate = 0;
      let coarseAggregateList = formikTesting?.values?.ListOfParameter?.filter(
        (x) =>
          x.ParameterName?.toLowerCase().includes(
            "specific gravity of Coarse Aggregate".toLowerCase()
          )
      );
      coarseAggregateList?.map((item) => {
        coarseAggregate =
          parseFloat(coarseAggregate) +
          parseFloat(
            item?.ListOfResultValue?.[0]?.ResultValue
              ? item?.ListOfResultValue?.[0]?.ResultValue
              : 0
          );
      });
      specificGravityOfCoarseAggregate =
        coarseAggregateList.length > 0
          ? (parseFloat(coarseAggregate) / coarseAggregateList.length).toFixed(
              3
            )
          : 0;
      formulaValue = `${g ? g : 0} * ${
        volumeOfCourseAggregate ? volumeOfCourseAggregate : 0
      } * ${
        specificGravityOfCoarseAggregate ? specificGravityOfCoarseAggregate : 0
      } * 1000`;
      resultValue = (
        parseFloat(g ? g : 0) *
        parseFloat(volumeOfCourseAggregate ? volumeOfCourseAggregate : 0) *
        parseFloat(
          specificGravityOfCoarseAggregate
            ? specificGravityOfCoarseAggregate
            : 0
        ) *
        1000
      ).toFixed(2);
    } else if (parameterShortCode == "j") {
      let a =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "a"
        )[0]?.ParameterResultValue ?? 0;
      let b =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "b"
        )[0]?.ParameterResultValue ?? 0;
      let c =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "c"
        )[0]?.ParameterResultValue ?? 0;
      let d =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "d"
        )[0]?.ParameterResultValue ?? 0;
      let e =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "e"
        )[0]?.ParameterResultValue ?? 0;
      let f =
        formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
          (x) => x.ParameterShortCode == "f"
        )[0]?.ParameterResultValue ?? 0;
      let g = (
        [parseFloat(a ? a : 0) - parseFloat(b ? b : 0)] -
        (parseFloat(c ? c : 0) +
          parseFloat(d ? d : 0) +
          parseFloat(e ? e : 0) +
          parseFloat(f ? f : 0))
      ).toFixed(4);
      let volumeOfFineAggregate =
        formikTesting?.values?.ListOfMixDesignGroupParameters.filter(
          (x) => x.ShortCode == "VFAC" && x.GroupName == "A-8"
        )[0]?.ResultValue;
      let specificGravityOfFineAggregate =
        formikTesting?.values?.ListOfParameter?.find((x) =>
          x.ParameterName?.toLowerCase().includes(
            "specific gravity of Fine Aggregate".toLowerCase()
          )
        )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
      formulaValue = `${g ? g : 0} * ${
        volumeOfFineAggregate ? volumeOfFineAggregate : 0
      } * ${
        specificGravityOfFineAggregate ? specificGravityOfFineAggregate : 0
      } * 1000`;
      resultValue = (
        parseFloat(g ? g : 0) *
        parseFloat(volumeOfFineAggregate ? volumeOfFineAggregate : 0) *
        parseFloat(
          specificGravityOfFineAggregate ? specificGravityOfFineAggregate : 0
        ) *
        1000
      ).toFixed(2);
    } else {
      let cementContent =
        formikTesting?.values?.TestMixDesignDetail
          .CementContentKgPerM3FinalResult;
      formulaValue = `1.0%  * ${cementContent ? cementContent : 0}`;
      resultValue = (
        (parseFloat(cementContent ? cementContent : 0) * 1) /
        100
      ).toFixed(3);
    }
    formikTesting.setFieldValue(
      `ListOfMixDesignMixCalculation[${indx}].ParameterFormulaValue`,
      formulaValue
    );
    formikTesting.setFieldValue(
      `ListOfMixDesignMixCalculation[${indx}].ParameterResultValue`,
      resultValue
    );
  };

  const calculateMixProportionsForTrial = (columnName) => {
    let cementContent,
      cementitiousMaterial,
      waterContent,
      fineAggreagte,
      percentage20mm,
      coarseAggreagte,
      courseAggreagte20mm,
      percentage10mm,
      courseAggreagte10mm,
      chemicalAdmixture,
      mineralAdmixture,
      wcRatio,
      Total = 0;
    if (columnName == "PerM3OfConcreteKg") {
      formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.map(
        (x, ix) => {
          if (x?.MaterialShortCode == "C") {
            if (
              formikTesting?.values?.TestMixDesignDetail
                ?.TypeofMineralAdmixtureIDEncrypted
            ) {
              cementContent =
                formikTesting?.values?.TestMixDesignDetail.CementContentKgPerM3;
            } else {
              cementContent =
                formikTesting?.values?.TestMixDesignDetail
                  .CementContentKgPerM3FinalResult;
            }
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
              cementContent
            );
          } else if (x?.MaterialShortCode == "CM") {
            cementitiousMaterial =
              formikTesting?.values?.TestMixDesignDetail
                .CementitiousMaterialContentKgPerM3 ?? 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
              cementitiousMaterial
            );
          } else if (x?.MaterialShortCode == "W") {
            waterContent =
              formikTesting?.values?.TestMixDesignDetail.WaterContentKgPerM3 ??
              0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
              waterContent
            );
          } else if (x?.MaterialShortCode == "FA") {
            fineAggreagte =
              formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
                (m) => m.ParameterShortCode == "j"
              )[0]?.ParameterResultValue ?? 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
              fineAggreagte
            );
          } else if (x?.MaterialShortCode == "CA20") {
            percentage20mm =
              formikTesting?.values
                ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                ?.SieveSizeList[0]?.ParameterList[1]?.CriateriaList[0]
                ?.InputColumnValueofX ?? 0;
            coarseAggreagte =
              formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
                (m) => m.ParameterShortCode == "h"
              )[0]?.ParameterResultValue ?? 0;
            courseAggreagte20mm = (
              (parseFloat(coarseAggreagte) * parseFloat(percentage20mm)) /
              100
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].CoarseAggregatePercentageOfFraction`,
              `${percentage20mm}%`
            );
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
              courseAggreagte20mm
            );
          } else if (x?.MaterialShortCode == "CA10") {
            percentage10mm =
              formikTesting?.values
                ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                ?.SieveSizeList[0]?.ParameterList[1]?.CriateriaList[1]
                ?.InputColumnValueofX ?? 0;
            coarseAggreagte =
              formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
                (m) => m.ParameterShortCode == "h"
              )[0]?.ParameterResultValue ?? 0;
            courseAggreagte10mm = (
              (parseFloat(coarseAggreagte) * parseFloat(percentage10mm)) /
              100
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].CoarseAggregatePercentageOfFraction`,
              `${percentage10mm}%`
            );
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
              courseAggreagte10mm
            );
          } else if (x?.MaterialShortCode == "CAD") {
            chemicalAdmixture =
              formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
                (m) => m.ParameterShortCode == ""
              )[0]?.ParameterResultValue ?? 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
              chemicalAdmixture
            );
          } else if (x?.MaterialShortCode == "MAD") {
            mineralAdmixture =
              formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
                (m) => m.ParameterShortCode == "f."
              )[0]?.ParameterResultValue ?? 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
              mineralAdmixture
            );
          } else if (x?.MaterialShortCode == "WCR") {
            wcRatio =
              formikTesting?.values?.TestMixDesignDetail
                .WaterCementRatioCementitiousMaterial;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
              wcRatio
            );
          } else if (x?.MaterialShortCode == "TOTAL") {
            Total = (
              parseFloat(cementContent ? cementContent : 0) +
              parseFloat(cementitiousMaterial ? cementitiousMaterial : 0) +
              parseFloat(waterContent ? waterContent : 0) +
              parseFloat(fineAggreagte ? fineAggreagte : 0) +
              parseFloat(courseAggreagte20mm ? courseAggreagte20mm : 0) +
              parseFloat(courseAggreagte10mm ? courseAggreagte10mm : 0) +
              parseFloat(chemicalAdmixture ? chemicalAdmixture : 0) +
              parseFloat(mineralAdmixture ? mineralAdmixture : 0) +
              parseFloat(wcRatio ? wcRatio : 0)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKg`,
              Total
            );
          }
        }
      );
    } else if (columnName == "WaterAbsorptionPercentage") {
      formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.map(
        (x, ix) => {
          if (x?.MaterialShortCode == "C") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
              "-"
            );
          } else if (x?.MaterialShortCode == "CM") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
              "-"
            );
          } else if (x?.MaterialShortCode == "W") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
              "-"
            );
          } else if (x?.MaterialShortCode == "FA") {
            fineAggreagte =
              formikTesting?.values?.ListOfParameter?.find(
                (x) =>
                  x.ParameterName?.toLowerCase().includes(
                    "Water Absorption".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes(
                    "Fine Aggregate".toLowerCase()
                  )
              )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
              fineAggreagte
            );
          } else if (x?.MaterialShortCode == "CA20") {
            courseAggreagte20mm =
              formikTesting?.values?.ListOfParameter?.find(
                (x) =>
                  x.ParameterName?.toLowerCase().includes(
                    "Water Absorption".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes(
                    "Coarse Aggregate".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes("20".toLowerCase())
              )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
              courseAggreagte20mm
            );
          } else if (x?.MaterialShortCode == "CA10") {
            courseAggreagte10mm =
              formikTesting?.values?.ListOfParameter?.find(
                (x) =>
                  x.ParameterName?.toLowerCase().includes(
                    "Water Absorption".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes(
                    "Coarse Aggregate".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes("10".toLowerCase())
              )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
              courseAggreagte10mm
            );
          } else if (x?.MaterialShortCode == "CAD") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
              "-"
            );
          } else if (x?.MaterialShortCode == "MAD") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
              "-"
            );
          } else if (x?.MaterialShortCode == "WCR") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
              "-"
            );
          } else if (x?.MaterialShortCode == "TOTAL") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WaterAbsorptionPercentage`,
              ""
            );
          }
        }
      );
    } else if (columnName == "WeightOfWaterAbsorptionKg") {
      formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.map(
        (x, ix) => {
          if (x?.MaterialShortCode == "C") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "CM") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "W") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "FA") {
            let fineAggreagteConcrete =
              formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
                (m) => m.ParameterShortCode == "j"
              )[0]?.ParameterResultValue ?? 0;
            let fineAggreagteWaterAbsorptionPercentage =
              formikTesting?.values?.ListOfParameter?.find(
                (x) =>
                  x.ParameterName?.toLowerCase().includes(
                    "Water Absorption".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes(
                    "Fine Aggregate".toLowerCase()
                  )
              )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
            fineAggreagte = (
              (parseFloat(fineAggreagteConcrete) *
                parseFloat(fineAggreagteWaterAbsorptionPercentage)) /
              100
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
              fineAggreagte
            );
          } else if (x?.MaterialShortCode == "CA20") {
            percentage20mm =
              formikTesting?.values
                ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                ?.SieveSizeList[0]?.ParameterList[1]?.CriateriaList[0]
                ?.InputColumnValueofX ?? 0;
            coarseAggreagte =
              formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
                (m) => m.ParameterShortCode == "h"
              )[0]?.ParameterResultValue ?? 0;
            let courseAggreagte20mmConcrete = (
              (parseFloat(coarseAggreagte) * parseFloat(percentage20mm)) /
              100
            ).toFixed(2);
            let courseAggreagte20mmWAPercentage =
              formikTesting?.values?.ListOfParameter?.find(
                (x) =>
                  x.ParameterName?.toLowerCase().includes(
                    "Water Absorption".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes(
                    "Coarse Aggregate".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes("20".toLowerCase())
              )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
            courseAggreagte20mm = (
              (parseFloat(courseAggreagte20mmConcrete) *
                parseFloat(courseAggreagte20mmWAPercentage)) /
              100
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
              courseAggreagte20mm
            );
          } else if (x?.MaterialShortCode == "CA10") {
            percentage10mm =
              formikTesting?.values
                ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                ?.SieveSizeList[0]?.ParameterList[1]?.CriateriaList[1]
                ?.InputColumnValueofX ?? 0;
            coarseAggreagte =
              formikTesting?.values?.ListOfMixDesignMixCalculation?.filter(
                (m) => m.ParameterShortCode == "h"
              )[0]?.ParameterResultValue ?? 0;
            let courseAggreagte10mmConcrete = (
              (parseFloat(coarseAggreagte) * parseFloat(percentage10mm)) /
              100
            ).toFixed(2);
            let courseAggreagte10mmWAPercentage =
              formikTesting?.values?.ListOfParameter?.find(
                (x) =>
                  x.ParameterName?.toLowerCase().includes(
                    "Water Absorption".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes(
                    "Coarse Aggregate".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes("10".toLowerCase())
              )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
            courseAggreagte10mm = (
              (parseFloat(courseAggreagte10mmConcrete) *
                parseFloat(courseAggreagte10mmWAPercentage)) /
              100
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
              courseAggreagte10mm
            );
          } else if (x?.MaterialShortCode == "CAD") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "MAD") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "WCR") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "TOTAL") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].WeightOfWaterAbsorptionKg`,
              ""
            );
          }
        }
      );
    } else if (
      columnName == "PerM3OfConcreteKgAfterWaterAbsorptionCorrection"
    ) {
      formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.map(
        (x, ix) => {
          if (x?.MaterialShortCode == "C") {
            if (
              formikTesting?.values?.TestMixDesignDetail
                ?.TypeofMineralAdmixtureIDEncrypted
            ) {
              cementContent =
                formikTesting?.values?.TestMixDesignDetail.CementContentKgPerM3;
            } else {
              cementContent =
                formikTesting?.values?.TestMixDesignDetail
                  .CementContentKgPerM3FinalResult;
            }
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
              cementContent
            );
          } else if (x?.MaterialShortCode == "CM") {
            cementitiousMaterial =
              formikTesting?.values?.TestMixDesignDetail
                .CementitiousMaterialContentKgPerM3 ?? 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
              cementitiousMaterial
            );
          } else if (x?.MaterialShortCode == "W") {
            waterContent =
              formikTesting?.values?.TestMixDesignDetail.WaterContentKgPerM3 ??
              0;
            let waFineAggregate =
              formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.filter(
                (m) => m.MaterialShortCode == "FA"
              )[0]?.WeightOfWaterAbsorptionKg ?? 0;
            let waCoarseAggregate20mm =
              formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.filter(
                (m) => m.MaterialShortCode == "CA20"
              )[0]?.WeightOfWaterAbsorptionKg ?? 0;
            let waCoarseAggregate10mm =
              formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.filter(
                (m) => m.MaterialShortCode == "CA10"
              )[0]?.WeightOfWaterAbsorptionKg ?? 0;
            waterContent = (
              parseFloat(waterContent) +
              parseFloat(waFineAggregate) +
              parseFloat(waCoarseAggregate20mm) +
              parseFloat(waCoarseAggregate10mm)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
              waterContent
            );
          } else if (x?.MaterialShortCode == "FA") {
            fineAggreagte = (
              parseFloat(x?.PerM3OfConcreteKg ?? 0) -
              parseFloat(x?.WeightOfWaterAbsorptionKg ?? 0)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
              fineAggreagte
            );
          } else if (x?.MaterialShortCode == "CA20") {
            courseAggreagte20mm = (
              parseFloat(x?.PerM3OfConcreteKg ?? 0) -
              parseFloat(x?.WeightOfWaterAbsorptionKg ?? 0)
            ).toFixed(2);

            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
              courseAggreagte20mm
            );
          } else if (x?.MaterialShortCode == "CA10") {
            courseAggreagte10mm = (
              parseFloat(x?.PerM3OfConcreteKg ?? 0) -
              parseFloat(x?.WeightOfWaterAbsorptionKg ?? 0)
            ).toFixed(2);

            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
              courseAggreagte10mm
            );
          } else if (x?.MaterialShortCode == "CAD") {
            chemicalAdmixture = x?.PerM3OfConcreteKg;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
              chemicalAdmixture
            );
          } else if (x?.MaterialShortCode == "MAD") {
            mineralAdmixture = x?.PerM3OfConcreteKg;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
              mineralAdmixture
            );
          } else if (x?.MaterialShortCode == "WCR") {
            wcRatio = x?.PerM3OfConcreteKg;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
              wcRatio
            );
          } else if (x?.MaterialShortCode == "TOTAL") {
            Total = (
              parseFloat(cementContent ? cementContent : 0) +
              parseFloat(cementitiousMaterial ? cementitiousMaterial : 0) +
              parseFloat(waterContent ? waterContent : 0) +
              parseFloat(fineAggreagte ? fineAggreagte : 0) +
              parseFloat(courseAggreagte20mm ? courseAggreagte20mm : 0) +
              parseFloat(courseAggreagte10mm ? courseAggreagte10mm : 0) +
              parseFloat(chemicalAdmixture ? chemicalAdmixture : 0) +
              parseFloat(mineralAdmixture ? mineralAdmixture : 0) +
              parseFloat(wcRatio ? wcRatio : 0)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`,
              Total
            );
          }
        }
      );
    } else if (columnName == "MoistureContentPercentageOfAggregate") {
      formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.map(
        (x, ix) => {
          if (x?.MaterialShortCode == "C") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
              "-"
            );
          } else if (x?.MaterialShortCode == "CM") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
              "-"
            );
          } else if (x?.MaterialShortCode == "W") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
              "-"
            );
          } else if (x?.MaterialShortCode == "FA") {
            fineAggreagte =
              formikTesting?.values?.ListOfParameter?.find(
                (x) =>
                  x.ParameterName?.toLowerCase().includes(
                    "Moisture Content".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes(
                    "Fine Aggregate".toLowerCase()
                  )
              )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
              fineAggreagte
            );
          } else if (x?.MaterialShortCode == "CA20") {
            courseAggreagte20mm =
              formikTesting?.values?.ListOfParameter?.find(
                (x) =>
                  x.ParameterName?.toLowerCase().includes(
                    "Moisture Content".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes(
                    "Coarse Aggregate".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes("20".toLowerCase())
              )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
              courseAggreagte20mm
            );
          } else if (x?.MaterialShortCode == "CA10") {
            courseAggreagte10mm =
              formikTesting?.values?.ListOfParameter?.find(
                (x) =>
                  x.ParameterName?.toLowerCase().includes(
                    "Moisture Content".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes(
                    "Coarse Aggregate".toLowerCase()
                  ) &&
                  x.ParameterName?.toLowerCase().includes("10".toLowerCase())
              )?.ListOfResultValue?.[0]?.ResultValue ?? 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
              courseAggreagte10mm
            );
          } else if (x?.MaterialShortCode == "CAD") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
              "-"
            );
          } else if (x?.MaterialShortCode == "MAD") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
              "-"
            );
          } else if (x?.MaterialShortCode == "WCR") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
              "-"
            );
          } else if (x?.MaterialShortCode == "TOTAL") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentPercentageOfAggregate`,
              ""
            );
          }
        }
      );
    } else if (columnName == "MoistureContentWeightKg") {
      formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.map(
        (x, ix) => {
          if (x?.MaterialShortCode == "C") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "CM") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "W") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "FA") {
            fineAggreagte = (
              (parseFloat(x?.MoistureContentPercentageOfAggregate) *
                parseFloat(
                  x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection
                )) /
              100
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
              fineAggreagte
            );
          } else if (x?.MaterialShortCode == "CA20") {
            courseAggreagte20mm = (
              (parseFloat(x?.MoistureContentPercentageOfAggregate) *
                parseFloat(
                  x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection
                )) /
              100
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
              courseAggreagte20mm
            );
          } else if (x?.MaterialShortCode == "CA10") {
            courseAggreagte10mm = (
              (parseFloat(x?.MoistureContentPercentageOfAggregate) *
                parseFloat(
                  x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection
                )) /
              100
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
              courseAggreagte10mm
            );
          } else if (x?.MaterialShortCode == "CAD") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "MAD") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "WCR") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
              "-"
            );
          } else if (x?.MaterialShortCode == "TOTAL") {
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].MoistureContentWeightKg`,
              ""
            );
          }
        }
      );
    } else if (
      columnName == "PerM3OfConcreteKgAfterMoistureContentCorrection"
    ) {
      formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.map(
        (x, ix) => {
          if (x?.MaterialShortCode == "C") {
            cementContent = x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
              cementContent
            );
          } else if (x?.MaterialShortCode == "CM") {
            cementitiousMaterial =
              x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
              cementitiousMaterial
            );
          } else if (x?.MaterialShortCode == "W") {
            waterContent = x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
            let mcwFineAggregate =
              formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.filter(
                (m) => m.MaterialShortCode == "FA"
              )[0]?.MoistureContentWeightKg ?? 0;
            let mcwCoarseAggregate20mm =
              formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.filter(
                (m) => m.MaterialShortCode == "CA20"
              )[0]?.MoistureContentWeightKg ?? 0;
            let mcwCoarseAggregate10mm =
              formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.filter(
                (m) => m.MaterialShortCode == "CA10"
              )[0]?.MoistureContentWeightKg ?? 0;
            waterContent = (
              parseFloat(waterContent) -
              parseFloat(mcwFineAggregate) -
              parseFloat(mcwCoarseAggregate20mm) -
              parseFloat(mcwCoarseAggregate10mm)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
              waterContent
            );
          } else if (x?.MaterialShortCode == "FA") {
            fineAggreagte = (
              parseFloat(x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection) +
              parseFloat(x?.MoistureContentWeightKg)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
              fineAggreagte
            );
          } else if (x?.MaterialShortCode == "CA20") {
            courseAggreagte20mm = (
              parseFloat(x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection) +
              parseFloat(x?.MoistureContentWeightKg)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
              courseAggreagte20mm
            );
          } else if (x?.MaterialShortCode == "CA10") {
            courseAggreagte10mm = (
              parseFloat(x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection) +
              parseFloat(x?.MoistureContentWeightKg)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
              courseAggreagte10mm
            );
          } else if (x?.MaterialShortCode == "CAD") {
            chemicalAdmixture =
              x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
              chemicalAdmixture
            );
          } else if (x?.MaterialShortCode == "MAD") {
            mineralAdmixture =
              x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
              mineralAdmixture
            );
          } else if (x?.MaterialShortCode == "WCR") {
            wcRatio = x?.PerM3OfConcreteKgAfterWaterAbsorptionCorrection;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
              wcRatio
            );
          } else if (x?.MaterialShortCode == "TOTAL") {
            Total = (
              parseFloat(cementContent ? cementContent : 0) +
              parseFloat(cementitiousMaterial ? cementitiousMaterial : 0) +
              parseFloat(waterContent ? waterContent : 0) +
              parseFloat(fineAggreagte ? fineAggreagte : 0) +
              parseFloat(courseAggreagte20mm ? courseAggreagte20mm : 0) +
              parseFloat(courseAggreagte10mm ? courseAggreagte10mm : 0) +
              parseFloat(chemicalAdmixture ? chemicalAdmixture : 0) +
              parseFloat(mineralAdmixture ? mineralAdmixture : 0) +
              parseFloat(wcRatio ? wcRatio : 0)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].PerM3OfConcreteKgAfterMoistureContentCorrection`,
              Total
            );
          }
        }
      );
    } else if (columnName == "LaboratoryMixTrialProportion") {
      formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.map(
        (x, ix) => {
          if (x?.MaterialShortCode == "C") {
            cementContent = (
              parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
              parseFloat(0.027)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
              cementContent
            );
          } else if (x?.MaterialShortCode == "CM") {
            cementitiousMaterial = (
              parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
              parseFloat(0.027)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
              cementitiousMaterial
            );
          } else if (x?.MaterialShortCode == "W") {
            waterContent = (
              parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
              parseFloat(0.027)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
              waterContent
            );
          } else if (x?.MaterialShortCode == "FA") {
            fineAggreagte = (
              parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
              parseFloat(0.027)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
              fineAggreagte
            );
          } else if (x?.MaterialShortCode == "CA20") {
            courseAggreagte20mm = (
              parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
              parseFloat(0.027)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
              courseAggreagte20mm
            );
          } else if (x?.MaterialShortCode == "CA10") {
            courseAggreagte10mm = (
              parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
              parseFloat(0.027)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
              courseAggreagte10mm
            );
          } else if (x?.MaterialShortCode == "CAD") {
            chemicalAdmixture = (
              parseFloat(x?.PerM3OfConcreteKgAfterMoistureContentCorrection) *
              parseFloat(0.027)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
              chemicalAdmixture
            );
          } else if (x?.MaterialShortCode == "MAD") {
            mineralAdmixture =
              x?.PerM3OfConcreteKgAfterMoistureContentCorrection > 0
                ? (
                    parseFloat(
                      x?.PerM3OfConcreteKgAfterMoistureContentCorrection
                    ) * parseFloat(0.027)
                  ).toFixed(2)
                : "-";
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
              mineralAdmixture
            );
          } else if (x?.MaterialShortCode == "WCR") {
            wcRatio = 0;
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
              "-"
            );
          } else if (x?.MaterialShortCode == "TOTAL") {
            Total = (
              parseFloat(cementContent ? cementContent : 0) +
              parseFloat(cementitiousMaterial ? cementitiousMaterial : 0) +
              parseFloat(waterContent ? waterContent : 0) +
              parseFloat(fineAggreagte ? fineAggreagte : 0) +
              parseFloat(courseAggreagte20mm ? courseAggreagte20mm : 0) +
              parseFloat(courseAggreagte10mm ? courseAggreagte10mm : 0) +
              parseFloat(chemicalAdmixture ? chemicalAdmixture : 0) +
              parseFloat(mineralAdmixture ? mineralAdmixture : 0) +
              parseFloat(wcRatio ? wcRatio : 0)
            ).toFixed(2);
            formikTesting.setFieldValue(
              `ListOfMixDesignMixProportionsForTrial[${ix}].LaboratoryMixTrialProportion`,
              Total
            );
          }
        }
      );
    }
  };

  const handleKeyDownDisable = (event) => {
    if (formikTesting?.values?.AllowTestingEdit != 1) {
      event.preventDefault(); // Prevent key action
    }
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam || editHeaderInwardIdParam
                ? "Edit"
                : ViewPrimaryIdParam
                ? "View"
                : "Add"}{" "}
              Sample Preparation & Testing
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={9}>
                    <Row>
                      <Col lg={4}>
                        {!ViewPrimaryIdParam && InwardCurrentStatus == 1 ? (
                          <Field
                            label="Inward Date"
                            name="InwardDate"
                            placeholder={"Select Inward Date"}
                            component={CustomFlatpickr}
                            options={{
                              altInput: true,
                              altFormat: "j-M-Y",
                              dateFormat: "d-m-Y",
                              maxDate: new Date(),
                            }}
                            required
                          />
                        ) : (
                          <Field
                            label="Inward Date"
                            name="InwardDate"
                            component={CustomInput}
                            value={moment(InwardDate).format("DD-MMM-yyyy")}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col lg={4}>
                        {!ViewPrimaryIdParam && InwardCurrentStatus == 1 ? (
                          <Field
                            label="Inward No"
                            name="InwardNo"
                            placeholder={"Select Inward No"}
                            options={inwardNoOptions}
                            component={CustomSelect}
                            required
                            autoFocus
                            onChange={(e) => {
                              //console.log(e);
                              formik.setFieldValue("InwardNo", e?.value ?? "");
                              formik.setFieldValue(
                                "IsTCNoBasedOnInwardNo",
                                e ? e?.IsTCNoBasedOnInwardNo : true
                              );
                            }}
                          />
                        ) : (
                          <Field
                            label="Inward No"
                            name="InwardNo"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                        <Col lg={4}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex mb-2">
                            <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 mb-1 me-1">
                              <label className="mb-1">
                                Sample Returnable &nbsp;
                              </label>
                            </text>
                            <div class="form-check form-switch">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckIsMaterialReturnable"
                                title={
                                  IsMaterialReturnable == true ? "Yes" : "No"
                                }
                                checked={IsMaterialReturnable}
                                onChange={() => {
                                  if (
                                    editHeaderInwardIdParam &&
                                    formik?.values?.IsMaterialDispatched ==
                                      true &&
                                    IsMaterialReturnable == true
                                  ) {
                                    warningMessage(
                                      "The sample has been dispatched, it cannot be changed."
                                    );
                                  } else {
                                    formik.setFieldValue(
                                      "IsMaterialReturnable",
                                      !IsMaterialReturnable
                                    );
                                  }
                                }}
                                disabled={ViewPrimaryIdParam}
                                style={{ cursor: "pointer" }}
                              ></input>
                            </div>
                          </div>
                        </Col>
                      ) : (
                        <Col lg={4}></Col>
                      )}
                      <Col lg={4}>
                        {/* <Field
                          label="Customer"
                          name="CustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          options={customerOptions}
                          component={CustomSelect}
                          required
                        /> */}
                        {!PrimaryIdParam &&
                        !editHeaderInwardIdParam &&
                        !ViewPrimaryIdParam ? (
                          <>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 10 && x?.IsAdd
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                className="icon-box icon-box-md bg-primary-light me-1"
                                title="New Customer"
                                style={{ float: "right" }}
                                // onClick={() => {
                                //   redirectToNewCustomer();
                                // }}
                                onClick={() => {
                                  window.open(
                                    `/add-customer/${true}`,
                                    "_blank"
                                  );
                                }}
                              >
                                <i className="fa fa-plus"></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="Reload Customer"
                              style={{ float: "right" }}
                              onClick={() => {
                                // loadOptionsCutomer("");
                                setRefreshCustomerKey(
                                  Math.random().toString(9).substring(2, 9)
                                );
                              }}
                            >
                              <i className="fa fa-refresh"></i>
                            </Link>
                          </>
                        ) : (
                          ""
                        )}
                        {editHeaderInwardIdParam ? (
                          formik?.values?.IsHeaderDetailCustomerChange ==
                          false ? (
                            <Link
                              to="#"
                              className="me-1"
                              title="Edit"
                              style={{ float: "right" }}
                              onClick={handleChangeHeaderDetailCustomerChange}
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Edit
                              </label>
                            </Link>
                          ) : (
                            <Link
                              to="#"
                              className="me-1"
                              title="Cancel"
                              style={{ float: "right" }}
                              onClick={cancelHeaderDetailCustomerChange}
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Cancel
                              </label>
                            </Link>
                          )
                        ) : (
                          ""
                        )}

                        {(editHeaderInwardIdParam &&
                          formik?.values?.IsHeaderDetailCustomerChange ==
                            false) ||
                        IsAllowToEdit != 1 ||
                        ViewPrimaryIdParam ? (
                          <Field
                            label="Customer"
                            name="CustomerName"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        ) : (
                          <Field
                            key={refreshCustomerKey}
                            label="Customer"
                            name="CustomerIDEncrypted"
                            placeholder={"Select Customer"}
                            //options={customerOptions}
                            loadOptionsFn={loadOptionsCutomer}
                            component={CustomSelectAsync}
                            title={CustomerName}
                            labelFieldName="CustomerName"
                            onChange={(e) => {
                              formik.setFieldValue(
                                "CustomerIDEncrypted",
                                e?.value ?? ""
                              );
                              formik.setFieldValue(
                                "CustomerName",
                                e?.label ?? ""
                              );
                              if (e && e?.value && !editHeaderInwardIdParam) {
                                ValidateCustomerCredit(e?.value);
                              }
                            }}
                            required
                          />
                        )}
                      </Col>
                      <Col lg={4}>
                        {editHeaderInwardIdParam ? (
                          formik?.values?.IsHeaderDetailProjectChange ==
                          false ? (
                            <Link
                              to="#"
                              className="me-1"
                              title="Edit"
                              style={{ float: "right" }}
                              onClick={handleChangeHeaderDetailProjectChange}
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Edit
                              </label>
                            </Link>
                          ) : (
                            <Link
                              to="#"
                              className="me-1"
                              title="Cancel"
                              style={{ float: "right" }}
                              onClick={cancelHeaderDetailProjectChange}
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Cancel
                              </label>
                            </Link>
                          )
                        ) : (
                          ""
                        )}

                        {(editHeaderInwardIdParam &&
                          formik?.values?.IsHeaderDetailProjectChange ==
                            false) ||
                        IsAllowToEdit != 1 ||
                        ViewPrimaryIdParam ? (
                          <Field
                            label="Project"
                            name="CustomerProjectName"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        ) : (
                          <Field
                            label="Project"
                            name="CustomerProjectIDEncrypted"
                            placeholder={"Select Project"}
                            options={projectOptions}
                            component={CustomSelect}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "CustomerProjectIDEncrypted",
                                e?.value ?? ""
                              );
                              formik.setFieldValue(
                                "CustomerProjectName",
                                e?.label ?? ""
                              );
                            }}
                            required
                          />
                        )}
                      </Col>
                      <Col lg={4}>
                        <Field
                          label="Stamp"
                          name="StampWriteUpIDEncrypted"
                          placeholder={"Select Stamp"}
                          options={stampWriteUpOptions}
                          component={CustomSelect}
                          isDisabled={ViewPrimaryIdParam}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={3}>
                    <label className="mb-1">
                      Stamp Image
                      {/* <span className="text-danger">*</span>*/}
                      {/* {" "} <span className="text-danger fs-12">(200 x 200)</span> */}
                    </label>
                    <div className="image-placeholder square-placeholder">
                      {!ViewPrimaryIdParam ? (
                        <>
                          <div className="avatar-edit">
                            <input
                              type="file"
                              id="imageUpload"
                              accept="image/png, image/gif, image/jpeg"
                              onChange={uploadStampImage}
                            />
                            <label htmlFor="imageUpload" name=""></label>
                          </div>
                          <div
                            id="removeFile"
                            className="avatar-delete"
                            onClick={() => {
                              setStampImageFile(null);
                              setStampImage(null);
                              //formik.setFieldValue("StampImageFilePath", "");
                              formik.setFieldValue(
                                "IsStampImageFileDeleted",
                                true
                              );
                            }}
                          >
                            <label htmlFor="removeFile" name=""></label>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      <div className="avatar-preview">
                        <div id="imagePreview">
                          <img
                            id="saveImageFile"
                            src={stampImage ? stampImage : img200}
                            alt={"Stamp Image"}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    {!editHeaderInwardIdParam &&
                      IsAllowToEdit == 1 &&
                      !ViewPrimaryIdParam && (
                        <Link
                          to="#"
                          className="icon-box icon-box-md bg-primary-light me-1"
                          title="Select Work Detail"
                          style={{ float: "right" }}
                          onClick={() => {
                            setShowWorkDetailModal(true);
                          }}
                        >
                          <i className="fa fa-edit"></i>
                        </Link>
                      )}
                    {editHeaderInwardIdParam ? (
                      formik?.values?.IsHeaderDetailWorkDetailChange ==
                      false ? (
                        <Link
                          to="#"
                          className="me-1"
                          title="Edit"
                          style={{ float: "right" }}
                          onClick={handleChangeHeaderDetailWorkDetailChange}
                        >
                          {SVGICON.EditSquareDanger}{" "}
                          <label
                            className="mb-1 text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Edit
                          </label>
                        </Link>
                      ) : (
                        <Link
                          to="#"
                          className="me-1"
                          title="Cancel"
                          style={{ float: "right" }}
                          onClick={cancelHeaderDetailWorkDetailChange}
                        >
                          {SVGICON.EditSquareDanger}{" "}
                          <label
                            className="mb-1 text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Cancel
                          </label>
                        </Link>
                      )
                    ) : (
                      ""
                    )}
                    <Field
                      label="Work Detail"
                      name="ProjectDetails"
                      placeholder={"Enter Work Detail"}
                      component={CustomTextArea}
                      rows={5}
                      // required
                      maxLength={500}
                      disabled={
                        (editHeaderInwardIdParam &&
                          formik?.values?.IsHeaderDetailWorkDetailChange ==
                            false) ||
                        IsAllowToEdit != 1 ||
                        ViewPrimaryIdParam
                      }
                    />
                  </Col>
                  <Col lg={6}>
                    <Row>
                      <Col lg={6}>
                        {editHeaderInwardIdParam ? (
                          formik?.values?.IsHeaderDetailLetterRefNoChange ==
                          false ? (
                            <Link
                              to="#"
                              className="me-1"
                              title="Edit"
                              style={{ float: "right" }}
                              onClick={
                                handleChangeHeaderDetailLetterRefNoChange
                              }
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Edit
                              </label>
                            </Link>
                          ) : (
                            <Link
                              to="#"
                              className="me-1"
                              title="Cancel"
                              style={{ float: "right" }}
                              onClick={cancelHeaderDetailLetterRefNoChange}
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Cancel
                              </label>
                            </Link>
                          )
                        ) : (
                          ""
                        )}
                        <Field
                          label="Letter Ref No"
                          name="LetterRefNo"
                          placeholder={"Enter Letter Ref No"}
                          component={CustomInput}
                          maxLength={100}
                          disabled={
                            (editHeaderInwardIdParam &&
                              formik?.values?.IsHeaderDetailLetterRefNoChange ==
                                false) ||
                            ViewPrimaryIdParam
                          }
                        />
                      </Col>
                      <Col lg={6}>
                        {ListOfLetterRefDoc.length > 0 ? (
                          <label
                            // style={{ color: "#4189e8" }}
                            className="text-primary"
                            title="File Uploaded"
                          >
                            Letter Ref Doc
                          </label>
                        ) : (
                          <label>Letter Ref Doc </label>
                        )}
                        <div className="mb-2">
                          <div className="input-group">
                            <span className="form-control form-control-sm ps-2">
                              <Link
                                to="#"
                                className="text-primary"
                                onClick={() => {
                                  setShowLetterRefDocModal(true);
                                }}
                              >
                                View Letter Ref Doc
                              </Link>
                            </span>
                            <div
                              className="input-group-text"
                              title="Choose File"
                              style={{
                                borderRadius: "0 0.375rem 0.375rem 0",
                              }}
                            >
                              <div className="open-file">
                                <input
                                  // type="file"
                                  id="LetterRefUpload"
                                  ////accept="image/png, image/gif, image/jpeg"
                                  //onChange={uploadLetterRefDoc}
                                  onClick={() => {
                                    setShowLetterRefDocModal(true);
                                  }}
                                />
                                <label
                                  htmlFor="LetterRefUpload"
                                  name=""
                                ></label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <label className="mb-1"></label>
                        <div className="d-flex mb-2">
                          <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 mb-1 me-1">
                            <label className="mb-1">TPI Required &nbsp;</label>
                          </text>
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckIsTPIRequired"
                              title={IsTPIRequired == true ? "Yes" : "No"}
                              checked={IsTPIRequired}
                              onChange={handleChangeIsTPIRequired}
                              style={{ cursor: "pointer" }}
                              disabled={ViewPrimaryIdParam}
                            ></input>
                          </div>
                        </div>
                      </Col>
                      {IsTPIRequired == true && (
                        <Col lg={6}>
                          {/* {editHeaderInwardIdParam &&
                          formik?.values?.originalIsTPIRequired == true ? (
                            formik?.values?.IsHeaderDetailTPIDetailChange ==
                            false ? (
                              <Link
                                to="#"
                                className="me-1"
                                title="Edit"
                                style={{ float: "right" }}
                                onClick={
                                  handleChangeHeaderDetailTPIDetailChange
                                }
                              >
                                {SVGICON.EditSquareDanger}{" "}
                                <label
                                  className="mb-1 text-danger"
                                  style={{ cursor: "pointer" }}
                                >
                                  Edit
                                </label>
                              </Link>
                            ) : (
                              <Link
                                to="#"
                                className="me-1"
                                title="Cancel"
                                style={{ float: "right" }}
                                onClick={cancelHeaderDetailTPIDetailChange}
                              >
                                {SVGICON.EditSquareDanger}{" "}
                                <label
                                  className="mb-1 text-danger"
                                  style={{ cursor: "pointer" }}
                                >
                                  Cancel
                                </label>
                              </Link>
                            )
                          ) : (
                            ""
                          )} */}

                          {ListOfTPIDetails.length > 0 ? (
                            <label
                              // style={{ color: "#4189e8" }}
                              className="text-primary"
                              title="TPI is Available"
                            >
                              TPI Details
                            </label>
                          ) : (
                            <label>TPI Details</label>
                          )}
                          <div className="mb-2">
                            <div className="input-group">
                              <span className="form-control form-control-sm ps-2">
                                <Link
                                  to="#"
                                  className="text-primary"
                                  // style={{
                                  //   cursor:
                                  //     editHeaderInwardIdParam &&
                                  //     formik?.values
                                  //       ?.IsHeaderDetailTPIDetailChange == false
                                  //       ? "not-allowed"
                                  //       : "pointer",
                                  // }}
                                  onClick={() => {
                                    // if (
                                    //   editHeaderInwardIdParam &&
                                    //   formik?.values
                                    //     ?.IsHeaderDetailTPIDetailChange == false
                                    // ) {
                                    // } else {
                                    setShowTPIDetailModal(true);
                                    // }
                                  }}
                                >
                                  View TPI Details
                                </Link>
                              </span>
                              <div
                                className="input-group-text"
                                title="Add TPI Detail"
                                style={{
                                  borderRadius: "0 0.375rem 0.375rem 0",
                                  cursor: ViewPrimaryIdParam
                                    ? "not-allowed"
                                    : "pointer",
                                  // cursor:
                                  //   editHeaderInwardIdParam &&
                                  //   formik?.values
                                  //     ?.IsHeaderDetailTPIDetailChange == false
                                  //     ? "not-allowed"
                                  //     : "pointer",
                                }}
                                onClick={() => {
                                  // if (
                                  //   editHeaderInwardIdParam &&
                                  //   formik?.values
                                  //     ?.IsHeaderDetailTPIDetailChange == false
                                  // ) {
                                  // } else {
                                  if (!ViewPrimaryIdParam) {
                                    addNewTPI(false);
                                  }
                                  // }
                                }}
                              >
                                <i className="fa fa-plus" />
                              </div>
                            </div>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
                {AuthUser?.Permissions?.InwardClubing == true ? (
                  <Row>
                    {CustomerIDEncrypted ? (
                      <>
                        <Col lg={6}>
                          <div className="d-flex">
                            <div className="pt-2">
                              <label className="mb-1"></label>
                              <div className="d-flex mb-2">
                                <label className="mb-1">
                                  Inward Clubing &nbsp;
                                </label>
                                <div class="form-check form-switch">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="flexSwitchCheckInwardClubing"
                                    title={InwardClubing == true ? "Yes" : "No"}
                                    checked={InwardClubing}
                                    onChange={handleChangeInwardClubing}
                                    style={{ cursor: "pointer" }}
                                    disabled={ViewPrimaryIdParam}
                                  ></input>
                                </div>
                              </div>
                            </div>
                            &nbsp;&nbsp;&nbsp;
                            <div style={{ flex: 1 }}>
                              {InwardClubing ? (
                                <Field
                                  label="Clubing Inward No"
                                  name="InwardIDsClubing"
                                  placeholder={"Select Inward No"}
                                  options={inwardNoClubingOptions}
                                  component={CustomMultiSelect}
                                  isMulti={true}
                                  menuPosition="fixed"
                                  onChange={handleChangeInwardNos}
                                  isDisabled={ViewPrimaryIdParam}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                  </Row>
                ) : (
                  ""
                )}
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <Col lg={6}>
                    <label>Material Information</label>
                  </Col>
                  {CopyInwardIdParam && (
                    <Col lg={6} style={{ textAlign: "right" }}>
                      <span className="text-warning fs-12">
                        [Note: Sample Images are not copied & Test details are
                        copied automatically upon saving.]
                      </span>
                    </Col>
                  )}

                  {editHeaderInwardIdParam && (
                    <Col lg={6} style={{ textAlign: "right" }}>
                      <span className="text-danger fs-12">
                        [Note: Changed Sample information will result in the
                        deletion of related transactions, such as Report
                        Printing
                        {AuthUser?.Permissions?.UploadScanCopy == 1
                          ? " and Upload Scan Copy"
                          : ""}
                        , if they exist.]
                      </span>
                    </Col>
                  )}

                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="MaterialInfo-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="MaterialInfo-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="2%">
                                {!editHeaderInwardIdParam &&
                                  !ViewPrimaryIdParam && (
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md bg-primary-light"
                                      title="Add New"
                                      onClick={() => {
                                        AddNewMaterialInformation();
                                      }}
                                    >
                                      <i className="fa fa-plus"></i>
                                    </Link>
                                  )}
                              </th>
                              {/* <th width="14%">Department</th> */}
                              {(IsTCNoBasedOnInwardNo == false ||
                                (InwardCurrentStatus > 1 &&
                                  (PrimaryIdParam ||
                                    editHeaderInwardIdParam ||
                                    ViewPrimaryIdParam))) && (
                                <th width="12%">TC No</th>
                              )}
                              {/* <th width="14%">Material Group</th>
                              <th width="14%">Material Type</th> */}
                              {/* <th width="14%">Size</th>
                              <th width="14%">Condition</th>
                              <th width="23%">Sample Detail</th> */}
                              <th width="35%">Sample Detail</th>
                              <th width="20%">Condition</th>
                              <th width="20%">Size</th>
                              {AuthUser?.Permissions?.Machining == 1 ? (
                                <th width="7%">Machining</th>
                              ) : (
                                ""
                              )}
                              <th width="4%" style={{ textAlign: "left" }}>
                                Images
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListOfMaterials?.filter(
                              (x) => x.IsDeleted == false
                            )?.length > 0 ? (
                              ListOfMaterials?.map((item, indx) => (
                                <React.Fragment key={indx}>
                                  <tr
                                    key={indx}
                                    style={{
                                      display:
                                        item.IsDeleted == true ? "none" : "",
                                      backgroundColor:
                                        item?.IsErrorDisplay == true
                                          ? "#f69393"
                                          : "",
                                    }}
                                  >
                                    <td className="p-1">
                                      {editHeaderInwardIdParam ? (
                                        item?.IsHeaderDetailMaterialInformationChange ==
                                        false ? (
                                          <Link
                                            to="#"
                                            className="me-1"
                                            title="Edit"
                                            onClick={() => {
                                              handleChangeHeaderDetailMaterialInformationChange(
                                                indx
                                              );
                                            }}
                                          >
                                            {SVGICON.EditSquareDanger}{" "}
                                            <label
                                              className="mb-1 text-danger"
                                              style={{ cursor: "pointer" }}
                                            >
                                              Edit
                                            </label>
                                          </Link>
                                        ) : (
                                          <Link
                                            to="#"
                                            className="me-1"
                                            title="Cancel"
                                            style={{ float: "right" }}
                                            onClick={() => {
                                              cancelHeaderDetailMaterialInformationChange(
                                                indx
                                              );
                                            }}
                                          >
                                            {SVGICON.EditSquareDanger}{" "}
                                            <label
                                              className="mb-1 text-danger"
                                              style={{ cursor: "pointer" }}
                                            >
                                              Cancel
                                            </label>
                                          </Link>
                                        )
                                      ) : (
                                        !ViewPrimaryIdParam && (
                                          <>
                                            {item?.AllowTCEdit == 1 && (
                                              <Link
                                                to="#"
                                                className="icon-box icon-box-md me-1"
                                                title="Delete"
                                                onClick={() => {
                                                  //deleteMaterialInformation(indx);
                                                  delete_RecordWithoutApi(
                                                    deleteMaterialInformation,
                                                    indx
                                                  );
                                                }}
                                              >
                                                {SVGICON.DeleteDanger}
                                              </Link>
                                            )}
                                            <Link
                                              to="#"
                                              className="icon-box icon-box-md"
                                              title="Repeat"
                                              onClick={() => {
                                                formik.setFieldValue(
                                                  "selectedMaterialInfoRow",
                                                  indx
                                                );
                                                formikMaterialInfoRepeatRow.resetForm();
                                                setShowMaterialInfoRepeatRowQtyModal(
                                                  true
                                                );
                                              }}
                                            >
                                              <i className="fa fa-repeat" />
                                            </Link>
                                          </>
                                        )
                                      )}
                                    </td>
                                    {/* <td
                                    className="p-1"
                                    style={{ minWidth: "150px" }}
                                  >
                                    <Field
                                      name={`ListOfMaterials[${indx}].DepartmentIDEncrypted`}
                                      placeholder={"Department"}
                                      options={departmentOptions}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListOfMaterials[${indx}].DepartmentIDEncrypted`,
                                          e?.value ?? ""
                                        );
                                        getProductGroupDDL(
                                          e?.value ?? "",
                                          indx
                                        );
                                        formik.setFieldValue(
                                          `ListOfMaterials[${indx}].ProductGroupIDEncrypted`,
                                          ""
                                        );
                                        getMaterialTypeDDL(
                                          e?.value ?? "",
                                          "",
                                          indx
                                        );
                                      }}
                                      // style={{ borderColor: "red" }}
                                    />
                                  </td> */}

                                    {/* <td
                                      className="p-1"
                                      style={{ minWidth: "150px" }}
                                    >
                                      {item.TCNoAllocated == false ||
                                      !item.InwardMaterialIDEncrypted ? (
                                        <Field
                                          name={`ListOfMaterials[${indx}].TCNo`}
                                          placeholder={"TC No"}
                                          options={tcNoOptions}
                                          component={CustomSelect}
                                          noMarginBottom={true}
                                          menuPosition="fixed"
                                        />
                                      ) : (
                                        <Field
                                          name={`ListOfMaterials[${indx}].TCNo`}
                                          placeholder={"TC No"}
                                          component={CustomInput}
                                          disabled={true}
                                          noMarginBottom={true}
                                        />
                                      )}
                                    </td> */}
                                    {IsTCNoBasedOnInwardNo == false ||
                                    (InwardCurrentStatus > 1 &&
                                      (PrimaryIdParam ||
                                        editHeaderInwardIdParam ||
                                        ViewPrimaryIdParam)) ? (
                                      <td
                                        className="p-1"
                                        style={{ minWidth: "150px" }}
                                      >
                                        {(item.TCNoAllocated == false ||
                                          !item.InwardMaterialIDEncrypted) &&
                                        IsTCNoBasedOnInwardNo == false ? (
                                          <Field
                                            name={`ListOfMaterials[${indx}].TCNo`}
                                            placeholder={"TC No"}
                                            options={tcNoOptions}
                                            component={CustomSelect}
                                            noMarginBottom={true}
                                            menuPosition="fixed"
                                          />
                                        ) : item.TCNoAllocated == false ||
                                          !item.InwardMaterialIDEncrypted ? (
                                          ""
                                        ) : (
                                          <Field
                                            name={`ListOfMaterials[${indx}].TCNo`}
                                            placeholder={"TC No"}
                                            component={CustomInput}
                                            disabled={true}
                                            noMarginBottom={true}
                                          />
                                        )}
                                      </td>
                                    ) : (
                                      ""
                                    )}

                                    {/* <td
                                    className="p-1"
                                    style={{ minWidth: "150px" }}
                                  >
                                    <Field
                                      name={`ListOfMaterials[${indx}].ProductGroupIDEncrypted`}
                                      placeholder={"Material Group"}
                                      // options={item.productGroupOptions}
                                      options={productGroupOptions}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListOfMaterials[${indx}].ProductGroupIDEncrypted`,
                                          e?.value ?? ""
                                        );
                                        // getMaterialTypeDDL(
                                        //   item.DepartmentIDEncrypted,
                                        //   e?.value ?? "",
                                        //   indx
                                        // );
                                        getMaterialTypeDDL(
                                          e?.value ?? "",
                                          indx
                                        );
                                        formik.setFieldValue(
                                          `ListOfMaterials[${indx}].MaterialTypeIDEncrypted`,
                                          ""
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{ minWidth: "150px" }}
                                  >
                                    <Field
                                      name={`ListOfMaterials[${indx}].MaterialTypeIDEncrypted`}
                                      placeholder={"Material Type"}
                                      options={item.materialTypeOptions}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                    />
                                  </td> */}

                                    <td
                                      className="p-1"
                                      style={{ minWidth: "230px" }}
                                    >
                                      <Field
                                        name={`ListOfMaterials[${indx}].SampleDetail`}
                                        placeholder={"Sample Detail"}
                                        component={CustomInput}
                                        maxLength={2000}
                                        noMarginBottom={true}
                                        disabled={
                                          (editHeaderInwardIdParam &&
                                            item?.IsHeaderDetailMaterialInformationChange ==
                                              false) ||
                                          item?.AllowTCEdit != 1 ||
                                          ViewPrimaryIdParam
                                        }
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{ minWidth: "150px" }}
                                    >
                                      <Field
                                        name={`ListOfMaterials[${indx}].Condition`}
                                        placeholder={"Condition"}
                                        component={CustomInput}
                                        maxLength={500}
                                        noMarginBottom={true}
                                        disabled={
                                          (editHeaderInwardIdParam &&
                                            item?.IsHeaderDetailMaterialInformationChange ==
                                              false) ||
                                          item?.AllowTCEdit != 1 ||
                                          ViewPrimaryIdParam
                                        }
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{ minWidth: "150px" }}
                                    >
                                      <Field
                                        name={`ListOfMaterials[${indx}].Size`}
                                        placeholder={"Size"}
                                        component={CustomInput}
                                        maxLength={500}
                                        noMarginBottom={true}
                                        disabled={
                                          (editHeaderInwardIdParam &&
                                            item?.IsHeaderDetailMaterialInformationChange ==
                                              false) ||
                                          item?.AllowTCEdit != 1 ||
                                          ViewPrimaryIdParam
                                        }
                                      />
                                    </td>
                                    {AuthUser?.Permissions?.Machining == 1 ? (
                                      <td
                                        className="p-1"
                                        style={{ minWidth: "100px" }}
                                      >
                                        <div className="form-check form-switch ms-4">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            id="flexSwitchCheckMachining"
                                            title={
                                              item?.IsMachining == true
                                                ? "Yes"
                                                : "No"
                                            }
                                            checked={item?.IsMachining}
                                            onChange={(e) => {
                                              handleChangeIsMachining(
                                                indx,
                                                e,
                                                item
                                              );
                                            }}
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            disabled={
                                              item?.IsHold || ViewPrimaryIdParam
                                            }
                                          ></input>
                                          &nbsp;
                                          {item?.IsMachining == true ? (
                                            <Link
                                              to="#"
                                              className="text-primary"
                                              title="View Machining Details"
                                              onClick={() => {
                                                if (item?.IsHold == false) {
                                                  getMaterialProcessDetails(
                                                    indx,
                                                    item?.IsMachining,
                                                    item?.InwardMaterialIDEncrypted
                                                  );
                                                }
                                              }}
                                              disabled={item?.IsHold}
                                            >
                                              View
                                            </Link>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </td>
                                    ) : (
                                      ""
                                    )}
                                    <td
                                      className="p-1"
                                      style={{ textAlign: "center" }}
                                    >
                                      <Link
                                        to="#"
                                        // className="icon-box icon-box-md bg-primary-light"
                                        className="icon-box icon-box-md"
                                        onClick={() => {
                                          if (
                                            editHeaderInwardIdParam &&
                                            item?.IsHeaderDetailMaterialInformationChange ==
                                              false
                                          ) {
                                          } else {
                                            setShowMaterialInfoImagesModal(
                                              true
                                            );
                                            formik.setFieldValue(
                                              "selectedMaterialInfoRow",
                                              indx
                                            );
                                            setMaterialPhotoFile(null);
                                            setMaterialPhoto(null);
                                          }
                                        }}
                                        disabled={
                                          editHeaderInwardIdParam &&
                                          item?.IsHeaderDetailMaterialInformationChange ==
                                            false
                                        }
                                      >
                                        {/* Upload / View */}
                                        <i className="fa fa-cloud-upload"></i>
                                      </Link>
                                    </td>
                                  </tr>
                                  <tr
                                    key={`iRow_${indx}`}
                                    style={{
                                      display:
                                        item.IsDeleted == true ? "none" : "",
                                    }}
                                  >
                                    <td
                                      className="p-1 pt-3"
                                      style={{
                                        verticalAlign: "top",
                                      }}
                                    >
                                      {!ViewPrimaryIdParam ? (
                                        <>
                                          {ListOfMaterials?.filter(
                                            (x) => x.IsDeleted == false
                                          )?.length > 1 &&
                                            item?.ListOfMaterialTestDetails?.filter(
                                              (x) => x.IsDeleted == false
                                            )?.length > 0 && (
                                              <Link
                                                to="#"
                                                // className="icon-box icon-box-md bg-primary-light"
                                                className="icon-box icon-box-md"
                                                title="Repeat Test Details"
                                                onClick={() => {
                                                  handleOnClickRepeatTestDetails(
                                                    indx
                                                  );
                                                }}
                                              >
                                                <i className="fa fa-repeat" />
                                              </Link>
                                            )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                    <td
                                      colSpan={9}
                                      className="p-1"
                                      style={{
                                        textAlign: "left",
                                        maxWidth: "500px",
                                      }}
                                    >
                                      <Accordion
                                        className="accordion accordion-solid-bg"
                                        defaultActiveKey="0"
                                      >
                                        <Accordion.Item
                                          className="accordion-item m-0"
                                          key={indx}
                                          eventKey={"0"}
                                        >
                                          <Accordion.Header className="accordion-header rounded-lg">
                                            Test Details
                                          </Accordion.Header>
                                          <Accordion.Collapse eventKey={"0"}>
                                            <div className="accordion-body p-0">
                                              <div className="table-responsive active-projects style-1 shorting">
                                                <div
                                                  id="MaterialTestInfo-tbl_wrapper"
                                                  className="dataTables_wrapper table-responsive no-footer"
                                                >
                                                  <table
                                                    id="MaterialTestInfo-tbl"
                                                    className="table table-bordered no-footer mb-0"
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th
                                                          width="2%"
                                                          className="ps-2 newPara"
                                                        >
                                                          {!ViewPrimaryIdParam ? (
                                                            <>
                                                              {item?.IsHold ==
                                                                false && (
                                                                <Link
                                                                  to="#"
                                                                  className="icon-box icon-box-md bg-primary-light"
                                                                  title="Add New"
                                                                  onClick={() => {
                                                                    AddNewMaterialTestInformation(
                                                                      indx
                                                                    );
                                                                  }}
                                                                >
                                                                  <i className="fa fa-plus"></i>
                                                                </Link>
                                                              )}
                                                            </>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </th>
                                                        <th
                                                          width="14%"
                                                          className="newPara"
                                                        >
                                                          Department
                                                        </th>
                                                        <th
                                                          width="18%"
                                                          className="newPara"
                                                        >
                                                          Test
                                                        </th>
                                                        <th className="newPara"></th>
                                                        <th
                                                          width="12%"
                                                          className="newPara"
                                                        >
                                                          Material Group
                                                        </th>
                                                        <th
                                                          width="12%"
                                                          className="newPara"
                                                        >
                                                          Material Type
                                                        </th>
                                                        {/* <th
                                                                                            width="13%"
                                                                                            className="newPara"
                                                                                          >
                                                                                            Test Method
                                                                                          </th> */}
                                                        <th
                                                          width="14%"
                                                          className="newPara"
                                                        >
                                                          Ref. Standard
                                                        </th>
                                                        <th
                                                          width="9%"
                                                          className="newPara"
                                                        >
                                                          Group
                                                        </th>
                                                        <th className="newPara"></th>
                                                        <th
                                                          width="5%"
                                                          className="newPara"
                                                        >
                                                          Test Count
                                                        </th>
                                                        <th
                                                          width="5%"
                                                          className="newPara"
                                                        >
                                                          Billing Qty
                                                        </th>
                                                        {/* 
                                                                                          <th width="10%" className="newPara">
                                                                                            Unit
                                                                                          </th>
                                                                                          <th width="10%" className="newPara">
                                                                                            Rate
                                                                                          </th> */}
                                                        {/* <th
                                                                                            width="10%"
                                                                                            className="newPara"
                                                                                          >
                                                                                            Machining
                                                                                          </th> */}
                                                        <th
                                                          width="9%"
                                                          style={{
                                                            textAlign: "left",
                                                          }}
                                                          className="newPara"
                                                        >
                                                          Note
                                                        </th>
                                                        <th
                                                          style={{
                                                            textAlign: "left",
                                                          }}
                                                          className="newPara"
                                                        ></th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {item?.ListOfMaterialTestDetails?.filter(
                                                        (x) =>
                                                          x.IsDeleted == false
                                                      )?.length > 0 ? (
                                                        item?.ListOfMaterialTestDetails?.map(
                                                          (
                                                            itemTest,
                                                            indxTest
                                                          ) => (
                                                            <tr
                                                              key={`test_${indxTest}`}
                                                              style={{
                                                                display:
                                                                  itemTest?.IsDeleted ==
                                                                  true
                                                                    ? "none"
                                                                    : "",
                                                              }}
                                                            >
                                                              <td className="p-1">
                                                                {itemTest?.IsCancel ==
                                                                false ? (
                                                                  item?.IsHold ==
                                                                    false &&
                                                                  (!ViewPrimaryIdParam &&
                                                                  itemTest?.AllowTestEdit ==
                                                                    1 ? (
                                                                    <Link
                                                                      to="#"
                                                                      // className="icon-box icon-box-md bg-danger-light"
                                                                      className="icon-box icon-box-md"
                                                                      title="Delete"
                                                                      onClick={() => {
                                                                        //deleteMaterialTestInformation(indx,indxTest);
                                                                        delete_RecordWithoutApi(
                                                                          deleteMaterialTestInformation,
                                                                          indx,
                                                                          indxTest
                                                                        );
                                                                      }}
                                                                    >
                                                                      {
                                                                        SVGICON.DeleteDanger
                                                                      }
                                                                    </Link>
                                                                  ) : (
                                                                    ""
                                                                  ))
                                                                ) : (
                                                                  <i
                                                                    className="fa fa-ban ps-2 text-danger"
                                                                    title="Cancelled"
                                                                  ></i>
                                                                )}
                                                              </td>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "150px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].DepartmentIDEncrypted`}
                                                                  placeholder={
                                                                    "Department"
                                                                  }
                                                                  options={
                                                                    departmentOptions
                                                                  }
                                                                  component={
                                                                    CustomSelect
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  menuPosition="fixed"
                                                                  isDisabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam ||
                                                                    itemTest?.IsMixDesignIncludedTest ||
                                                                    itemTest
                                                                      ?.TestingDetails
                                                                      ?.TestingStatus >
                                                                      1
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    if (
                                                                      e &&
                                                                      e?.value &&
                                                                      e?.IsNABLScopeExpired ==
                                                                        true
                                                                    ) {
                                                                      customConfirmDialog(
                                                                        `${e?.label} Scope is Expired`,
                                                                        `Do you want to continue?`,
                                                                        () => {
                                                                          handleChangeDepartment(
                                                                            indx,
                                                                            indxTest,
                                                                            e
                                                                          );
                                                                        },
                                                                        true
                                                                      );
                                                                    } else {
                                                                      handleChangeDepartment(
                                                                        indx,
                                                                        indxTest,
                                                                        e
                                                                      );
                                                                    }
                                                                  }}
                                                                />
                                                              </td>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "150px",
                                                                  borderRight:
                                                                    "1px solid transparent",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestMasterIDEncrypted`}
                                                                  placeholder={
                                                                    "Test"
                                                                  }
                                                                  // options={
                                                                  //   item.testOptions
                                                                  // }
                                                                  options={
                                                                    itemTest?.testOptions
                                                                  }
                                                                  component={
                                                                    CustomSelect
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  isDisabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam ||
                                                                    itemTest?.IsMixDesignIncludedTest ||
                                                                    itemTest
                                                                      ?.TestingDetails
                                                                      ?.TestingStatus >
                                                                      1
                                                                  }
                                                                  menuPosition="fixed"
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    handleChangeTestMaster(
                                                                      indx,
                                                                      indxTest,
                                                                      e,
                                                                      itemTest
                                                                    );
                                                                  }}
                                                                />
                                                              </td>
                                                              <td className="p-1">
                                                                <>
                                                                  {itemTest?.TestMasterIDEncrypted && (
                                                                    <>
                                                                      {AuthUser
                                                                        ?.Permissions
                                                                        ?.Account ==
                                                                      1 ? (
                                                                        <Link
                                                                          to="#"
                                                                          className="icon-box icon-box-md bg-primary-light"
                                                                          title="Define More Rates Selection"
                                                                          disabled={
                                                                            itemTest?.IsCancel ||
                                                                            item?.IsHold ||
                                                                            itemTest
                                                                              ?.TestingDetails
                                                                              ?.TestingStatus >
                                                                              1
                                                                          }
                                                                          onClick={() => {
                                                                            handleOnClickDefineMoreRatesSelection(
                                                                              indx,
                                                                              indxTest,
                                                                              item,
                                                                              itemTest,
                                                                              itemTest?.TestMasterIDEncrypted,
                                                                              itemTest?.InwardMaterialTestDetailIDEncrypted
                                                                            );
                                                                          }}
                                                                        >
                                                                          {
                                                                            SVGICON.Rates
                                                                          }
                                                                        </Link>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </>
                                                                  )}
                                                                  {itemTest?.TestMasterIDEncrypted &&
                                                                    itemTest?.IsMixDesign ==
                                                                      true && (
                                                                      <Link
                                                                        to="#"
                                                                        className="icon-box icon-box-md bg-primary-light ms-1"
                                                                        title="Mix Design Details"
                                                                        disabled={
                                                                          itemTest?.IsCancel ||
                                                                          item?.IsHold ||
                                                                          itemTest
                                                                            ?.TestingDetails
                                                                            ?.TestingStatus >
                                                                            1
                                                                        }
                                                                        onClick={() => {
                                                                          handleOnClickMixDesignDetail(
                                                                            indx,
                                                                            indxTest,
                                                                            item,
                                                                            itemTest
                                                                          );
                                                                        }}
                                                                      >
                                                                        {
                                                                          SVGICON.Setting2
                                                                        }
                                                                      </Link>
                                                                    )}
                                                                </>
                                                              </td>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "150px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ProductGroupIDEncrypted`}
                                                                  placeholder={
                                                                    "Material Group"
                                                                  }
                                                                  options={
                                                                    itemTest?.productGroupOptions
                                                                  }
                                                                  component={
                                                                    CustomSelect
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  isDisabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam ||
                                                                    itemTest?.AllowTestEdit !=
                                                                      1
                                                                  }
                                                                  menuPosition="fixed"
                                                                  // onChange={(
                                                                  //   e
                                                                  // ) => {
                                                                  //   formik.setFieldValue(
                                                                  //     `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ProductGroupIDEncrypted`,
                                                                  //     e?.value ??
                                                                  //       ""
                                                                  //   );
                                                                  //   // formik.setFieldValue(
                                                                  //   //   `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].MaterialTypeIDEncrypted`,
                                                                  //   //   ""
                                                                  //   // );
                                                                  //   // getTestDDL(
                                                                  //   //   itemTest?.DepartmentIDEncrypted,
                                                                  //   //   e?.value ??
                                                                  //   //     "",
                                                                  //   //   "",
                                                                  //   //   indx,
                                                                  //   //   indxTest
                                                                  //   // );
                                                                  // }}
                                                                />
                                                              </td>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "150px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].MaterialTypeIDEncrypted`}
                                                                  placeholder={
                                                                    "Material Type"
                                                                  }
                                                                  options={
                                                                    itemTest?.materialTypeOptions
                                                                  }
                                                                  component={
                                                                    CustomSelect
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  isDisabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam ||
                                                                    itemTest?.AllowTestEdit !=
                                                                      1
                                                                  }
                                                                  menuPosition="fixed"
                                                                  // onChange={(
                                                                  //   e
                                                                  // ) => {
                                                                  //   formik.setFieldValue(
                                                                  //     `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].MaterialTypeIDEncrypted`,
                                                                  //     e?.value ??
                                                                  //       ""
                                                                  //   );
                                                                  //   // getTestDDL(
                                                                  //   //   itemTest?.DepartmentIDEncrypted,
                                                                  //   //   itemTest?.ProductGroupIDEncrypted,
                                                                  //   //   e?.value ??
                                                                  //   //     "",
                                                                  //   //   indx,
                                                                  //   //   indxTest
                                                                  //   // );
                                                                  // }}
                                                                />
                                                              </td>

                                                              {/* <td
                                                                                                  className="p-1"
                                                                                                  style={{
                                                                                                    minWidth:
                                                                                                      "150px",
                                                                                                  }}
                                                                                                >
                                                                                                  <Field
                                                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestMethodIDEncrypted`}
                                                                                                    placeholder={
                                                                                                      "Test Method"
                                                                                                    }
                                                                                                    options={
                                                                                                      itemTest?.testMethodOptions
                                                                                                    }
                                                                                                    component={
                                                                                                      CustomSelect
                                                                                                    }
                                                                                                    noMarginBottom={
                                                                                                      true
                                                                                                    }
                                                                                                    menuPosition="fixed"
                                                                                                    isDisabled={
                                                                                                      itemTest?.IsCancel
                                                                                                    }
                                                                                                    onChange={(
                                                                                                      e
                                                                                                    ) => {
                                                                                                      if (
                                                                                                        e?.IsExpiredTestMethod ==
                                                                                                        true
                                                                                                      ) {
                                                                                                        warningMessage(
                                                                                                          "Test Method is Expired..!"
                                                                                                        );
                                                                                                      } else {
                                                                                                        formik.setFieldValue(
                                                                                                          `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestMethodIDEncrypted`,
                                                                                                          e?.value ??
                                                                                                            ""
                                                                                                        );
                                                                                                      }
                                                                                                    }}
                                                                                                  />
                                                                                                </td> */}
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "150px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ReferenceStandardIDEncrypted`}
                                                                  placeholder={
                                                                    "Ref. Standard"
                                                                  }
                                                                  options={
                                                                    itemTest?.referenceStandardOptions
                                                                  }
                                                                  component={
                                                                    CustomSelect
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  menuPosition="fixed"
                                                                  isDisabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam ||
                                                                    itemTest
                                                                      ?.TestingDetails
                                                                      ?.TestingStatus >
                                                                      1
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    handleChangeReferenceStandard(
                                                                      itemTest?.TestMasterIDEncrypted,
                                                                      indx,
                                                                      indxTest,
                                                                      e
                                                                    );
                                                                  }}
                                                                />
                                                              </td>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "100px",
                                                                  borderRight:
                                                                    "1px solid transparent",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`}
                                                                  placeholder={
                                                                    "Group"
                                                                  }
                                                                  options={
                                                                    itemTest?.refStandardSubGroupOptions
                                                                  }
                                                                  component={
                                                                    CustomSelect
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  menuPosition="fixed"
                                                                  isDisabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam ||
                                                                    itemTest
                                                                      ?.TestingDetails
                                                                      ?.TestingStatus >
                                                                      1
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    handleChangeRefStandardSubGroup(
                                                                      itemTest?.ReferenceStandardIDEncrypted,
                                                                      itemTest?.TestMasterIDEncrypted,
                                                                      indx,
                                                                      indxTest,
                                                                      e
                                                                    );
                                                                  }}
                                                                />
                                                              </td>
                                                              <td className="p-1">
                                                                {itemTest?.TestMasterIDEncrypted && (
                                                                  <Link
                                                                    to="#"
                                                                    className="icon-box icon-box-md bg-primary-light"
                                                                    title="Parameters Selection"
                                                                    disabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      itemTest
                                                                        ?.TestingDetails
                                                                        ?.TestingStatus >
                                                                        1
                                                                    }
                                                                    onClick={() => {
                                                                      handleOnClickParameterSelection(
                                                                        indx,
                                                                        indxTest,
                                                                        item,
                                                                        itemTest
                                                                      );
                                                                    }}
                                                                  >
                                                                    <i className="fa fa-tags"></i>
                                                                  </Link>
                                                                )}
                                                              </td>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "105px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestCount`}
                                                                  placeholder={
                                                                    "Test Count"
                                                                  }
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  type="number"
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  numberTypeWithoutDot={
                                                                    true
                                                                  }
                                                                  disabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam ||
                                                                    itemTest
                                                                      ?.TestingDetails
                                                                      ?.TestingStatus >
                                                                      1
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    handleChangeTestCount(
                                                                      indx,
                                                                      indxTest,
                                                                      e
                                                                    );
                                                                  }}
                                                                />
                                                              </td>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "105px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].BillingQty`}
                                                                  placeholder={
                                                                    "Billing Qty"
                                                                  }
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  type="number"
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  numberTypeWithoutDot={
                                                                    true
                                                                  }
                                                                  disabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam
                                                                  }
                                                                />
                                                              </td>
                                                              {/*
                                                                                                <td
                                                                                                  className="p-1"
                                                                                                  style={{
                                                                                                    minWidth:
                                                                                                      "130px",
                                                                                                  }}
                                                                                                >
                                                                                                  <Field
                                                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].UnitID`}
                                                                                                    placeholder={
                                                                                                      "Unit"
                                                                                                    }
                                                                                                    options={
                                                                                                      unitOptions
                                                                                                    }
                                                                                                    component={
                                                                                                      CustomSelect
                                                                                                    }
                                                                                                    noMarginBottom={
                                                                                                      true
                                                                                                    }
                                                                                                    menuPosition="fixed"
                                                                                                    isDisabled={
                                                                                                      itemTest?.IsCancel
                                                                                                    }
                                                                                                  />
                                                                                                </td>
                                                                                                <td
                                                                                                  className="p-1"
                                                                                                  style={{
                                                                                                    minWidth:
                                                                                                      "110px",
                                                                                                  }}
                                                                                                >
                                                                                                  <Field
                                                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].Rate`}
                                                                                                    placeholder={
                                                                                                      "Rate"
                                                                                                    }
                                                                                                    component={
                                                                                                      CustomInput
                                                                                                    }
                                                                                                    type="number"
                                                                                                    noMarginBottom={
                                                                                                      true
                                                                                                    }
                                                                                                    disabled={
                                                                                                      itemTest?.IsCancel
                                                                                                    }
                                                                                                  />
                                                                                                </td> */}
                                                              {/* <td
                                                                                                  className="p-1"
                                                                                                  style={{
                                                                                                    display:
                                                                                                      "none",
                                                                                                  }}
                                                                                                >
                                                                                                  <div className="form-check form-switch ms-4">
                                                                                                    <input
                                                                                                      className="form-check-input"
                                                                                                      type="checkbox"
                                                                                                      role="switch"
                                                                                                      id="flexSwitchCheckMachiningTestWise"
                                                                                                      title={
                                                                                                        itemTest.IsMachining ==
                                                                                                        true
                                                                                                          ? "Yes"
                                                                                                          : "No"
                                                                                                      }
                                                                                                      checked={
                                                                                                        itemTest.IsMachining
                                                                                                      }
                                                                                                      onChange={() => {
                                                                                                        formik.setFieldValue(
                                                                                                          `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].IsMachining`,
                                                                                                          !itemTest.IsMachining
                                                                                                        );
                                                                                                      }}
                                                                                                      style={{
                                                                                                        cursor:
                                                                                                          "pointer",
                                                                                                      }}
                                                                                                    ></input>
                                                                                                  </div>
                                                                                                </td> */}
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                  minWidth:
                                                                    "150px",
                                                                  borderRight:
                                                                    "1px solid transparent",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestNote`}
                                                                  placeholder={
                                                                    "Note"
                                                                  }
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  maxLength={
                                                                    100
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  disabled={
                                                                    itemTest?.IsCancel ||
                                                                    item?.IsHold ||
                                                                    ViewPrimaryIdParam
                                                                  }
                                                                />
                                                              </td>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                }}
                                                              >
                                                                {itemTest?.TestMasterIDEncrypted && (
                                                                  <Link
                                                                    to="#"
                                                                    className="icon-box icon-box-md bg-primary-light"
                                                                    title="Testing"
                                                                    disabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold
                                                                    }
                                                                    onClick={() => {
                                                                      handleOnClickTesting(
                                                                        indx,
                                                                        indxTest,
                                                                        item,
                                                                        itemTest
                                                                      );
                                                                    }}
                                                                  >
                                                                    {
                                                                      SVGICON.Testing
                                                                    }
                                                                  </Link>
                                                                )}
                                                              </td>
                                                            </tr>
                                                          )
                                                        )
                                                      ) : (
                                                        <tr>
                                                          <td
                                                            colSpan={13}
                                                            style={{
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            <div>
                                                              {
                                                                "No Record Found..."
                                                              }
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </Accordion.Collapse>
                                        </Accordion.Item>
                                      </Accordion>
                                    </td>
                                  </tr>
                                  <tr className="border-0 p-0">
                                    <td colSpan={9} className="p-0">
                                      <hr className="m-0 customHR"></hr>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={9} style={{ textAlign: "left" }}>
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <ErrorMessage
                        name={"ListOfMaterials"}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />
                      <ErrorMessage
                        name={`TestError`}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />
                    </div>
                  </Col>
                </Row>
                {/* <hr className="mt-1 mb-1"></hr>
                <Row>
                  <label>Mode</label>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="Mode-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="Mode-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="14%">Mode Type</th>
                              <th width="14%">Mode By </th>
                              <th width="18%">Customer</th>
                              <th width="18%">Project</th>
                              <th width="20%">Address</th>
                              <th width="16%" style={{ textAlign: "left" }}>
                                Contact Person
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListOfModeDetails?.map((item, idx) => (
                              <tr
                                key={idx}
                                style={{
                                  display:
                                    item.ModeDetailID == 4 &&
                                    IsMaterialReturnable == false
                                      ? "none"
                                      : "",
                                }}
                              >
                                <td
                                  className="p-1 ps-3"
                                  style={{ minWidth: "150px" }}
                                >
                                  <label>
                                    {item.ModeDetailID == 1
                                      ? "Sample Submitted By"
                                      : item.ModeDetailID == 2
                                      ? "Reporting"
                                      : item.ModeDetailID == 3
                                      ? "Billing"
                                      : item.ModeDetailID == 4
                                      ? "Dispatch"
                                      : ""}
                                  </label>
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "150px" }}
                                >
                                  {item.ModeDetailID > 1 ? (
                                    item.ModeDetailID == 4 ? (
                                      <Field
                                        name={`ListOfModeDetails[${idx}].ModeType`}
                                        placeholder={"Mode By"}
                                        options={dispatchMaterialModeOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                      />
                                    ) : (
                                      <Field
                                        name={`ListOfModeDetails[${idx}].ModeType`}
                                        placeholder={"Mode By"}
                                        options={modeByOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                      />
                                    )
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "160px" }}
                                >
                                  <Field
                                    name={`ListOfModeDetails[${idx}].CustomerIDEncrypted`}
                                    placeholder={"Customer"}
                                    //options={customerOptions}
                                    loadOptionsFn={loadOptionsCutomer}
                                    component={CustomSelectAsync}
                                    title={item?.CustomerName}
                                    labelFieldName={`ListOfModeDetails[${idx}].CustomerName`}
                                    noMarginBottom={true}
                                    menuPosition="fixed"
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerIDEncrypted`,
                                        e?.value ?? ""
                                      );
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerName`,
                                        e?.label ?? ""
                                      );
                                      getProjectDDLModeDetails(
                                        e?.value ?? "",
                                        idx
                                      );
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerProjectIDEncrypted`,
                                        ""
                                      );
                                      getProjectAddressDDL(
                                        e?.value ?? "",
                                        "",
                                        idx
                                      );
                                      getContactPersonDDL(
                                        e?.value ?? "",
                                        "",
                                        idx
                                      );
                                    }}
                                  />
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "160px" }}
                                >
                                  <Field
                                    name={`ListOfModeDetails[${idx}].CustomerProjectIDEncrypted`}
                                    placeholder={"Project"}
                                    options={item.projectOptions}
                                    component={CustomSelect}
                                    noMarginBottom={true}
                                    menuPosition="fixed"
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerProjectIDEncrypted`,
                                        e?.value ?? ""
                                      );
                                      getProjectAddressDDL(
                                        item.CustomerIDEncrypted,
                                        e?.value ?? "",
                                        idx
                                      );
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerProjectAddressIDEncrypted`,
                                        ""
                                      );
                                      getContactPersonDDL(
                                        item.CustomerIDEncrypted,
                                        e?.value ?? "",
                                        idx
                                      );
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`,
                                        ""
                                      );
                                    }}
                                  />
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "180px" }}
                                >
                                  <Field
                                    name={`ListOfModeDetails[${idx}].CustomerProjectAddressIDEncrypted`}
                                    placeholder={"Address"}
                                    options={item.projectAddressOptions}
                                    component={CustomSelect}
                                    noMarginBottom={true}
                                    menuPosition="fixed"
                                  />
                                </td>
                                <td
                                  className="p-1"
                                  style={{
                                    textAlign: "left",
                                    minWidth: "150px",
                                  }}
                                >
                                  {item.ModeDetailID == 2 ? (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                      placeholder={"Contact Person"}
                                      // options={item.contactPersonOptions}
                                      options={item.contactPersonOptions.filter(
                                        (x) => x.IsReporting == true
                                      )}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      menuStyles={{
                                        position: "absolute",
                                        right: 0,
                                      }}
                                    />
                                  ) : item.ModeDetailID == 3 ? (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                      placeholder={"Contact Person"}
                                      // options={item.contactPersonOptions}
                                      options={item.contactPersonOptions.filter(
                                        (x) => x.IsBilling == true
                                      )}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      menuStyles={{
                                        position: "absolute",
                                        right: 0,
                                      }}
                                    />
                                  ) : item.ModeDetailID == 4 ? (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                      placeholder={"Contact Person"}
                                      // options={item.contactPersonOptions}
                                      options={item.contactPersonOptions.filter(
                                        (x) => x.IsDispatch == true
                                      )}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      menuStyles={{
                                        position: "absolute",
                                        right: 0,
                                      }}
                                    />
                                  ) : (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                      placeholder={"Contact Person"}
                                      options={item.contactPersonOptions}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      menuStyles={{
                                        position: "absolute",
                                        right: 0,
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row> */}
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <Col lg={3}>
                    {ViewPrimaryIdParam ? (
                      <Field
                        label="Expected Delivery Date"
                        name="ExpectedDateOfDelivery"
                        placeholder={"Select Expected Delivery Date"}
                        component={CustomInput}
                        value={
                          formik?.values?.ExpectedDateOfDelivery
                            ? moment(
                                formik?.values?.ExpectedDateOfDelivery
                              ).format("DD-MMM-yyyy")
                            : ""
                        }
                        required
                        disabled={true}
                      />
                    ) : (
                      <Field
                        label="Expected Delivery Date"
                        name="ExpectedDateOfDelivery"
                        placeholder={"Select Expected Delivery Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          minDate: InwardDate ? InwardDate : new Date(),
                        }}
                      />
                    )}
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Material Taken By Employee"
                      name="MaterialTakenByUserEncrypted"
                      placeholder={"Select Material Taken By"}
                      options={employeeOptions}
                      component={CustomSelect}
                      isDisabled={ViewPrimaryIdParam}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Sample Received Via"
                      name="MaterialReceiveViaID"
                      placeholder={"Select Sample Received Via"}
                      options={sampleReceivedViaOptions}
                      component={CustomSelect}
                      isDisabled={ViewPrimaryIdParam}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Reference By"
                      name="ReferenceByIDEncrypted"
                      placeholder={"Select Reference By"}
                      options={referredByOptions}
                      component={CustomSelect}
                      menuStyles={{
                        position: "absolute",
                        right: 0,
                      }}
                      isDisabled={ViewPrimaryIdParam}
                    />
                  </Col>
                  <Col lg={6}>
                    <Field
                      label="Delivery Remarks"
                      name="EDDRemarks"
                      placeholder={"Enter Delivery Remarks"}
                      component={CustomTextArea}
                      rows={2}
                      maxLength={200}
                      disabled={ViewPrimaryIdParam}
                    />
                  </Col>
                  <Col lg={6}>
                    <Field
                      label="Received Remarks"
                      name="ReceiveRemarks"
                      placeholder={"Enter Received Remarks"}
                      component={CustomTextArea}
                      rows={2}
                      maxLength={100}
                      disabled={ViewPrimaryIdParam}
                    />
                  </Col>
                </Row>
                {/* {ListOfReviews?.length > 0 && (
                  <>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <label>Customer Review</label>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting mb-2">
                          <div
                            id="Review-tbl_wrapper"
                            className="dataTables_wrapper table-responsive no-footer"
                          >
                            <table
                              id="Review-tbl"
                              className="table table-bordered no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="4%"></th>
                                  <th width="82%">Points Reviewed</th>
                                  <th width="14%" style={{ textAlign: "left" }}>
                                    Status of review
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfReviews?.length > 0 ? (
                                  ListOfReviews?.map((item, indx) => (
                                    <tr key={indx}>
                                      <td
                                        className="p-1 text-center"
                                        style={{ minWidth: "40px" }}
                                      >
                                        {indx + 1}
                                      </td>

                                      <td
                                        className="p-1"
                                        style={{ minWidth: "180px" }}
                                      >
                                        {item.Review}
                                      </td>

                                      <td
                                        className="p-1"
                                        style={{
                                          textAlign: "left",
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfReviews[${indx}].StatusOfReview`}
                                          placeholder={"Select"}
                                          options={yesNoOptions}
                                          component={CustomSelect}
                                          noMarginBottom={true}
                                          menuPosition="fixed"
                                          isClearable={false}
                                        />
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={3}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                )} */}
                {editHeaderInwardIdParam && (
                  <Row>
                    <Col lg={6}>
                      <Field
                        label="Change Reason"
                        name="ChangeReason"
                        placeholder={"Enter Change Reason"}
                        component={CustomTextArea}
                        rows={5}
                        maxLength={500}
                        required
                      />
                    </Col>
                  </Row>
                )}
                <div className="stickyBottomButtons">
                  <hr className="mt-1 mb-2"></hr>
                  {!ViewPrimaryIdParam ? (
                    <>
                      {InwardCurrentStatus == 1 && (
                        <>
                          <button
                            type="submit"
                            // className="btn btn-primary"
                            className="btn btn-primary btn-sm me-2"
                            onClick={() => {
                              formik.setFieldValue("btnSubmitType", 1);
                            }}
                            disabled={formik.isSubmitting}
                          >
                            <i className="fa-solid fa-bookmark"></i>{" "}
                            {formik.isSubmitting ? "Drafting..." : "Draft"}
                          </button>
                        </>
                      )}
                      <button
                        type="submit"
                        // className="btn btn-primary"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => {
                          formik.setFieldValue("btnSubmitType", 2);
                        }}
                        disabled={formik.isSubmitting}
                      >
                        <i className="fa-solid fa-floppy-disk"></i>{" "}
                        {formik.isSubmitting ? "Submitting..." : "Submit"}
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showLetterRefDocModal}
          onHide={setShowLetterRefDocModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Letter Ref Doc</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowLetterRefDocModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  {!ViewPrimaryIdParam && (
                    <div className="mb-2">
                      <label></label>
                      <div className="avatar-file">
                        <input
                          type="file"
                          id="LetterRefUpload2"
                          //accept="image/png, image/gif, image/jpeg"
                          onChange={uploadLetterRefDoc}
                          //key={fileKeyLetterRefDocPhoto || ""}
                        />
                        <label htmlFor="LetterRefUpload2" name=""></label>
                      </div>
                      <div
                        id="webCam"
                        className="avatar-camera"
                        onClick={() => {
                          setOpenWebCamModalLetterRefDocImage(true);
                        }}
                        style={{ marginLeft: "50px" }}
                      >
                        <input type="hidden" />
                        <label htmlFor="webCam" name=""></label>
                      </div>
                    </div>
                  )}
                  {/* <div style={{ float: "right", marginRight: "2rem" }}>
                    + Add
                    <div
                      className="open-file mt-2"
                      style={{ marginLeft: "2rem" }}
                    >
                      <input
                        type="file"
                        id="LetterRefUpload2"
                        //accept="image/png, image/gif, image/jpeg"
                        onChange={uploadLetterRefDoc}
                      />
                      <label htmlFor="LetterRefUpload2" name=""></label>
                    </div>
                  </div> */}
                </Col>
                {letterRefDocPhoto && (
                  <Col lg={12}>
                    <div className="d-flex">
                      <div className="image-placeholder companyLogo-placeholder mt-0 ms-0">
                        <div className="avatar-preview">
                          <div id="imagePreview">
                            <img
                              id="saveImageFile"
                              src={
                                letterRefDocPhoto ? letterRefDocPhoto : img200
                              }
                              alt={"Material Image"}
                              style={{
                                maxHeight: "100px",
                                maxWidth: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={() => {
                            addLetterRefDocFile();
                          }}
                        >
                          <i className="fa fa-cloud-upload"></i> Upload
                        </button>
                        <button
                          // className="btn btn-sm btn-danger light"
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            setLetterRefDocPhoto(null);
                            setLetterRefDocPhotoFile(null);
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="LetterRefDoc-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="LetterRefDoc-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              File Name
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfLetterRefDoc?.filter(
                            (x) => x.IsDeleted == false
                          )?.length > 0 ? (
                            ListOfLetterRefDoc?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.LetterRefImageFilePath
                                          ? item.LetterRefImageFilePath
                                          : item.viewFile
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                  {!ViewPrimaryIdParam && (
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        //deleteLetterRefDoc(indx);
                                        delete_RecordWithoutApi(
                                          deleteLetterRefDoc,
                                          indx
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  )}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.LetterRefImageFileName}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {openWebCamModalLetterRefDocImage == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowLetterRefDocModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={openWebCamModalLetterRefDocImage}
          onHide={setOpenWebCamModalLetterRefDocImage}
        >
          <Modal.Header>
            <Modal.Title>Letter Ref Doc</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenWebCamModalLetterRefDocImage(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  mirrored={true}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  onUserMedia={onUserMedia}
                  className="webCam"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // className="btn btn-primary "
              variant="primary btn-sm"
              onClick={captureLetterRefDocPhoto}
            >
              <i className="fa fa-camera"></i> Capture
            </Button>

            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenWebCamModalLetterRefDocImage(false);
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          className="fade"
          show={showAddTPIDetailModal}
          onHide={setShowAddTPIDetailModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTPIDetail}>
              <Form onSubmit={formikTPIDetail.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    {actionFlagTPI == 1 ? "Edit" : "Add"} TPI Detail
                  </Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowAddTPIDetailModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="TPI"
                        name="TPIIDEncrypted"
                        placeholder={"Select TPI"}
                        options={tpiCustomerOptions}
                        component={CustomSelect}
                        required
                        onChange={(e) => {
                          formikTPIDetail.setFieldValue(
                            "TPIIDEncrypted",
                            e?.value ?? ""
                          );
                          formikTPIDetail.setFieldValue(
                            "TPIName",
                            e?.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="TPI Contact Person"
                        name="TPIContactPersonIDEncrypted"
                        placeholder={"Select Contact Person"}
                        options={tpiContactPersonOptions}
                        component={CustomSelect}
                        required
                        onChange={(e) => {
                          formikTPIDetail.setFieldValue(
                            "TPIContactPersonIDEncrypted",
                            e?.value ?? ""
                          );
                          formikTPIDetail.setFieldValue(
                            "TPIContactPersonName",
                            e?.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="TPI Expected Date"
                        name="TPIExpectedDate"
                        placeholder={"Select Expected Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          minDate: InwardDate
                            ? moment(InwardDate).format("DD-MM-YYYY")
                            : new Date(),
                          static: true, //to solve month dropdown not visible inside modal
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setShowAddTPIDetailModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTPIDetailModal}
          onHide={setShowTPIDetailModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>TPI Detail</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowTPIDetailModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                {/* <Col lg={12}>
                  <div className="mb-1" style={{ float: "right" }}>
                    <button
                      // className="btn btn-sm btn-primary"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {
                        addNewTPI(false);
                      }}
                    >
                      <i className="fa-solid fa-plus"></i> Add
                    </button>
                  </div>
                </Col> */}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="TPIdetail-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="TPIdetail-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            {!ViewPrimaryIdParam && (
                              <th width="4%">
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md bg-primary-light me-1"
                                  title="Add TPI Detail"
                                  onClick={() => {
                                    addNewTPI(false);
                                  }}
                                >
                                  <i className="fa fa-plus"></i>
                                </Link>
                              </th>
                            )}
                            <th width="46%">TPI</th>
                            <th width="30%">TPI Contact Person</th>
                            <th width="20%" style={{ textAlign: "left" }}>
                              TPI Expected Date
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfTPIDetails?.filter((x) => x.IsDeleted == false)
                            ?.length > 0 ? (
                            ListOfTPIDetails?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                {!ViewPrimaryIdParam && (
                                  <td>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="Edit"
                                      onClick={() => {
                                        editTPI(indx, false);
                                      }}
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-danger-light"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        //deleteTPI(indx);
                                        delete_RecordWithoutApi(
                                          deleteTPI,
                                          indx,
                                          false
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  </td>
                                )}
                                <td>{item.TPIName}</td>
                                <td>{item.TPIContactPersonName}</td>
                                <td style={{ textAlign: "left" }}>
                                  {item.displayTPIExpectedDate}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {showAddTPIDetailModal == true && (
                <div class="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowTPIDetailModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showMaterialInfoImagesModal}
          onHide={setShowMaterialInfoImagesModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Images - Material Information</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowMaterialInfoImagesModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                {!ViewPrimaryIdParam && (
                  <Col lg={12}>
                    <div className="mb-2">
                      <label></label>
                      <div className="avatar-file">
                        <input
                          type="file"
                          id="imageUploadMaterial"
                          accept="image/png, image/gif, image/jpeg"
                          onChange={uploadMaterialPhoto}
                          key={fileKeyMaterialPhoto || ""}
                        />
                        <label htmlFor="imageUploadMaterial" name=""></label>
                      </div>
                      <div
                        id="webCam"
                        className="avatar-camera"
                        onClick={() => {
                          setOpenWebCamModalMaterialImage(true);
                        }}
                        style={{ marginLeft: "50px" }}
                      >
                        <input type="hidden" />
                        <label htmlFor="webCam" name=""></label>
                      </div>
                    </div>
                  </Col>
                )}
                {materialPhoto && (
                  <Col lg={12}>
                    <div className="d-flex">
                      <div className="image-placeholder companyLogo-placeholder mt-0 ms-0">
                        <div className="avatar-preview">
                          <div id="imagePreview">
                            <img
                              id="saveImageFile"
                              src={materialPhoto ? materialPhoto : img200}
                              alt={"Material Image"}
                              style={{
                                maxHeight: "100px",
                                maxWidth: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={() => {
                            addMaterialImage();
                          }}
                        >
                          <i className="fa fa-cloud-upload"></i> Upload
                        </button>
                        <button
                          // className="btn btn-sm btn-danger light"
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            setMaterialPhoto(null);
                            setMaterialPhotoFile(null);
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting">
                    <div
                      id="MaterialPhotos-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="MaterialPhotos-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              Image
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfMaterials[
                            selectedMaterialInfoRow
                          ]?.ListOfMaterialPhotos?.filter(
                            (x) => x.IsDeleted == false
                          )?.length > 0 ? (
                            ListOfMaterials[
                              selectedMaterialInfoRow
                            ]?.ListOfMaterialPhotos?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.MaterialPhotoFilePath
                                          ? item.MaterialPhotoFilePath
                                          : item.viewFile
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                  {!ViewPrimaryIdParam && (
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-danger-light"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        //deleteMaterialImage(indx);
                                        delete_RecordWithoutApi(
                                          deleteMaterialImage,
                                          indx
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  )}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  <img
                                    src={
                                      item.MaterialPhotoFilePath
                                        ? item.MaterialPhotoFilePath
                                        : item.viewFile
                                    }
                                    alt={"Material Image"}
                                    style={{
                                      maxHeight: "50px",
                                      maxWidth: "50px",
                                    }}
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {(openCropperModalMaterialPhoto == true ||
                openWebCamModalMaterialImage == true) && (
                <div class="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowMaterialInfoImagesModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={openCropperModalMaterialPhoto}
          onHide={setOpenCropperModalMaterialPhoto}
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>Material Image</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenCropperModalMaterialPhoto(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <Cropper
                  style={{ height: 400, width: 400 }}
                  // zoomTo={0.5}
                  zoomTo={zoomMaterialPhoto}
                  initialAspectRatio={1 / 1}
                  // aspectRatio={1 / 1}
                  src={imageMaterialPhoto}
                  // viewMode={1}
                  // minCropBoxHeight={500}
                  // minCropBoxWidth={500}
                  // maxCropBoxHeight={500}
                  // maxCropBoxWidth={500}
                  background={false}
                  responsive={true}
                  // autoCropArea={1}
                  checkOrientation={false}
                  onInitialized={(instance) => {
                    setCropperMaterialPhoto(instance);
                  }}
                  //guides={false}
                  checkCrossOrigin={false}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // variant="secondary light"
              variant="secondary light btn-sm"
              onClick={() => {
                setZoomMaterialPhoto(zoomMaterialPhoto + 0.5);
              }}
              title="zoom-in"
            >
              <i className="fa fa-search-plus"></i>
            </Button>
            <Button
              // variant="secondary light"
              variant="secondary light btn-sm"
              onClick={() => {
                setZoomMaterialPhoto(
                  zoomMaterialPhoto > 0.5
                    ? zoomMaterialPhoto - 0.5
                    : zoomMaterialPhoto
                );
              }}
              title="zoom-out"
            >
              <i className="fa fa-search-minus"></i>
            </Button>
            <Button
              // className="btn btn-primary"
              variant="primary btn-sm"
              onClick={() => {
                getCropDataMaterialPhoto();
                setOpenCropperModalMaterialPhoto(false);
                setFileKeyMaterialPhoto(
                  Math.random().toString(9).substring(2, 9)
                );
              }}
            >
              <i className="fa fa-crop"></i> Crop Image
            </Button>
            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenCropperModalMaterialPhoto(false);
                setFileKeyMaterialPhoto(
                  Math.random().toString(9).substring(2, 9)
                );
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          className="fade"
          show={openWebCamModalMaterialImage}
          onHide={setOpenWebCamModalMaterialImage}
        >
          <Modal.Header>
            <Modal.Title>Material Image</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenWebCamModalMaterialImage(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  mirrored={true}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  onUserMedia={onUserMedia}
                  className="webCam"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // className="btn btn-primary "
              variant="primary btn-sm"
              onClick={capturePhoto}
            >
              <i className="fa fa-camera"></i> Capture
            </Button>

            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenWebCamModalMaterialImage(false);
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          className="fade"
          show={showMaterialInfoRepeatRowQtyModal}
          onHide={setShowMaterialInfoRepeatRowQtyModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMaterialInfoRepeatRow}>
              <Form onSubmit={formikMaterialInfoRepeatRow.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Repeat Row - Material Information</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowMaterialInfoRepeatRowQtyModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        type="number"
                        label="No of Repeat Row"
                        name="NoOfRepeatMaterialInfoRow"
                        placeholder={"Enter No of Repeat Row"}
                        component={CustomInput}
                        numberTypeWithoutDot={true}
                        required
                        onChange={(e) => {
                          let nRow = e?.target?.value ?? 0;
                          if (nRow >= 0 && nRow < 1000) {
                            formikMaterialInfoRepeatRow.setFieldValue(
                              "NoOfRepeatMaterialInfoRow",
                              e?.target?.value ?? ""
                            );
                          }
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // className="btn btn-primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>

                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowMaterialInfoRepeatRowQtyModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showWorkDetailModal}
          onHide={setShowWorkDetailModal}
          size="lg"
        >
          <FormikProvider value={formikWorkDetail}>
            <Form onSubmit={formikWorkDetail.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Work Detail</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowWorkDetailModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="table-responsive active-projects style-1 shorting mb-0">
                      <div
                        id="workDetail-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="workDetail-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="5%"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Work Detail
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {projectWorkDetailList?.length > 0 ? (
                              projectWorkDetailList?.map((item, indx) => (
                                <tr key={indx}>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "0.5rem",
                                      width: "5%",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkWorkDetail${indx}`}
                                      name={`chkWorkDetail${indx}`}
                                      checked={item.IsSelected}
                                      onChange={(e) => {
                                        formikWorkDetail.setFieldValue(
                                          "projectWorkDetailList",
                                          projectWorkDetailList?.map(
                                            (x, idx) => {
                                              if (idx == indx) {
                                                return {
                                                  ...x,
                                                  IsSelected: true,
                                                };
                                              } else {
                                                return {
                                                  ...x,
                                                  IsSelected: false,
                                                };
                                              }
                                            }
                                          )
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "0.5rem",
                                      width: "95%",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.WorkDetail}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2} style={{ textAlign: "left" }}>
                                  <div>{"No record found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  type="submit"
                  // className="btn btn-primary"
                  variant="primary btn-sm"
                >
                  <i className="fa-solid fa-plus"></i> Add
                </Button>

                <Button
                  // className="btn btn-danger light"
                  variant="danger btn-sm"
                  onClick={() => {
                    setShowWorkDetailModal(false);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Modal>
        <Modal
          className="fade"
          show={showMaterialProcessModal}
          onHide={setShowMaterialProcessModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMaterialProcessDetail}>
              <Form onSubmit={formikMaterialProcessDetail.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Machining Details</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowMaterialProcessModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="MaterialProcess-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="MaterialProcess-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                {!ViewPrimaryIdParam ? (
                                  <th width="4%"></th>
                                ) : (
                                  ""
                                )}
                                <th width="28%">Process Name</th>
                                <th width="24%">Process Note</th>
                                <th width="12%">Qty</th>
                                <th width="12%">Length</th>
                                <th width="20%" style={{ textAlign: "left" }}>
                                  Thickness
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ListOfProcessThicknessDetails?.length > 0 ? (
                                ListOfProcessThicknessDetails?.map(
                                  (itemTest, indxTest) => (
                                    <tr
                                      key={indxTest}
                                      style={{
                                        display:
                                          itemTest.IsDeleted == true
                                            ? "none"
                                            : "",
                                      }}
                                    >
                                      {!ViewPrimaryIdParam ? (
                                        <td className="p-1">
                                          <Link
                                            to="#"
                                            className="icon-box icon-box-md bg-primary-light"
                                            title="New Process"
                                            onClick={(e) => {
                                              addNewProcess(indxTest);
                                              e.preventDefault();
                                            }}
                                          >
                                            <i className="fa fa-plus"></i>
                                          </Link>
                                          {ListOfProcessThicknessDetails?.filter(
                                            (x) => x.IsDeleted == false
                                          )?.length > 1 ? (
                                            <Link
                                              to="#"
                                              className="icon-box icon-box-md bg-danger-light ms-1"
                                              title="Remove Process"
                                              onClick={(e) => {
                                                removeProcess(indxTest);
                                                e.preventDefault();
                                              }}
                                            >
                                              <i className="fa fa-minus"></i>
                                            </Link>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      ) : (
                                        ""
                                      )}
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].MachiningConfigurationIDEncrypted`}
                                          placeholder={"Process Name"}
                                          options={processNameOptions}
                                          component={CustomSelect}
                                          noMarginBottom={true}
                                          menuPosition="fixed"
                                          onChange={(e) => {
                                            formikMaterialProcessDetail.setFieldValue(
                                              `ListOfProcessThicknessDetails[${indxTest}].MachiningConfigurationIDEncrypted`,
                                              e?.value ?? ""
                                            );

                                            formikMaterialProcessDetail.setFieldValue(
                                              `ListOfProcessThicknessDetails[${indxTest}].VendorRate`,
                                              e?.RateMatrix == false
                                                ? e?.VendorRate ?? ""
                                                : ""
                                            );

                                            formikMaterialProcessDetail.setFieldValue(
                                              `ListOfProcessThicknessDetails[${indxTest}].InvoiceRate`,
                                              e?.RateMatrix == false
                                                ? e?.InvoiceRate ?? ""
                                                : ""
                                            );

                                            checkValidationProcess(
                                              e?.value,
                                              indxTest
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].MachiningNote`}
                                          placeholder={"Process Note"}
                                          component={CustomInput}
                                          maxLength={100}
                                          noMarginBottom={true}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "105px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].Qty`}
                                          placeholder={"Qty"}
                                          component={CustomInput}
                                          type="number"
                                          noMarginBottom={true}
                                          numberTypeWithoutDot={true}
                                          onChange={(e) => {
                                            if (e?.target?.value < 1000) {
                                              formikMaterialProcessDetail.setFieldValue(
                                                `ListOfProcessThicknessDetails[${indxTest}].Qty`,
                                                e?.target?.value ?? ""
                                              );
                                            }
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "105px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].Length`}
                                          placeholder={"Length"}
                                          component={CustomInput}
                                          type="number"
                                          noMarginBottom={true}
                                        />
                                      </td>

                                      <td
                                        className="p-1"
                                        style={{
                                          textAlign: "left",
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].Thickness`}
                                          placeholder={"Thickness"}
                                          type="number"
                                          component={CustomInput}
                                          maxLength={100}
                                          noMarginBottom={true}
                                        />
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan={10}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {showAddTPIDetailModal == true && (
                    <div className="fade modal-backdrop show"></div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam ? (
                    <Button
                      type="submit"
                      // className="btn btn-primary"
                      variant="primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    // variant="secondary light"
                    variant="danger btn-sm"
                    onClick={() => setShowMaterialProcessModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTestDetailsRepeatModal}
          onHide={setShowTestDetailsRepeatModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTestDetailsRepeat}>
              <Form onSubmit={formikTestDetailsRepeat.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Repeat - Test Details</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowTestDetailsRepeatModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <ul className="unorder-list ps-4 mb-2">
                        <li>
                          Selected Material Information(TC) Test Details should
                          be repeat in all the Material Information(TC).
                          {/* which is
                                  having Material Group is{" "}
                                  <b>"{repeatTestDetailsProductGroupName}"</b> and
                                  Material Type is{" "}
                                  <b>"{repeatTestDetailsMaterialTypeName}"</b>. */}
                        </li>
                        <li>
                          Repeat Test Details should be replace with existing
                          Test Details if exists.
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // className="btn btn-primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>

                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowTestDetailsRepeatModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTestParametersModal}
          onHide={setShowTestParametersModal}
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTestPrameters}>
              <Form onSubmit={formikTestPrameters.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>{ParametersTestName}</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowTestParametersModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div
                        className="table-responsive active-projects style-1 shorting"
                        style={{ maxHeight: "450px" }}
                      >
                        <div
                          id="TestParameters-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="TestParameters-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="3%" className="ps-1">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`chkSelectAllPara`}
                                    name={`chkSelectAllPara`}
                                    checked={selectAllPara}
                                    onChange={(e) => {
                                      handleChangeSelectAllPara(
                                        e?.target?.checked
                                      );
                                    }}
                                    disabled={ViewPrimaryIdParam}
                                  />
                                </th>
                                <th width="97%" style={{ textAlign: "left" }}>
                                  Parameters
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ParametersList?.length > 0 ? (
                                ParametersList?.map((para, iPara) => (
                                  <tr key={`para_${iPara}`}>
                                    <td className="p-1">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsSelected${iPara}`}
                                        name={`chkIsSelected${iPara}`}
                                        checked={para.IsSelected}
                                        onChange={(e) => {
                                          formikTestPrameters.setFieldValue(
                                            `ParametersList[${iPara}].IsSelected`,
                                            e?.target?.checked
                                          );
                                        }}
                                        disabled={ViewPrimaryIdParam}
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      {para?.ParameterName}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam ? (
                    <Button
                      // className="btn btn-primary"
                      variant="primary btn-sm"
                      type="submit"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowTestParametersModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showMixDesignTestDetailModal}
          onHide={setShowMixDesignTestDetailModal}
          backdrop="static"
          size="xl"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMixDesignTestDetails}>
              <Form onSubmit={formikMixDesignTestDetails.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    {MixDesignTestName} (STIPULATIONS FOR PROPORTIONING)
                  </Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowMixDesignTestDetailModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={4}>
                      <Field
                        name={"GradeDesignation"}
                        label={"Grade Designation"}
                        placeholder={"Grade Designation"}
                        component={CustomInput}
                        maxLength={200}
                        required
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Type of Cement"
                        name="TypeofCementIDEncrypted"
                        placeholder={"Select Type of Cement"}
                        options={optionsTypeOfCement}
                        component={CustomSelect}
                        onChange={(e) => {
                          formikMixDesignTestDetails.setFieldValue(
                            "TypeofCementIDEncrypted",
                            e?.value ?? ""
                          );
                          formikMixDesignTestDetails.setFieldValue(
                            "TypeofCementName",
                            e?.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={4}>
                      <div className="mb-2">
                        <label className="mb-1">
                          Method of Concrete Placing &nbsp;
                        </label>
                        <div className="form-control form-control-sm">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                            name={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                            checked={MethodofConcretePlacingIsChute_NonPumpable}
                            onChange={(e) => {
                              formikMixDesignTestDetails.setFieldValue(
                                "MethodofConcretePlacingIsChute_NonPumpable",
                                !MethodofConcretePlacingIsChute_NonPumpable
                              );
                            }}
                          />
                          <label className="mb-1 ms-1 me-2 mt-1">
                            Chute (Non pumpable) &nbsp;
                          </label>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`chkMethodofConcretePlacingIsPumping`}
                            name={`chkMethodofConcretePlacingIsPumping`}
                            checked={MethodofConcretePlacingIsPumping}
                            onChange={(e) => {
                              formikMixDesignTestDetails.setFieldValue(
                                "MethodofConcretePlacingIsPumping",
                                !MethodofConcretePlacingIsPumping
                              );
                            }}
                          />
                          <label className="mb-1 ms-1 mt-1">
                            Pumping &nbsp;
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Type of Mineral Admixture"
                        name="TypeofMineralAdmixtureIDEncrypted"
                        placeholder={"Select Type of Mineral Admixture"}
                        options={optionsTypeOfMineralAdmixture}
                        component={CustomSelect}
                        onChange={(e) => {
                          formikMixDesignTestDetails.setFieldValue(
                            "TypeofMineralAdmixtureIDEncrypted",
                            e?.value ?? ""
                          );
                          formikMixDesignTestDetails.setFieldValue(
                            "TypeofMineralAdmixtureName",
                            e?.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        name={"DegreeofSiteControl"}
                        label={"Degree of Site Control"}
                        placeholder={"Degree of Site Control"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Maximum Nominal Size of Aggregate"
                        name="MaximumNominalSizeofAggregateIDEncrypted"
                        placeholder={"Select Maximum Nominal Size of Aggregate"}
                        options={optionsMaximumNominalSizeofAggregate}
                        component={CustomSelect}
                        onChange={(e) => {
                          formikMixDesignTestDetails.setFieldValue(
                            "MaximumNominalSizeofAggregateIDEncrypted",
                            e?.value ?? ""
                          );
                          formikMixDesignTestDetails.setFieldValue(
                            "MaximumNominalSizeofAggregateName",
                            e?.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        name={"TypeofAggregateFineCoarse"}
                        label={"Type of Aggregate Coarse"}
                        placeholder={"Type of Aggregate Coarse"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Type of Aggregate Fine"
                        name="TypeofAggregateFineIDEncrypted"
                        placeholder={"Select Type of Aggregate Fine"}
                        options={optionsTypeOfAggregateFine}
                        component={CustomSelect}
                        onChange={(e) => {
                          formikMixDesignTestDetails.setFieldValue(
                            "TypeofAggregateFineIDEncrypted",
                            e?.value ?? ""
                          );
                          formikMixDesignTestDetails.setFieldValue(
                            "TypeofAggregateFineName",
                            e?.label ?? ""
                          );
                        }}
                      />
                    </Col>

                    <Col lg={4}>
                      <Field
                        label="Environmental Exposure Conditions"
                        name="EnvironmentalExposureConditionsIDEncrypted"
                        placeholder={"Select Environmental Exposure Conditions"}
                        options={optionsEnvironmentralExposureConditions}
                        component={CustomSelect}
                        onChange={(e) => {
                          formikMixDesignTestDetails.setFieldValue(
                            "EnvironmentalExposureConditionsIDEncrypted",
                            e?.value ?? ""
                          );
                          formikMixDesignTestDetails.setFieldValue(
                            "EnvironmentalExposureConditionsName",
                            e?.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        type="number"
                        name={"MaximumCementContent"}
                        label={"Maximum Cement Content (kg/m3)"}
                        placeholder={"Maximum Cement Content (kg/m3)"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        type="number"
                        name={"MinimumCementContent"}
                        label={"Minimum Cement Content (kg/m3)"}
                        placeholder={"Minimum Cement Content (kg/m3)"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>

                    <Col lg={4}>
                      <Field
                        type="number"
                        name={"MaximumWaterCementRatio"}
                        label={"Maximum Water Cement Ratio"}
                        placeholder={"Maximum Water Cement Ratio"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        name={"Workability"}
                        label={"Workability"}
                        placeholder={"Workability"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Chemical Admixture Type"
                        name="ChemicalAdmixtureTypeIDEncrypted"
                        placeholder={"Select Chemical Admixture Type"}
                        options={optionsChemicalAdmixtureType}
                        component={CustomSelect}
                        onChange={(e) => {
                          formikMixDesignTestDetails.setFieldValue(
                            "ChemicalAdmixtureTypeIDEncrypted",
                            e?.value ?? ""
                          );
                          formikMixDesignTestDetails.setFieldValue(
                            "ChemicalAdmixtureTypeName",
                            e?.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Chemical Admixture Brand/Batch/ID Mark"
                        name="ChemicalAdmixtureBrandBatchandMarkIDEncrypted"
                        placeholder={"Chemical Admixture Brand/Batch/ID Mark"}
                        options={optionsChemicalAdmixtureBrandBatchMarkId}
                        component={CustomSelect}
                        onChange={(e) => {
                          formikMixDesignTestDetails.setFieldValue(
                            "ChemicalAdmixtureBrandBatchandMarkIDEncrypted",
                            e?.value ?? ""
                          );
                          formikMixDesignTestDetails.setFieldValue(
                            "ChemicalAdmixtureBrandBatchandMarkName",
                            e?.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        name="TransportationTime"
                        label={"Transportation Time"}
                        placeholder={"hh:mm"}
                        component={CustomFlatpickr}
                        options={{
                          enableTime: true,
                          noCalendar: true,
                          dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                          time_24hr: true, // Enforces 24-hour format
                          //allowInput: true, // Allows typing
                          minuteIncrement: 1, // Allows setting minutes with up/down arrows
                          static: true, //to solve up-down key not working in modal
                        }}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        name="RetentionTime"
                        label={"Retention Time"}
                        placeholder={"hh:mm"}
                        component={CustomFlatpickr}
                        options={{
                          enableTime: true,
                          noCalendar: true,
                          dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                          time_24hr: true, // Enforces 24-hour format
                          //allowInput: true, // Allows typing
                          minuteIncrement: 1, // Allows setting minutes with up/down arrows
                          static: true, //to solve up-down key not working in modal
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam ? (
                    <Button
                      // className="btn btn-primary"
                      variant="primary btn-sm"
                      type="submit"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowMixDesignTestDetailModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showDefineMoreRatesModal}
          onHide={setShowDefineMoreRatesModal}
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikDefineMoreRates}>
              <Form onSubmit={formikDefineMoreRates.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Define More Rates</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="DefineMoreRates-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="DefineMoreRates-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="5%" className="ps-1"></th>
                                <th width="95%" style={{ textAlign: "left" }}>
                                  Rate Type
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {MoreTestRatesList?.length > 0 ? (
                                MoreTestRatesList?.map((tRate, tRateindx) => (
                                  <tr key={`para_${tRateindx}`}>
                                    <td className="p-1">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsSelected${tRateindx}`}
                                        name={`chkIsSelected${tRateindx}`}
                                        checked={tRate.IsSelected}
                                        onChange={(e) => {
                                          formikDefineMoreRates.setFieldValue(
                                            `MoreTestRatesList[${tRateindx}].IsSelected`,
                                            e?.target?.checked
                                          );
                                        }}
                                        disabled={ViewPrimaryIdParam}
                                      />
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      {tRate.RateTypeName}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam && MoreTestRatesList?.length > 0 ? (
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTestingModal}
          onHide={setshowTestingModal}
          backdrop="static"
          size="xl"
          dialogClassName="fullWidthModal"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTesting}>
              <Form onSubmit={formikTesting.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    Testing:{" "}
                    <span className="text-primary fw-bold">
                      {formikTesting?.values?.TestName}
                    </span>
                  </Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setshowTestingModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body
                  style={{
                    maxHeight:
                      formikTesting?.values?.AllowTestingEdit == 1 &&
                      !ViewPrimaryIdParam
                        ? "765px"
                        : "auto",
                    overflowY: "auto",
                  }}
                  className={
                    formikTesting?.values?.AllowTestingEdit == 1 &&
                    !ViewPrimaryIdParam
                      ? ""
                      : "disableDiv"
                  }
                  onKeyDown={handleKeyDownDisable}
                >
                  <Row>
                    <Col lg={10}>
                      <Row>
                        <Col lg={4}>
                          <Field
                            label="Department"
                            name={`DepartmentName`}
                            placeholder={"Department"}
                            component={CustomInput}
                            // disabled={true}
                            readOnly={true}
                            onChange={() => {}} //to prevent change
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Material Group"
                            name={`ProductGroupIDEncrypted`}
                            placeholder={"Material Group"}
                            options={
                              ListOfMaterials[tcIndexTesting]
                                ?.ListOfMaterialTestDetails[testIndexTesting]
                                ?.productGroupOptions
                            }
                            component={CustomSelect}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Material Type"
                            name={`MaterialTypeIDEncrypted`}
                            placeholder={"Material Type"}
                            options={
                              ListOfMaterials[tcIndexTesting]
                                ?.ListOfMaterialTestDetails[testIndexTesting]
                                ?.materialTypeOptions
                            }
                            component={CustomSelect}
                            required
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Reference Standard"
                            name={`ReferenceStandardIDEncrypted`}
                            placeholder={"Reference Standard"}
                            options={
                              ListOfMaterials[tcIndexTesting]
                                ?.ListOfMaterialTestDetails[testIndexTesting]
                                ?.referenceStandardOptions
                            }
                            component={CustomSelect}
                            onChange={(e) => {
                              if (e?.IsExpiredReferenceStandard == true) {
                                warningMessage(
                                  "Reference Standard is Expired..!"
                                );
                                formikTesting.setFieldValue(
                                  "ReferenceStandardIDEncrypted",
                                  ""
                                );
                                formikTesting.setFieldValue(
                                  "RefStandardSubGroup",
                                  ""
                                );
                                formikTesting.setFieldValue(
                                  "refStandardSubGroupOptionsTesting",
                                  []
                                );
                                formikTesting.setFieldValue(
                                  "testingParametersRangeList",
                                  []
                                );
                              } else {
                                formikTesting.setFieldValue(
                                  "ReferenceStandardIDEncrypted",
                                  e?.value ?? ""
                                );
                                formikTesting.setFieldValue(
                                  "RefStandardSubGroup",
                                  ""
                                );
                                getRefSubGroupAndRangeDDLTesting(
                                  formikTesting?.values?.TestMasterIDEncrypted,
                                  e?.value ?? "",
                                  formikTesting?.values?.TestingStatus
                                );
                                handleChangeReferenceSubGroupTesting("");
                              }
                            }}
                          />
                        </Col>
                        <Col lg={1}>
                          <Field
                            label="Group"
                            name={`RefStandardSubGroup`}
                            placeholder={"Group"}
                            options={
                              formikTesting?.values
                                ?.refStandardSubGroupOptionsTesting
                            }
                            component={CustomSelect}
                            onChange={(e) => {
                              formikTesting.setFieldValue(
                                "RefStandardSubGroup",
                                e?.value ?? ""
                              );
                              handleChangeReferenceSubGroupTesting(
                                e?.value ?? ""
                              );
                            }}
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Testing From Date"
                            name="TestingDate"
                            placeholder={"Select Testing From Date"}
                            component={CustomFlatpickr}
                            options={{
                              altInput: true,
                              altFormat: "j-M-Y",
                              dateFormat: "d-m-Y",
                              // minDate: InwardDate ? new Date(InwardDate) : "",
                              minDate: InwardDate
                                ? moment(InwardDate).format("DD-MM-YYYY")
                                : new Date(),
                              maxDate: new Date(),
                              static: true, //to solve month dropdown not visible inside modal
                            }}
                            onChange={(e) => {
                              formikTesting.setFieldValue("TestingDate", e);
                              getParameterTestMethodDDLList(e);
                              getDepartmentDDLForScopeValidityCheck(e);
                            }}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Testing To Date"
                            name="TestingToDate"
                            placeholder={"Select Testing To Date"}
                            component={CustomFlatpickr}
                            options={{
                              altInput: true,
                              altFormat: "j-M-Y",
                              dateFormat: "d-m-Y",
                              minDate: TestingDate ? new Date(TestingDate) : "",
                              static: true, //to solve month dropdown not visible inside modal
                            }}
                            required
                          />
                        </Col>

                        <Col lg={1}>
                          <Field
                            label="Test Count"
                            name={`TestingQty`}
                            placeholder={"Test Count"}
                            component={CustomInput}
                            type="number"
                            numberTypeWithoutDot={true}
                            required
                            onChange={handleChangeTestingQty}
                          />
                        </Col>
                        <Col lg={1}>
                          <Field
                            label="Billing Qty"
                            name={`InvoiceQty`}
                            placeholder={"Billing Qty"}
                            component={CustomInput}
                            type="number"
                            numberTypeWithoutDot={true}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Location"
                            name="LocationType"
                            placeholder={"Select Location Type"}
                            component={CustomSelect}
                            options={locationTypeOptions}
                            isClearable={false}
                          />
                        </Col>

                        <Col lg={3}>
                          <Field
                            label="Test Method"
                            name="TestMethodIDEncrypt"
                            placeholder={"Select Test Method"}
                            component={CustomSelect}
                            options={testMethodOptionsTesting}
                            onChange={(e) => {
                              handleChangeTestMethodTesting(
                                e?.value ?? "",
                                e?.IsExpiredTestMethod
                              );
                            }}
                          />
                        </Col>
                        <Col lg={1}>
                          <Field
                            label="Unit"
                            name="UnitID"
                            placeholder={"Unit"}
                            options={unitOptions}
                            component={CustomSelect}
                          />
                        </Col>
                        <Col lg={4}>
                          {AuthUser?.Permissions?.TestResultFromFile == 1 &&
                          formikTesting?.values?.MachineIDEncrypt &&
                          ListOfMaterials[tcIndexTesting]
                            ?.InwardMaterialIDEncrypted ? (
                            <Link
                              to="#"
                              className="text-primary"
                              title="Machine Results"
                              style={{ float: "right" }}
                              onClick={fetchMachineResults}
                            >
                              Fetch Parameter Results
                            </Link>
                          ) : (
                            ""
                          )}

                          {formikTesting?.values?.MachineIDEncrypt &&
                          AuthUser?.Permissions?.MachineMaintenance == 1 ? (
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light mb-1"
                              title="View Machine Calibration"
                              style={{
                                position: "absolute",
                                left: "70px",
                              }}
                              onClick={fetchMachineList}
                            >
                              {SVGICON.Certificate}
                            </Link>
                          ) : (
                            ""
                          )}
                          <Field
                            label="Machine"
                            name="MachineIDEncrypt"
                            placeholder={"Select Machine"}
                            component={CustomSelect}
                            options={machineOptions}
                            isClearable={false}
                            onChange={handleChangeMachine}
                          />
                        </Col>

                        {AuthUser?.Permissions?.Account == 1 ? (
                          <Col lg={2}>
                            <div className="mb-2">
                              <label className="mb-1">Define More Rates</label>
                              <div className="input-group">
                                <span className="form-control form-control-sm ps-2">
                                  <Link
                                    to="#"
                                    className="text-primary"
                                    onClick={() => {
                                      getDefineMoreRatesModal();
                                    }}
                                  >
                                    Set Define More Rates
                                  </Link>
                                </span>
                              </div>
                            </div>
                          </Col>
                        ) : (
                          ""
                        )}
                        <Col lg={2}>
                          <div className="mb-2">
                            <label className="mb-1">Test Master Images</label>
                            <div className="input-group">
                              <span className="form-control form-control-sm ps-2">
                                <Link
                                  to="#"
                                  className="text-primary"
                                  onClick={() => {
                                    setShowTestMasterImagesModal(true);
                                  }}
                                >
                                  View Test Master Images
                                </Link>
                              </span>
                            </div>
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-2">
                            <label className="mb-1">Testing Images</label>
                            <div className="input-group">
                              <span className="form-control form-control-sm ps-2">
                                <Link
                                  to="#"
                                  className="text-primary"
                                  onClick={() => {
                                    setShowTestingImagesModal(true);
                                  }}
                                >
                                  View Testing Images
                                </Link>
                              </span>
                              {/* {IsReTestTesting == false ? ( */}
                              <div
                                className="input-group-text"
                                title="Add Testing Images"
                                style={{
                                  borderRadius: "0 0.375rem 0.375rem 0",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setShowTestingImagesModal(true);
                                }}
                              >
                                <i className="fa fa-plus" />
                              </div>
                              {/* ) : (
                                                              ""
                                                            )} */}
                            </div>
                          </div>
                        </Col>
                        {formikTesting?.values?.ListOfTestDefineMoreRates?.filter(
                          (e) => e.IsSelected == true && e.RateType == 4 //Based On Measurement
                        )?.length > 0 ? (
                          <Col lg={2}>
                            <Field
                              type="number"
                              label={"Based On Measurement Value"}
                              name="BasedOnMeasurementValue"
                              placeholder={"Enter Measurement Value"}
                              component={CustomInput}
                              maxLength={20}
                              // disabled={
                              //   IsReTestTesting ? true : false
                              // }
                              ////numberTypeWithoutDot={true}
                            />
                          </Col>
                        ) : (
                          ""
                        )}
                        {formikTesting?.values?.ListOfTestDefineMoreRates?.filter(
                          (e) => e.IsSelected == true && e.RateType == 7 //Based On Hrs
                        )?.length > 0 ? (
                          <Col lg={2}>
                            <Field
                              type="number"
                              label={"Based On Hrs Value"}
                              name="BasedOnHrsValue"
                              placeholder={"Enter Hrs Value"}
                              component={CustomInput}
                              maxLength={20}
                              // disabled={
                              //   IsReTestTesting ? true : false
                              // }
                              ////numberTypeWithoutDot={true}
                            />
                          </Col>
                        ) : (
                          ""
                        )}
                        {IsTPIRequired == true && (
                          <Col lg={4}>
                            <label>TPI Details</label>
                            <div className="mb-2">
                              <div className="input-group">
                                <span className="form-control form-control-sm ps-2">
                                  <Link
                                    to="#"
                                    className="text-primary"
                                    onClick={() => {
                                      setShowTestingTPIDetailModal(true);
                                    }}
                                  >
                                    View TPI Details
                                  </Link>
                                </span>
                                <div
                                  className="input-group-text"
                                  title="Add TPI Detail"
                                  style={{
                                    borderRadius: "0 0.375rem 0.375rem 0",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    addNewTPI(true);
                                  }}
                                >
                                  <i className="fa fa-plus" />
                                </div>
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </Col>
                    <Col lg={2} className="mb-2">
                      <label className="mb-1">
                        Testing By <span className="text-danger">*</span>
                      </label>
                      <div
                        className="card mb-0 w-100"
                        style={{ height: "180px" }}
                      >
                        <div className="card-header p-0">
                          <input
                            type="text"
                            name="searchTestingBy"
                            placeholder={"Search here..."}
                            className="form-control form-control-sm"
                            value={formikTesting?.values?.searchTestingBy}
                            onChange={handleChangeSearchTestingBy}
                            style={{
                              borderBottomLeftRadius: "0",
                              borderBottomRightRadius: "0",
                            }}
                          ></input>
                        </div>
                        <div
                          className="card-body p-0 table-responsive"
                          style={{
                            maxHeight: "135px",
                            overflow: "auto",
                          }}
                        >
                          <table className="table table-hover header-border no-footer">
                            <tbody>
                              {formikTesting?.values?.ListTestingBy?.filter(
                                (x) => x.display == true
                              )?.length > 0 ? (
                                formikTesting?.values?.ListTestingBy?.map(
                                  (item, indx) => (
                                    <tr
                                      key={indx}
                                      style={{
                                        display:
                                          item.display == true ? "" : "none",
                                      }}
                                    >
                                      <td
                                        style={{
                                          textAlign: "center",
                                          padding: "0.5rem",
                                          width: "15%",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkTestingBy${indx}`}
                                          name={`chkTestingBy${indx}`}
                                          checked={item.IsSelected}
                                          onChange={(e) => {
                                            formikTesting.setFieldValue(
                                              `ListTestingBy[${indx}].IsSelected`,
                                              e.target.checked
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "left",
                                          padding: "0.5rem",
                                          width: "85%",
                                        }}
                                      >
                                        {item.EmployeeName}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      textAlign: "center",
                                    }}
                                  >
                                    <div>{"No options"}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <ErrorMessage
                        name={"ListTestingBy"}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />
                    </Col>
                  </Row>
                  {/* {formikTesting?.values?.IsMixDesign == true && (
                    <>
                      <hr className="mt-0 mb-1"></hr>
                      <Row>
                        <Col lg={6}>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label>
                                Mix Design (STIPULATIONS FOR PROPORTIONING)
                              </label>
                            </div>
                          </div>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={6}>
                                  <Field
                                    name={
                                      "TestMixDesignDetail.GradeDesignation"
                                    }
                                    label={"Grade Designation"}
                                    placeholder={"Grade Designation"}
                                    component={CustomInput}
                                    maxLength={200}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Type of Cement"
                                    name="TestMixDesignDetail.TypeofCementIDEncrypted"
                                    placeholder={"Select Type of Cement"}
                                    options={optionsTypeOfCement}
                                    component={CustomSelect}
                                    onChange={(e) => {
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.TypeofCementIDEncrypted",
                                        e?.value ?? ""
                                      );
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.TypeofCementName",
                                        e?.label ?? ""
                                      );
                                    }}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <div className="mb-2">
                                    <label className="mb-1">
                                      Method of Concrete Placing &nbsp;
                                    </label>
                                    <div className="form-control form-control-sm">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                                        name={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                                        checked={
                                          formikTesting?.values
                                            ?.TestMixDesignDetail
                                            ?.MethodofConcretePlacingIsChute_NonPumpable
                                        }
                                        onChange={(e) => {
                                          formikTesting.setFieldValue(
                                            "TestMixDesignDetail.MethodofConcretePlacingIsChute_NonPumpable",
                                            !formikTesting?.values
                                              ?.TestMixDesignDetail
                                              ?.MethodofConcretePlacingIsChute_NonPumpable
                                          );
                                        }}
                                      />
                                      <label className="mb-1 ms-1 me-2 mt-1">
                                        Chute (Non pumpable) &nbsp;
                                      </label>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkMethodofConcretePlacingIsPumping`}
                                        name={`chkMethodofConcretePlacingIsPumping`}
                                        checked={
                                          formikTesting?.values
                                            ?.TestMixDesignDetail
                                            ?.MethodofConcretePlacingIsPumping
                                        }
                                        onChange={(e) => {
                                          formikTesting.setFieldValue(
                                            "TestMixDesignDetail.MethodofConcretePlacingIsPumping",
                                            !formikTesting?.values
                                              ?.TestMixDesignDetail
                                              ?.MethodofConcretePlacingIsPumping
                                          );
                                        }}
                                      />
                                      <label className="mb-1 ms-1 mt-1">
                                        Pumping &nbsp;
                                      </label>
                                    </div>
                                  </div>
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Type of Mineral Admixture"
                                    name="TestMixDesignDetail.TypeofMineralAdmixtureIDEncrypted"
                                    placeholder={
                                      "Select Type of Mineral Admixture"
                                    }
                                    options={optionsTypeOfMineralAdmixture}
                                    component={CustomSelect}
                                    onChange={(e) => {
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.TypeofMineralAdmixtureIDEncrypted",
                                        e?.value ?? ""
                                      );
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.TypeofMineralAdmixtureName",
                                        e?.label ?? ""
                                      );
                                    }}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    name={
                                      "TestMixDesignDetail.DegreeofSiteControl"
                                    }
                                    label={"Degree of Site Control"}
                                    placeholder={"Degree of Site Control"}
                                    component={CustomInput}
                                    maxLength={200}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Maximum Nominal Size of Aggregate"
                                    name="TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted"
                                    placeholder={
                                      "Select Maximum Nominal Size of Aggregate"
                                    }
                                    options={
                                      optionsMaximumNominalSizeofAggregate
                                    }
                                    component={CustomSelect}
                                    onChange={(e) => {
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.MaximumNominalSizeofAggregateIDEncrypted",
                                        e?.value ?? ""
                                      );
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.MaximumNominalSizeofAggregateName",
                                        e?.label ?? ""
                                      );
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.ApproximateAirContentResultValue",
                                        e?.ApproximateAirContent ?? ""
                                      );
                                    }}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    name={
                                      "TestMixDesignDetail.TypeofAggregateFineCoarse"
                                    }
                                    label={"Type of Aggregate Coarse"}
                                    placeholder={"Type of Aggregate Coarse"}
                                    component={CustomInput}
                                    maxLength={200}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Type of Aggregate Fine"
                                    name="TestMixDesignDetail.TypeofAggregateFineIDEncrypted"
                                    placeholder={
                                      "Select Type of Aggregate Fine"
                                    }
                                    options={optionsTypeOfAggregateFine}
                                    component={CustomSelect}
                                    onChange={(e) => {
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.TypeofAggregateFineIDEncrypted",
                                        e?.value ?? ""
                                      );
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.TypeofAggregateFineName",
                                        e?.label ?? ""
                                      );
                                    }}
                                  />
                                </Col>

                                <Col lg={6}>
                                  <Field
                                    label="Environmental Exposure Conditions"
                                    name="TestMixDesignDetail.EnvironmentalExposureConditionsIDEncrypted"
                                    placeholder={
                                      "Select Environmental Exposure Conditions"
                                    }
                                    options={
                                      optionsEnvironmentralExposureConditions
                                    }
                                    component={CustomSelect}
                                    onChange={(e) => {
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.EnvironmentalExposureConditionsIDEncrypted",
                                        e?.value ?? ""
                                      );
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.EnvironmentalExposureConditionsName",
                                        e?.label ?? ""
                                      );
                                    }}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    type="number"
                                    name={
                                      "TestMixDesignDetail.MaximumCementContent"
                                    }
                                    label={"Maximum Cement Content (kg/m3)"}
                                    placeholder={
                                      "Maximum Cement Content (kg/m3)"
                                    }
                                    component={CustomInput}
                                    maxLength={200}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    type="number"
                                    name={
                                      "TestMixDesignDetail.MinimumCementContent"
                                    }
                                    label={"Minimum Cement Content (kg/m3)"}
                                    placeholder={
                                      "Minimum Cement Content (kg/m3)"
                                    }
                                    component={CustomInput}
                                    maxLength={200}
                                  />
                                </Col>

                                <Col lg={6}>
                                  <Field
                                    type="number"
                                    name={
                                      "TestMixDesignDetail.MaximumWaterCementRatio"
                                    }
                                    label={"Maximum Water Cement Ratio"}
                                    placeholder={"Maximum Water Cement Ratio"}
                                    component={CustomInput}
                                    maxLength={200}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    name={"TestMixDesignDetail.Workability"}
                                    label={"Workability"}
                                    placeholder={"Workability"}
                                    component={CustomInput}
                                    maxLength={200}
                                    onChange={(e) => {
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.Workability",
                                        e?.target?.value ?? ""
                                      );
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.EstimatedWaterContentFor",
                                        e?.target?.value ?? ""
                                      );
                                    }}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Chemical Admixture Type"
                                    name="TestMixDesignDetail.ChemicalAdmixtureTypeIDEncrypted"
                                    placeholder={
                                      "Select Chemical Admixture Type"
                                    }
                                    options={optionsChemicalAdmixtureType}
                                    component={CustomSelect}
                                    onChange={(e) => {
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.ChemicalAdmixtureTypeIDEncrypted",
                                        e?.value ?? ""
                                      );
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.ChemicalAdmixtureTypeName",
                                        e?.label ?? ""
                                      );
                                    }}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Chemical Admixture Brand/Batch/ID Mark"
                                    name="TestMixDesignDetail.ChemicalAdmixtureBrandBatchandMarkIDEncrypted"
                                    placeholder={
                                      "Chemical Admixture Brand/Batch/ID Mark"
                                    }
                                    options={
                                      optionsChemicalAdmixtureBrandBatchMarkId
                                    }
                                    component={CustomSelect}
                                    onChange={(e) => {
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.ChemicalAdmixtureBrandBatchandMarkIDEncrypted",
                                        e?.value ?? ""
                                      );
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.ChemicalAdmixtureBrandBatchandMarkName",
                                        e?.label ?? ""
                                      );
                                    }}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    name="TestMixDesignDetail.TransportationTime"
                                    label={"Transportation Time"}
                                    placeholder={"hh:mm"}
                                    component={CustomFlatpickr}
                                    options={{
                                      enableTime: true,
                                      noCalendar: true,
                                      dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                                      time_24hr: true, // Enforces 24-hour format
                                      //allowInput: true, // Allows typing
                                      minuteIncrement: 1, // Allows setting minutes with up/down arrows
                                    }}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    name="TestMixDesignDetail.RetentionTime"
                                    label={"Retention Time"}
                                    placeholder={"hh:mm"}
                                    component={CustomFlatpickr}
                                    options={{
                                      enableTime: true,
                                      noCalendar: true,
                                      dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                                      time_24hr: true, // Enforces 24-hour format
                                      //allowInput: true, // Allows typing
                                      minuteIncrement: 1, // Allows setting minutes with up/down arrows
                                    }}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label>Mix Design Included Tests</label>
                            </div>
                          </div>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Accordion
                                className="accordion accordion-primary"
                                defaultActiveKey="0"
                              >
                                {formikTesting?.values
                                  ?.ListOfMixDesignIncludedTest?.length > 0 &&
                                  formikTesting?.values?.ListOfMixDesignIncludedTest?.map(
                                    (item, index) => (
                                      <Accordion.Item
                                        className="accordion-item"
                                        key={index}
                                        eventKey={index}
                                      >
                                        <Accordion.Header className="accordion-header rounded-lg">
                                          {item?.TestName}
                                        </Accordion.Header>
                                        <Accordion.Collapse eventKey={index}>
                                          <div className="accordion-body ps-0 pe-0 pb-0">
                                            {item?.TestDetails?.TestingStatus <=
                                            2 ? (
                                              <>
                                                Testing Status: &nbsp;
                                                <label className="mb-0">
                                                  {
                                                    item?.TestDetails
                                                      ?.TestingStatusName
                                                  }
                                                </label>
                                              </>
                                            ) : (
                                              <MixDesignIncludedTestResultDetail
                                                test={item.TestDetails}
                                                testIndex={index}
                                              />
                                            )}
                                          </div>
                                        </Accordion.Collapse>
                                      </Accordion.Item>
                                    )
                                  )}
                              </Accordion>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )} */}
                  <hr className="mt-0 mb-1"></hr>
                  <Row>
                    <div className="d-flex justify-content-between mb-0">
                      <div className="d-flex mb-0">
                        <label>Testing Parameters</label>
                      </div>
                    </div>
                    <Col lg={12}>
                      <div className="card mb-2" style={{ height: "auto" }}>
                        <div className="card-body p-2">
                          <Row>
                            <Col lg={2} style={{ width: "125px" }}>
                              <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  id="None"
                                  name="ParameterWith"
                                  title="None"
                                  style={{ cursor: "pointer" }}
                                  checked={
                                    formikTesting?.values?.ParameterWith == 1
                                  }
                                  onChange={() => {
                                    formikTesting.setFieldValue(
                                      "ParameterWith",
                                      1
                                    );
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="None"
                                >
                                  None
                                </label>
                              </div>
                            </Col>
                            {formikTesting?.values
                              ?.ReferenceStandardIDEncrypted && (
                              <Col lg={2} style={{ width: "180px" }}>
                                <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    id="PrintMinMax"
                                    name="ParameterWith"
                                    title="Print Min-Max"
                                    style={{ cursor: "pointer" }}
                                    checked={
                                      formikTesting?.values?.ParameterWith == 2
                                    }
                                    onChange={() => {
                                      formikTesting.setFieldValue(
                                        "ParameterWith",
                                        2
                                      );
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="PrintMinMax"
                                  >
                                    Print Min/Max
                                  </label>
                                </div>
                              </Col>
                            )}
                            {formikTesting?.values?.IsMixDesign == false && (
                              <Col lg={2} style={{ width: "220px" }}>
                                <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    id="PrintRequirement"
                                    name="ParameterWith"
                                    title="Print Requirement"
                                    style={{ cursor: "pointer" }}
                                    checked={
                                      formikTesting?.values?.ParameterWith == 3
                                    }
                                    onChange={() => {
                                      formikTesting.setFieldValue(
                                        "ParameterWith",
                                        3
                                      );
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="PrintRequirement"
                                  >
                                    Print Requirement
                                  </label>
                                </div>
                              </Col>
                            )}
                            <Col lg={3}>
                              <div className="d-flex mb-2">
                                <label className="mb-1">
                                  Merge Same Value &nbsp;
                                </label>
                                <div class="form-check form-switch">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="flexSwitchCheckIsMergeSameValue"
                                    title={
                                      formikTesting?.values?.IsMergeSameValue ==
                                      true
                                        ? "Yes"
                                        : "No"
                                    }
                                    checked={
                                      formikTesting?.values?.IsMergeSameValue
                                    }
                                    onChange={() => {
                                      formikTesting.setFieldValue(
                                        "IsMergeSameValue",
                                        !formikTesting?.values?.IsMergeSameValue
                                      );
                                    }}
                                    style={{ cursor: "pointer" }}
                                  ></input>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <hr className="mt-0 mb-1"></hr>
                          <Row>
                            <Col lg={12}>
                              <div>
                                <Row>
                                  <Col lg={4}>
                                    <div className="d-flex ">
                                      <div style={{ width: "160px" }}>
                                        <label>NABL Range Indication :</label>
                                      </div>
                                      <div>
                                        <i
                                          className="fa fa-certificate"
                                          style={{ color: "green" }}
                                        ></i>
                                        &nbsp; Valid &nbsp;&nbsp;
                                        <i
                                          className="fa fa-certificate"
                                          style={{ color: "red" }}
                                        ></i>
                                        &nbsp; Invalid &nbsp;&nbsp;
                                        <i
                                          className="fa fa-certificate"
                                          style={{ color: "orange" }}
                                        ></i>
                                        &nbsp; Unidentified
                                      </div>
                                    </div>
                                  </Col>
                                  {formikTesting?.values
                                    ?.ReferenceStandardIDEncrypted ? (
                                    <Col lg={4}>
                                      <div className="d-flex ">
                                        <div style={{ width: "170px" }}>
                                          <label>
                                            Ref. Standard Indication :{" "}
                                          </label>
                                        </div>
                                        <div>
                                          <i
                                            className="fa fa-circle"
                                            style={{ color: "green" }}
                                          ></i>
                                          &nbsp; Valid &nbsp;&nbsp;
                                          <i
                                            className="fa fa-circle"
                                            style={{ color: "red" }}
                                          ></i>
                                          &nbsp; Invalid &nbsp;&nbsp;
                                          <i
                                            className="fa fa-circle"
                                            style={{ color: "orange" }}
                                          ></i>
                                          &nbsp; Unidentified
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}
                                  <Col lg={4}>
                                    <div className="d-flex ">
                                      <div style={{ width: "160px" }}>
                                        <label>Parameter Result Type :</label>
                                      </div>
                                      <div>
                                        &nbsp; QN - Quantitative &nbsp;&nbsp;
                                        &nbsp; QL - Qualitative &nbsp;&nbsp;
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                              <DragDropContext onDragEnd={onDragEnd}>
                                <div className="table-responsive active-projects style-1 shorting mb-2">
                                  <div
                                    id="ParameterDetail-tbl_wrapper"
                                    className="dataTables_wrapper table-responsive no-footer"
                                  >
                                    <table
                                      id="ParameterDetail-tbl"
                                      className="table table-bordered no-footer mb-0"
                                    >
                                      <thead>
                                        <tr>
                                          <th width="2%">
                                            <Link
                                              to="#"
                                              className="icon-box icon-box-md bg-primary-light"
                                              title="Parameters Selection"
                                              onClick={() => {
                                                formikTestPrameters.setFieldValue(
                                                  "ParametersList",
                                                  formikTesting?.values
                                                    ?.ListOfParameter
                                                );
                                                formikTestPrameters.setFieldValue(
                                                  "selectAllPara",
                                                  formikTesting?.values?.ListOfParameter?.filter(
                                                    (x) => x.IsSelected == false
                                                  )?.length > 0
                                                    ? false
                                                    : true
                                                );
                                                formikTestPrameters.setFieldValue(
                                                  "ParametersTestName",
                                                  "Testing Parameters"
                                                );
                                                formikTestPrameters.setFieldValue(
                                                  "isTestParametersForTesting",
                                                  true
                                                );
                                                setShowTestParametersModal(
                                                  true
                                                );
                                              }}
                                            >
                                              {SVGICON.EditSquare}
                                            </Link>
                                          </th>
                                          <th width="2%">#</th>
                                          {/* <th width="16%">Code</th> */}
                                          <th width="16%">Parameter</th>
                                          <th width="16%">Test Method</th>
                                          {formikTesting?.values
                                            ?.ReferenceStandardIDEncrypted && (
                                            <th width="15%">Range</th>
                                          )}
                                          {formikTesting?.values
                                            ?.ParameterWith == 2 && (
                                            <>
                                              <th width="9%">Min</th>
                                              <th width="9%">Max</th>
                                            </>
                                          )}
                                          {/* {ParameterWith == 3 && (
                                            <th width="15%">Requirement</th>
                                          )} */}
                                          {formikTesting?.values?.IsMixDesign ==
                                          true ? (
                                            <th width="15%">Printing Group</th>
                                          ) : (
                                            formikTesting?.values
                                              ?.ParameterWith == 3 && (
                                              <th width="15%">Requirement</th>
                                            )
                                          )}
                                          <th width="5%">NABL</th>
                                          {formikTesting?.values?.ListOfParameter[0]?.ListOfResultValue?.map(
                                            (result, rIdx) => (
                                              <th
                                                width="15%"
                                                style={{
                                                  textAlign: "left",
                                                  width: "150px",
                                                }}
                                              >
                                                {/* Value */}
                                                {formikTesting?.values
                                                  ?.ListOfParameter[0]
                                                  ?.ListOfResultValue?.length >
                                                1 ? (
                                                  <Field
                                                    // type="number"
                                                    name={`ListOfParameter[0].ListOfResultValue[${rIdx}].TestingCountHeader`}
                                                    component={CustomInput}
                                                    placeholder="Header Text"
                                                    maxLength={50}
                                                    noMarginBottom={true}
                                                    onChange={(e) => {
                                                      // formik.setFieldValue(
                                                      //   `ListOfParameter[0].ListOfResultValue[${rIdx}].TestingCountHeader`,
                                                      //   e?.target?.value ?? ""
                                                      // );
                                                      handleChangeTestingCountHeaderText(
                                                        e?.target?.value ?? "",
                                                        rIdx
                                                      );
                                                    }}
                                                  />
                                                ) : (
                                                  "Value"
                                                )}
                                                {/* {AuthUser?.Permissions
                                                  ?.TestResultFromFile ==
                                                1 ? (
                                                  <>
                                                    &nbsp;&nbsp;
                                                    <div className="input-group">
                                                      <div
                                                        className="open-file"
                                                        style={{
                                                          marginTop: "-26px",
                                                          marginLeft: "35px",
                                                        }}
                                                        title="Add CSV File"
                                                      >
                                                        <input
                                                          type="file"
                                                          id={`valuesUploadCSVFile${rIdx}`}
                                                          accept=".csv"
                                                          onChange={(e) => {
                                                            uploadCSVFile(
                                                              e,
                                                              rIdx
                                                            );
                                                          }}
                                                          key={
                                                            fileKeyCSVFile ||
                                                            ""
                                                          }
                                                          // title="Add CSV File"
                                                        />
                  
                                                        <label
                                                          htmlFor={`valuesUploadCSVFile${rIdx}`}
                                                          name=""
                                                        ></label>
                                                      </div>
                                                    </div>
                                                  </>
                                                ) : (
                                                  ""
                                                )} */}
                                              </th>
                                            )
                                          )}
                                          {formikTesting?.values?.TestingQty &&
                                          parseInt(
                                            formikTesting?.values?.TestingQty
                                          ) > 1 ? (
                                            formikTesting?.values?.ListOfParameter?.filter(
                                              (x) =>
                                                x.IsSelected == true &&
                                                x.IsAverageRequired == true
                                            )?.length > 0 ? (
                                              <th
                                                width="5%"
                                                style={{ textAlign: "left" }}
                                              >
                                                Average
                                              </th>
                                            ) : (
                                              ""
                                            )
                                          ) : (
                                            ""
                                          )}
                                        </tr>
                                      </thead>
                                      <Droppable droppableId="droppable">
                                        {(provided, _) => (
                                          <tbody
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                          >
                                            {formikTesting?.values
                                              ?.ListOfParameter?.length > 0 ? (
                                              formikTesting?.values?.ListOfParameter?.map(
                                                (item, indx) =>
                                                  item?.IsSelected == true ? (
                                                    <Draggable
                                                      key={`id_${indx}`}
                                                      draggableId={`id_${indx}`}
                                                      index={indx}
                                                    >
                                                      {(provided, _) => (
                                                        <tr
                                                          key={indx}
                                                          role="row"
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          //{...provided.dragHandleProps}  /* this sentence shifted to td level because select control not work properly */
                                                          className={`sub-card draggable-handle draggable`}
                                                        >
                                                          <td
                                                            className="p-1 text-center"
                                                            {...provided.dragHandleProps}
                                                            tabIndex={-1}
                                                          >
                                                            {SVGICON.Dotes}
                                                          </td>
                                                          <td
                                                            className="p-1 text-center"
                                                            {...provided.dragHandleProps}
                                                            tabIndex={-1}
                                                          >
                                                            {item?.Sequence}
                                                          </td>
                                                          {/* <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            {item.DisplayCode}
                                                          </td> */}
                                                          <td
                                                            className="p-1"
                                                            style={{
                                                              minWidth: "100px",
                                                            }}
                                                            {...provided.dragHandleProps}
                                                            tabIndex={-1}
                                                          >
                                                            {item.ParameterName}
                                                            {item.ShortCode ? (
                                                              <>
                                                                &nbsp;(
                                                                <span className="text-primary">
                                                                  <b>
                                                                    {
                                                                      item.ShortCode
                                                                    }
                                                                  </b>
                                                                </span>
                                                                )
                                                              </>
                                                            ) : (
                                                              ""
                                                            )}
                                                            {item.FormulaEvaluationStatus >
                                                              0 && (
                                                              <Link
                                                                to="#"
                                                                className={`icon-box icon-box-md ms-1 ${
                                                                  item.FormulaEvaluationStatus ==
                                                                  1
                                                                    ? "bg-success"
                                                                    : item.FormulaEvaluationStatus ==
                                                                      2
                                                                    ? "bg-danger"
                                                                    : "bg-secondary-light"
                                                                }`}
                                                                title={
                                                                  item.FormulaExpression
                                                                }
                                                                onClick={() => {
                                                                  showFormula(
                                                                    item.ParameterName,
                                                                    item.FormulaExpression
                                                                  );
                                                                }}
                                                                tabIndex={-1}
                                                              >
                                                                {
                                                                  SVGICON.Formula
                                                                }
                                                              </Link>
                                                            )}
                                                            {item.FormulaEvaluationStatus ==
                                                              1 && (
                                                              <Link
                                                                to="#"
                                                                className={`icon-box icon-box-md bg-primary-light ms-1`}
                                                                title="Calculate Formula"
                                                                onClick={() => {
                                                                  calculateFormula(
                                                                    indx,
                                                                    item.FormulaExpression,
                                                                    item.FormulaVariables
                                                                  );
                                                                }}
                                                                tabIndex={-1}
                                                              >
                                                                {
                                                                  SVGICON.Calculator
                                                                }
                                                              </Link>
                                                            )}
                                                          </td>
                                                          {item?.ParameterType ==
                                                          1 ? (
                                                            <td
                                                              className="p-1"
                                                              style={{
                                                                minWidth:
                                                                  "130px",
                                                              }}
                                                            >
                                                              <Field
                                                                name={`ListOfParameter[${indx}].TestMethodIDEncrypt`}
                                                                placeholder={
                                                                  "Test Method"
                                                                }
                                                                component={
                                                                  CustomSelect
                                                                }
                                                                options={
                                                                  item?.testMethodOptions
                                                                }
                                                                // isClearable={
                                                                //   false
                                                                // }
                                                                noMarginBottom={
                                                                  true
                                                                }
                                                                menuPosition="fixed"
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  handleChangeTestMethodParameter(
                                                                    indx,
                                                                    e?.value ??
                                                                      "",
                                                                    e?.IsExpiredTestMethod,
                                                                    e?.label ??
                                                                      ""
                                                                  );
                                                                }}
                                                              />
                                                            </td>
                                                          ) : (
                                                            <td
                                                              className="p-1"
                                                              style={{
                                                                minWidth:
                                                                  "130px",
                                                              }}
                                                              {...provided.dragHandleProps}
                                                              tabIndex={-1}
                                                            ></td>
                                                          )}
                                                          {formikTesting?.values
                                                            ?.ReferenceStandardIDEncrypted ? (
                                                            item.rangeOptions
                                                              ?.length > 0 ? (
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "130px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfParameter[${indx}].RangeValue`}
                                                                  placeholder={
                                                                    "Range"
                                                                  }
                                                                  options={
                                                                    item.rangeOptions
                                                                  }
                                                                  component={
                                                                    CustomSelect
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  menuPosition="fixed"
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    formikTesting.setFieldValue(
                                                                      `ListOfParameter[${indx}].RangeValue`,
                                                                      e?.label ??
                                                                        ""
                                                                    );
                                                                    formikTesting.setFieldValue(
                                                                      `ListOfParameter[${indx}].MinValue`,
                                                                      e?.MinValue ??
                                                                        ""
                                                                    );
                                                                    formikTesting.setFieldValue(
                                                                      `ListOfParameter[${indx}].MaxValue`,
                                                                      e?.MaxValue ??
                                                                        ""
                                                                    );
                                                                    formikTesting.setFieldValue(
                                                                      `ListOfParameter[${indx}].Requirement`,
                                                                      e?.Requirement ??
                                                                        ""
                                                                    );
                                                                    if (
                                                                      formikTesting
                                                                        ?.values
                                                                        ?.TestingStatus ==
                                                                      1
                                                                      // && formikTesting?.values?.IsReTestTesting ==
                                                                      // false
                                                                    ) {
                                                                      formikTesting.setFieldValue(
                                                                        `ListOfParameter[${indx}].ListOfResultValue`,
                                                                        item?.ListOfResultValue?.map(
                                                                          (
                                                                            result
                                                                          ) => {
                                                                            return {
                                                                              ...result,
                                                                              ResultValue:
                                                                                item?.ParameterType ==
                                                                                1
                                                                                  ? e?.DefaultValue ??
                                                                                    ""
                                                                                  : result?.ResultValue,
                                                                            };
                                                                          }
                                                                        )
                                                                      );
                                                                    }
                                                                    OnMinMaxValueChangeConsiderResult(
                                                                      indx,
                                                                      e?.MinValue ??
                                                                        "",
                                                                      e?.MaxValue ??
                                                                        ""
                                                                    );
                                                                  }}
                                                                />
                                                              </td>
                                                            ) : (
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "130px",
                                                                }}
                                                                {...provided.dragHandleProps}
                                                                tabIndex={-1}
                                                              ></td>
                                                            )
                                                          ) : (
                                                            ""
                                                          )}

                                                          {formikTesting?.values
                                                            ?.ParameterWith ==
                                                            2 && (
                                                            <>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "80px",
                                                                }}
                                                              >
                                                                <Field
                                                                  // type="number"
                                                                  name={`ListOfParameter[${indx}].MinValue`}
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  placeholder="Min"
                                                                  maxLength={50}
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    formikTesting.setFieldValue(
                                                                      `ListOfParameter[${indx}].MinValue`,
                                                                      e?.target
                                                                        ?.value ??
                                                                        ""
                                                                    );
                                                                    OnMinMaxValueChangeConsiderResult(
                                                                      indx,
                                                                      e?.target
                                                                        ?.value ??
                                                                        "",
                                                                      item?.MaxValue
                                                                    );
                                                                  }}
                                                                />
                                                              </td>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "80px",
                                                                }}
                                                              >
                                                                <Field
                                                                  // type="number"
                                                                  name={`ListOfParameter[${indx}].MaxValue`}
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  placeholder="Max"
                                                                  maxLength={50}
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    formikTesting.setFieldValue(
                                                                      `ListOfParameter[${indx}].MaxValue`,
                                                                      e?.target
                                                                        ?.value ??
                                                                        ""
                                                                    );
                                                                    OnMinMaxValueChangeConsiderResult(
                                                                      indx,
                                                                      item?.MinValue,
                                                                      e?.target
                                                                        ?.value ??
                                                                        ""
                                                                    );
                                                                  }}
                                                                />
                                                              </td>
                                                            </>
                                                          )}
                                                          {/* {ParameterWith ==
                                                            3 && (
                                                            <td
                                                              className="p-1"
                                                              style={{
                                                                minWidth:
                                                                  "100px",
                                                              }}
                                                            >
                                                              <Field
                                                                type="text"
                                                                name={`ListOfParameter[${indx}].Requirement`}
                                                                component={
                                                                  CustomInput
                                                                }
                                                                placeholder="Requirement"
                                                                maxLength={
                                                                  500
                                                                }
                                                                noMarginBottom={
                                                                  true
                                                                }
                                                              />
                                                            </td>
                                                          )} */}
                                                          {formikTesting?.values
                                                            ?.IsMixDesign ==
                                                          true ? (
                                                            <td
                                                              {...provided.dragHandleProps}
                                                              tabIndex={-1}
                                                            >
                                                              <label>
                                                                {
                                                                  item.Requirement
                                                                }
                                                              </label>
                                                            </td>
                                                          ) : (
                                                            formikTesting
                                                              ?.values
                                                              ?.ParameterWith ==
                                                              3 && (
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "100px",
                                                                }}
                                                              >
                                                                <Field
                                                                  type="text"
                                                                  name={`ListOfParameter[${indx}].Requirement`}
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  placeholder="Requirement"
                                                                  maxLength={
                                                                    500
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                />
                                                              </td>
                                                            )
                                                          )}
                                                          <td
                                                            {...provided.dragHandleProps}
                                                            tabIndex={-1}
                                                          >
                                                            <label
                                                              title={
                                                                item.NABLRangeFrom
                                                                  ? item.NABLRangeFrom +
                                                                    " - " +
                                                                    item.NABLRangeTo
                                                                  : ""
                                                              }
                                                            >
                                                              {item.IsNABLParameter
                                                                ? "Yes"
                                                                : "No"}{" "}
                                                              &nbsp;
                                                              {item?.ParameterType ==
                                                              1
                                                                ? item?.ParameterResultType ==
                                                                  2
                                                                  ? "(QL)"
                                                                  : "(QN)"
                                                                : ""}
                                                            </label>
                                                          </td>
                                                          {item?.ListOfResultValue?.map(
                                                            (result, rIdx) => (
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                  minWidth:
                                                                    "100px",
                                                                }}
                                                              >
                                                                <div className="d-flex justify-content-between">
                                                                  <div
                                                                    className="pe-1"
                                                                    style={{
                                                                      width:
                                                                        "90%",
                                                                    }}
                                                                  >
                                                                    <Field
                                                                      type="text"
                                                                      name={`ListOfParameter[${indx}].ListOfResultValue[${rIdx}].ResultValue`}
                                                                      component={
                                                                        CustomInput
                                                                      }
                                                                      placeholder="Value"
                                                                      maxLength={
                                                                        500
                                                                      }
                                                                      noMarginBottom={
                                                                        true
                                                                      }
                                                                      onChange={(
                                                                        e
                                                                      ) => {
                                                                        formikTesting.setFieldValue(
                                                                          `ListOfParameter[${indx}].ListOfResultValue[${rIdx}].ResultValue`,
                                                                          e
                                                                            ?.target
                                                                            ?.value ??
                                                                            ""
                                                                        );

                                                                        OnResultValueChangeConsiderResult(
                                                                          indx,
                                                                          rIdx,
                                                                          item?.MinValue,
                                                                          item?.MaxValue,
                                                                          e
                                                                            ?.target
                                                                            ?.value ??
                                                                            "",
                                                                          item?.ParameterType,
                                                                          item?.NABLRangeFrom,
                                                                          item?.NABLRangeTo,
                                                                          item?.ParameterResultType,
                                                                          item?.IsNABLParameter
                                                                        );

                                                                        if (
                                                                          item.IsAverageRequired ==
                                                                          true
                                                                        ) {
                                                                          calculateResultAverage(
                                                                            indx,
                                                                            rIdx,
                                                                            e
                                                                              ?.target
                                                                              ?.value ??
                                                                              ""
                                                                          );
                                                                        }
                                                                      }}
                                                                    />
                                                                  </div>
                                                                  <div
                                                                    style={{
                                                                      alignContent:
                                                                        "center",
                                                                    }}
                                                                    {...provided.dragHandleProps}
                                                                    tabIndex={
                                                                      -1
                                                                    }
                                                                  >
                                                                    {formikTesting
                                                                      ?.values
                                                                      ?.ReferenceStandardIDEncrypted ? (
                                                                      <>
                                                                        <i
                                                                          className="fa fa-circle"
                                                                          style={{
                                                                            color:
                                                                              result?.ResultValue
                                                                                ? result?.ConsiderResult ==
                                                                                  1
                                                                                  ? "green"
                                                                                  : result?.ConsiderResult ==
                                                                                    0
                                                                                  ? "red"
                                                                                  : result?.ConsiderResult ==
                                                                                    -1
                                                                                  ? "orange"
                                                                                  : ""
                                                                                : "",
                                                                          }}
                                                                        ></i>
                                                                        <br></br>
                                                                      </>
                                                                    ) : (
                                                                      ""
                                                                    )}

                                                                    {item.IsNABLParameter ==
                                                                    true ? (
                                                                      <i
                                                                        className="fa fa-certificate"
                                                                        style={{
                                                                          color:
                                                                            result?.ResultValue
                                                                              ? result?.ConsiderNABLResult ==
                                                                                1
                                                                                ? "green"
                                                                                : result?.ConsiderNABLResult ==
                                                                                  0
                                                                                ? "red"
                                                                                : result?.ConsiderNABLResult ==
                                                                                  -1
                                                                                ? "orange"
                                                                                : ""
                                                                              : "",
                                                                        }}
                                                                      ></i>
                                                                    ) : (
                                                                      ""
                                                                    )}
                                                                  </div>
                                                                </div>
                                                              </td>
                                                            )
                                                          )}
                                                          {formikTesting?.values
                                                            ?.TestingQty &&
                                                          parseInt(
                                                            formikTesting
                                                              ?.values
                                                              ?.TestingQty
                                                          ) > 1 ? (
                                                            formikTesting?.values?.ListOfParameter?.filter(
                                                              (x) =>
                                                                x.IsSelected ==
                                                                  true &&
                                                                x.IsAverageRequired ==
                                                                  true
                                                            )?.length > 0 ? (
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                  minWidth:
                                                                    "80px",
                                                                }}
                                                              >
                                                                {item.IsAverageRequired ==
                                                                  true && (
                                                                  <Field
                                                                    type="text"
                                                                    name={`ListOfParameter[${indx}].AverageResultValue`}
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    placeholder="Average"
                                                                    maxLength={
                                                                      50
                                                                    }
                                                                    disabled={
                                                                      true
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    onChange={() => {}} //to prevent change
                                                                  />
                                                                )}
                                                              </td>
                                                            ) : (
                                                              ""
                                                            )
                                                          ) : (
                                                            ""
                                                          )}
                                                        </tr>
                                                      )}
                                                    </Draggable>
                                                  ) : (
                                                    ""
                                                  )
                                              )
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan={10}
                                                  style={{
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  <div>
                                                    {"No Record Found..."}
                                                  </div>
                                                </td>
                                              </tr>
                                            )}
                                            {provided.placeholder}
                                          </tbody>
                                        )}
                                      </Droppable>
                                    </table>
                                    <ErrorMessage
                                      name="ListOfParameter"
                                      component="div"
                                      className="invalid-feedback animated fadeInUp mb-0"
                                      style={{ display: "block" }}
                                    />
                                  </div>
                                </div>
                              </DragDropContext>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {/* {formikTesting?.values?.IsMixDesign == true && (
                    <>
                      <hr className="mt-0 mb-1"></hr>
                      <Row>
                        <div className="d-flex justify-content-between mb-0">
                          <div className="d-flex mb-0">
                            <label>Sieve Analysis</label>
                          </div>
                        </div>
                        <Col lg={12}>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={12}>
                                  <label className="mb-0">
                                    1 - Coarse Aggregate
                                  </label>
                                </Col>
                                <Col lg={12}>
                                  <div className="table-responsive active-projects style-1 shorting mb-0">
                                    <div
                                      id="mixDesignCourseAggRefStdParameterCriteria-tbl_wrapper"
                                      className="dataTables_wrapper table-responsive no-footer"
                                    >
                                      <table
                                        id="mixDesignCourseAggRefStdParameterCriteria-tbl"
                                        className="table table-bordered no-footer mb-2"
                                      >
                                        <thead>
                                          <tr key={0}>
                                            <th
                                              className="text-center"
                                              rowSpan="3"
                                            >
                                              IS Sieve Size <br></br>mm
                                            </th>
                                            {formikTesting?.values
                                              ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                              formikTesting?.values
                                                ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                                ?.SieveSizeList?.length > 0 &&
                                              formikTesting?.values?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList[0]?.ParameterList.map(
                                                (p, pIdx) => (
                                                  <th
                                                    className="text-center"
                                                    rowSpan={
                                                      p?.CriateriaList.length >
                                                      0
                                                        ? p?.CriateriaList.filter(
                                                            (x) =>
                                                              x.IsInputColumn ==
                                                              true
                                                          ).length > 0
                                                          ? 1
                                                          : 2
                                                        : 3
                                                    }
                                                    colSpan={
                                                      p?.CriateriaList.length >
                                                      0
                                                        ? p?.CriateriaList
                                                            .length
                                                        : 1
                                                    }
                                                    style={{
                                                      whiteSpace: "normal",
                                                    }}
                                                  >
                                                    {p?.ParameterColumnName}
                                                  </th>
                                                )
                                              )}
                                          </tr>
                                          <tr key={1}>
                                            {formikTesting?.values
                                              ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                              formikTesting?.values
                                                ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                                ?.SieveSizeList?.length > 0 &&
                                              formikTesting?.values?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList[0]?.ParameterList.map(
                                                (p, pIdx) =>
                                                  p?.CriateriaList?.filter(
                                                    (x) =>
                                                      x.IsInputColumn == true
                                                  ).map((c, cIdx) => (
                                                    <th
                                                      className="text-center"
                                                      style={{
                                                        whiteSpace: "normal",
                                                      }}
                                                    >
                                                      {c?.ParameterCriteria}
                                                      <br></br>
                                                      <span
                                                        style={{
                                                          fontSize: "10px",
                                                        }}
                                                      >
                                                        {c?.ColumnShortCode
                                                          ? `(Short Code: ${c?.ColumnShortCode})`
                                                          : ""}
                                                      </span>
                                                    </th>
                                                  ))
                                              )}
                                          </tr>
                                          <tr key={2}>
                                            {formikTesting?.values
                                              ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                              formikTesting?.values
                                                ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                                ?.SieveSizeList?.length > 0 &&
                                              formikTesting?.values?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList[0]?.ParameterList.map(
                                                (p, pIdx) =>
                                                  p?.CriateriaList?.map(
                                                    (c, cIdx) => (
                                                      <th
                                                        className="text-center"
                                                        style={{
                                                          whiteSpace: "normal",
                                                        }}
                                                      >
                                                        {c?.IsInputColumn ==
                                                        true ? (
                                                          <div className="d-flex">
                                                            {c?.IsInputColumnValueType ==
                                                              true && (
                                                              <>
                                                                <span className="mt-2 mb-1 me-1">
                                                                  {
                                                                    c.ColumnShortCode
                                                                  }
                                                                  {`${
                                                                    c.ColumnShortCode
                                                                      ? "X"
                                                                      : ""
                                                                  }`}
                                                                </span>
                                                                <Field
                                                                  style={{
                                                                    minWidth:
                                                                      "50px",
                                                                  }}
                                                                  type="number"
                                                                  name={`TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[0].ParameterList[${pIdx}].CriateriaList[${cIdx}].InputColumnValueofX`}
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  maxLength={50}
                                                                  placeholder="Value"
                                                                />
                                                              </>
                                                            )}
                                                            <Field
                                                              style={{
                                                                minWidth:
                                                                  c?.IsInputColumnValueType ==
                                                                  true
                                                                    ? "50px"
                                                                    : "100px",
                                                              }}
                                                              type="text"
                                                              name={`TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[0].ParameterList[${pIdx}].CriateriaList[${cIdx}].InputColumnName`}
                                                              component={
                                                                CustomInput
                                                              }
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={200}
                                                              placeholder={
                                                                c?.IsInputColumnValueType ==
                                                                true
                                                                  ? "Prefix"
                                                                  : "Column Name"
                                                              }
                                                            />
                                                            {c.FormulaEvaluationStatus >
                                                              0 && (
                                                              <Link
                                                                to="#"
                                                                className={`icon-box icon-box-md ms-1 mt-1 ${
                                                                  c.FormulaEvaluationStatus ==
                                                                  1
                                                                    ? "bg-success"
                                                                    : c.FormulaEvaluationStatus ==
                                                                      2
                                                                    ? "bg-danger"
                                                                    : "bg-secondary-light"
                                                                }`}
                                                                title={
                                                                  c.FormulaExpression
                                                                }
                                                                onClick={() => {
                                                                  showFormula(
                                                                    `${p.ParameterColumnName} - ${c.ParameterCriteria}`,
                                                                    c.FormulaExpression
                                                                  );
                                                                }}
                                                                tabIndex={-1}
                                                              >
                                                                {
                                                                  SVGICON.Formula
                                                                }
                                                              </Link>
                                                            )}
                                                            {c.FormulaEvaluationStatus ==
                                                              1 && (
                                                              <Link
                                                                to="#"
                                                                className={`icon-box icon-box-md bg-primary-light ms-1 mt-1`}
                                                                title="Calculate Formula"
                                                                onClick={() => {
                                                                  calculateFormulaMixDesignSieveAnalysisCoarseAggregate(
                                                                    cIdx,
                                                                    pIdx,
                                                                    c.FormulaExpression,
                                                                    c.FormulaVariables
                                                                  );
                                                                }}
                                                                tabIndex={-1}
                                                              >
                                                                {
                                                                  SVGICON.Calculator
                                                                }
                                                              </Link>
                                                            )}
                                                          </div>
                                                        ) : (
                                                          c?.ParameterCriteria
                                                        )}
                                                      </th>
                                                    )
                                                  )
                                              )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {formikTesting?.values
                                            ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData &&
                                            formikTesting?.values
                                              ?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData
                                              ?.SieveSizeList?.length > 0 &&
                                            formikTesting?.values?.TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData?.SieveSizeList?.map(
                                              (s, sIdx) => (
                                                <tr>
                                                  <td className="text-center">
                                                    {s?.SieveSize}
                                                  </td>
                                                  {s?.ParameterList.map(
                                                    (p, pIdx) =>
                                                      p?.CriateriaList.map(
                                                        (c, cIdx) => (
                                                          <td className="text-center">
                                                            {c?.IsInputColumn ==
                                                            true ? (
                                                              <Field
                                                                type="text"
                                                                name={`TestingMixDesignSieveAnalysisCoarseAggregateReferenceStandardData.SieveSizeList[${sIdx}].ParameterList[${pIdx}].CriateriaList[${cIdx}].ColumnValue`}
                                                                component={
                                                                  CustomInput
                                                                }
                                                                noMarginBottom={
                                                                  true
                                                                }
                                                                maxLength={100}
                                                              />
                                                            ) : c?.ColumnValue ? (
                                                              c.ColumnValue
                                                            ) : (
                                                              "-"
                                                            )}
                                                          </td>
                                                        )
                                                      )
                                                  )}
                                                </tr>
                                              )
                                            )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={12}>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={12}>
                                  <label className="mb-0">
                                    2 - Fine Aggregate
                                  </label>
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    label="Conforming To grading Zone"
                                    name={
                                      "TestMixDesignDetail.FineAggregateConformingToGradingZone"
                                    }
                                    placeholder={"Conforming to grading Zone"}
                                    component={CustomInput}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    label="Reference Standard Table"
                                    name={
                                      "TestMixDesignDetail.FineAggregateReferenceStandardAndTableName"
                                    }
                                    placeholder={"Reference Standard Table"}
                                    options={
                                      optionsFineAggregateReferenceStandardWithTable
                                    }
                                    component={CustomSelect}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mt-0 mb-1"></hr>
                      <Row>
                        <div className="d-flex justify-content-between mb-0">
                          <div className="d-flex mb-0">
                            <label>
                              A-3 TARGET STRENGTH FOR MIX PROPORTIONING
                            </label>
                          </div>
                        </div>
                        <Col lg={12}>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={12}>
                                  <div className="table-responsive active-projects style-1 shorting mb-0">
                                    <div
                                      id="mixDesignCourseAggRefStdParameterCriteria-tbl_wrapper"
                                      className="dataTables_wrapper table-responsive no-footer"
                                    >
                                      <table
                                        id="mixDesignCourseAggRefStdParameterCriteria-tbl"
                                        className="table table-bordered no-footer mb-2"
                                      >
                                        <tbody>
                                          {Object.entries(
                                            objMixDesignTargetStrength
                                          )?.map(
                                            (
                                              [formula, items],
                                              formulaIndex
                                            ) => (
                                              <React.Fragment
                                                key={formulaIndex}
                                              >
                                                <tr>
                                                  <td
                                                    colSpan={2}
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <label>{formula}</label>
                                                  </td>
                                                </tr>
                                                {items.map((T) => (
                                                  <tr key={T.originalIndex}>
                                                    <td>
                                                      {T.VariableName} ={" "}
                                                      {T.VariableTitle}
                                                      {T.FormulaExpression &&
                                                        T.IsResultRow ==
                                                          false &&
                                                        T.FormulaEvaluationStatus >
                                                          0 && (
                                                          <Link
                                                            to="#"
                                                            className={`icon-box icon-box-md ms-1 mt-1 ${
                                                              T.FormulaEvaluationStatus ==
                                                              1
                                                                ? "bg-success"
                                                                : T.FormulaEvaluationStatus ==
                                                                  2
                                                                ? "bg-danger"
                                                                : "bg-secondary-light"
                                                            }`}
                                                            title={
                                                              T.FormulaExpression
                                                            }
                                                            onClick={() => {
                                                              showFormula(
                                                                "f 'ck",
                                                                T.FormulaExpression
                                                              );
                                                            }}
                                                            tabIndex={-1}
                                                          >
                                                            {SVGICON.Formula}
                                                          </Link>
                                                        )}
                                                      {T.FormulaExpression &&
                                                        T.IsResultRow ==
                                                          false &&
                                                        T.FormulaEvaluationStatus ==
                                                          1 && (
                                                          <Link
                                                            to="#"
                                                            className={`icon-box icon-box-md bg-primary-light ms-1 mt-1`}
                                                            title="Calculate Formula"
                                                            onClick={() => {
                                                              calculateFormulaMixDesignTargetStrength(
                                                                T.originalIndex,
                                                                T.Formula,
                                                                T.FormulaExpression,
                                                                T.FormulaVariables
                                                              );
                                                            }}
                                                            tabIndex={-1}
                                                          >
                                                            {SVGICON.Calculator}
                                                          </Link>
                                                        )}
                                                      {T.IsResultRow == true &&
                                                        T.FormulaVariables
                                                          ?.length > 0 &&
                                                        `(${T.FormulaVariables})`}
                                                    </td>
                                                    <td>
                                                      <Field
                                                        style={{
                                                          minWidth: "100px",
                                                        }}
                                                        type="number"
                                                        name={`ListOfMixDesignTargetStrengthForMixProportioning[${T.originalIndex}].VariableValue`} // Use the original index here
                                                        placeholder="Value"
                                                        component={CustomInput}
                                                        noMarginBottom={true}
                                                        maxLength={50}
                                                      />
                                                    </td>
                                                  </tr>
                                                ))}
                                              </React.Fragment>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mt-0 mb-1"></hr>
                      <Row>
                        <div className="d-flex justify-content-between mb-0">
                          <div className="d-flex mb-0">
                            <label>A-4 APPROXIMATE AIR CONTENT</label>
                          </div>
                        </div>
                        <Col lg={12}>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={12}>
                                  <div className="table-responsive active-projects style-1 shorting mb-0">
                                    <div
                                      id="mixDesignApproximateAirContent-tbl_wrapper"
                                      className="dataTables_wrapper table-responsive no-footer"
                                    >
                                      <table
                                        id="mixDesignApproximateAirContent-tbl"
                                        className="table table-bordered no-footer mb-2"
                                      >
                                        <tbody>
                                          <tr>
                                            <td colSpan={2}>
                                              {
                                                formikTesting?.values
                                                  ?.TestMixDesignDetail
                                                  .ApproximateAirContentResultTitle
                                              }
                                            </td>
                                            <td
                                              rowSpan={2}
                                              style={{ textAlign: "center" }}
                                            >
                                              {
                                                formikTesting?.values
                                                  ?.TestMixDesignDetail
                                                  .ApproximateAirContentResultValue
                                              }
                                            </td>
                                            <td
                                              rowspan={2}
                                              style={{ textAlign: "center" }}
                                            >
                                              {
                                                formikTesting?.values
                                                  ?.TestMixDesignDetail
                                                  .ApproximateAirContentReferenceStandardAndTableName
                                              }
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              For nominal maximum size of
                                              aggregate,
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              {formikTesting?.values
                                                ?.TestMixDesignDetail
                                                .MaximumNominalSizeofAggregateIDEncrypted
                                                ? optionsMaximumNominalSizeofAggregate?.filter(
                                                    (x) =>
                                                      x.value ==
                                                      formikTesting?.values
                                                        ?.TestMixDesignDetail
                                                        .MaximumNominalSizeofAggregateIDEncrypted
                                                  )[0]?.label
                                                : ""}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mt-0 mb-1"></hr>
                      <Row>
                        <div className="d-flex justify-content-between mb-0">
                          <div className="d-flex mb-0">
                            <label>A-5 SELECTION OF WATER-CEMENT RATIO</label>
                          </div>
                        </div>
                        <Col lg={12}>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={3}>
                                  <Field
                                    label="Reference Standard"
                                    name={
                                      "TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardName"
                                    }
                                    placeholder={"Reference Standard"}
                                    options={
                                      optionsReferenceStandardConcreteExposure
                                    }
                                    component={CustomSelect}
                                    onChange={(e) => {
                                      handleChangeSelectionOfWaterCementRatioReferenceStandardName(
                                        e
                                      );
                                    }}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    label="Reference Standard Table"
                                    name={
                                      "TestMixDesignDetail.SelectionOfWaterCementRatioReferenceStandardTableName"
                                    }
                                    placeholder={"Reference Standard Table"}
                                    options={
                                      optionsReferenceStandardTableConcreteExposure
                                    }
                                    component={CustomSelect}
                                    onChange={(e) => {
                                      handleChangeSelectionOfWaterCementRatioReferenceStandardTableName(
                                        e
                                      );
                                    }}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    label="Concrete Type"
                                    name={"TestMixDesignDetail.ConcreteType"}
                                    placeholder={"Concrete Type"}
                                    options={optionsTypeOfConcrete}
                                    component={CustomSelect}
                                    onChange={(e) => {
                                      handleChangeSelectionOfWaterCementRatioTypeOfConcrete(
                                        e
                                      );
                                    }}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    label="Concrete Grade"
                                    name={"TestMixDesignDetail.ConcreteGrade"}
                                    placeholder={"Concrete Grade"}
                                    options={optionsTypeOfConcreteGrade}
                                    component={CustomSelect}
                                    onChange={(e) => {
                                      handleChangeSelectionOfWaterCementRatioTypeOfConcreteGrade(
                                        e
                                      );
                                    }}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    label="Max Free Water Cement Ratio"
                                    name={
                                      "TestMixDesignDetail.MaxFreeWaterCementRatio"
                                    }
                                    placeholder={"Max Free Water Cement Ratio"}
                                    component={CustomInput}
                                    disabled={true}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    type="number"
                                    label="Free Water Cement Ratio"
                                    name={
                                      "TestMixDesignDetail.FreeWaterCementRatio"
                                    }
                                    placeholder={"Free Water Cement Ratio"}
                                    component={CustomInput}
                                    onChange={(e) => {
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.FreeWaterCementRatio",
                                        e?.target?.value ?? ""
                                      );
                                      formikTesting.setFieldValue(
                                        "TestMixDesignDetail.WaterCementRatio",
                                        e?.target?.value ?? ""
                                      );
                                      if (e?.target?.value) {
                                        SetCalculateCementContent(true);
                                      }
                                    }}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mt-0 mb-1"></hr>
                      <Row>
                        <div className="d-flex justify-content-between mb-0">
                          <div className="d-flex mb-0">
                            <label>A-6 SELECTION OF WATER CONTENT</label>
                          </div>
                        </div>
                        <Col lg={12}>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={12}>
                                  <div className="table-responsive active-projects style-1 shorting mb-0">
                                    <div
                                      id="mixDesignA6-tbl_wrapper"
                                      className="dataTables_wrapper table-responsive no-footer"
                                    >
                                      <table
                                        id="mixDesignA6-tbl"
                                        className="table table-bordered no-footer mb-2"
                                      >
                                        <tbody>
                                          <tr>
                                            <td>
                                              For nominal maximum size of
                                              aggregate,
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "center",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {formikTesting?.values
                                                ?.TestMixDesignDetail
                                                .MaximumNominalSizeofAggregateIDEncrypted
                                                ? optionsMaximumNominalSizeofAggregate?.filter(
                                                    (x) =>
                                                      x.value ==
                                                      formikTesting?.values
                                                        ?.TestMixDesignDetail
                                                        .MaximumNominalSizeofAggregateIDEncrypted
                                                  )[0]?.label
                                                : ""}
                                            </td>
                                            <td>Estimated Water Content</td>
                                            <td
                                              style={{
                                                textAlign: "center",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {
                                                formikTesting?.values
                                                  ?.TestMixDesignDetail
                                                  .Workability
                                              }
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    name={
                                      "TestMixDesignDetail.AsSuperPlasticizerIsUsed"
                                    }
                                    label={"As Super Plasticizer is used"}
                                    placeholder={"As Super Plasticizer is used"}
                                    component={CustomInput}
                                    maxLength={500}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    name={
                                      "TestMixDesignDetail.SelectionOfWaterContentReferenceStandardAndTableName"
                                    }
                                    label={"Reference Standard With Table Name"}
                                    placeholder={
                                      "Reference Standard With Table Name"
                                    }
                                    component={CustomInput}
                                    maxLength={500}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    name={
                                      "TestMixDesignDetail.SelectionOfWaterContentRemarks"
                                    }
                                    label={"Remarks"}
                                    placeholder={"Remarks"}
                                    component={CustomInput}
                                    maxLength={1000}
                                  />
                                </Col>
                                {formikTesting?.values?.ListOfMixDesignGroupParameters?.map(
                                  (item, indx) =>
                                    item.GroupName == "A-6" && (
                                      <>
                                        <Col lg={3}>
                                          {item.IsResultValueBasedOnFormula ==
                                            false &&
                                            item.FormulaExpression && (
                                              <>
                                                {item.FormulaEvaluationStatus ==
                                                  1 && (
                                                  <Link
                                                    to="#"
                                                    className={`icon-box icon-box-md bg-primary-light ms-1`}
                                                    title="Calculate Formula"
                                                    style={{ float: "right" }}
                                                    onClick={() => {
                                                      calculateFormulaMixDesignGroupParameters(
                                                        indx,
                                                        item.FormulaExpression,
                                                        item.FormulaVariables,
                                                        "A-6"
                                                      );
                                                    }}
                                                    tabIndex={-1}
                                                  >
                                                    {SVGICON.Calculator}
                                                  </Link>
                                                )}
                                                <Link
                                                  to="#"
                                                  className={`icon-box icon-box-md ms-1 ${
                                                    item.FormulaEvaluationStatus ==
                                                    1
                                                      ? "bg-success"
                                                      : item.FormulaEvaluationStatus ==
                                                        2
                                                      ? "bg-danger"
                                                      : "bg-secondary-light"
                                                  }`}
                                                  style={{ float: "right" }}
                                                  title={item.FormulaExpression}
                                                  onClick={() => {
                                                    showFormula(
                                                      item.ParameterName,
                                                      item.FormulaExpression
                                                    );
                                                  }}
                                                  tabIndex={-1}
                                                >
                                                  {SVGICON.Formula}
                                                </Link>
                                              </>
                                            )}
                                          <Field
                                            type="number"
                                            name={`ListOfMixDesignGroupParameters[${indx}].ParameterValue`}
                                            label={`${item.ParameterName} ${
                                              item.ShortCode
                                                ? "(" + item.ShortCode + ")"
                                                : ""
                                            }`}
                                            placeholder={`Enter ${item.ParameterName} Value`}
                                            component={CustomInput}
                                            maxLength={50}
                                          />
                                        </Col>
                                        {item.IsResultValueBasedOnFormula ==
                                          true && (
                                          <Col lg={3}>
                                            <Link
                                              to="#"
                                              className={`icon-box icon-box-md ms-1 ${
                                                item.FormulaEvaluationStatus ==
                                                1
                                                  ? "bg-success"
                                                  : item.FormulaEvaluationStatus ==
                                                    2
                                                  ? "bg-danger"
                                                  : "bg-secondary-light"
                                              }`}
                                              title={item.FormulaExpression}
                                              onClick={() => {
                                                showFormula(
                                                  item.ParameterName,
                                                  item.FormulaExpression
                                                );
                                              }}
                                              tabIndex={-1}
                                            >
                                              {SVGICON.Formula}
                                            </Link>
                                            {item.FormulaEvaluationStatus ==
                                              1 && (
                                              <Link
                                                to="#"
                                                className={`icon-box icon-box-md bg-primary-light ms-1`}
                                                title="Calculate Formula"
                                                onClick={() => {
                                                  calculateFormulaMixDesignGroupParameters(
                                                    indx,
                                                    item.FormulaExpression,
                                                    item.FormulaVariables,
                                                    "A-6"
                                                  );
                                                }}
                                                tabIndex={-1}
                                              >
                                                {SVGICON.Calculator}
                                              </Link>
                                            )}
                                            <Field
                                              type="number"
                                              name={`ListOfMixDesignGroupParameters[${indx}].ResultValue`}
                                              placeholder={`Result Value`}
                                              component={CustomInput}
                                              maxLength={50}
                                            />
                                          </Col>
                                        )}
                                      </>
                                    )
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mt-0 mb-1"></hr>
                      <Row>
                        <div className="d-flex justify-content-between mb-0">
                          <div className="d-flex mb-0">
                            <label>A-7(I) CALCULATION OF CEMENT CONTENT</label>
                          </div>
                        </div>
                        <Col lg={12}>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={3}>
                                  <Field
                                    name={
                                      "TestMixDesignDetail.WaterCementRatio"
                                    }
                                    label={"Water Cement Ratio"}
                                    placeholder={"Water Cement Ratio"}
                                    component={CustomInput}
                                    maxLength={50}
                                    disabled={true}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    name={
                                      "TestMixDesignDetail.CementContentKgPerM3FormulaValue"
                                    }
                                    label={"Cement Content Kg/m3 Calculation"}
                                    placeholder={
                                      "Cement Content Kg/m3 Calculation"
                                    }
                                    component={CustomInput}
                                    maxLength={50}
                                    disabled={true}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    name={
                                      "TestMixDesignDetail.CementContentKgPerM3ResultValue"
                                    }
                                    label={"Cement Content Kg/m3 Result Value"}
                                    placeholder={
                                      "Cement Content Kg/m3 Calculation"
                                    }
                                    component={CustomInput}
                                    maxLength={50}
                                    disabled={true}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    name={
                                      "TestMixDesignDetail.CementContentKgPerM3FinalResult"
                                    }
                                    label={
                                      "Cement Content Kg/m3 Final Result Value"
                                    }
                                    placeholder={
                                      "Cement Content Kg/m3 Final Result Value"
                                    }
                                    component={CustomInput}
                                    maxLength={50}
                                    disabled={true}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <Field
                                    type="number"
                                    name={
                                      "TestMixDesignDetail.MinimumCementContent"
                                    }
                                    label={"Minimum Cement Content (kg/m3)"}
                                    placeholder={
                                      "Minimum Cement Content (kg/m3)"
                                    }
                                    component={CustomInput}
                                    maxLength={50}
                                    disabled={true}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      {formikTesting?.values?.TestMixDesignDetail
                        ?.TypeofMineralAdmixtureIDEncrypted && (
                        <>
                          <hr className="mt-0 mb-1"></hr>
                          <Row>
                            <div className="d-flex justify-content-between mb-0">
                              <div className="d-flex mb-0">
                                <label>
                                  A-7(II) CALCULATION OF CEMENTITOUS MATERIAL /
                                  Mineral Admixture
                                </label>
                              </div>
                            </div>
                            <Col lg={12}>
                              <div
                                className="card mb-2"
                                style={{ height: "auto" }}
                              >
                                <div className="card-body p-2">
                                  <Row>
                                    <Col lg={12}>
                                      In certain situations, increase in
                                      cementitious material content may be
                                      warranted. The decision on increase in
                                      cementitious material content and its
                                      percentage may be based on experience and
                                      trials.
                                    </Col>
                                    <Col lg={3}>
                                      <label>
                                        Cementitious material content kg/m3:
                                      </label>
                                    </Col>
                                    <Col lg={3}>
                                      <Field
                                        type="number"
                                        name={
                                          "TestMixDesignDetail.CementitiousMaterialContentIsTakenAsMoreOrLessPercentage"
                                        }
                                        label={"Is Taken as More Or Less %"}
                                        placeholder={
                                          "Is Taken as More Or Less %"
                                        }
                                        component={CustomInput}
                                        maxLength={50}
                                        onChange={(e) => {
                                          if (e?.target.value <= 100) {
                                            formikTesting.setFieldValue(
                                              "TestMixDesignDetail.CementitiousMaterialContentIsTakenAsMoreOrLessPercentage",
                                              e?.target?.value ?? ""
                                            );
                                          }
                                        }}
                                        onBlur={(e) => {
                                          let cementContentPer =
                                            100 - (e?.target?.value ?? 0);
                                          formikTesting.setFieldValue(
                                            "TestMixDesignDetail.CementitiousMaterialContentOfCementContentPercentage",
                                            cementContentPer
                                          );
                                          let cementContent =
                                            ((formikTesting?.values
                                              ?.TestMixDesignDetail
                                              .CementContentKgPerM3FinalResult ??
                                              0) *
                                              cementContentPer) /
                                            100;
                                          formikTesting.setFieldValue(
                                            "TestMixDesignDetail.CementContentKgPerM3",
                                            cementContent.toFixed(2)
                                          );
                                          let cementitiousContent =
                                            formikTesting?.values
                                              ?.TestMixDesignDetail
                                              .CementContentKgPerM3FinalResult -
                                            cementContent;
                                          formikTesting.setFieldValue(
                                            "TestMixDesignDetail.CementitiousMaterialContentKgPerM3",
                                            cementitiousContent.toFixed(2)
                                          );
                                        }}
                                      />
                                    </Col>
                                    <Col lg={3}>
                                      <Field
                                        type="number"
                                        name={
                                          "TestMixDesignDetail.CementitiousMaterialContentOfCementContentPercentage"
                                        }
                                        label={"Of Cement Content %"}
                                        placeholder={"Of Cement Content %"}
                                        component={CustomInput}
                                        maxLength={50}
                                        disabled={true}
                                      />
                                    </Col>
                                    <Col lg={3}>
                                      <Field
                                        type="number"
                                        name={
                                          "TestMixDesignDetail.CementContentKgPerM3"
                                        }
                                        label={"Cement Content Kg/m3"}
                                        placeholder={"Cement Content Kg/m3"}
                                        component={CustomInput}
                                        maxLength={50}
                                        disabled={true}
                                      />
                                    </Col>
                                    <Col lg={3}>
                                      <Field
                                        type="number"
                                        name={
                                          "TestMixDesignDetail.WaterContentKgPerM3"
                                        }
                                        label={"Water Content Kg/m3"}
                                        placeholder={"Water Content Kg/m3"}
                                        component={CustomInput}
                                        maxLength={50}
                                        disabled={true}
                                      />
                                    </Col>
                                    <Col lg={3}>
                                      <Field
                                        type="number"
                                        name={
                                          "TestMixDesignDetail.WaterCementRatioCementitiousMaterial"
                                        }
                                        label={"Water Cement Ratio"}
                                        placeholder={"Water Cement Ratio"}
                                        component={CustomInput}
                                        maxLength={50}
                                        disabled={true}
                                      />
                                    </Col>
                                    <Col lg={3}>
                                      <Field
                                        type="number"
                                        name={
                                          "TestMixDesignDetail.CementitiousMaterialContentKgPerM3"
                                        }
                                        label={
                                          "Cementitious Material Content Kg/m3"
                                        }
                                        placeholder={
                                          "Cementitious Material Content Kg/m3"
                                        }
                                        component={CustomInput}
                                        maxLength={50}
                                        disabled={true}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                      <hr className="mt-0 mb-1"></hr>
                      <Row>
                        <div className="d-flex justify-content-between mb-0">
                          <div className="d-flex mb-0">
                            <label>
                              A-8 PROPORTION OF VOLUME OF COARSE AGGREGATE AND
                              FINE AGGREGETE CONTENT
                            </label>
                          </div>
                        </div>
                        <Col lg={12}>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={12}>
                                  <div className="table-responsive active-projects style-1 shorting mb-0">
                                    <div
                                      id="A-8-tbl_wrapper"
                                      className="dataTables_wrapper table-responsive no-footer"
                                    >
                                      <table
                                        id="A-8-tbl"
                                        className="table table-bordered no-footer mb-2"
                                      >
                                        <tbody>
                                          <tr>
                                            <td>
                                              For nominal maximum size of
                                              aggregate,
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "center",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {formikTesting?.values
                                                ?.TestMixDesignDetail
                                                .MaximumNominalSizeofAggregateIDEncrypted
                                                ? optionsMaximumNominalSizeofAggregate?.filter(
                                                    (x) =>
                                                      x.value ==
                                                      formikTesting?.values
                                                        ?.TestMixDesignDetail
                                                        .MaximumNominalSizeofAggregateIDEncrypted
                                                  )[0]?.label
                                                : ""}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Fine Aggregate grading Zone</td>
                                            <td
                                              style={{
                                                textAlign: "center",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {
                                                formikTesting?.values
                                                  ?.TestMixDesignDetail
                                                  .FineAggregateConformingToGradingZone
                                              }
                                            </td>
                                          </tr>
                                          {formikTesting?.values?.ListOfMixDesignGroupParameters?.map(
                                            (item, indx) =>
                                              (item.GroupName == "A-8" ||
                                                (item.GroupName == "A-8." &&
                                                  formikTesting?.values
                                                    ?.TestMixDesignDetail
                                                    .MethodofConcretePlacingIsPumping ==
                                                    true)) && (
                                                <tr>
                                                  <td
                                                    style={{
                                                      whiteSpace: "normal",
                                                      minWidth: "100px",
                                                      maxWidth: "400px",
                                                    }}
                                                  >
                                                    <label>{`${
                                                      item.ParameterName
                                                    } ${
                                                      item.ShortCode
                                                        ? "(" +
                                                          item.ShortCode +
                                                          ")"
                                                        : ""
                                                    }`}</label>
                                                  </td>
                                                  <td
                                                    style={{
                                                      minWidth: "100px",
                                                      maxWidth: "100px",
                                                    }}
                                                  >
                                                    {item.IsResultValueBasedOnFormula ==
                                                      false &&
                                                      item.FormulaExpression && (
                                                        <>
                                                          {item.FormulaEvaluationStatus ==
                                                            1 && (
                                                            <Link
                                                              to="#"
                                                              className={`icon-box icon-box-md bg-primary-light ms-1`}
                                                              title="Calculate Formula"
                                                              style={{
                                                                float: "right",
                                                              }}
                                                              onClick={() => {
                                                                calculateFormulaMixDesignGroupParameters(
                                                                  indx,
                                                                  item.FormulaExpression,
                                                                  item.FormulaVariables,
                                                                  "A-8"
                                                                );
                                                              }}
                                                              tabIndex={-1}
                                                            >
                                                              {
                                                                SVGICON.Calculator
                                                              }
                                                            </Link>
                                                          )}
                                                          <Link
                                                            to="#"
                                                            className={`icon-box icon-box-md ms-1 ${
                                                              item.FormulaEvaluationStatus ==
                                                              1
                                                                ? "bg-success"
                                                                : item.FormulaEvaluationStatus ==
                                                                  2
                                                                ? "bg-danger"
                                                                : "bg-secondary-light"
                                                            }`}
                                                            style={{
                                                              float: "right",
                                                            }}
                                                            title={
                                                              item.FormulaExpression
                                                            }
                                                            onClick={() => {
                                                              showFormula(
                                                                item.ParameterName,
                                                                item.FormulaExpression
                                                              );
                                                            }}
                                                            tabIndex={-1}
                                                          >
                                                            {SVGICON.Formula}
                                                          </Link>
                                                        </>
                                                      )}
                                                    <Field
                                                      type="number"
                                                      label={" "}
                                                      name={`ListOfMixDesignGroupParameters[${indx}].ParameterValue`}
                                                      placeholder={`Enter ${item.ParameterName} Value`}
                                                      component={CustomInput}
                                                      maxLength={50}
                                                    />
                                                  </td>
                                                  {item.IsResultValueBasedOnFormula ==
                                                    true && (
                                                    <td width={"200px"}>
                                                      {item.FormulaEvaluationStatus ==
                                                        1 && (
                                                        <Link
                                                          to="#"
                                                          className={`icon-box icon-box-md bg-primary-light ms-1`}
                                                          style={{
                                                            float: "right",
                                                          }}
                                                          title="Calculate Formula"
                                                          onClick={() => {
                                                            calculateFormulaMixDesignGroupParameters(
                                                              indx,
                                                              item.FormulaExpression,
                                                              item.FormulaVariables,
                                                              "A-8"
                                                            );
                                                          }}
                                                          tabIndex={-1}
                                                        >
                                                          {SVGICON.Calculator}
                                                        </Link>
                                                      )}
                                                      <Link
                                                        to="#"
                                                        className={`icon-box icon-box-md ms-1 ${
                                                          item.FormulaEvaluationStatus ==
                                                          1
                                                            ? "bg-success"
                                                            : item.FormulaEvaluationStatus ==
                                                              2
                                                            ? "bg-danger"
                                                            : "bg-secondary-light"
                                                        }`}
                                                        style={{
                                                          float: "right",
                                                        }}
                                                        title={
                                                          item.FormulaExpression
                                                        }
                                                        onClick={() => {
                                                          showFormula(
                                                            item.ParameterName,
                                                            item.FormulaExpression
                                                          );
                                                        }}
                                                        tabIndex={-1}
                                                      >
                                                        {SVGICON.Formula}
                                                      </Link>

                                                      <Field
                                                        type="number"
                                                        name={`ListOfMixDesignGroupParameters[${indx}].ResultValue`}
                                                        placeholder={`Result Value`}
                                                        component={CustomInput}
                                                        maxLength={50}
                                                      />
                                                    </td>
                                                  )}
                                                  {item?.Remarks && (
                                                    <td
                                                      style={{
                                                        minWidth: "100px",
                                                      }}
                                                      colSpan={2}
                                                    >
                                                      <Field
                                                        // label="Remarks"
                                                        name={`ListOfMixDesignGroupParameters[${indx}].Remarks`}
                                                        placeholder={`Remarks`}
                                                        component={
                                                          CustomTextArea
                                                        }
                                                        rows={5}
                                                        maxLength={2000}
                                                      />
                                                    </td>
                                                  )}
                                                </tr>
                                              )
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mt-0 mb-1"></hr>
                      <Row>
                        <div className="d-flex justify-content-between mb-0">
                          <div className="d-flex mb-0">
                            <label>A-9 MIX CALCULATIONS</label>
                          </div>
                        </div>
                        <Col lg={12}>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={12}>
                                  <div className="table-responsive active-projects style-1 shorting mb-0">
                                    <div
                                      id="A-9-tbl_wrapper"
                                      className="dataTables_wrapper table-responsive no-footer"
                                    >
                                      <table
                                        id="A-9-tbl"
                                        className="table table-bordered no-footer mb-2"
                                      >
                                        <tbody>
                                          <tr>
                                            <td
                                              colSpan={4}
                                              style={{
                                                textAlign: "left",
                                              }}
                                            >
                                              The mix calculations per unit
                                              volume of concrete shall be as
                                              follows:
                                            </td>
                                          </tr>
                                          {formikTesting?.values?.ListOfMixDesignMixCalculation?.map(
                                            (item, indx) => (
                                              <tr>
                                                <td
                                                  style={{
                                                    minWidth: "100px",
                                                  }}
                                                >
                                                  {item.ParameterShortCode
                                                    ? `${item.ParameterShortCode}) `
                                                    : ""}
                                                  {item.ParameterName}
                                                </td>
                                                <td
                                                  style={{ minWidth: "100%" }}
                                                >
                                                  {item.ParameterFormula}
                                                </td>
                                                <td
                                                  style={{
                                                    minWidth: "100px",
                                                  }}
                                                >
                                                  {item.ParameterFormulaValue}
                                                </td>
                                                <td
                                                  style={{
                                                    textAlign: "center",
                                                    minWidth: "150px",
                                                  }}
                                                >
                                                  <div className="d-flex">
                                                    {item.ParameterShortCode !=
                                                    "a" ? (
                                                      <Link
                                                        to="#"
                                                        className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                        title="Calculate Formula"
                                                        onClick={() => {
                                                          calculateFormulaMixCalculation(
                                                            indx,
                                                            item.ParameterShortCode
                                                          );
                                                        }}
                                                        tabIndex={-1}
                                                      >
                                                        {SVGICON.Calculator}
                                                      </Link>
                                                    ) : (
                                                      <>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                      </>
                                                    )}
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMixDesignMixCalculation[${indx}].ParameterResultValue`}
                                                      placeholder={`Value`}
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      noMarginBottom={true}
                                                    />
                                                    <div
                                                      style={{ width: "10%" }}
                                                    >
                                                      &nbsp;
                                                      {item.ResultUnit}
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mt-0 mb-1"></hr>
                      <Row>
                        <Col lg={12}>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={12}>
                                  <div className="table-responsive active-projects style-1 shorting mb-0">
                                    <div
                                      id="mixProportionsForTrial-tbl_wrapper"
                                      className="dataTables_wrapper table-responsive no-footer"
                                    >
                                      <table
                                        id="mixProportionsForTrial-tbl"
                                        className="table table-bordered no-footer mb-2"
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              colSpan={3}
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                              }}
                                            >
                                              A-10 MIX PROPORTIONS FOR TRIAL
                                            </th>
                                            <th
                                              colSpan={2}
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                              }}
                                            >
                                              A-11 ADJUSTMENT ON WATER, FINE
                                              AGGREGATE AND COARSE AGGREGATE (IF
                                              THE COARSE AND FINE AGGREGATE IS
                                              IN DRY CONDITION)
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                              }}
                                            >
                                              A-12 MIX PROPORTIONS AFTER
                                              ADUSTMENT FOR DRY AGGREGATES
                                            </th>
                                            <th
                                              colSpan={4}
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                              }}
                                            >
                                              A-12 LABORATORY MIX TRIAL
                                              PROPORTIONS AFTER MOSTURE CONTENT
                                              CORRECTION
                                            </th>
                                          </tr>
                                          <tr>
                                            <th
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                              }}
                                            >
                                              Sr. No.
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                                minWidth: "100px",
                                              }}
                                            >
                                              Type of material
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                                minWidth: "100px",
                                              }}
                                            >
                                              Per m3 of Concrete, Kg (SSD-
                                              Aggregates shall be used in
                                              saturated surface dry condition)
                                              <Link
                                                to="#"
                                                className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                title="Calculate Formula"
                                                onClick={() => {
                                                  calculateMixProportionsForTrial(
                                                    "PerM3OfConcreteKg"
                                                  );
                                                }}
                                                tabIndex={-1}
                                              >
                                                {SVGICON.Calculator}
                                              </Link>
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                                minWidth: "100px",
                                              }}
                                            >
                                              Water Absorption %
                                              <Link
                                                to="#"
                                                className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                title="Calculate Formula"
                                                onClick={() => {
                                                  calculateMixProportionsForTrial(
                                                    "WaterAbsorptionPercentage"
                                                  );
                                                }}
                                                tabIndex={-1}
                                              >
                                                {SVGICON.Calculator}
                                              </Link>
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                                minWidth: "100px",
                                              }}
                                            >
                                              Weight of W.A,kg
                                              <Link
                                                to="#"
                                                className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                title="Calculate Formula"
                                                onClick={() => {
                                                  calculateMixProportionsForTrial(
                                                    "WeightOfWaterAbsorptionKg"
                                                  );
                                                }}
                                                tabIndex={-1}
                                              >
                                                {SVGICON.Calculator}
                                              </Link>
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                                minWidth: "100px",
                                              }}
                                            >
                                              Per m3 of Concrete, Kg after water
                                              absorption correction
                                              <Link
                                                to="#"
                                                className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                title="Calculate Formula"
                                                onClick={() => {
                                                  calculateMixProportionsForTrial(
                                                    "PerM3OfConcreteKgAfterWaterAbsorptionCorrection"
                                                  );
                                                }}
                                                tabIndex={-1}
                                              >
                                                {SVGICON.Calculator}
                                              </Link>
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                                minWidth: "100px",
                                              }}
                                            >
                                              Moisture content % of aggregate
                                              <Link
                                                to="#"
                                                className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                title="Calculate Formula"
                                                onClick={() => {
                                                  calculateMixProportionsForTrial(
                                                    "MoistureContentPercentageOfAggregate"
                                                  );
                                                }}
                                                tabIndex={-1}
                                              >
                                                {SVGICON.Calculator}
                                              </Link>
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                                minWidth: "100px",
                                              }}
                                            >
                                              Moisture content weigth,kg
                                              <Link
                                                to="#"
                                                className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                title="Calculate Formula"
                                                onClick={() => {
                                                  calculateMixProportionsForTrial(
                                                    "MoistureContentWeightKg"
                                                  );
                                                }}
                                                tabIndex={-1}
                                              >
                                                {SVGICON.Calculator}
                                              </Link>
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                                minWidth: "100px",
                                              }}
                                            >
                                              Per m3 of Concrete, Kg after
                                              Moisture content correction
                                              <Link
                                                to="#"
                                                className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                title="Calculate Formula"
                                                onClick={() => {
                                                  calculateMixProportionsForTrial(
                                                    "PerM3OfConcreteKgAfterMoistureContentCorrection"
                                                  );
                                                }}
                                                tabIndex={-1}
                                              >
                                                {SVGICON.Calculator}
                                              </Link>
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "center",
                                                whiteSpace: "normal",
                                                minWidth: "100px",
                                              }}
                                            >
                                              0.027 m3 of concrete , Kg for
                                              Laboratory Mix Trial proportion{" "}
                                              <Link
                                                to="#"
                                                className={`icon-box icon-box-md bg-primary-light ms-1 me-1 mt-1`}
                                                title="Calculate Formula"
                                                onClick={() => {
                                                  calculateMixProportionsForTrial(
                                                    "LaboratoryMixTrialProportion"
                                                  );
                                                }}
                                                tabIndex={-1}
                                              >
                                                {SVGICON.Calculator}
                                              </Link>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {formikTesting?.values?.ListOfMixDesignMixProportionsForTrial?.map(
                                            (item, indx) => (
                                              <tr>
                                                <td
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {item?.SrNo == 0
                                                    ? ""
                                                    : item?.SrNo}
                                                </td>
                                                <td
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {item?.TypeOfMaterial}
                                                </td>
                                                <td
                                                  style={{
                                                    minWidth: "150px",
                                                  }}
                                                >
                                                  <div className="d-flex">
                                                    {(item?.MaterialShortCode ==
                                                      "CA20" ||
                                                      item?.MaterialShortCode ==
                                                        "CA10") && (
                                                      <Field
                                                        type="text"
                                                        name={`ListOfMixDesignMixProportionsForTrial[${indx}].CoarseAggregatePercentageOfFraction`}
                                                        placeholder={`Percentage(%)`}
                                                        component={CustomInput}
                                                        maxLength={50}
                                                        noMarginBottom={true}
                                                      />
                                                    )}
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMixDesignMixProportionsForTrial[${indx}].PerM3OfConcreteKg`}
                                                      placeholder={`Value`}
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      noMarginBottom={true}
                                                    />
                                                  </div>
                                                </td>
                                                <td>
                                                  {item?.SrNo && (
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMixDesignMixProportionsForTrial[${indx}].WaterAbsorptionPercentage`}
                                                      placeholder={`Value`}
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      noMarginBottom={true}
                                                    />
                                                  )}
                                                </td>
                                                <td>
                                                  {item?.SrNo && (
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMixDesignMixProportionsForTrial[${indx}].WeightOfWaterAbsorptionKg`}
                                                      placeholder={`Value`}
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      noMarginBottom={true}
                                                    />
                                                  )}
                                                </td>
                                                <td>
                                                  <Field
                                                    type="number"
                                                    name={`ListOfMixDesignMixProportionsForTrial[${indx}].PerM3OfConcreteKgAfterWaterAbsorptionCorrection`}
                                                    placeholder={`Value`}
                                                    component={CustomInput}
                                                    maxLength={50}
                                                    noMarginBottom={true}
                                                  />
                                                </td>
                                                <td>
                                                  {item?.SrNo && (
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMixDesignMixProportionsForTrial[${indx}].MoistureContentPercentageOfAggregate`}
                                                      placeholder={`Value`}
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      noMarginBottom={true}
                                                    />
                                                  )}
                                                </td>
                                                <td>
                                                  {item?.SrNo && (
                                                    <Field
                                                      type="number"
                                                      name={`ListOfMixDesignMixProportionsForTrial[${indx}].MoistureContentWeightKg`}
                                                      placeholder={`Value`}
                                                      component={CustomInput}
                                                      maxLength={50}
                                                      noMarginBottom={true}
                                                    />
                                                  )}
                                                </td>
                                                <td>
                                                  <Field
                                                    type="number"
                                                    name={`ListOfMixDesignMixProportionsForTrial[${indx}].PerM3OfConcreteKgAfterMoistureContentCorrection`}
                                                    placeholder={`Value`}
                                                    component={CustomInput}
                                                    maxLength={50}
                                                    noMarginBottom={true}
                                                  />
                                                </td>
                                                <td>
                                                  <Field
                                                    type="number"
                                                    name={`ListOfMixDesignMixProportionsForTrial[${indx}].LaboratoryMixTrialProportion`}
                                                    placeholder={`Value`}
                                                    component={CustomInput}
                                                    maxLength={50}
                                                    noMarginBottom={true}
                                                  />
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )} */}
                  <hr className="mt-0 mb-1"></hr>
                  <Row>
                    <Col lg={6}>
                      <Field
                        label="Result"
                        name="Result"
                        placeholder={"Enter Result"}
                        component={CustomTextArea}
                        rows={5}
                        maxLength={2000}
                      />
                    </Col>
                    <Col lg={6}>
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-primary-light me-1"
                        title="Select Testing Remarks"
                        style={{ float: "right" }}
                        onClick={() => {
                          setShowTestingRemarksModal(true);
                        }}
                      >
                        <i className="fa fa-edit"></i>
                      </Link>
                      <Field
                        label="Remarks"
                        name="Remarks"
                        placeholder={"Enter Remarks"}
                        component={CustomTextArea}
                        rows={5}
                        maxLength={2000}
                      />
                    </Col>
                  </Row>
                  {formikTesting?.values?.TestingStatus > 1 &&
                  formikTesting?.values?.InwardMaterialTestDetailIDEncrypt ? (
                    <Row>
                      <Col lg={6}>
                        <Field
                          label="Change Note"
                          name="ChangeNote"
                          placeholder={"Enter Change Note"}
                          component={CustomTextArea}
                          rows={5}
                          maxLength={2000}
                          required
                        />
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  {(showMachineListModal == true ||
                    showTestMasterImagesModal == true ||
                    showTestingImagesModal == true ||
                    showDefineMoreRatesModal == true ||
                    showTestParametersModal == true ||
                    showParameterFormulaExpressionModal == true ||
                    showTestingRemarksModal == true ||
                    showTestingTPIDetailModal == true ||
                    showAddTPIDetailModal == true) && (
                    <div className="fade modal-backdrop show"></div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam &&
                  formikTesting?.values?.AllowTestingEdit == 1 ? (
                    <>
                      {formikTesting?.values?.TestingStatus <= 2 && (
                        <Button
                          variant="primary btn-sm"
                          type="submit"
                          onClick={() => {
                            formikTesting.setFieldValue(
                              "btnSubmitTypeTesting",
                              1
                            );
                          }}
                        >
                          <i className="fa-solid fa-bookmark"></i> Draft
                        </Button>
                      )}
                      <Button
                        variant="primary btn-sm"
                        type="submit"
                        onClick={() => {
                          formikTesting.setFieldValue(
                            "btnSubmitTypeTesting",
                            2
                          );
                        }}
                      >
                        <i className="fa-solid fa-floppy-disk"></i> Submit
                      </Button>
                    </>
                  ) : (
                    ""
                  )}
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setshowTestingModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showMachineListModal}
          onHide={setShowMachineListModal}
          backdrop="static"
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Machine Calibration </Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowMachineListModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="Machine-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="Machine-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="5%"> Sr No</th>
                            <th width="35%">Machine Name</th>
                            <th width="20%">Calibration Date</th>
                            <th width="20%">Calibration Expiry Date</th>
                            <th width="20%" style={{ textAlign: "left" }}>
                              Certificate
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formikTesting?.values?.ListOfMachines?.length > 0 ? (
                            formikTesting?.values?.ListOfMachines?.map(
                              (item, indx) => (
                                <tr key={indx}>
                                  <td style={{ textAlign: "center" }}>
                                    {indx + 1}
                                  </td>
                                  <td>{item?.MachineName}</td>
                                  <td>{item?.CalibrationDate}</td>
                                  <td>{item?.CalibrationExpiryDate}</td>
                                  <td style={{ textAlign: "left" }}>
                                    {item?.ListOfMachineCalibrationDocuments
                                      ?.length > 0 ? (
                                      <Link
                                        to="#"
                                        className="text-primary"
                                        onClick={() => {
                                          setMachineCalibrationDocumentsList(
                                            []
                                          );
                                          setMachineCalibrationDocumentsList(
                                            item?.ListOfMachineCalibrationDocuments
                                          );
                                          setShowCertificateModal(true);
                                        }}
                                      >
                                        View
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan={7} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {showCertificateModal == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary btn-sm"
                onClick={() => setShowMachineListModal(false)}
              >
                OK
              </Button>
            </Modal.Footer>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showCertificateModal}
          onHide={setShowCertificateModal}
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Machine Calibration Certificate</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowCertificateModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="CertificateImages-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="CertificateImages-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              Certificate Preview
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {machineCalibrationDocumentsList?.length > 0 ? (
                            machineCalibrationDocumentsList?.map(
                              (item, indx) => (
                                <tr key={indx}>
                                  <td>
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="View"
                                      onClick={() => {
                                        window.open(
                                          item.MachineCalibrationDocumentPath
                                            ? item.MachineCalibrationDocumentPath
                                            : "",
                                          "_blank"
                                        );
                                      }}
                                    >
                                      <i className="fa fa-eye"></i>
                                    </Link>
                                  </td>
                                  <td style={{ textAlign: "left" }}>
                                    {item.MachineCalibrationDocumentFileName}
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan={5} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary btn-sm"
                onClick={() => setShowCertificateModal(false)}
              >
                OK
              </Button>
            </Modal.Footer>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTestMasterImagesModal}
          onHide={setShowTestMasterImagesModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Test Master Images</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowTestMasterImagesModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <div className="table-responsive active-projects style-1 shorting mb-2">
                <div
                  id="TestMasterImages-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="TestMasterImages-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="2%"></th>
                        <th width="98%" style={{ textAlign: "left" }}>
                          Image Preview
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {formikTesting?.values?.ListTestMasterImages?.length >
                      0 ? (
                        formikTesting?.values?.ListTestMasterImages?.map(
                          (item, indx) => (
                            <tr key={indx}>
                              <td>
                                <Link
                                  to="#"
                                  // className="icon-box icon-box-md bg-primary-light me-1"
                                  className="icon-box icon-box-md me-1"
                                  title="View"
                                  onClick={() => {
                                    window.open(item.ImageFilePath, "_blank");
                                  }}
                                >
                                  <i className="fa fa-eye"></i>
                                </Link>
                              </td>
                              <td>
                                <div
                                  className="image-placeholder"
                                  style={{
                                    maxWidth: "100px",
                                    margin: "10px",
                                    zIndex: 0,
                                  }}
                                >
                                  <div
                                    className="avatar-preview"
                                    style={{
                                      width: "100px",
                                      height: "auto",
                                    }}
                                  >
                                    <div id="testMasterImagePreview">
                                      <img
                                        id="saveTestMasterImageFile"
                                        src={item.ImageFilePath}
                                        alt={"Image"}
                                        onClick={() => {
                                          window.open(
                                            item.ImageFilePath,
                                            "_blank"
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td colSpan={3} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Modal.Body>
            {/* <Modal.Footer>
                      <Button
                        variant="secondary light"
                        onClick={() => setShowTestMasterImagesModal(false)}
                      >
                        Close
                      </Button>
                    </Modal.Footer> */}
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showTestingImagesModal}
          onHide={setShowTestingImagesModal}
          size="lg"
        >
          <FormikProvider value={formikTesting}>
            <Form onSubmit={formikTesting.handleSubmit}>
              <Spin
                size="large"
                spinning={isLoading}
                tip={"Loading..."}
                style={{ position: "fixed" }}
              >
                <Modal.Header>
                  <Modal.Title>Testing Images</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowTestingImagesModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    {/* {IsReTestTesting == false ? ( */}
                    <Col lg={12}>
                      <div style={{ float: "right", marginRight: "2rem" }}>
                        + Add
                        <div
                          className="open-file mt-2"
                          style={{ marginLeft: "2rem" }}
                        >
                          <input
                            type="file"
                            id="TestingImages"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={uploadTestingResultImage}
                          />
                          <label htmlFor="TestingImages" name=""></label>
                        </div>
                      </div>
                    </Col>
                    {/* ) : (
                              ""
                            )} */}
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="TestingImages-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="TestingImages-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                <th width="4%"></th>
                                <th width="50%">Image Preview</th>
                                <th width="46%" style={{ textAlign: "left" }}>
                                  Remarks
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {formikTesting?.values?.ListTestingResultImages?.filter(
                                (x) => x.IsDeleted == false
                              ).length > 0 ? (
                                formikTesting?.values?.ListTestingResultImages?.map(
                                  (item, indx) => (
                                    <tr
                                      key={indx}
                                      style={{
                                        display:
                                          item?.IsDeleted == true ? "none" : "",
                                      }}
                                    >
                                      <td>
                                        <Link
                                          to="#"
                                          // className="icon-box icon-box-md bg-primary-light me-1"
                                          className="icon-box icon-box-md me-1"
                                          title="View"
                                          onClick={() => {
                                            window.open(
                                              item.ResultImagePath
                                                ? item.ResultImagePath
                                                : item.viewFile,
                                              "_blank"
                                            );
                                          }}
                                        >
                                          <i className="fa fa-eye"></i>
                                        </Link>
                                        {/* {IsReTestTesting == false ? ( */}
                                        <Link
                                          to="#"
                                          // className="icon-box icon-box-md bg-danger-light"
                                          className="icon-box icon-box-md me-1"
                                          title="Delete"
                                          onClick={() => {
                                            //deleteTestingResultImage(indx);
                                            delete_RecordWithoutApi(
                                              deleteTestingResultImage,
                                              indx
                                            );
                                          }}
                                        >
                                          {SVGICON.DeleteDanger}
                                        </Link>
                                        {/* ) : (
                                                ""
                                              )} */}
                                      </td>
                                      <td>
                                        <div
                                          className="image-placeholder"
                                          style={{
                                            maxWidth: "100px",
                                            margin: "10px",
                                            zIndex: 0,
                                          }}
                                        >
                                          <div
                                            className="avatar-preview"
                                            style={{
                                              width: "100px",
                                              height: "auto",
                                            }}
                                          >
                                            <div id="testingImagePreview">
                                              <img
                                                id="saveTestMasterImageFile"
                                                src={
                                                  item.ResultImagePath
                                                    ? item.ResultImagePath
                                                    : item.viewFile
                                                }
                                                alt={"Image"}
                                                onClick={() => {
                                                  window.open(
                                                    item.ResultImagePath
                                                      ? item.ResultImagePath
                                                      : item.viewFile,
                                                    "_blank"
                                                  );
                                                }}
                                                style={{ cursor: "pointer" }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <Field
                                          name={`ListTestingResultImages[${indx}].Remarks`}
                                          component={CustomInput}
                                        />
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan={3} style={{ textAlign: "left" }}>
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                {/* <Modal.Footer>
                      <Button
                        variant="secondary light"
                        onClick={() => setShowTestingImagesModal(false)}
                      >
                        Close
                      </Button>
                    </Modal.Footer> */}
              </Spin>
            </Form>
          </FormikProvider>
        </Modal>
        <Modal
          className="fade"
          show={showParameterFormulaExpressionModal}
          onHide={setShowParameterFormulaExpressionModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikParameterFormula}>
              <Form onSubmit={formikParameterFormula.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    {formikParameterFormula.values.ParameterName}
                  </Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() =>
                      setShowParameterFormulaExpressionModal(false)
                    }
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label={`Formula Expression`}
                        name="FormulaExpression"
                        placeholder={"Enter Formula Expression"}
                        component={CustomTextArea}
                        rows={4}
                        maxLength={2000}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTestingRemarksModal}
          onHide={setShowTestingRemarksModal}
          size="lg"
        >
          <FormikProvider value={formikTestingRemarks}>
            <Form onSubmit={formikTestingRemarks.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Testing Remarks</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowTestingRemarksModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="table-responsive active-projects style-1 shorting mb-0">
                      <div
                        id="TestingRemarks-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="TestingRemarks-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="5%"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Testing Remarks
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {TestingRemarksList?.length > 0 ? (
                              TestingRemarksList?.map((item, indx) => (
                                <tr key={indx}>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "0.5rem",
                                      width: "5%",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkTestingRemarks${indx}`}
                                      name={`chkTestingRemarks${indx}`}
                                      checked={item.IsSelected}
                                      onChange={(e) => {
                                        formikTestingRemarks.setFieldValue(
                                          "TestingRemarksList",
                                          TestingRemarksList?.map((x, idx) => {
                                            if (idx == indx) {
                                              return {
                                                ...x,
                                                IsSelected: true,
                                              };
                                            } else {
                                              return {
                                                ...x,
                                                IsSelected: false,
                                              };
                                            }
                                          })
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "0.5rem",
                                      width: "95%",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.TestingRemarks}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2} style={{ textAlign: "left" }}>
                                  <div>{"No record found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  type="submit"
                  // className="btn btn-primary"
                  variant="primary btn-sm"
                >
                  <i className="fa-solid fa-plus"></i> Add
                </Button>

                <Button
                  // className="btn btn-danger light"
                  variant="danger btn-sm"
                  onClick={() => {
                    setShowTestingRemarksModal(false);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Modal>
        <Modal
          className="fade"
          show={showTestingTPIDetailModal}
          onHide={setShowTestingTPIDetailModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>TPI Detail</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowTestingTPIDetailModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="TPIdetail-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="TPIdetail-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%">
                              <Link
                                to="#"
                                className="icon-box icon-box-md bg-primary-light me-1"
                                title="Add TPI Detail"
                                onClick={() => {
                                  addNewTPI(true);
                                }}
                              >
                                <i className="fa fa-plus"></i>
                              </Link>
                            </th>
                            <th width="46%">TPI</th>
                            <th width="30%">TPI Contact Person</th>
                            <th width="20%" style={{ textAlign: "left" }}>
                              TPI Expected Date
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formikTesting?.values?.ListOfTPIDetails?.filter(
                            (x) => x.IsDeleted == false
                          )?.length > 0 ? (
                            formikTesting?.values?.ListOfTPIDetails?.map(
                              (item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display:
                                      item.IsDeleted == true ? "none" : "",
                                  }}
                                >
                                  <td>
                                    {/* <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="Edit"
                                      onClick={() => {
                                        editTPI(indx, true);
                                      }}
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link> */}
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-danger-light"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        //deleteTPI(indx);
                                        delete_RecordWithoutApi(
                                          deleteTPI,
                                          indx,
                                          true
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  </td>
                                  <td>{item.TPIName}</td>
                                  <td>{item.TPIContactPersonName}</td>
                                  <td style={{ textAlign: "left" }}>
                                    {item.displayTPIExpectedDate}
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan={4} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {showAddTPIDetailModal == true && (
                <div class="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowTPIDetailModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default AddSamplePreparationAndTesting;
